import { useId } from 'react';
import { lightTheme } from '../styles';

export const CarIcon = ({ color }: { color: string }) => {
  return (
    <svg
      width="40"
      height="40"
      viewBox="0 0 40 40"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <circle cx="20" cy="20" r="20" fill={color} />
      <path
        d="M15.7531 14.6703L14.8355 17.293H25.1645L24.2469 14.6703C24.0887 14.2203 23.6633 13.918 23.1852 13.918H16.8148C16.3367 13.918 15.9113 14.2203 15.7531 14.6703ZM12.3922 17.4617L13.6297 13.9285C14.1043 12.575 15.3805 11.668 16.8148 11.668H23.1852C24.6195 11.668 25.8957 12.575 26.3703 13.9285L27.6078 17.4617C28.4234 17.7992 29 18.6043 29 19.543V24.6055V26.293C29 26.9152 28.4973 27.418 27.875 27.418H26.75C26.1277 27.418 25.625 26.9152 25.625 26.293V24.6055H14.375V26.293C14.375 26.9152 13.8723 27.418 13.25 27.418H12.125C11.5027 27.418 11 26.9152 11 26.293V24.6055V19.543C11 18.6043 11.5766 17.7992 12.3922 17.4617ZM15.5 20.668C15.5 20.3696 15.3815 20.0835 15.1705 19.8725C14.9595 19.6615 14.6734 19.543 14.375 19.543C14.0766 19.543 13.7905 19.6615 13.5795 19.8725C13.3685 20.0835 13.25 20.3696 13.25 20.668C13.25 20.9663 13.3685 21.2525 13.5795 21.4635C13.7905 21.6744 14.0766 21.793 14.375 21.793C14.6734 21.793 14.9595 21.6744 15.1705 21.4635C15.3815 21.2525 15.5 20.9663 15.5 20.668ZM25.625 21.793C25.9234 21.793 26.2095 21.6744 26.4205 21.4635C26.6315 21.2525 26.75 20.9663 26.75 20.668C26.75 20.3696 26.6315 20.0835 26.4205 19.8725C26.2095 19.6615 25.9234 19.543 25.625 19.543C25.3266 19.543 25.0405 19.6615 24.8295 19.8725C24.6185 20.0835 24.5 20.3696 24.5 20.668C24.5 20.9663 24.6185 21.2525 24.8295 21.4635C25.0405 21.6744 25.3266 21.793 25.625 21.793Z"
        fill="white"
      />
    </svg>
  );
};

export const CheckmarkBlue = () => (
  <svg
    width="18"
    height="18"
    viewBox="0 0 18 18"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clipPath="url(#clip0_32423_42602)">
      <path
        d="M0 8.82759C0 3.95172 3.95172 0 8.82759 0C13.7034 0 17.6552 3.95172 17.6552 8.82759C17.6552 13.7034 13.7034 17.6552 8.82759 17.6552C3.95172 17.6552 0 13.7034 0 8.82759ZM12.8207 7.30345C13.1966 6.92759 13.1966 6.31379 12.8207 5.93793C12.4448 5.56207 11.831 5.56207 11.4552 5.93793L7.72414 9.66897L6.2 8.14483C5.82414 7.76897 5.21034 7.76897 4.83448 8.14483C4.45862 8.52069 4.45862 9.13448 4.83448 9.51034L7.04138 11.7172C7.41724 12.0931 8.03103 12.0931 8.4069 11.7172L12.8207 7.30345Z"
        fill="#0068EE"
      />
    </g>
    <defs>
      <clipPath id="clip0_32423_42602">
        <rect width="17.6552" height="17.6552" fill="white" />
      </clipPath>
    </defs>
  </svg>
);

export const FileRedCircleIcon = () => (
  <svg
    width="32"
    height="32"
    viewBox="0 0 32 32"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <circle cx="16" cy="16" r="16" fill="#E61E29" />
    <path
      d="M10 10C10 8.89688 10.8969 8 12 8H16.6719C17.2031 8 17.7125 8.20937 18.0875 8.58437L21.4156 11.9156C21.7906 12.2906 22 12.8 22 13.3313V22C22 23.1031 21.1031 24 20 24H12C10.8969 24 10 23.1031 10 22V10ZM16.5 9.82812V12.75C16.5 13.1656 16.8344 13.5 17.25 13.5H20.1719L16.5 9.82812ZM13.75 16C13.3344 16 13 16.3344 13 16.75C13 17.1656 13.3344 17.5 13.75 17.5H18.25C18.6656 17.5 19 17.1656 19 16.75C19 16.3344 18.6656 16 18.25 16H13.75ZM13.75 19C13.3344 19 13 19.3344 13 19.75C13 20.1656 13.3344 20.5 13.75 20.5H18.25C18.6656 20.5 19 20.1656 19 19.75C19 19.3344 18.6656 19 18.25 19H13.75Z"
      fill="white"
    />
  </svg>
);

export const IconCheckmark = () => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clipPath="url(#clip0_366_2)">
      <rect x="4" y="6" width="17" height="12" fill="white" />
      <path
        d="M12 24C18.6281 24 24 18.6281 24 12C24 5.37188 18.6281 0 12 0C5.37188 0 0 5.37188 0 12C0 18.6281 5.37188 24 12 24ZM17.2969 9.79688L11.2969 15.7969C10.8563 16.2375 10.1438 16.2375 9.70781 15.7969L6.70781 12.7969C6.26719 12.3563 6.26719 11.6438 6.70781 11.2078C7.14844 10.7719 7.86094 10.7672 8.29688 11.2078L10.5 13.4109L15.7031 8.20312C16.1437 7.7625 16.8562 7.7625 17.2922 8.20312C17.7281 8.64375 17.7328 9.35625 17.2922 9.79219L17.2969 9.79688Z"
        fill="#E61E29"
      />
    </g>
    <defs>
      <clipPath id="clip0_366_2">
        <rect width="24" height="24" fill="white" />
      </clipPath>
    </defs>
  </svg>
);

export const IconCheckmarkGreen = () => (
  <svg
    width="33"
    height="33"
    viewBox="0 0 33 33"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clipPath="url(#clip0_22258_69028)">
      <path
        d="M0.195312 16.2502C0.195312 7.41274 7.35781 0.250244 16.1953 0.250244C25.0328 0.250244 32.1953 7.41274 32.1953 16.2502C32.1953 25.0877 25.0328 32.2502 16.1953 32.2502C7.35781 32.2502 0.195312 25.0877 0.195312 16.2502ZM23.4328 13.4877C24.1141 12.8065 24.1141 11.694 23.4328 11.0127C22.7516 10.3315 21.6391 10.3315 20.9578 11.0127L14.1953 17.7752L11.4328 15.0127C10.7516 14.3315 9.63906 14.3315 8.95781 15.0127C8.27656 15.694 8.27656 16.8065 8.95781 17.4877L12.9578 21.4877C13.6391 22.169 14.7516 22.169 15.4328 21.4877L23.4328 13.4877Z"
        fill="#00B51D"
      />
    </g>
    <defs>
      <clipPath id="clip0_22258_69028">
        <rect
          width="32"
          height="32"
          fill="white"
          transform="translate(0.195312 0.250244)"
        />
      </clipPath>
    </defs>
  </svg>
);

export const IconCheckmarkX = () => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clipPath="url(#clip0_469_1552)">
      <path
        d="M12 24C18.6281 24 24 18.6281 24 12C24 5.37188 18.6281 0 12 0C5.37188 0 0 5.37188 0 12C0 18.6281 5.37188 24 12 24ZM8.20312 8.20312C8.64375 7.7625 9.35625 7.7625 9.79219 8.20312L11.9953 10.4062L14.1984 8.20312C14.6391 7.7625 15.3516 7.7625 15.7875 8.20312C16.2234 8.64375 16.2281 9.35625 15.7875 9.79219L13.5844 11.9953L15.7875 14.1984C16.2281 14.6391 16.2281 15.3516 15.7875 15.7875C15.3469 16.2234 14.6344 16.2281 14.1984 15.7875L11.9953 13.5844L9.79219 15.7875C9.35156 16.2281 8.63906 16.2281 8.20312 15.7875C7.76719 15.3469 7.7625 14.6344 8.20312 14.1984L10.4062 11.9953L8.20312 9.79219C7.7625 9.35156 7.7625 8.63906 8.20312 8.20312Z"
        fill="#E3E3E3"
      />
    </g>
    <defs>
      <clipPath id="clip0_469_1552">
        <rect width="24" height="24" fill="white" />
      </clipPath>
    </defs>
  </svg>
);

export const Facebook = () => (
  <svg
    width="40"
    height="40"
    viewBox="0 0 40 40"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M20 2.88794C10.32 2.88794 2.47998 10.7279 2.47998 20.4079C2.47998 30.0879 10.32 37.9279 20 37.9279C29.68 37.9279 37.52 30.0879 37.52 20.4079C37.52 10.7279 29.68 2.88794 20 2.88794ZM25 13.9199C25 13.9199 23.16 13.9039 22.696 13.9039C22 13.9039 21.536 14.5039 21.536 15.1199C21.536 15.5359 21.536 17.6799 21.536 17.6799H25L24.608 21.1679H21.496V30.0799H17.976V21.2159H15V17.6399H18.016C18.016 17.6399 18.016 16.3839 18.016 14.2719C18.016 12.3919 20.104 10.7439 21.56 10.7439C21.776 10.7439 25 10.7759 25 10.7759V13.9199Z"
      fill="#4C4C4C"
    />
  </svg>
);

export const Instagram = () => (
  <svg
    width="40"
    height="41"
    viewBox="0 0 40 41"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M23.888 12.874H16.232C14.048 12.874 12.28 14.6944 12.28 16.9248V24.7722C12.28 27.0108 14.056 28.823 16.232 28.823H23.888C26.072 28.823 27.84 27.0026 27.84 24.7722V16.9248C27.84 14.6944 26.072 12.874 23.888 12.874ZM20.064 26.1006C17.24 26.1006 14.944 23.7472 14.944 20.8526C14.944 17.958 17.24 15.6046 20.064 15.6046C22.888 15.6046 25.184 17.958 25.184 20.8526C25.184 23.7472 22.888 26.1006 20.064 26.1006ZM25.44 16.1868C24.96 16.1868 24.576 15.7932 24.576 15.3012C24.576 14.8092 24.96 14.4156 25.44 14.4156C25.92 14.4156 26.304 14.8092 26.304 15.3012C26.304 15.7932 25.92 16.1868 25.44 16.1868Z"
      fill="#4C4C4C"
    />
    <path
      d="M20.0639 2.96021C10.4239 2.96021 2.60791 10.9716 2.60791 20.8526C2.60791 30.7336 10.4239 38.745 20.0639 38.745C29.7039 38.745 37.5199 30.7336 37.5199 20.8526C37.5199 10.9716 29.7039 2.96021 20.0639 2.96021ZM30.0799 24.7804C30.0799 28.2736 27.3039 31.119 23.8959 31.119H16.2399C12.8319 31.119 10.0559 28.2736 10.0559 24.7804V16.933C10.0559 13.4398 12.8319 10.5944 16.2399 10.5944H23.8959C27.3039 10.5944 30.0799 13.4398 30.0799 16.933V24.7804Z"
      fill="#4C4C4C"
    />
    <path
      d="M20.084 24.0428C21.8027 24.0316 23.1872 22.5945 23.1763 20.8328C23.1654 19.0711 21.7633 17.652 20.0446 17.6632C18.3259 17.6743 16.9414 19.1115 16.9523 20.8732C16.9632 22.6348 18.3653 24.0539 20.084 24.0428Z"
      fill="#4C4C4C"
    />
  </svg>
);

export const LinkedIn = () => (
  <svg
    width="40"
    height="40"
    viewBox="0 0 40 40"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M20.247 2.95999C10.839 2.95999 3.20703 10.592 3.20703 20C3.20703 29.408 10.839 37.04 20.247 37.04C29.655 37.04 37.287 29.408 37.287 20C37.287 10.592 29.655 2.95999 20.247 2.95999ZM16.079 27.624H12.559V16.192H16.079V27.624ZM14.279 14.68C13.127 14.68 12.191 13.744 12.191 12.592C12.191 11.44 13.127 10.504 14.279 10.504C15.431 10.504 16.367 11.44 16.367 12.592C16.367 13.744 15.431 14.68 14.279 14.68ZM25.711 27.624C25.711 27.624 25.711 23.312 25.711 21.656C25.711 20 25.063 19.064 23.767 19.064C22.327 19.064 21.607 20 21.607 21.656C21.607 23.384 21.607 27.624 21.607 27.624H18.231V16.192H21.607V17.704C21.607 17.704 22.615 15.832 25.055 15.832C27.495 15.832 29.223 17.344 29.223 20.36C29.223 23.376 29.231 27.624 29.231 27.624H25.711Z"
      fill="#4C4C4C"
    />
  </svg>
);

export const Logo = (props: React.SVGProps<SVGSVGElement>) => (
  <svg
    width="70"
    height="70"
    viewBox="0 0 70 70"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <ellipse cx="35" cy="34.9316" rx="34.9316" ry="34.9316" fill="#E61E29" />
    <path
      d="M46.0445 29.3021C45.9771 29.2496 45.8992 29.2122 45.8162 29.1923C45.7331 29.1724 45.6467 29.1705 45.5629 29.1867C45.4384 29.2267 45.3337 29.3123 45.2699 29.4264L44.7727 30.2876L45.8137 30.8913L46.3175 30.019C46.3539 29.9617 46.3761 29.8966 46.3823 29.8291C46.3885 29.7615 46.3784 29.6935 46.353 29.6306C46.2915 29.4885 46.1824 29.3724 46.0445 29.3021Z"
      fill="white"
    />
    <path
      d="M41.8762 37.4891C41.7862 37.4006 41.6838 37.3259 41.5721 37.2672C41.468 37.2035 41.3551 37.1556 41.2369 37.1251C41.1526 37.1028 41.0638 37.1028 40.9795 37.1251C40.9061 37.1464 40.8391 37.1852 40.7841 37.2383C40.724 37.2988 40.6718 37.3667 40.6288 37.4403L40.1671 38.2305L41.4633 38.9807L41.925 38.1816C41.9683 38.1083 42.0004 38.0291 42.0204 37.9464C42.0392 37.8736 42.0392 37.7972 42.0204 37.7244C41.9918 37.6356 41.9424 37.5549 41.8762 37.4891Z"
      fill="white"
    />
    <path
      d="M47.8845 30.1741C47.7832 30.112 47.668 30.0762 47.5493 30.0698C47.4467 30.0655 47.3449 30.0909 47.2564 30.1431C47.164 30.196 47.0874 30.2726 47.0344 30.365L46.5017 31.2861L47.6381 31.952L48.1708 31.0309C48.2295 30.939 48.2631 30.8334 48.2685 30.7246C48.2722 30.6218 48.2426 30.5206 48.1841 30.436C48.1054 30.3272 48.0029 30.2376 47.8845 30.1741Z"
      fill="white"
    />
    <path
      d="M56.1456 20.6409C55.4463 19.6207 54.5058 18.789 53.4077 18.2198C52.3095 17.6506 51.0878 17.3615 49.851 17.3782H48.8589C46.1199 17.4936 43.7295 19.3003 42.5043 21.7485L40.8729 24.5473C37.6657 30.0274 35.3929 33.9915 34.5783 35.0391C33.8539 35.989 32.9185 36.7573 31.8461 37.2835C30.7737 37.8097 29.5936 38.0793 28.3991 38.071C27.4856 38.0578 26.58 37.9005 25.7156 37.6049C22.4529 36.4397 20.3532 33.5254 20.3532 30.0851C20.3532 27.6947 21.5784 25.7126 22.6859 24.0235C23.7957 22.2745 24.7834 20.7586 24.142 19.2426C23.8062 18.5244 23.2288 17.9471 22.5106 17.6112C22.0969 17.4073 21.6399 17.3068 21.1789 17.3183H20.1201C17.5566 17.3183 14.9331 18.6012 13.5924 20.7586C12.8882 21.8711 12.5046 23.1565 12.4838 24.4731C12.463 25.7897 12.806 27.0865 13.4748 28.2207L28.6321 54.4513C29.2741 55.5516 30.1932 56.4644 31.2978 57.0988C32.4024 57.7332 33.654 58.067 34.9279 58.067C36.2017 58.067 37.4533 57.7332 38.5579 57.0988C39.6626 56.4644 40.5817 55.5516 41.2236 54.4513L56.3787 28.2207C57.0712 27.0681 57.4175 25.7406 57.3761 24.3966C57.3348 23.0525 56.9077 21.7488 56.1456 20.6409ZM42.4821 42.7032L42.1114 42.65C42.1053 42.8588 42.0816 43.0667 42.0404 43.2715C41.9892 43.5408 41.8916 43.7991 41.7519 44.035C41.6218 44.2815 41.4279 44.4885 41.1903 44.6343C40.9755 44.7523 40.7313 44.8062 40.4867 44.7896C40.198 44.7665 39.9148 44.6976 39.6477 44.5854C39.3136 44.4492 38.9901 44.2882 38.68 44.1038C38.3559 43.9214 38.0478 43.712 37.7589 43.4779C37.5258 43.2954 37.3306 43.0692 37.184 42.812C37.0568 42.5797 37.0027 42.3143 37.0287 42.0507C37.0671 41.7231 37.1786 41.4083 37.3549 41.1296C37.4748 40.9224 37.5924 40.7382 37.7078 40.5769C37.8233 40.4149 37.9298 40.2662 38.0585 40.133C38.1873 39.9998 38.3027 39.8644 38.4314 39.7335L39.1217 40.133C39.0618 40.2107 38.9841 40.3172 38.8997 40.4504C38.8154 40.5836 38.7044 40.7367 38.5934 40.9054C38.4825 41.0741 38.3715 41.2472 38.2672 41.4337C38.1337 41.6298 38.064 41.8623 38.0674 42.0995C38.0971 42.3106 38.2057 42.5026 38.3715 42.6367C38.632 42.8611 38.9155 43.0575 39.2171 43.2226C39.4533 43.3641 39.6988 43.4894 39.9518 43.5977C40.1146 43.6695 40.2891 43.7109 40.4667 43.7198C40.5962 43.726 40.724 43.6877 40.8285 43.611C40.9423 43.5214 41.0366 43.4097 41.106 43.2825C41.1953 43.1233 41.2696 42.9561 41.3279 42.7831C41.3786 42.6473 41.4216 42.5088 41.4567 42.3681L40.5888 41.8532L40.1161 42.67L39.408 42.2593C39.4458 42.1683 39.4946 42.0596 39.5545 41.9397C39.6144 41.8199 39.6766 41.6911 39.7454 41.5602C39.8142 41.4292 39.8808 41.3049 39.9474 41.1895C40.014 41.0741 40.0894 40.9431 40.1516 40.8433C40.2137 40.7434 40.2736 40.6502 40.3314 40.5703L42.8727 42.044L42.4821 42.7032ZM44.6794 38.9145L42.6042 38.6748L42.5043 38.839C42.4643 38.9012 42.4288 38.9633 42.3911 39.0277L42.2779 39.2208C42.2402 39.2874 42.2047 39.3428 42.1714 39.3939L43.8405 40.3616L43.3211 41.2494L38.842 38.6526L39.923 36.8103C40.0184 36.6419 40.1364 36.4874 40.2736 36.3509C40.3984 36.2256 40.5503 36.1306 40.7176 36.0735C40.9116 36.0163 41.1169 36.0087 41.3146 36.0513C41.5881 36.1105 41.8494 36.2164 42.087 36.3642C42.2657 36.4645 42.4306 36.5876 42.5775 36.7304C42.6866 36.8359 42.776 36.9599 42.8417 37.0967C42.8928 37.2096 42.9243 37.3305 42.9349 37.454C42.9417 37.5681 42.9372 37.6826 42.9216 37.7958L45.2033 38L44.6794 38.9145ZM46.8679 35.0613C46.7789 35.3153 46.6652 35.5599 46.5283 35.7916C46.3966 36.024 46.242 36.2426 46.0667 36.4441C45.9137 36.622 45.7275 36.7683 45.5184 36.8747C45.3113 36.9735 45.0804 37.0112 44.8526 36.9835C44.5646 36.944 44.2883 36.8433 44.0424 36.6883L41.0039 34.9282L41.5233 34.0403L44.5574 35.7894C44.6898 35.8742 44.844 35.9189 45.0013 35.9181C45.1425 35.9038 45.2755 35.8447 45.3808 35.7494C45.5148 35.6272 45.628 35.484 45.716 35.3255C45.8089 35.1726 45.8756 35.0053 45.9135 34.8305C45.9443 34.6912 45.9295 34.5457 45.8713 34.4154C45.7941 34.2754 45.6766 34.1617 45.534 34.0892L42.5021 32.3313L43.0259 31.4302L46.0644 33.1903C46.3241 33.3265 46.5513 33.5173 46.7303 33.7496C46.8641 33.9336 46.9448 34.1509 46.9634 34.3777C46.9788 34.6097 46.9463 34.8424 46.8679 35.0613ZM48.992 31.4723L47.9266 33.3101L43.4476 30.7155L44.4686 28.9531C44.7261 28.5092 45.0153 28.2444 45.3364 28.1585C45.5155 28.1201 45.7005 28.1179 45.8805 28.1522C46.0604 28.1866 46.2317 28.2566 46.3841 28.3583C46.5446 28.4479 46.6881 28.5651 46.808 28.7045C46.9083 28.8226 46.9798 28.9624 47.0166 29.1129C47.0514 29.2596 47.0461 29.413 47.0011 29.5569C47.0834 29.4701 47.1775 29.3953 47.2808 29.3349C47.3912 29.2731 47.5112 29.2303 47.6359 29.2084C47.7768 29.1864 47.9206 29.191 48.0598 29.2217C48.2281 29.2594 48.3892 29.3238 48.537 29.4126C48.795 29.5467 49.0143 29.7446 49.174 29.9874C49.2953 30.1917 49.3401 30.4324 49.3005 30.6666C49.2486 30.952 49.144 31.2252 48.992 31.4723ZM51.3159 27.3151C51.233 27.6219 51.1075 27.9155 50.943 28.1874C50.8764 28.305 50.8032 28.4227 50.7211 28.5425C50.6389 28.6624 50.559 28.7822 50.4725 28.8999C50.3859 29.0175 50.2993 29.1218 50.215 29.2328C50.1307 29.3438 50.0508 29.4259 49.9731 29.5036L49.265 29.093C49.3472 28.9798 49.4359 28.8488 49.5336 28.7001C49.6313 28.5514 49.7289 28.396 49.8288 28.2318C49.9287 28.0675 50.0219 27.9122 50.1085 27.7635C50.1872 27.631 50.2512 27.4903 50.2993 27.344C50.3335 27.2341 50.3335 27.1165 50.2993 27.0066C50.2596 26.898 50.1803 26.8085 50.0774 26.7558L49.9131 26.6603C49.859 26.6239 49.7976 26.5999 49.7331 26.5899C49.6687 26.5799 49.6028 26.5843 49.5403 26.6026C49.4089 26.6525 49.3012 26.75 49.2384 26.8756L49.0164 27.2574C48.8374 27.6218 48.5368 27.9123 48.1664 28.0786C47.8467 28.1985 47.4605 28.1245 47.0078 27.8567L46.7858 27.7302C46.3508 27.4771 46.1044 27.1671 46.0467 26.8002C46.0081 26.3601 46.1208 25.9201 46.3663 25.5528C46.4618 25.3879 46.5655 25.2279 46.677 25.0734C46.7858 24.9202 46.899 24.7737 47.0078 24.6295C47.1165 24.4852 47.2164 24.3742 47.303 24.2788L48.011 24.6894C47.8911 24.8669 47.7602 25.0667 47.6159 25.2887C47.4716 25.5106 47.3429 25.717 47.2297 25.9101C47.1583 26.0331 47.1003 26.1633 47.0566 26.2986C47.0197 26.4057 47.0197 26.5221 47.0566 26.6293C47.1112 26.7438 47.2026 26.8368 47.3163 26.8934L47.4383 26.9644C47.4978 27.0067 47.5663 27.0343 47.6384 27.0451C47.7106 27.0559 47.7842 27.0496 47.8534 27.0266C47.9973 26.955 48.1135 26.838 48.1841 26.6936L48.4416 26.2497C48.567 26.0126 48.7512 25.8116 48.9765 25.666C49.1684 25.5511 49.3902 25.4962 49.6135 25.5084C49.8496 25.5299 50.0776 25.6059 50.2794 25.7304L50.5346 25.8791C50.828 26.0243 51.0692 26.2569 51.2249 26.5449C51.3457 26.7827 51.378 27.0557 51.3159 27.3151Z"
      fill="white"
    />
    <path
      d="M28.339 24.248C27.1743 24.248 26.0357 24.5935 25.0673 25.2406C24.0989 25.8877 23.3442 26.8075 22.8986 27.8836C22.453 28.9597 22.3365 30.1438 22.5639 31.2861C22.7913 32.4284 23.3523 33.4776 24.176 34.3011C24.9998 35.1245 26.0492 35.6851 27.1916 35.9121C28.334 36.1391 29.518 36.0221 30.594 35.5761C31.6699 35.1301 32.5894 34.375 33.2362 33.4064C33.883 32.4377 34.2279 31.299 34.2275 30.1343C34.2119 28.5776 33.5864 27.0892 32.4854 25.9886C31.3844 24.888 29.8957 24.2631 28.339 24.248ZM29.198 33.053H27.56L25.842 27.4331H27.1982L28.3856 31.6502L29.562 27.4331H30.8937L29.198 33.053Z"
      fill="white"
    />
  </svg>
);

export const LogoV2 = (props: React.SVGProps<SVGSVGElement>) => (
  <svg
    width="27"
    height="24"
    viewBox="0 0 27 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M19.7451 7.0707C19.7065 7.04073 19.662 7.01934 19.6146 7.00796C19.5671 6.99659 19.5178 6.99549 19.4698 7.00475C19.3987 7.02761 19.3389 7.07655 19.3024 7.14173L19.0183 7.63383L19.6131 7.97882L19.9011 7.48037C19.9219 7.44766 19.9346 7.41045 19.9381 7.37185C19.9416 7.33324 19.9359 7.29435 19.9214 7.25841C19.8862 7.17725 19.8239 7.11088 19.7451 7.0707Z"
      fill="white"
    />
    <path
      d="M17.3633 11.7498C17.3119 11.6992 17.2534 11.6565 17.1896 11.623C17.1301 11.5866 17.0656 11.5592 16.998 11.5418C16.9498 11.529 16.8991 11.529 16.8509 11.5418C16.809 11.5539 16.7707 11.5761 16.7393 11.6065C16.705 11.641 16.6751 11.6798 16.6505 11.7219L16.3867 12.1734L17.1274 12.6021L17.3912 12.1455C17.4159 12.1036 17.4343 12.0583 17.4458 12.0111C17.4565 11.9695 17.4565 11.9258 17.4458 11.8842C17.4294 11.8335 17.4012 11.7874 17.3633 11.7498Z"
      fill="white"
    />
    <path
      d="M20.7965 7.56916C20.7386 7.53368 20.6728 7.51319 20.605 7.50955C20.5463 7.50706 20.4882 7.5216 20.4376 7.5514C20.3848 7.58166 20.341 7.62544 20.3107 7.67824L20.0063 8.20459L20.6557 8.58508L20.9601 8.05873C20.9936 8.00624 21.0129 7.94591 21.0159 7.8837C21.018 7.82499 21.0011 7.76716 20.9677 7.71882C20.9227 7.65662 20.8642 7.60545 20.7965 7.56916Z"
      fill="white"
    />
    <path
      d="M25.5173 2.12182C25.1177 1.53884 24.5802 1.0636 23.9527 0.738341C23.3252 0.413081 22.6271 0.247875 21.9203 0.257403H21.3534C19.7883 0.323356 18.4223 1.35576 17.7222 2.75471L16.79 4.35406C14.9573 7.48552 13.6585 9.75073 13.1931 10.3494C12.7791 10.8921 12.2446 11.3312 11.6318 11.6319C11.019 11.9326 10.3447 12.0866 9.66208 12.0819C9.14012 12.0743 8.62263 11.9844 8.12869 11.8155C6.26427 11.1497 5.06444 9.48439 5.06444 7.5185C5.06444 6.15253 5.76455 5.01992 6.39744 4.05473C7.0316 3.0553 7.596 2.18904 7.22946 1.32279C7.03756 0.912408 6.70762 0.582468 6.29725 0.390576C6.06085 0.274062 5.79973 0.216615 5.53626 0.223159H4.93127C3.46637 0.223159 1.96722 0.956244 1.20116 2.18905C0.798722 2.82481 0.579507 3.55929 0.567647 4.31162C0.555787 5.06396 0.751742 5.80498 1.13394 6.45312L9.79525 21.4421C10.1621 22.0708 10.6873 22.5924 11.3185 22.9549C11.9497 23.3174 12.6649 23.5082 13.3928 23.5082C14.1207 23.5082 14.8359 23.3174 15.4672 22.9549C16.0984 22.5924 16.6236 22.0708 16.9904 21.4421L25.6504 6.45312C26.0462 5.79449 26.244 5.0359 26.2204 4.2679C26.1968 3.49989 25.9527 2.7549 25.5173 2.12182ZM17.7095 14.7289L17.4977 14.6984C17.4942 14.8177 17.4807 14.9365 17.4571 15.0536C17.4279 15.2074 17.3721 15.3551 17.2923 15.4899C17.2179 15.6307 17.1071 15.749 16.9714 15.8323C16.8486 15.8998 16.7091 15.9306 16.5693 15.9211C16.4043 15.9079 16.2425 15.8685 16.0899 15.8044C15.899 15.7266 15.7141 15.6346 15.5369 15.5292C15.3517 15.4249 15.1757 15.3053 15.0106 15.1715C14.8774 15.0672 14.7658 14.938 14.6821 14.791C14.6094 14.6582 14.5784 14.5066 14.5933 14.356C14.6152 14.1688 14.6789 13.9889 14.7797 13.8296C14.8482 13.7113 14.9154 13.606 14.9814 13.5138C15.0473 13.4212 15.1082 13.3363 15.1818 13.2602C15.2553 13.1841 15.3213 13.1067 15.3949 13.0319L15.7893 13.2602C15.7551 13.3045 15.7107 13.3654 15.6625 13.4415C15.6143 13.5176 15.5509 13.6051 15.4874 13.7015C15.424 13.7979 15.3606 13.8968 15.301 14.0034C15.2248 14.1155 15.1849 14.2483 15.1869 14.3839C15.2038 14.5045 15.2659 14.6142 15.3606 14.6908C15.5095 14.8191 15.6715 14.9313 15.8438 15.0257C15.9788 15.1065 16.1191 15.1781 16.2637 15.24C16.3567 15.281 16.4564 15.3047 16.5579 15.3098C16.6319 15.3133 16.7049 15.2914 16.7646 15.2476C16.8296 15.1964 16.8835 15.1325 16.9232 15.0599C16.9742 14.9689 17.0167 14.8734 17.05 14.7745C17.079 14.6969 17.1035 14.6177 17.1236 14.5373L16.6277 14.2431L16.3575 14.7098L15.9529 14.4752C15.9745 14.4232 16.0024 14.3611 16.0366 14.2926C16.0709 14.2241 16.1064 14.1505 16.1457 14.0757C16.185 14.0009 16.2231 13.9298 16.2611 13.8639C16.2992 13.7979 16.3423 13.7231 16.3778 13.666C16.4133 13.6089 16.4476 13.5557 16.4805 13.51L17.9328 14.3522L17.7095 14.7289ZM18.9652 12.5639L17.7793 12.4269L17.7222 12.5207C17.6994 12.5562 17.6791 12.5918 17.6575 12.6285L17.5928 12.7389C17.5713 12.7769 17.551 12.8086 17.532 12.8378L18.4857 13.3908L18.189 13.8981L15.6295 12.4142L16.2472 11.3615C16.3017 11.2653 16.3691 11.1769 16.4476 11.0989C16.5188 11.0273 16.6056 10.9731 16.7012 10.9404C16.8121 10.9078 16.9294 10.9034 17.0424 10.9277C17.1987 10.9616 17.348 11.0221 17.4838 11.1066C17.5859 11.1639 17.6801 11.2342 17.7641 11.3158C17.8264 11.3761 17.8775 11.447 17.915 11.5251C17.9442 11.5897 17.9622 11.6587 17.9683 11.7293C17.9721 11.7945 17.9696 11.8599 17.9607 11.9246L19.2645 12.0413L18.9652 12.5639ZM20.2157 10.3621C20.1649 10.5072 20.0999 10.6469 20.0217 10.7793C19.9464 10.9121 19.858 11.0371 19.7579 11.1522C19.6705 11.2539 19.564 11.3375 19.4446 11.3983C19.3262 11.4547 19.1943 11.4763 19.0641 11.4604C18.8995 11.4379 18.7417 11.3803 18.6012 11.2917L16.8648 10.286L17.1616 9.77863L18.8954 10.7781C18.9711 10.8266 19.0592 10.8521 19.1491 10.8516C19.2298 10.8434 19.3058 10.8097 19.3659 10.7552C19.4425 10.6854 19.5072 10.6036 19.5575 10.513C19.6105 10.4256 19.6487 10.3301 19.6703 10.2302C19.6879 10.1506 19.6795 10.0674 19.6462 9.99298C19.6021 9.91294 19.5349 9.84799 19.4535 9.80654L17.7209 8.80203L18.0203 8.2871L19.7566 9.29287C19.905 9.37072 20.0348 9.47975 20.1371 9.61249C20.2135 9.71765 20.2596 9.84183 20.2703 9.97142C20.279 10.104 20.2605 10.237 20.2157 10.3621ZM21.4295 8.3112L20.8207 9.36136L18.2612 7.8787L18.8447 6.87166C18.9918 6.618 19.1571 6.46665 19.3406 6.4176C19.4429 6.39562 19.5486 6.3944 19.6515 6.41401C19.7543 6.43361 19.8521 6.47365 19.9392 6.53175C20.031 6.58296 20.113 6.64994 20.1815 6.72961C20.2388 6.79707 20.2796 6.87698 20.3007 6.96298C20.3206 7.04679 20.3175 7.13442 20.2918 7.21664C20.3388 7.16705 20.3926 7.12435 20.4516 7.08981C20.5147 7.05447 20.5833 7.03003 20.6546 7.01752C20.7351 7.00498 20.8172 7.00756 20.8968 7.02513C20.9929 7.04666 21.085 7.08349 21.1695 7.1342C21.3169 7.21082 21.4422 7.32391 21.5335 7.46269C21.6028 7.57942 21.6284 7.71695 21.6058 7.8508C21.5761 8.01387 21.5163 8.17 21.4295 8.3112ZM22.7574 5.93564C22.7101 6.11094 22.6383 6.27873 22.5443 6.43409C22.5063 6.50131 22.4644 6.56853 22.4175 6.63702C22.3706 6.70551 22.3249 6.774 22.2755 6.84122C22.226 6.90844 22.1765 6.96805 22.1283 7.03147C22.0801 7.09488 22.0345 7.14181 21.9901 7.1862L21.5855 6.95156C21.6324 6.88688 21.6832 6.81205 21.739 6.72707C21.7948 6.6421 21.8506 6.55331 21.9076 6.45946C21.9647 6.3656 22.018 6.27682 22.0675 6.19184C22.1124 6.11615 22.149 6.03577 22.1765 5.95213C22.196 5.88935 22.196 5.82213 22.1765 5.75935C22.1538 5.69732 22.1085 5.64614 22.0497 5.61603L21.9558 5.56149C21.9249 5.54068 21.8898 5.52694 21.853 5.52124C21.8162 5.51554 21.7785 5.51802 21.7428 5.52852C21.6677 5.55701 21.6061 5.6127 21.5703 5.68452L21.4434 5.90267C21.3411 6.11092 21.1693 6.2769 20.9577 6.37194C20.775 6.44043 20.5544 6.39816 20.2956 6.24511L20.1688 6.17282C19.9202 6.02823 19.7794 5.85109 19.7464 5.6414C19.7244 5.38993 19.7888 5.13847 19.9291 4.9286C19.9837 4.83438 20.0429 4.74295 20.1066 4.65465C20.1688 4.56713 20.2335 4.48343 20.2956 4.40098C20.3578 4.31854 20.4148 4.25513 20.4643 4.20059L20.8689 4.43523C20.8004 4.53669 20.7256 4.65084 20.6431 4.77767C20.5607 4.90451 20.4871 5.02246 20.4225 5.1328C20.3817 5.20306 20.3485 5.27746 20.3235 5.35476C20.3025 5.41599 20.3025 5.4825 20.3235 5.54374C20.3547 5.60921 20.407 5.66234 20.4719 5.69466L20.5417 5.73525C20.5756 5.75939 20.6148 5.77519 20.656 5.78136C20.6972 5.78753 20.7393 5.7839 20.7788 5.77076C20.8611 5.72987 20.9275 5.663 20.9678 5.58052L21.115 5.32685C21.1866 5.19133 21.2919 5.07648 21.4206 4.99329C21.5302 4.92763 21.657 4.89627 21.7846 4.90324C21.9196 4.91553 22.0498 4.95895 22.1651 5.03007L22.311 5.11505C22.4786 5.19802 22.6165 5.33096 22.7054 5.49554C22.7745 5.63141 22.7929 5.78742 22.7574 5.93564Z"
      fill="white"
    />
    <path
      d="M9.62778 4.18262C8.96222 4.18262 8.31161 4.37999 7.75824 4.74978C7.20487 5.11957 6.77359 5.64516 6.51895 6.26008C6.26431 6.875 6.19775 7.55162 6.32769 8.20437C6.45762 8.85712 6.77822 9.45667 7.24893 9.9272C7.71963 10.3977 8.31931 10.7181 8.97211 10.8478C9.62491 10.9775 10.3015 10.9107 10.9163 10.6558C11.5311 10.4009 12.0566 9.96945 12.4262 9.41594C12.7957 8.86242 12.9929 8.21174 12.9926 7.54619C12.9837 6.65666 12.6263 5.80611 11.9971 5.1772C11.368 4.5483 10.5173 4.19121 9.62778 4.18262ZM10.1186 9.21402H9.1826L8.20092 6.00265H8.97586L9.65441 8.41244L10.3266 6.00265H11.0876L10.1186 9.21402Z"
      fill="white"
    />
  </svg>
);

export const LogoWhiteCircle = (props: React.SVGProps<SVGSVGElement>) => (
  <svg
    width="115"
    height="116"
    viewBox="0 0 115 116"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <ellipse cx="57.5" cy="57.8877" rx="57.3877" ry="57.3877" fill="white" />
    <path
      d="M75.6444 48.6391C75.5337 48.5529 75.4058 48.4914 75.2693 48.4587C75.1328 48.426 74.991 48.4229 74.8532 48.4495C74.6487 48.5152 74.4767 48.6559 74.3718 48.8433L73.5551 50.2581L75.2652 51.2499L76.0929 49.8169C76.1528 49.7229 76.1893 49.6159 76.1994 49.5049C76.2096 49.3939 76.1931 49.2821 76.1513 49.1788C76.0502 48.9455 75.871 48.7546 75.6444 48.6391Z"
      fill="#E61E29"
    />
    <path
      d="M68.7964 62.0913C68.6486 61.9459 68.4803 61.8231 68.2968 61.7267C68.1259 61.622 67.9403 61.5434 67.7462 61.4933C67.6076 61.4567 67.4618 61.4567 67.3232 61.4933C67.2027 61.5282 67.0925 61.592 67.0023 61.6793C66.9036 61.7786 66.8178 61.8901 66.7471 62.0111L65.9886 63.3092L68.1181 64.5417L68.8766 63.229C68.9477 63.1086 69.0005 62.9783 69.0334 62.8425C69.0643 62.7229 69.0643 62.5974 69.0334 62.4778C68.9864 62.3319 68.9051 62.1993 68.7964 62.0913Z"
      fill="#E61E29"
    />
    <path
      d="M78.6672 50.0726C78.5008 49.9705 78.3115 49.9116 78.1166 49.9012C77.9479 49.894 77.7808 49.9358 77.6353 50.0215C77.4835 50.1085 77.3576 50.2344 77.2706 50.3861L76.3955 51.8994L78.2625 52.9933L79.1376 51.4801C79.234 51.3292 79.2893 51.1557 79.2981 50.9769C79.3041 50.8081 79.2555 50.6418 79.1595 50.5028C79.0301 50.324 78.8618 50.1769 78.6672 50.0726Z"
      fill="#E61E29"
    />
    <path
      d="M92.2392 34.4113C91.0903 32.7352 89.5452 31.3689 87.7411 30.4338C85.937 29.4986 83.9298 29.0237 81.898 29.0511H80.268C75.7684 29.2407 71.8412 32.2089 69.8284 36.2308L67.1483 40.8289C61.8792 49.8319 58.1453 56.3444 56.8071 58.0655C55.617 59.6259 54.0803 60.8882 52.3185 61.7527C50.5567 62.6172 48.618 63.0601 46.6555 63.0465C45.1549 63.0247 43.6671 62.7663 42.247 62.2807C36.8868 60.3664 33.4373 55.5786 33.4373 49.9267C33.4373 45.9995 35.4501 42.7433 37.2697 39.9684C39.0929 37.095 40.7155 34.6045 39.6617 32.114C39.11 30.9342 38.1615 29.9856 36.9816 29.4339C36.302 29.099 35.5513 28.9338 34.7938 28.9526H33.0544C28.8429 28.9526 24.5328 31.0602 22.3304 34.6045C21.1734 36.4324 20.5431 38.544 20.509 40.707C20.4749 42.8699 21.0383 45.0004 22.1371 46.8637L47.0384 89.9569C48.093 91.7645 49.603 93.2641 51.4177 94.3064C53.2325 95.3486 55.2887 95.897 57.3814 95.897C59.4742 95.897 61.5304 95.3486 63.3451 94.3064C65.1599 93.2641 66.6698 91.7645 67.7244 89.9569L92.6221 46.8637C93.7598 44.9702 94.3286 42.7893 94.2607 40.5812C94.1928 38.3732 93.4911 36.2314 92.2392 34.4113ZM69.7919 70.6565L69.183 70.569C69.173 70.912 69.1339 71.2536 69.0663 71.59C68.9822 72.0324 68.8218 72.4569 68.5923 72.8444C68.3786 73.2493 68.06 73.5894 67.6697 73.8289C67.3168 74.0228 66.9156 74.1114 66.5138 74.0841C66.0395 74.0462 65.5742 73.933 65.1355 73.7487C64.5866 73.5249 64.0551 73.2604 63.5457 72.9574C63.0133 72.6577 62.5071 72.3137 62.0324 71.9291C61.6495 71.6293 61.3287 71.2577 61.088 70.8352C60.879 70.4535 60.79 70.0176 60.8327 69.5845C60.8958 69.0463 61.079 68.5291 61.3688 68.0712C61.5657 67.7309 61.7589 67.4282 61.9485 67.1633C62.1381 66.8971 62.3132 66.6528 62.5247 66.434C62.7362 66.2152 62.9258 65.9928 63.1373 65.7776L64.2713 66.434C64.1728 66.5616 64.0452 66.7366 63.9067 66.9554C63.7681 67.1742 63.5858 67.4258 63.4034 67.7029C63.2211 67.9801 63.0388 68.2645 62.8674 68.5708C62.6482 68.893 62.5336 69.275 62.5392 69.6647C62.5879 70.0115 62.7665 70.3269 63.0388 70.5471C63.4668 70.9159 63.9325 71.2385 64.4281 71.5098C64.8161 71.7421 65.2193 71.948 65.635 72.126C65.9024 72.244 66.1891 72.312 66.481 72.3266C66.6937 72.3368 66.9036 72.2738 67.0754 72.1479C67.2622 72.0006 67.4172 71.8171 67.5312 71.6082C67.6778 71.3466 67.7999 71.072 67.8958 70.7878C67.9791 70.5647 68.0497 70.337 68.1073 70.1059L66.6816 69.2599L65.9049 70.6018L64.7417 69.9272C64.8037 69.7777 64.8839 69.5991 64.9823 69.4022C65.0808 69.2052 65.1829 68.9938 65.2959 68.7786C65.409 68.5635 65.5184 68.3593 65.6278 68.1697C65.7371 67.9801 65.8611 67.7649 65.9632 67.6008C66.0653 67.4367 66.1638 67.2836 66.2586 67.1523L70.4337 69.5735L69.7919 70.6565ZM73.4019 64.4321L69.9925 64.0383L69.8284 64.3081C69.7628 64.4102 69.7044 64.5123 69.6424 64.6181L69.4565 64.9353C69.3945 65.0447 69.3361 65.1359 69.2814 65.2197L72.0235 66.8096L71.1703 68.2681L63.8118 64.0018L65.5876 60.9753C65.7444 60.6987 65.9383 60.4447 66.1638 60.2205C66.3687 60.0146 66.6182 59.8587 66.8931 59.7647C67.2118 59.6709 67.5491 59.6583 67.8739 59.7282C68.3233 59.8256 68.7525 59.9996 69.1429 60.2424C69.4364 60.4072 69.7073 60.6094 69.9487 60.8441C70.1279 61.0173 70.2748 61.221 70.3827 61.4457C70.4666 61.6313 70.5184 61.8298 70.5358 62.0328C70.547 62.2202 70.5396 62.4083 70.5139 62.5943L74.2624 62.9298L73.4019 64.4321ZM76.9972 58.102C76.851 58.5192 76.6642 58.921 76.4393 59.3016C76.223 59.6834 75.9689 60.0426 75.6809 60.3737C75.4296 60.6659 75.1237 60.9062 74.7802 61.0811C74.44 61.2434 74.0605 61.3053 73.6863 61.2597C73.2131 61.1949 72.7593 61.0295 72.3554 60.7748L67.3634 57.8832L68.2167 56.4246L73.2013 59.298C73.4189 59.4374 73.6722 59.5109 73.9306 59.5095C74.1627 59.4859 74.3812 59.3888 74.5541 59.2323C74.7742 59.0316 74.9602 58.7964 75.1047 58.5359C75.2574 58.2847 75.367 58.0099 75.4293 57.7227C75.4798 57.4939 75.4555 57.2549 75.36 57.0408C75.2331 56.8107 75.04 56.624 74.8057 56.5048L69.8248 53.6169L70.6853 52.1364L75.6772 55.028C76.1039 55.2519 76.4771 55.5653 76.7711 55.9469C76.991 56.2493 77.1234 56.6063 77.154 56.9789C77.1793 57.36 77.1259 57.7423 76.9972 58.102ZM80.4868 52.2057L78.7366 55.2249L71.3781 50.9623L73.0555 48.0671C73.4784 47.3378 73.9537 46.9026 74.4812 46.7616C74.7755 46.6985 75.0794 46.6949 75.375 46.7513C75.6707 46.8077 75.952 46.9228 76.2023 47.0898C76.4661 47.237 76.7018 47.4296 76.8988 47.6587C77.0636 47.8526 77.181 48.0823 77.2415 48.3296C77.2987 48.5706 77.2899 48.8225 77.216 49.0589C77.3512 48.9163 77.5059 48.7935 77.6755 48.6942C77.8569 48.5926 78.0541 48.5224 78.2589 48.4864C78.4904 48.4503 78.7266 48.4578 78.9553 48.5083C79.2318 48.5702 79.4965 48.6761 79.7393 48.8219C80.1631 49.0422 80.5234 49.3673 80.7858 49.7663C80.985 50.1019 81.0587 50.4973 80.9937 50.8821C80.9083 51.3509 80.7365 51.7998 80.4868 52.2057ZM84.3046 45.376C84.1685 45.88 83.9623 46.3624 83.692 46.809C83.5826 47.0023 83.4623 47.1956 83.3274 47.3925C83.1925 47.5894 83.0612 47.7863 82.919 47.9795C82.7768 48.1728 82.6346 48.3442 82.496 48.5265C82.3574 48.7088 82.2262 48.8437 82.0985 48.9714L80.9353 48.2968C81.0703 48.1108 81.2161 47.8957 81.3766 47.6514C81.537 47.4071 81.6974 47.1518 81.8615 46.882C82.0256 46.6121 82.1788 46.3569 82.321 46.1126C82.4503 45.895 82.5554 45.6639 82.6346 45.4234C82.6907 45.2429 82.6907 45.0497 82.6346 44.8692C82.5692 44.6908 82.439 44.5437 82.2699 44.4571L82.0001 44.3003C81.9112 44.2405 81.8102 44.201 81.7044 44.1846C81.5985 44.1682 81.4903 44.1754 81.3875 44.2055C81.1717 44.2874 80.9947 44.4475 80.8916 44.654L80.5269 45.2812C80.2328 45.8799 79.7389 46.3571 79.1304 46.6304C78.6053 46.8273 77.9708 46.7057 77.227 46.2657L76.8623 46.0579C76.1476 45.6422 75.7429 45.1329 75.6481 44.53C75.5847 43.8071 75.7699 43.0842 76.1731 42.4808C76.3301 42.2099 76.5004 41.947 76.6836 41.6931C76.8623 41.4415 77.0483 41.2009 77.227 40.9639C77.4056 40.7269 77.5697 40.5445 77.7119 40.3877L78.8751 41.0623C78.6782 41.354 78.4631 41.6822 78.2261 42.0468C77.9891 42.4115 77.7776 42.7506 77.5916 43.0678C77.4743 43.2698 77.379 43.4837 77.3072 43.706C77.2466 43.882 77.2466 44.0732 77.3072 44.2493C77.3969 44.4375 77.5471 44.5903 77.7338 44.6832L77.9344 44.7999C78.032 44.8693 78.1446 44.9147 78.2631 44.9325C78.3816 44.9502 78.5025 44.9398 78.6162 44.902C78.8526 44.7844 79.0435 44.5921 79.1595 44.355L79.5825 43.6257C79.7885 43.2361 80.0911 42.9059 80.4613 42.6667C80.7765 42.478 81.141 42.3878 81.5078 42.4078C81.8958 42.4432 82.2702 42.568 82.6017 42.7725L83.0211 43.0168C83.5031 43.2553 83.8994 43.6375 84.1551 44.1107C84.3536 44.5013 84.4066 44.9499 84.3046 45.376Z"
      fill="#E61E29"
    />
    <path
      d="M46.557 40.3369C44.6435 40.3369 42.773 40.9044 41.1821 41.9675C39.5911 43.0307 38.3512 44.5417 37.6191 46.3096C36.887 48.0775 36.6956 50.0228 37.0692 51.8994C37.4428 53.7761 38.3645 55.4998 39.7178 56.8526C41.0711 58.2054 42.7951 59.1264 44.6719 59.4993C46.5487 59.8721 48.4939 59.68 50.2615 58.9473C52.0291 58.2145 53.5397 56.974 54.6023 55.3827C55.6648 53.7914 56.2316 51.9206 56.2309 50.0072C56.2052 47.4498 55.1776 45.0044 53.3689 43.1963C51.5601 41.3882 49.1144 40.3616 46.557 40.3369ZM47.9681 54.8022H45.2771L42.4548 45.5695H44.6827L46.6335 52.4977L48.5661 45.5695H50.754L47.9681 54.8022Z"
      fill="#E61E29"
    />
  </svg>
);

export const PlusSeparator = () => (
  <svg
    width="60"
    height="60"
    viewBox="0 0 60 60"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clipPath="url(#clip0_177_140)">
      <path
        d="M56.7052 26.7043H39.0152C38.1414 26.7043 37.3035 27.0516 36.6856 27.6696C36.0678 28.2876 35.7207 29.1259 35.7207 30C35.7207 30.874 36.0678 31.7123 36.6856 32.3303C37.3035 32.9484 38.1414 33.2956 39.0152 33.2956H56.7052C57.579 33.2956 58.4169 32.9484 59.0348 32.3303C59.6526 31.7123 59.9997 30.874 59.9997 30C59.9997 29.1259 59.6526 28.2876 59.0348 27.6696C58.4169 27.0516 57.579 26.7043 56.7052 26.7043Z"
        fill="#E3E3E3"
      />
      <path
        d="M21.0006 26.7043H3.29445C2.42071 26.7043 1.58275 27.0516 0.96492 27.6696C0.347092 28.2876 0 29.1259 0 30C0 30.874 0.347092 31.7123 0.96492 32.3303C1.58275 32.9484 2.42071 33.2956 3.29445 33.2956H20.9853C21.859 33.2956 22.697 32.9484 23.3148 32.3303C23.9326 31.7123 24.2797 30.874 24.2797 30C24.2797 29.1259 23.9326 28.2876 23.3148 27.6696C22.697 27.0516 21.859 26.7043 20.9853 26.7043H21.0006Z"
        fill="#E3E3E3"
      />
      <path
        d="M30.0103 0C29.1373 0 28.3001 0.346904 27.6828 0.964402C27.0655 1.5819 26.7188 2.41941 26.7188 3.29268V20.989C26.7188 21.8631 27.0658 22.7013 27.6837 23.3194C28.3015 23.9374 29.1395 24.2846 30.0132 24.2846C30.8869 24.2846 31.7249 23.9374 32.3427 23.3194C32.9605 22.7013 33.3076 21.8631 33.3076 20.989V3.29268C33.3076 2.41941 32.9608 1.5819 32.3436 0.964402C31.7263 0.346904 30.8891 0 30.0161 0H30.0103Z"
        fill="#E3E3E3"
      />
      <path
        d="M30.0103 35.7175C29.1373 35.7175 28.3001 36.0644 27.6828 36.6819C27.0655 37.2994 26.7188 38.1369 26.7188 39.0102V56.7066C26.7188 57.5806 27.0658 58.4189 27.6837 59.0369C28.3015 59.655 29.1395 60.0022 30.0132 60.0022C30.8869 60.0022 31.7249 59.655 32.3427 59.0369C32.9605 58.4189 33.3076 57.5806 33.3076 56.7066V39.008C33.3073 38.5753 33.2218 38.1469 33.0559 37.7473C32.89 37.3477 32.647 36.9847 32.3407 36.6791C32.0345 36.3735 31.671 36.1313 31.2712 35.9663C30.8713 35.8013 30.4428 35.7168 30.0103 35.7175Z"
        fill="#E3E3E3"
      />
    </g>
    <defs>
      <clipPath id="clip0_177_140">
        <rect width="60" height="60" fill="white" />
      </clipPath>
    </defs>
  </svg>
);

export const CancellationsIcon = () => (
  <svg
    width="114"
    height="114"
    viewBox="0 0 114 114"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <circle cx="57" cy="57" r="52" stroke="white" strokeWidth="10" />
    <circle cx="57" cy="56" r="31.5" fill="#E61E29" stroke="#ECECEC" />
    <g clipPath="url(#clip0_329_3)">
      <path
        d="M68.2948 49.1773C69.2323 48.2496 69.2323 46.7429 68.2948 45.8152C67.3573 44.8875 65.8348 44.8875 64.8973 45.8152L56.9998 53.6378L49.0948 45.8226C48.1573 44.8949 46.6348 44.8949 45.6973 45.8226C44.7598 46.7503 44.7598 48.257 45.6973 49.1847L53.6023 57L45.7048 64.8226C44.7673 65.7503 44.7673 67.257 45.7048 68.1847C46.6423 69.1125 48.1648 69.1125 49.1023 68.1847L56.9998 60.3621L64.9048 68.1773C65.8423 69.105 67.3648 69.105 68.3023 68.1773C69.2398 67.2496 69.2398 65.7429 68.3023 64.8152L60.3973 57L68.2948 49.1773Z"
        fill="white"
      />
    </g>
    <defs>
      <clipPath id="clip0_329_3">
        <rect
          width="24"
          height="38"
          fill="white"
          transform="translate(45 38)"
        />
      </clipPath>
    </defs>
  </svg>
);

export const CustomersCallingIcon = () => (
  <svg
    width="140"
    height="140"
    viewBox="0 0 140 140"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <circle cx="70" cy="70" r="65" stroke="white" strokeWidth="10" />
    <circle cx="71.5" cy="69.5" r="42.5" fill="#E61E29" />
    <g clipPath="url(#clip0_351_3)">
      <path
        d="M65.5945 53.7296C65.0531 52.4218 63.6258 51.7257 62.2617 52.0983L56.0742 53.7858C54.8508 54.1233 54 55.2343 54 56.4999C54 73.8952 68.1047 87.9999 85.5 87.9999C86.7656 87.9999 87.8766 87.1491 88.2141 85.9257L89.9016 79.7382C90.2742 78.3741 89.5781 76.9468 88.2703 76.4053L81.5203 73.5928C80.3742 73.1147 79.0453 73.4452 78.2648 74.4085L75.4242 77.8749C70.4742 75.5335 66.4664 71.5257 64.125 66.5757L67.5914 63.7421C68.5547 62.9546 68.8852 61.6327 68.407 60.4866L65.5945 53.7366V53.7296Z"
        fill="white"
      />
    </g>
    <defs>
      <clipPath id="clip0_351_3">
        <rect
          width="36"
          height="36"
          fill="white"
          transform="translate(54 52)"
        />
      </clipPath>
    </defs>
  </svg>
);

export const OrderIssuesIcon = () => (
  <svg
    width="64"
    height="64"
    viewBox="0 0 64 64"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <circle cx="32" cy="32" r="31.5" fill="#E61E29" stroke="#ECECEC" />
    <g clipPath="url(#clip0_351_4)">
      <path
        d="M31.5 50C41.166 50 49 42.166 49 32.5C49 22.834 41.166 15 31.5 15C21.834 15 14 22.834 14 32.5C14 42.166 21.834 50 31.5 50ZM31.5 23.75C32.4092 23.75 33.1406 24.4814 33.1406 25.3906V33.0469C33.1406 33.9561 32.4092 34.6875 31.5 34.6875C30.5908 34.6875 29.8594 33.9561 29.8594 33.0469V25.3906C29.8594 24.4814 30.5908 23.75 31.5 23.75ZM33.6875 39.0625C33.6875 40.2725 32.71 41.25 31.5 41.25C30.29 41.25 29.3125 40.2725 29.3125 39.0625C29.3125 37.8525 30.29 36.875 31.5 36.875C32.71 36.875 33.6875 37.8525 33.6875 39.0625Z"
        fill="white"
      />
    </g>
    <defs>
      <clipPath id="clip0_351_4">
        <rect
          width="35"
          height="35"
          fill="white"
          transform="translate(14 15)"
        />
      </clipPath>
    </defs>
  </svg>
);

/** Font Awesome `triangle-exclamation` (solid). Incidents, in the sidebar. */
export const IncidentsIcon = ({ color }: { color?: string }) => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 640 640"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M320 64C331.3 64 341.7 70 347.4 79.7L603.4 511.7C609.2 521.6 609.3 533.8 603.6 543.7C597.9 553.6 587.4 559.8 576 559.8L64 559.8C52.6 559.8 42.1 553.7 36.4 543.7C30.7 533.7 30.8 521.5 36.6 511.7L292.6 79.7C298.4 70 308.7 64 320 64zM320 232C306.7 232 296 242.7 296 256L296 384C296 397.3 306.7 408 320 408C333.3 408 344 397.3 344 384L344 256C344 242.7 333.3 232 320 232zM352 464C352 446.3 337.7 432 320 432C302.3 432 288 446.3 288 464C288 481.7 302.3 496 320 496C337.7 496 352 481.7 352 464z"
      fill={color || '#FFFFFF'}
    />
  </svg>
);

export const ComplaintsIcon = () => (
  <svg
    width="85"
    height="85"
    viewBox="0 0 85 85"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <circle cx="42.5" cy="42.5" r="42" fill="#E61E29" stroke="#ECECEC" />
    <g clipPath="url(#clip0_351_6)">
      <path
        d="M28.75 27C26.1301 27 24 29.1301 24 31.75V53.125C24 55.7449 26.1301 57.875 28.75 57.875H35.875V63.8125C35.875 64.2652 36.1273 64.6734 36.5281 64.8738C36.9289 65.0742 37.4113 65.0297 37.775 64.7625L46.9559 57.875H57.25C59.8699 57.875 62 55.7449 62 53.125V31.75C62 29.1301 59.8699 27 57.25 27H28.75Z"
        fill="white"
      />
    </g>
    <defs>
      <clipPath id="clip0_351_6">
        <rect
          width="38"
          height="38"
          fill="white"
          transform="translate(24 27)"
        />
      </clipPath>
    </defs>
  </svg>
);

export const Chevron = ({ size }: { size?: number }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 512 512"
    fill="#E61E29"
    width={size ? size : 24}
    height={size ? size : 24}
  >
    <path d="M233.4 105.4c12.5-12.5 32.8-12.5 45.3 0l192 192c12.5 12.5 12.5 32.8 0 45.3s-32.8 12.5-45.3 0L256 173.3 86.6 342.6c-12.5 12.5-32.8 12.5-45.3 0s-12.5-32.8 0-45.3l192-192z" />
  </svg>
);

export const ArrowRed = () => (
  <svg
    width="21"
    height="25"
    viewBox="0 0 21 25"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clipPath="url(#clip0_11928_6294)">
      <path
        d="M0.291655 12.7129C0.291655 11.8832 0.889871 11.2129 1.68005 11.2129L15.372 11.2129L10.6667 6.27226C10.1086 5.68633 10.1086 4.73711 10.6667 4.15117C10.9479 3.8582 11.314 3.71289 11.68 3.71289C12.0461 3.71289 12.4113 3.85937 12.6899 4.15234L19.8327 11.6523C20.3908 12.2383 20.3908 13.1875 19.8327 13.7734L12.6899 21.2734C12.1318 21.8594 11.2278 21.8594 10.6698 21.2734C10.1117 20.6875 10.1117 19.7383 10.6698 19.1523L15.372 14.2129L1.68005 14.2129C0.88987 14.2129 0.291655 13.5426 0.291655 12.7129Z"
        fill="#E61E29"
      />
    </g>
    <defs>
      <clipPath id="clip0_11928_6294">
        <rect
          width="20"
          height="24"
          fill="white"
          transform="translate(20.2515 24.7129) rotate(-180)"
        />
      </clipPath>
    </defs>
  </svg>
);

export const ChevronSmall = () => (
  <svg
    width="29"
    height="30"
    viewBox="0 0 29 30"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clipPath="url(#clip0_11927_6146)">
      <path
        d="M19.8765 10.9795L14.6269 16.3636L9.37733 10.9795L7.76471 12.637L14.6269 19.6904L21.4891 12.637L19.8765 10.9795Z"
        fill="#4C4C4C"
      />
    </g>
    <defs>
      <clipPath id="clip0_11927_6146">
        <rect
          width="27.4488"
          height="28.2134"
          fill="white"
          transform="translate(0.902954 0.881836)"
        />
      </clipPath>
    </defs>
  </svg>
);

export const X = ({ fill }: { fill?: string }) => (
  <svg
    width="18"
    height="19"
    viewBox="0 0 18 19"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M17.4716 3.6638C18.1747 2.94469 18.1747 1.77687 17.4716 1.05776C16.7684 0.338656 15.6266 0.338656 14.9234 1.05776L9.00031 7.12126L3.07156 1.06351C2.36844 0.344409 1.22656 0.344409 0.523437 1.06351C-0.179687 1.78262 -0.179687 2.95045 0.523437 3.66955L6.45219 9.72729L0.529062 15.7908C-0.174063 16.5099 -0.174063 17.6777 0.529062 18.3968C1.23219 19.1159 2.37406 19.1159 3.07719 18.3968L9.00031 12.3333L14.9291 18.3911C15.6322 19.1102 16.7741 19.1102 17.4772 18.3911C18.1803 17.672 18.1803 16.5041 17.4772 15.785L11.5484 9.72729L17.4716 3.6638Z"
      fill={fill ? fill : '#E3E3E3'}
    />
  </svg>
);

export const Arrow = () => (
  <svg
    width="21"
    height="20"
    viewBox="0 0 21 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M0.770508 9.7002C0.770508 10.576 1.36993 11.2835 2.16171 11.2835H15.8814L11.1665 16.4986C10.6073 17.1171 10.6073 18.1191 11.1665 18.7376C11.4483 19.0468 11.8151 19.2002 12.182 19.2002C12.5488 19.2002 12.9147 19.0456 13.1938 18.7363L20.3511 10.8197C20.9103 10.2012 20.9103 9.19922 20.3511 8.58073L13.1938 0.664062C12.6347 0.0455729 11.7288 0.0455729 11.1696 0.664062C10.6105 1.28255 10.6105 2.28451 11.1696 2.90299L15.8814 8.11686H2.16171C1.36993 8.11686 0.770508 8.82441 0.770508 9.7002Z"
      fill="white"
    />
  </svg>
);

export const ArrowDarkGray = () => (
  <svg
    width="13"
    height="20"
    viewBox="0 0 13 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M11.3188 9.11719C11.8266 9.60547 11.8266 10.3984 11.3188 10.8867L4.81883 17.1367C4.31102 17.625 3.48633 17.625 2.97852 17.1367C2.4707 16.6484 2.4707 15.8555 2.97852 15.3672L8.56039 10L2.98258 4.63281C2.47477 4.14453 2.47477 3.35156 2.98258 2.86328C3.49039 2.375 4.31508 2.375 4.82289 2.86328L11.3229 9.11328L11.3188 9.11719Z"
      fill="#4C4C4C"
    />
  </svg>
);

export const File = () => (
  <svg
    width="16"
    height="21"
    viewBox="0 0 16 21"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clipPath="url(#clip0_2093_1915)">
      <path
        d="M2.66667 0C1.19583 0 0 1.17715 0 2.625V18.375C0 19.8229 1.19583 21 2.66667 21H13.3333C14.8042 21 16 19.8229 16 18.375V6.5625H10.6667C9.92917 6.5625 9.33333 5.97598 9.33333 5.25V0H2.66667ZM10.6667 0V5.25H16L10.6667 0ZM4.66667 10.5H11.3333C11.7 10.5 12 10.7953 12 11.1562C12 11.5172 11.7 11.8125 11.3333 11.8125H4.66667C4.3 11.8125 4 11.5172 4 11.1562C4 10.7953 4.3 10.5 4.66667 10.5ZM4.66667 13.125H11.3333C11.7 13.125 12 13.4203 12 13.7812C12 14.1422 11.7 14.4375 11.3333 14.4375H4.66667C4.3 14.4375 4 14.1422 4 13.7812C4 13.4203 4.3 13.125 4.66667 13.125ZM4.66667 15.75H11.3333C11.7 15.75 12 16.0453 12 16.4062C12 16.7672 11.7 17.0625 11.3333 17.0625H4.66667C4.3 17.0625 4 16.7672 4 16.4062C4 16.0453 4.3 15.75 4.66667 15.75Z"
        fill="#E61E29"
      />
    </g>
    <defs>
      <clipPath id="clip0_2093_1915">
        <rect width="16" height="21" fill="white" />
      </clipPath>
    </defs>
  </svg>
);

export const ImagePlaceholder = () => (
  <svg
    width="80"
    height="70"
    viewBox="0 0 80 70"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M0 10C0 4.48438 4.48438 0 10 0H70C75.5156 0 80 4.48438 80 10V60C80 65.5156 75.5156 70 70 70H10C4.48438 70 0 65.5156 0 60V10ZM50.5938 26.6406C49.8906 25.6094 48.7344 25 47.5 25C46.2656 25 45.0938 25.6094 44.4062 26.6406L30.8125 46.5781L26.6719 41.4062C25.9531 40.5156 24.875 40 23.75 40C22.625 40 21.5312 40.5156 20.8281 41.4062L10.8281 53.9062C9.92188 55.0312 9.75 56.5781 10.375 57.875C11 59.1719 12.3125 60 13.75 60H28.75H33.75H66.25C67.6406 60 68.9219 59.2344 69.5625 58C70.2031 56.7656 70.125 55.2812 69.3438 54.1406L50.5938 26.6406ZM17.5 25C19.4891 25 21.3968 24.2098 22.8033 22.8033C24.2098 21.3968 25 19.4891 25 17.5C25 15.5109 24.2098 13.6032 22.8033 12.1967C21.3968 10.7902 19.4891 10 17.5 10C15.5109 10 13.6032 10.7902 12.1967 12.1967C10.7902 13.6032 10 15.5109 10 17.5C10 19.4891 10.7902 21.3968 12.1967 22.8033C13.6032 24.2098 15.5109 25 17.5 25Z"
      fill="#4C4C4C"
    />
  </svg>
);

export const MostPopular = () => (
  <svg
    width="120"
    height="24"
    viewBox="0 0 120 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M0 12C0 5.37258 5.37258 0 12 0H108C114.627 0 120 5.37258 120 12V24H0V12Z"
      fill="#E61E29"
    />
    <path
      d="M23.9968 16.7109V7.55127H25.3171L28.491 15.27H28.5291L31.7029 7.55127H33.0232V16.7109H31.9568V9.6333H31.9187L28.9924 16.7109H28.0276L25.1013 9.6333H25.0632V16.7109H23.9968ZM37.365 16.8379C35.5305 16.8379 34.3054 15.5112 34.3054 13.4102V13.3975C34.3054 11.2964 35.5369 9.98242 37.3586 9.98242C39.1804 9.98242 40.4182 11.29 40.4182 13.3975V13.4102C40.4182 15.5176 39.1868 16.8379 37.365 16.8379ZM37.3713 15.8604C38.533 15.8604 39.2883 14.959 39.2883 13.4102V13.3975C39.2883 11.8486 38.5266 10.96 37.3586 10.96C36.2097 10.96 35.4353 11.855 35.4353 13.3975V13.4102C35.4353 14.9653 36.2034 15.8604 37.3713 15.8604ZM43.8777 16.8379C42.3225 16.8379 41.3831 16.0444 41.2498 14.8638L41.2434 14.8066H42.3479L42.3606 14.8701C42.4939 15.5303 42.9827 15.9175 43.884 15.9175C44.7791 15.9175 45.3123 15.543 45.3123 14.9463V14.9399C45.3123 14.4639 45.0647 14.1973 44.3157 14.0132L43.2683 13.7593C42.0242 13.4609 41.4211 12.8833 41.4211 11.9312V11.9248C41.4211 10.7886 42.4177 9.98242 43.8459 9.98242C45.2932 9.98242 46.2136 10.8267 46.2961 11.9312L46.3025 12.0137H45.2488L45.2424 11.9692C45.1536 11.3281 44.6648 10.9028 43.8459 10.9028C43.0461 10.9028 42.551 11.29 42.551 11.874V11.8804C42.551 12.3311 42.8494 12.6421 43.5793 12.8198L44.6267 13.0737C45.9597 13.3975 46.4421 13.9243 46.4421 14.8638V14.8701C46.4421 16.0254 45.3503 16.8379 43.8777 16.8379ZM49.7366 16.8379C48.5242 16.8379 47.9275 16.292 47.9275 15.0288V11.0234H46.9626V10.1094H47.9275V8.32568H49.0701V10.1094H50.3269V11.0234H49.0701V15.0225C49.0701 15.7271 49.3811 15.9238 49.9714 15.9238C50.1047 15.9238 50.2317 15.9048 50.3269 15.8984V16.7935C50.1873 16.8125 49.9524 16.8379 49.7366 16.8379ZM54.3513 16.7109V7.55127H57.614C59.3342 7.55127 60.553 8.73828 60.553 10.4775V10.4902C60.553 12.2295 59.3342 13.4419 57.614 13.4419H55.4939V16.7109H54.3513ZM57.322 8.56689H55.4939V12.4263H57.322C58.6296 12.4263 59.385 11.709 59.385 10.5029V10.4902C59.385 9.28418 58.6296 8.56689 57.322 8.56689ZM64.114 16.8379C62.2795 16.8379 61.0544 15.5112 61.0544 13.4102V13.3975C61.0544 11.2964 62.2859 9.98242 64.1077 9.98242C65.9294 9.98242 67.1672 11.29 67.1672 13.3975V13.4102C67.1672 15.5176 65.9358 16.8379 64.114 16.8379ZM64.1204 15.8604C65.282 15.8604 66.0374 14.959 66.0374 13.4102V13.3975C66.0374 11.8486 65.2756 10.96 64.1077 10.96C62.9587 10.96 62.1843 11.855 62.1843 13.3975V13.4102C62.1843 14.9653 62.9524 15.8604 64.1204 15.8604ZM68.2844 18.9326V10.1094H69.3889V11.2266H69.4143C69.8269 10.4585 70.5632 9.98242 71.509 9.98242C73.1975 9.98242 74.3147 11.3281 74.3147 13.4102V13.4165C74.3147 15.4985 73.1848 16.8379 71.5281 16.8379C70.595 16.8379 69.8269 16.3682 69.4143 15.6064H69.3889V18.9326H68.2844ZM71.2932 15.8604C72.4612 15.8604 73.1848 14.9209 73.1848 13.4165V13.4102C73.1848 11.8931 72.4612 10.96 71.2932 10.96C70.176 10.96 69.3826 11.9312 69.3826 13.4102V13.4165C69.3826 14.8892 70.1824 15.8604 71.2932 15.8604ZM77.6853 16.8379C76.238 16.8379 75.4001 15.8984 75.4001 14.394V10.1094H76.5046V14.1973C76.5046 15.27 77.0061 15.8604 78.0217 15.8604C79.0627 15.8604 79.7419 15.1177 79.7419 13.9941V10.1094H80.8464V16.7109H79.7419V15.7715H79.7166C79.3611 16.3872 78.6882 16.8379 77.6853 16.8379ZM82.3445 16.7109V7.55127H83.449V16.7109H82.3445ZM86.8704 16.8379C85.5564 16.8379 84.6741 16.0444 84.6741 14.8447V14.832C84.6741 13.7085 85.55 13.0039 87.0671 12.915L88.9587 12.8071V12.2549C88.9587 11.4487 88.4319 10.96 87.5115 10.96C86.6609 10.96 86.1277 11.3662 86.0007 11.9565L85.988 12.0137H84.9216L84.928 11.9438C85.0232 10.8584 85.969 9.98242 87.5242 9.98242C89.0857 9.98242 90.0632 10.8267 90.0632 12.147V16.7109H88.9587V15.6382H88.9333C88.5461 16.3618 87.7527 16.8379 86.8704 16.8379ZM85.804 14.8447C85.804 15.4795 86.3245 15.8794 87.1179 15.8794C88.1589 15.8794 88.9587 15.1621 88.9587 14.2036V13.6641L87.1941 13.772C86.3118 13.8228 85.804 14.2163 85.804 14.832V14.8447ZM91.4661 16.7109V10.1094H92.5706V11.2266H92.5959C92.8181 10.4648 93.3894 9.98242 94.1321 9.98242C94.3225 9.98242 94.4875 10.0142 94.5764 10.0269V11.0996C94.4875 11.0679 94.2527 11.0361 93.9861 11.0361C93.1292 11.0361 92.5706 11.6328 92.5706 12.6357V16.7109H91.4661Z"
      fill="white"
    />
  </svg>
);

export const Edit = () => (
  <svg
    width="22"
    height="22"
    viewBox="0 0 22 22"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M20.2641 0.932324C19.323 -0.00869142 17.802 -0.00869142 16.8609 0.932324L15.5676 2.22139L19.7742 6.42803L21.0676 5.13467C22.0086 4.19365 22.0086 2.67256 21.0676 1.73154L20.2641 0.932324ZM7.40781 10.3854C7.1457 10.6476 6.94375 10.9698 6.82773 11.3265L5.55586 15.1421C5.43125 15.5116 5.53008 15.9198 5.80508 16.1991C6.08008 16.4784 6.48828 16.5729 6.86211 16.4483L10.6777 15.1765C11.0301 15.0562 11.3523 14.8585 11.6187 14.5964L18.8074 7.40342L14.5965 3.19248L7.40781 10.3854ZM4.125 2.7499C1.84766 2.7499 0 4.59756 0 6.8749V17.8749C0 20.1522 1.84766 21.9999 4.125 21.9999H15.125C17.4023 21.9999 19.25 20.1522 19.25 17.8749V13.7499C19.25 12.9894 18.6355 12.3749 17.875 12.3749C17.1145 12.3749 16.5 12.9894 16.5 13.7499V17.8749C16.5 18.6354 15.8855 19.2499 15.125 19.2499H4.125C3.36445 19.2499 2.75 18.6354 2.75 17.8749V6.8749C2.75 6.11436 3.36445 5.4999 4.125 5.4999H8.25C9.01055 5.4999 9.625 4.88545 9.625 4.1249C9.625 3.36436 9.01055 2.7499 8.25 2.7499H4.125Z"
      fill="#4C4C4C"
    />
  </svg>
);

export const Delete = () => (
  <svg
    width="19"
    height="21"
    viewBox="0 0 19 21"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clipPath="url(#clip0_2114_2141)">
      <path
        d="M5.73393 0.725977L5.42857 1.3125H1.35714C0.606473 1.3125 0 1.89902 0 2.625C0 3.35098 0.606473 3.9375 1.35714 3.9375H17.6429C18.3935 3.9375 19 3.35098 19 2.625C19 1.89902 18.3935 1.3125 17.6429 1.3125H13.5714L13.2661 0.725977C13.0371 0.278906 12.5663 0 12.0531 0H6.94687C6.43371 0 5.96295 0.278906 5.73393 0.725977ZM17.6429 5.25H1.35714L2.25625 19.1543C2.32411 20.192 3.21473 21 4.28772 21H14.7123C15.7853 21 16.6759 20.192 16.7437 19.1543L17.6429 5.25Z"
        fill="#4C4C4C"
      />
    </g>
    <defs>
      <clipPath id="clip0_2114_2141">
        <rect width="19" height="21" fill="white" />
      </clipPath>
    </defs>
  </svg>
);

export const ToastError = () => (
  <svg
    width="27"
    height="24"
    viewBox="0 0 27 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M26.6985 20.625L15.4499 1.125C14.5887 -0.375 12.4155 -0.375 11.5485 1.125L0.305098 20.625C-0.560304 22.1196 0.517572 24 2.25212 24H24.7494C26.4771 24 27.5581 22.125 26.6985 20.625ZM12.233 7.28571C12.233 6.57589 12.7999 6 13.4987 6C14.1974 6 14.7643 6.57857 14.7643 7.28571V14.1429C14.7643 14.8527 14.1974 15.4286 13.5461 15.4286C12.8948 15.4286 12.233 14.8554 12.233 14.1429V7.28571ZM13.4987 20.5714C12.5832 20.5714 11.8406 19.8171 11.8406 18.8871C11.8406 17.9571 12.5826 17.2029 13.4987 17.2029C14.4147 17.2029 15.1567 17.9571 15.1567 18.8871C15.1546 19.8161 14.4163 20.5714 13.4987 20.5714Z"
      fill="#E61E29"
    />
  </svg>
);

export const ToastSuccess = () => (
  <svg
    width="29"
    height="29"
    viewBox="0 0 29 29"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M0 14.5C0 6.49102 6.49102 0 14.5 0C22.509 0 29 6.49102 29 14.5C29 22.509 22.509 29 14.5 29C6.49102 29 0 22.509 0 14.5ZM21.059 11.9965C21.6764 11.3791 21.6764 10.3709 21.059 9.75352C20.4416 9.13613 19.4334 9.13613 18.816 9.75352L12.6875 15.882L10.184 13.3785C9.5666 12.7611 8.5584 12.7611 7.94102 13.3785C7.32363 13.9959 7.32363 15.0041 7.94102 15.6215L11.566 19.2465C12.1834 19.8639 13.1916 19.8639 13.809 19.2465L21.059 11.9965Z"
      fill="#00B51D"
    />
  </svg>
);

export const LogoutIcon = ({ color }: { color?: string }) => (
  <svg
    width="100"
    height="100"
    viewBox="0 0 100 100"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <circle cx="50" cy="50" r="50" fill={color || '#E61E29'} />
    <path
      d="M37.1875 71.9375H43.3125C45.0064 71.9375 46.375 70.5689 46.375 68.875C46.375 67.1811 45.0064 65.8125 43.3125 65.8125H37.1875C35.4964 65.8125 34.125 64.4411 34.125 62.75V38.25C34.125 36.5589 35.4964 35.1875 37.1875 35.1875H43.3125C45.0064 35.1875 46.375 33.8161 46.375 32.125C46.375 30.4339 45.0064 29.0625 43.3125 29.0625H37.1875C32.1133 29.0625 28 33.1758 28 38.25V62.75C28 67.8223 32.1133 71.9375 37.1875 71.9375ZM76.3109 48.8252L62.5201 35.8096C61.8526 35.18 60.874 35.0081 60.0318 35.3699C59.1894 35.7333 58.6432 36.5633 58.6432 37.4802L58.6344 44.3708L46.3844 44.3707C44.6914 44.3707 43.32 45.7421 43.32 47.4332V53.5582C43.32 55.2493 44.6924 56.6207 46.3844 56.6207L58.6344 56.6208L58.6432 63.4253C58.6432 64.3419 59.1894 65.1719 60.0318 65.5355C60.8743 65.8974 61.8531 65.7254 62.5201 65.0959L76.3109 52.0802C77.2297 51.3039 77.2297 49.6961 76.3109 48.8252Z"
      fill="white"
    />
  </svg>
);

export const UploadIcon = () => (
  <svg
    width="40"
    height="40"
    viewBox="0 0 40 40"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M22.5 8.53753V27.4994C22.5 28.8823 21.3828 29.9995 20 29.9995C18.6172 29.9995 17.5 28.8823 17.5 27.4994V8.53753L11.7656 14.2722C10.7891 15.2488 9.20313 15.2488 8.22656 14.2722C7.25 13.2956 7.25 11.7096 8.22656 10.7329L18.2266 0.732458C19.2031 -0.244153 20.7891 -0.244153 21.7656 0.732458L31.7656 10.7329C32.7422 11.7096 32.7422 13.2956 31.7656 14.2722C30.7891 15.2488 29.2031 15.2488 28.2266 14.2722L22.5 8.53753ZM5 27.4994H15C15 30.2573 17.2422 32.4996 20 32.4996C22.7578 32.4996 25 30.2573 25 27.4994H35C37.7578 27.4994 40 29.7417 40 32.4996V34.9998C40 37.7577 37.7578 40 35 40H5C2.24219 40 0 37.7577 0 34.9998V32.4996C0 29.7417 2.24219 27.4994 5 27.4994ZM33.75 35.6248C34.2473 35.6248 34.7242 35.4272 35.0758 35.0756C35.4275 34.7239 35.625 34.247 35.625 33.7497C35.625 33.2524 35.4275 32.7755 35.0758 32.4238C34.7242 32.0722 34.2473 31.8746 33.75 31.8746C33.2527 31.8746 32.7758 32.0722 32.4242 32.4238C32.0725 32.7755 31.875 33.2524 31.875 33.7497C31.875 34.247 32.0725 34.7239 32.4242 35.0756C32.7758 35.4272 33.2527 35.6248 33.75 35.6248Z"
      fill="#E61E29"
    />
  </svg>
);

export const DeleteIcon = () => (
  <svg
    width="101"
    height="101"
    viewBox="0 0 101 101"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <circle cx="50.3359" cy="50.3828" r="50" fill="#E61E29" />
    <path
      d="M43.2378 32.463C43.6695 31.6478 44.5569 31.1328 45.5242 31.1328H55.1492C56.1165 31.1328 57.0038 31.6478 57.4355 32.463L58.0111 33.5391H65.6855C67.1005 33.5391 68.2436 34.6166 68.2436 35.9453C68.2436 37.274 67.1005 38.3516 65.6855 38.3516H34.9878C33.5753 38.3516 32.4297 37.274 32.4297 35.9453C32.4297 34.6166 33.5753 33.5391 34.9878 33.5391H42.6622L43.2378 32.463ZM34.9159 40.7578H65.6855V64.8203C65.6855 67.4747 63.3912 69.6328 60.5692 69.6328H40.0322C37.2782 69.6328 34.9159 67.4747 34.9159 64.8203V40.7578ZM41.3112 46.7734V63.6172C41.3112 64.2789 41.9588 64.8203 42.5903 64.8203C43.3657 64.8203 43.8694 64.2789 43.8694 63.6172V46.7734C43.8694 46.1117 43.3657 45.5703 42.5903 45.5703C41.9588 45.5703 41.3112 46.1117 41.3112 46.7734ZM48.9856 46.7734V63.6172C48.9856 64.2789 49.6332 64.8203 50.2647 64.8203C51.0402 64.8203 51.6157 64.2789 51.6157 63.6172V46.7734C51.6157 46.1117 51.0402 45.5703 50.2647 45.5703C49.6332 45.5703 48.9856 46.1117 48.9856 46.7734ZM56.732 46.7734V63.6172C56.732 64.2789 57.3076 64.8203 58.0111 64.8203C58.7146 64.8203 59.2902 64.2789 59.2902 63.6172V46.7734C59.2902 46.1117 58.7146 45.5703 58.0111 45.5703C57.3076 45.5703 56.732 46.1117 56.732 46.7734Z"
      fill="white"
    />
  </svg>
);

export const ImagePlaceholderIcon = () => (
  <svg
    width="80"
    height="80"
    viewBox="0 0 80 80"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M0 15C0 9.48438 4.48438 5 10 5H70C75.5156 5 80 9.48438 80 15V65C80 70.5156 75.5156 75 70 75H10C4.48438 75 0 70.5156 0 65V15ZM50.5938 31.6406C49.8906 30.6094 48.7344 30 47.5 30C46.2656 30 45.0938 30.6094 44.4062 31.6406L30.8125 51.5781L26.6719 46.4062C25.9531 45.5156 24.875 45 23.75 45C22.625 45 21.5312 45.5156 20.8281 46.4062L10.8281 58.9062C9.92188 60.0312 9.75 61.5781 10.375 62.875C11 64.1719 12.3125 65 13.75 65H28.75H33.75H66.25C67.6406 65 68.9219 64.2344 69.5625 63C70.2031 61.7656 70.125 60.2812 69.3438 59.1406L50.5938 31.6406ZM17.5 30C19.4891 30 21.3968 29.2098 22.8033 27.8033C24.2098 26.3968 25 24.4891 25 22.5C25 20.5109 24.2098 18.6032 22.8033 17.1967C21.3968 15.7902 19.4891 15 17.5 15C15.5109 15 13.6032 15.7902 12.1967 17.1967C10.7902 18.6032 10 20.5109 10 22.5C10 24.4891 10.7902 26.3968 12.1967 27.8033C13.6032 29.2098 15.5109 30 17.5 30Z"
      fill="#4C4C4C"
    />
  </svg>
);

export const ImagePlaceholderCircle = ({
  width = '60',
  height = '60',
}: {
  width?: string;
  height?: string;
}) => (
  <svg
    width={width}
    height={height}
    viewBox="0 0 60 60"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <circle cx="30" cy="30" r="30" fill="#F2F2F2" />
    <path
      d="M15 20.709C15 18.6406 16.6816 16.959 18.75 16.959H41.25C43.3184 16.959 45 18.6406 45 20.709V39.459C45 41.5273 43.3184 43.209 41.25 43.209H18.75C16.6816 43.209 15 41.5273 15 39.459V20.709ZM33.9727 26.9492C33.709 26.5625 33.2754 26.334 32.8125 26.334C32.3496 26.334 31.9102 26.5625 31.6523 26.9492L26.5547 34.4258L25.002 32.4863C24.7324 32.1523 24.3281 31.959 23.9062 31.959C23.4844 31.959 23.0742 32.1523 22.8105 32.4863L19.0605 37.1738C18.7207 37.5957 18.6563 38.1758 18.8906 38.6621C19.125 39.1484 19.6172 39.459 20.1562 39.459H25.7812H27.6562H39.8438C40.3652 39.459 40.8457 39.1719 41.0859 38.709C41.3262 38.2461 41.2969 37.6895 41.0039 37.2617L33.9727 26.9492ZM21.5625 26.334C22.3084 26.334 23.0238 26.0377 23.5512 25.5102C24.0787 24.9828 24.375 24.2674 24.375 23.5215C24.375 22.7756 24.0787 22.0602 23.5512 21.5327C23.0238 21.0053 22.3084 20.709 21.5625 20.709C20.8166 20.709 20.1012 21.0053 19.5738 21.5327C19.0463 22.0602 18.75 22.7756 18.75 23.5215C18.75 24.2674 19.0463 24.9828 19.5738 25.5102C20.1012 26.0377 20.8166 26.334 21.5625 26.334Z"
      fill="#A9A9A9"
    />
  </svg>
);

export const CalendarIcon = () => (
  <svg
    width="32"
    height="32"
    viewBox="0 0 32 32"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <circle cx="16" cy="16" r="16" fill="#E61E29" />
    <g clipPath="url(#clip0_2625_3081)">
      <path
        d="M13 8C13.5531 8 14 8.41895 14 8.9375V9.875H18V8.9375C18 8.41895 18.4469 8 19 8C19.5531 8 20 8.41895 20 8.9375V9.875H21.5C22.3281 9.875 23 10.5049 23 11.2812V12.6875H9V11.2812C9 10.5049 9.67188 9.875 10.5 9.875H12V8.9375C12 8.41895 12.4469 8 13 8ZM9 13.625H23V21.5938C23 22.3701 22.3281 23 21.5 23H10.5C9.67188 23 9 22.3701 9 21.5938V13.625ZM11 15.9688V16.9062C11 17.1641 11.225 17.375 11.5 17.375H12.5C12.775 17.375 13 17.1641 13 16.9062V15.9688C13 15.7109 12.775 15.5 12.5 15.5H11.5C11.225 15.5 11 15.7109 11 15.9688ZM15 15.9688V16.9062C15 17.1641 15.225 17.375 15.5 17.375H16.5C16.775 17.375 17 17.1641 17 16.9062V15.9688C17 15.7109 16.775 15.5 16.5 15.5H15.5C15.225 15.5 15 15.7109 15 15.9688ZM19.5 15.5C19.225 15.5 19 15.7109 19 15.9688V16.9062C19 17.1641 19.225 17.375 19.5 17.375H20.5C20.775 17.375 21 17.1641 21 16.9062V15.9688C21 15.7109 20.775 15.5 20.5 15.5H19.5ZM11 19.7188V20.6562C11 20.9141 11.225 21.125 11.5 21.125H12.5C12.775 21.125 13 20.9141 13 20.6562V19.7188C13 19.4609 12.775 19.25 12.5 19.25H11.5C11.225 19.25 11 19.4609 11 19.7188ZM15.5 19.25C15.225 19.25 15 19.4609 15 19.7188V20.6562C15 20.9141 15.225 21.125 15.5 21.125H16.5C16.775 21.125 17 20.9141 17 20.6562V19.7188C17 19.4609 16.775 19.25 16.5 19.25H15.5ZM19 19.7188V20.6562C19 20.9141 19.225 21.125 19.5 21.125H20.5C20.775 21.125 21 20.9141 21 20.6562V19.7188C21 19.4609 20.775 19.25 20.5 19.25H19.5C19.225 19.25 19 19.4609 19 19.7188Z"
        fill="white"
      />
    </g>
    <defs>
      <clipPath id="clip0_2625_3081">
        <rect width="14" height="15" fill="white" transform="translate(9 8)" />
      </clipPath>
    </defs>
  </svg>
);

export const ConciergeIcon = () => (
  <svg
    width="20"
    height="22"
    viewBox="0 0 20 22"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clipPath="url(#clip0_2841_2711)">
      <path
        d="M10 11C8.48448 11 7.03103 10.4205 5.95939 9.38909C4.88775 8.35764 4.28571 6.95869 4.28571 5.5C4.28571 4.04131 4.88775 2.64236 5.95939 1.61091C7.03103 0.579463 8.48448 0 10 0C11.5155 0 12.969 0.579463 14.0406 1.61091C15.1122 2.64236 15.7143 4.04131 15.7143 5.5C15.7143 6.95869 15.1122 8.35764 14.0406 9.38909C12.969 10.4205 11.5155 11 10 11ZM9.33482 15.4344L8.50446 14.1023C8.21875 13.6426 8.5625 13.0625 9.11607 13.0625H10H10.8795C11.433 13.0625 11.7768 13.6469 11.4911 14.1023L10.6607 15.4344L12.1518 20.7582L13.7589 14.4461C13.8482 14.098 14.1964 13.8703 14.558 13.9605C17.6875 14.7168 20 17.441 20 20.6809C20 21.4113 19.3839 22 18.6295 22H12.7455C12.6518 22 12.567 21.9828 12.4866 21.9527L12.5 22H7.5L7.51339 21.9527C7.43304 21.9828 7.34375 22 7.25446 22H1.37054C0.616072 22 0 21.407 0 20.6809C0 17.4367 2.31696 14.7125 5.44196 13.9605C5.80357 13.8746 6.15179 14.1023 6.24107 14.4461L7.84821 20.7582L9.33929 15.4344H9.33482Z"
        fill="#E61E29"
      />
    </g>
    <defs>
      <clipPath id="clip0_2841_2711">
        <rect width="20" height="22" fill="white" />
      </clipPath>
    </defs>
  </svg>
);

export const PaymentTabletIcon = (props: React.SVGProps<SVGSVGElement>) => (
  <svg
    width="48"
    height="60"
    viewBox="0 0 48 60"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <g clipPath="url(#clip0_2558_3232)">
      <path
        d="M6.85714 0C3.075 0 0 3.36328 0 7.5V52.5C0 56.6367 3.075 60 6.85714 60H41.1429C44.925 60 48 56.6367 48 52.5V7.5C48 3.36328 44.925 0 41.1429 0H6.85714ZM18.8571 50.625H29.1429C30.0857 50.625 30.8571 51.4688 30.8571 52.5C30.8571 53.5312 30.0857 54.375 29.1429 54.375H18.8571C17.9143 54.375 17.1429 53.5312 17.1429 52.5C17.1429 51.4688 17.9143 50.625 18.8571 50.625Z"
        fill="#E61E29"
      />
      <rect
        x="5.33301"
        y="5.3335"
        width="37.3333"
        height="38.6667"
        rx="2"
        fill="#ffffff"
      />
    </g>
    <defs>
      <clipPath id="clip0_2558_3232">
        <rect width="48" height="60" fill="white" />
      </clipPath>
    </defs>
  </svg>
);

/** Font Awesome `chevron-right` (solid). Ends a row the merchant taps to pick it. */
export const ChatChoiceChevronIcon = ({ color }: { color?: string }) => (
  <svg width="8" height="13" viewBox="0 0 320 512" fill="none">
    <path
      d="M311.1 233.4c12.5 12.5 12.5 32.8 0 45.3l-192 192c-12.5 12.5-32.8 12.5-45.3 0s-12.5-32.8 0-45.3L243.2 256 73.9 86.6c-12.5-12.5-12.5-32.8 0-45.3s32.8-12.5 45.3 0l192 192z"
      fill={color || '#A9A9A9'}
    />
  </svg>
);

export const PaymentChevronIcon = () => (
  <svg
    width="15"
    height="24"
    viewBox="0 0 15 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M1.94043 10.9407C1.35449 11.5267 1.35449 12.4782 1.94043 13.0642L9.44043 20.5642C10.0264 21.1501 10.9779 21.1501 11.5639 20.5642C12.1498 19.9782 12.1498 19.0267 11.5639 18.4407L5.12324 12.0001L11.5592 5.55947C12.1451 4.97353 12.1451 4.02197 11.5592 3.43604C10.9732 2.8501 10.0217 2.8501 9.43574 3.43604L1.93574 10.936L1.94043 10.9407Z"
      fill="#E3E3E3"
    />
  </svg>
);

export const TermsIcon = () => (
  <svg
    width="19"
    height="21"
    viewBox="0 0 19 21"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clipPath="url(#clip0_3640_1397)">
      <path
        d="M4.07143 0C1.82366 0 0 1.76367 0 3.9375V17.0625C0 19.2363 1.82366 21 4.07143 21H16.2857H17.6429C18.3935 21 19 20.4135 19 19.6875C19 18.9615 18.3935 18.375 17.6429 18.375V15.75C18.3935 15.75 19 15.1635 19 14.4375V1.3125C19 0.586523 18.3935 0 17.6429 0H16.2857H4.07143ZM4.07143 15.75H14.9286V18.375H4.07143C3.32076 18.375 2.71429 17.7885 2.71429 17.0625C2.71429 16.3365 3.32076 15.75 4.07143 15.75ZM5.42857 5.90625C5.42857 5.54531 5.73393 5.25 6.10714 5.25H14.25C14.6232 5.25 14.9286 5.54531 14.9286 5.90625C14.9286 6.26719 14.6232 6.5625 14.25 6.5625H6.10714C5.73393 6.5625 5.42857 6.26719 5.42857 5.90625ZM6.10714 7.875H14.25C14.6232 7.875 14.9286 8.17031 14.9286 8.53125C14.9286 8.89219 14.6232 9.1875 14.25 9.1875H6.10714C5.73393 9.1875 5.42857 8.89219 5.42857 8.53125C5.42857 8.17031 5.73393 7.875 6.10714 7.875Z"
        fill="white"
      />
    </g>
    <defs>
      <clipPath id="clip0_3640_1397">
        <rect width="19" height="21" fill="white" />
      </clipPath>
    </defs>
  </svg>
);

export const PrivacyIcon = () => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clipPath="url(#clip0_3640_1494)">
      <path
        d="M12 0C12.2156 0 12.4313 0.046875 12.6281 0.135937L21.4547 3.88125C22.486 4.31719 23.2547 5.33437 23.25 6.5625C23.2266 11.2125 21.3141 19.7203 13.2375 23.5875C12.4547 23.9625 11.5453 23.9625 10.7625 23.5875C2.68596 19.7203 0.773459 11.2125 0.750021 6.5625C0.745334 5.33437 1.51408 4.31719 2.54533 3.88125L11.3766 0.135937C11.5688 0.046875 11.7844 0 12 0ZM12 3.13125V20.85C18.4688 17.7187 20.2078 10.7859 20.25 6.62812L12 3.13125Z"
        fill="white"
      />
    </g>
    <defs>
      <clipPath id="clip0_3640_1494">
        <rect width="24" height="24" fill="white" />
      </clipPath>
    </defs>
  </svg>
);

export const PayoutsIcon = () => (
  <svg
    width="24"
    height="21"
    viewBox="0 0 24 21"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M23.6796 13.7936C23.1329 13.0631 22.0902 12.9052 21.3488 13.4462L16.3603 17.0625H11.3343C10.9697 17.0625 10.705 16.7652 10.705 16.4067C10.705 16.0478 11.0072 15.7505 11.3343 15.7505H14.5954C15.2246 15.7505 15.8769 15.3042 15.986 14.6586C16.1215 13.8383 15.4809 13.1255 14.6683 13.1255H7.96406C6.87635 13.1255 5.75029 13.5048 4.87512 14.2021L2.93724 15.75L0.62929 15.7131C0.302184 15.7131 0 16.0494 0 16.4062V20.3429C0 20.7047 0.302184 21 0.62929 21H15.0529C15.971 21 16.8833 20.7052 17.6243 20.1686L23.2546 16.0867C24.0672 15.549 24.2256 14.5236 23.6796 13.7936ZM11.6398 7.17773C11.323 7.13262 10.9063 6.98496 10.5396 6.85371L10.3354 6.78398C9.81442 6.5666 9.24348 6.87012 9.06011 7.3459C8.87674 7.82168 9.1485 8.42051 9.66814 8.60262L9.86214 8.67054C10.2158 8.79609 10.6073 8.92053 11.0036 9.01146V9.51562C11.0036 10.0591 11.4508 10.5 12.003 10.5C12.5552 10.5 13.0032 10.0591 13.0032 9.51562V9.08906C14.0563 8.85433 14.7902 8.19287 14.9244 7.21383C15.2865 5.161 13.3036 4.60277 12.2397 4.30377L12.019 4.22871C10.923 3.92273 10.9855 3.79066 11.0147 3.62209C11.0628 3.34458 11.6523 3.20947 12.357 3.31894C12.5628 3.35099 12.8308 3.42341 13.1759 3.54133C13.6981 3.71692 14.2682 3.4465 14.4478 2.93266C14.6274 2.41881 14.3516 1.85846 13.8294 1.68045C13.5126 1.5727 13.2493 1.50171 13.0034 1.4458V0.984375C13.0034 0.440918 12.5554 0 12.0032 0C11.451 0 11.0038 0.440918 11.0038 0.984375V1.41586C9.95195 1.65006 9.2143 2.30713 9.00593 3.28658C8.68503 5.31562 10.6979 5.89805 11.4564 6.11953L11.7272 6.19644C13.0466 6.56812 13.0254 6.68411 12.9916 6.87894C12.9442 7.15723 12.3566 7.29258 11.6398 7.17773Z"
      fill="#F2F2F2"
    />
  </svg>
);

export const GrubconLogo = (props: React.SVGProps<SVGSVGElement>) => (
  <svg
    width="171"
    height="52"
    viewBox="0 0 171 52"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <g clipPath="url(#clip0_3210_3323)">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M32.1902 20.1312H38.9093C36.7217 15.0595 31.6693 11.5039 25.7835 11.5039C17.8663 11.5039 11.5117 17.9352 11.5117 25.8306C11.5117 33.7782 17.9184 40.1572 25.7835 40.1572C31.6693 40.1572 36.6696 36.6017 38.9093 31.5299H32.1902C30.6276 33.3076 28.3357 34.4057 25.7835 34.4057C21.0436 34.4057 17.1892 30.5364 17.1892 25.7783C17.1892 21.0202 21.0436 17.1509 25.7835 17.1509C28.3357 17.2032 30.6276 18.3535 32.1902 20.1312Z"
        fill="#737373"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M33.8563 28.7056H39.7421H45.5237C45.3675 29.6991 45.1591 30.6402 44.8987 31.5814C42.4506 39.895 34.7939 45.908 25.7308 45.908C14.6885 45.908 5.72953 36.9146 5.72953 25.8298C5.72953 14.745 14.6885 5.75157 25.7308 5.75157C34.7939 5.75157 42.4506 11.8169 44.8987 20.0782H50.7845C48.1801 8.57509 37.9712 0 25.7308 0C11.5111 0 0 11.5554 0 25.8298C0 40.1041 11.5111 51.6596 25.7308 51.6596C37.9712 51.6596 48.2322 43.0845 50.7845 31.5814C50.9928 30.6402 51.1491 29.6991 51.2533 28.7056C51.3574 27.7644 51.4095 26.8232 51.4095 25.8298C51.4095 24.8363 51.3574 23.8951 51.2533 22.954H45.5237H39.7421H33.8563H25.7829V28.7056H33.8563Z"
        fill="#C28831"
      />
      <path
        d="M71.626 26.5087C70.5517 26.5087 69.5551 26.3398 68.6361 26.002C67.7171 25.6512 66.9211 25.1574 66.2481 24.5208C65.5879 23.8841 65.0702 23.137 64.6949 22.2795C64.3195 21.409 64.1318 20.454 64.1318 19.4145C64.1318 18.375 64.3195 17.4266 64.6949 16.569C65.0702 15.6985 65.5944 14.9449 66.2675 14.3082C66.9405 13.6716 67.7365 13.1844 68.6555 12.8465C69.5874 12.4957 70.6035 12.3203 71.7036 12.3203C72.985 12.3203 74.1305 12.5347 75.1401 12.9635C76.1496 13.3922 76.9845 14.0094 77.6446 14.815L75.1983 17.0368C74.7323 16.5301 74.2276 16.1532 73.6839 15.9064C73.1532 15.6465 72.5579 15.5166 71.8978 15.5166C71.3153 15.5166 70.7846 15.6075 70.3058 15.7894C69.8269 15.9714 69.4192 16.2377 69.0826 16.5885C68.7461 16.9264 68.4808 17.3356 68.2866 17.8164C68.1054 18.2841 68.0148 18.8168 68.0148 19.4145C68.0148 19.9862 68.1054 20.5124 68.2866 20.9932C68.4808 21.4739 68.7461 21.8897 69.0826 22.2405C69.4192 22.5783 69.8204 22.8447 70.2863 23.0396C70.7652 23.2215 71.2894 23.3124 71.8589 23.3124C72.4285 23.3124 72.985 23.2215 73.5286 23.0396C74.0722 22.8447 74.6223 22.5199 75.1789 22.0651L77.3339 24.7741C76.5573 25.3328 75.6575 25.7616 74.6353 26.0604C73.6128 26.3593 72.6096 26.5087 71.626 26.5087ZM73.9363 24.2674V19.1222H77.3339V24.7741L73.9363 24.2674ZM79.7712 26.2358V12.5932H85.984C87.2265 12.5932 88.2944 12.7946 89.1874 13.1973C90.0932 13.6001 90.7922 14.1848 91.2842 14.9514C91.7756 15.705 92.022 16.6015 92.022 17.641C92.022 18.6674 91.7756 19.5575 91.2842 20.311C90.7922 21.0516 90.0932 21.6233 89.1874 22.0261C88.2944 22.4159 87.2265 22.6108 85.984 22.6108H81.9069L83.6154 20.9932V26.2358H79.7712ZM88.1779 26.2358L84.7997 21.266H88.8962L92.2938 26.2358H88.1779ZM83.6154 21.4024L81.9069 19.6289H85.751C86.553 19.6289 87.1489 19.4535 87.5372 19.1027C87.9382 18.7519 88.139 18.2646 88.139 17.641C88.139 17.0043 87.9382 16.5106 87.5372 16.1598C87.1489 15.8089 86.553 15.6335 85.751 15.6335H81.9069L83.6154 13.86V21.4024ZM100.414 26.5087C98.4073 26.5087 96.8414 25.9565 95.7153 24.8521C94.5892 23.7477 94.0262 22.182 94.0262 20.1551V12.5932H97.8704V20.0382C97.8704 21.2075 98.0966 22.0456 98.5499 22.5523C99.0158 23.059 99.6498 23.3124 100.453 23.3124C101.255 23.3124 101.883 23.059 102.336 22.5523C102.789 22.0456 103.015 21.2075 103.015 20.0382V12.5932H106.801V20.1551C106.801 22.182 106.238 23.7477 105.112 24.8521C103.986 25.9565 102.42 26.5087 100.414 26.5087ZM109.405 26.2358V12.5932H116.356C118.142 12.5932 119.475 12.9245 120.355 13.5871C121.235 14.2368 121.675 15.0943 121.675 16.1598C121.675 16.8614 121.488 17.4785 121.112 18.0113C120.75 18.531 120.233 18.9468 119.559 19.2586C118.899 19.5574 118.11 19.7068 117.19 19.7068L117.579 18.7713C118.537 18.7713 119.372 18.9207 120.083 19.2196C120.796 19.5054 121.345 19.9278 121.733 20.4864C122.135 21.0321 122.335 21.7013 122.335 22.4938C122.335 23.6762 121.857 24.5987 120.899 25.2614C119.954 25.911 118.569 26.2358 116.744 26.2358H109.405ZM113.21 23.4488H116.433C117.093 23.4488 117.592 23.3384 117.928 23.1175C118.278 22.8836 118.452 22.5328 118.452 22.0651C118.452 21.5973 118.278 21.253 117.928 21.0321C117.592 20.7983 117.093 20.6813 116.433 20.6813H112.939V18.0113H115.851C116.498 18.0113 116.984 17.9008 117.307 17.6799C117.631 17.459 117.792 17.1277 117.792 16.686C117.792 16.2442 117.631 15.9194 117.307 15.7115C116.984 15.4906 116.498 15.3802 115.851 15.3802H113.21V23.4488Z"
        fill="#C28831"
      />
      <path
        d="M131.103 26.5087C130.028 26.5087 129.031 26.3398 128.113 26.002C127.206 25.6512 126.417 25.1574 125.744 24.5208C125.084 23.8841 124.566 23.137 124.191 22.2795C123.815 21.409 123.628 20.454 123.628 19.4145C123.628 18.375 123.815 17.4266 124.191 16.569C124.566 15.6985 125.084 14.9449 125.744 14.3082C126.417 13.6716 127.206 13.1844 128.113 12.8465C129.031 12.4957 130.028 12.3203 131.103 12.3203C132.358 12.3203 133.477 12.5412 134.461 12.983C135.458 13.4247 136.286 14.0614 136.947 14.8929L134.5 17.1147C134.06 16.595 133.574 16.1987 133.044 15.9259C132.526 15.653 131.943 15.5166 131.297 15.5166C130.74 15.5166 130.229 15.6075 129.763 15.7894C129.297 15.9714 128.895 16.2377 128.559 16.5885C128.235 16.9264 127.977 17.3356 127.783 17.8164C127.601 18.2971 127.511 18.8298 127.511 19.4145C127.511 19.9992 127.601 20.5319 127.783 21.0126C127.977 21.4934 128.235 21.9092 128.559 22.26C128.895 22.5978 129.297 22.8576 129.763 23.0396C130.229 23.2215 130.74 23.3124 131.297 23.3124C131.943 23.3124 132.526 23.176 133.044 22.9031C133.574 22.6303 134.06 22.234 134.5 21.7143L136.947 23.9361C136.286 24.7546 135.458 25.3913 134.461 25.846C133.477 26.2878 132.358 26.5087 131.103 26.5087ZM145.229 26.5087C144.142 26.5087 143.139 26.3333 142.22 25.9825C141.301 25.6317 140.499 25.1379 139.812 24.5013C139.14 23.8516 138.615 23.098 138.24 22.2405C137.865 21.3829 137.677 20.4409 137.677 19.4145C137.677 18.3881 137.865 17.4461 138.24 16.5885C138.615 15.731 139.14 14.9839 139.812 14.3472C140.499 13.6975 141.301 13.1973 142.22 12.8465C143.139 12.4957 144.142 12.3203 145.229 12.3203C146.33 12.3203 147.333 12.4957 148.238 12.8465C149.158 13.1973 149.954 13.6975 150.627 14.3472C151.3 14.9839 151.824 15.731 152.199 16.5885C152.587 17.4461 152.782 18.3881 152.782 19.4145C152.782 20.4409 152.587 21.3895 152.199 22.26C151.824 23.1175 151.3 23.8646 150.627 24.5013C149.954 25.1379 149.158 25.6317 148.238 25.9825C147.333 26.3333 146.33 26.5087 145.229 26.5087ZM145.229 23.3124C145.747 23.3124 146.226 23.2215 146.666 23.0396C147.119 22.8576 147.507 22.5978 147.831 22.26C148.168 21.9092 148.427 21.4934 148.607 21.0126C148.802 20.5319 148.899 19.9992 148.899 19.4145C148.899 18.8168 148.802 18.2841 148.607 17.8164C148.427 17.3356 148.168 16.9264 147.831 16.5885C147.507 16.2377 147.119 15.9714 146.666 15.7894C146.226 15.6075 145.747 15.5166 145.229 15.5166C144.712 15.5166 144.226 15.6075 143.773 15.7894C143.333 15.9714 142.945 16.2377 142.608 16.5885C142.285 16.9264 142.026 17.3356 141.832 17.8164C141.651 18.2841 141.56 18.8168 141.56 19.4145C141.56 19.9992 141.651 20.5319 141.832 21.0126C142.026 21.4934 142.285 21.9092 142.608 22.26C142.945 22.5978 143.333 22.8576 143.773 23.0396C144.226 23.2215 144.712 23.3124 145.229 23.3124ZM154.795 26.2358V12.5932H157.96L165.454 21.6753H163.959V12.5932H167.726V26.2358H164.561L157.067 17.1537H158.562V26.2358H154.795Z"
        fill="#737373"
      />
      <path
        d="M64.9238 38.9796V34.2571H66.7585C67.1707 34.2571 67.5224 34.3223 67.8137 34.4527C68.1049 34.5832 68.3289 34.7721 68.4857 35.0194C68.6425 35.2668 68.7209 35.5614 68.7209 35.9032C68.7209 36.245 68.6425 36.5396 68.4857 36.787C68.3289 37.0299 68.1049 37.2165 67.8137 37.3469C67.5224 37.4774 67.1707 37.5426 66.7585 37.5426H65.2935L65.5959 37.2322V38.9796H64.9238ZM68.069 38.9796L66.8728 37.266H67.5919L68.8016 38.9796H68.069ZM65.5959 37.2997L65.2935 36.9691H66.7384C67.1685 36.9691 67.4933 36.8769 67.7128 36.6925C67.9369 36.5036 68.0489 36.2405 68.0489 35.9032C68.0489 35.5659 67.9369 35.305 67.7128 35.1206C67.4933 34.9362 67.1685 34.844 66.7384 34.844H65.2935L65.5959 34.5067V37.2997ZM71.165 36.2945H73.5844V36.8679H71.165V36.2945ZM71.2255 38.3926H73.9675V38.9796H70.5535V34.2571H73.8734V34.844H71.2255V38.3926ZM77.1731 39.0335C76.8147 39.0335 76.4719 38.9796 76.1449 38.8716C75.8178 38.7592 75.5602 38.6153 75.372 38.4398L75.6207 37.9136C75.7999 38.071 76.0284 38.2015 76.3062 38.3049C76.5839 38.4084 76.8729 38.4601 77.1731 38.4601C77.4464 38.4601 77.6682 38.4286 77.8384 38.3656C78.0087 38.3027 78.1341 38.2172 78.2148 38.1093C78.2954 37.9968 78.3358 37.8709 78.3358 37.7315C78.3358 37.5696 78.282 37.4391 78.1745 37.3402C78.0714 37.2412 77.9348 37.1625 77.7645 37.1041C77.5987 37.0411 77.415 36.9871 77.2134 36.9422C77.0118 36.8972 76.808 36.8455 76.6019 36.787C76.4002 36.724 76.2143 36.6453 76.0441 36.5509C75.8783 36.4564 75.7439 36.3305 75.6408 36.1731C75.5378 36.0112 75.4862 35.8043 75.4862 35.5524C75.4862 35.3095 75.549 35.0869 75.6744 34.8845C75.8044 34.6776 76.0015 34.5135 76.2658 34.392C76.5347 34.2661 76.8752 34.2031 77.2874 34.2031C77.5607 34.2031 77.8317 34.2391 78.1005 34.3111C78.3694 34.383 78.6023 34.4865 78.7995 34.6214L78.5777 35.1611C78.3761 35.0262 78.1633 34.9295 77.9392 34.871C77.7152 34.8081 77.4979 34.7766 77.2874 34.7766C77.023 34.7766 76.8057 34.8103 76.6355 34.8778C76.4652 34.9452 76.3398 35.0352 76.2591 35.1476C76.1829 35.2601 76.1449 35.386 76.1449 35.5254C76.1449 35.6918 76.1964 35.8245 76.2994 35.9235C76.407 36.0224 76.5436 36.1011 76.7094 36.1596C76.8796 36.218 77.0656 36.272 77.2672 36.3215C77.4688 36.3665 77.6704 36.4182 77.872 36.4767C78.0781 36.5351 78.2641 36.6116 78.4298 36.706C78.6001 36.8005 78.7367 36.9264 78.8398 37.0838C78.9428 37.2412 78.9944 37.4436 78.9944 37.691C78.9944 37.9294 78.9294 38.152 78.7995 38.3589C78.6695 38.5613 78.4679 38.7254 78.1946 38.8514C77.9258 38.9728 77.5853 39.0335 77.1731 39.0335ZM81.5915 38.9796V34.844H79.9786V34.2571H83.8697V34.844H82.2568V38.9796H81.5915ZM84.3999 38.9796L86.5303 34.2571H87.1956L89.3328 38.9796H88.6271L86.7252 34.6349H86.994L85.0921 38.9796H84.3999ZM85.3072 37.7989L85.4886 37.2592H88.1365L88.3314 37.7989H85.3072ZM92.6318 39.0335C92.0135 39.0335 91.5274 38.8559 91.1734 38.5006C90.8195 38.1453 90.6425 37.6258 90.6425 36.9422V34.2571H91.3146V36.9152C91.3146 37.4414 91.4288 37.8259 91.6573 38.0688C91.8903 38.3117 92.2174 38.4331 92.6385 38.4331C93.0642 38.4331 93.3912 38.3117 93.6197 38.0688C93.8527 37.8259 93.9692 37.4414 93.9692 36.9152V34.2571H94.6211V36.9422C94.6211 37.6258 94.4441 38.1453 94.0902 38.5006C93.7407 38.8559 93.2546 39.0335 92.6318 39.0335ZM96.7455 38.9796V34.2571H98.5802C98.9924 34.2571 99.3441 34.3223 99.6353 34.4527C99.9266 34.5832 100.151 34.7721 100.307 35.0194C100.464 35.2668 100.543 35.5614 100.543 35.9032C100.543 36.245 100.464 36.5396 100.307 36.787C100.151 37.0299 99.9266 37.2165 99.6353 37.3469C99.3441 37.4774 98.9924 37.5426 98.5802 37.5426H97.1151L97.4176 37.2322V38.9796H96.7455ZM99.8907 38.9796L98.6945 37.266H99.4136L100.623 38.9796H99.8907ZM97.4176 37.2997L97.1151 36.9691H98.5601C98.9902 36.9691 99.315 36.8769 99.5345 36.6925C99.7585 36.5036 99.8706 36.2405 99.8706 35.9032C99.8706 35.5659 99.7585 35.305 99.5345 35.1206C99.315 34.9362 98.9902 34.844 98.5601 34.844H97.1151L97.4176 34.5067V37.2997ZM101.663 38.9796L103.793 34.2571H104.458L106.596 38.9796H105.89L103.988 34.6349H104.257L102.355 38.9796H101.663ZM102.57 37.7989L102.751 37.2592H105.399L105.594 37.7989H102.57ZM108.044 38.9796V34.2571H108.595L111.707 38.1363H111.418V34.2571H112.09V38.9796H111.539L108.427 35.1004H108.716V38.9796H108.044ZM115.179 38.9796V34.844H113.566V34.2571H117.457V34.844H115.844V38.9796H115.179ZM123.591 39.0335C123.233 39.0335 122.901 38.9751 122.596 38.8581C122.296 38.7367 122.034 38.568 121.81 38.3521C121.591 38.1318 121.418 37.8754 121.293 37.5831C121.167 37.2907 121.104 36.9691 121.104 36.6183C121.104 36.2675 121.167 35.9459 121.293 35.6536C121.418 35.3613 121.593 35.1071 121.817 34.8913C122.041 34.6709 122.303 34.5022 122.603 34.3853C122.908 34.2638 123.239 34.2031 123.598 34.2031C123.961 34.2031 124.294 34.2661 124.599 34.392C124.908 34.5135 125.17 34.6956 125.385 34.9385L124.949 35.3635C124.769 35.1746 124.568 35.0352 124.344 34.9452C124.12 34.8508 123.88 34.8036 123.625 34.8036C123.36 34.8036 123.114 34.8485 122.885 34.9385C122.661 35.0284 122.466 35.1544 122.301 35.3163C122.135 35.4782 122.005 35.6716 121.911 35.8965C121.821 36.1168 121.776 36.3575 121.776 36.6183C121.776 36.8792 121.821 37.1221 121.911 37.3469C122.005 37.5673 122.135 37.7585 122.301 37.9204C122.466 38.0823 122.661 38.2082 122.885 38.2982C123.114 38.3881 123.36 38.4331 123.625 38.4331C123.88 38.4331 124.12 38.3881 124.344 38.2982C124.568 38.2037 124.769 38.0598 124.949 37.8664L125.385 38.2914C125.17 38.5343 124.908 38.7187 124.599 38.8446C124.294 38.9706 123.958 39.0335 123.591 39.0335ZM129.116 39.0335C128.758 39.0335 128.424 38.9728 128.115 38.8514C127.81 38.7299 127.546 38.5613 127.322 38.3454C127.098 38.125 126.923 37.8687 126.797 37.5763C126.672 37.284 126.609 36.9646 126.609 36.6183C126.609 36.272 126.672 35.9527 126.797 35.6603C126.923 35.368 127.098 35.1139 127.322 34.898C127.546 34.6776 127.81 34.5067 128.115 34.3853C128.419 34.2638 128.753 34.2031 129.116 34.2031C129.474 34.2031 129.804 34.2638 130.104 34.3853C130.409 34.5022 130.673 34.6709 130.897 34.8913C131.125 35.1071 131.3 35.3613 131.421 35.6536C131.547 35.9459 131.609 36.2675 131.609 36.6183C131.609 36.9691 131.547 37.2907 131.421 37.5831C131.3 37.8754 131.125 38.1318 130.897 38.3521C130.673 38.568 130.409 38.7367 130.104 38.8581C129.804 38.9751 129.474 39.0335 129.116 39.0335ZM129.116 38.4331C129.376 38.4331 129.616 38.3881 129.835 38.2982C130.059 38.2082 130.252 38.0823 130.413 37.9204C130.579 37.754 130.707 37.5606 130.796 37.3402C130.89 37.1198 130.937 36.8792 130.937 36.6183C130.937 36.3575 130.89 36.1168 130.796 35.8965C130.707 35.6761 130.579 35.4849 130.413 35.323C130.252 35.1566 130.059 35.0284 129.835 34.9385C129.616 34.8485 129.376 34.8036 129.116 34.8036C128.852 34.8036 128.608 34.8485 128.383 34.9385C128.164 35.0284 127.971 35.1566 127.806 35.323C127.64 35.4849 127.51 35.6761 127.416 35.8965C127.326 36.1168 127.281 36.3575 127.281 36.6183C127.281 36.8792 127.326 37.1198 127.416 37.3402C127.51 37.5606 127.64 37.754 127.806 37.9204C127.971 38.0823 128.164 38.2082 128.383 38.2982C128.608 38.3881 128.852 38.4331 129.116 38.4331ZM133.384 38.9796V34.2571H133.935L137.046 38.1363H136.757V34.2571H137.429V38.9796H136.878L133.767 35.1004H134.056V38.9796H133.384ZM141.687 39.0335C141.329 39.0335 140.997 38.9751 140.693 38.8581C140.392 38.7367 140.13 38.568 139.906 38.3521C139.687 38.1318 139.514 37.8754 139.389 37.5831C139.263 37.2907 139.201 36.9691 139.201 36.6183C139.201 36.2675 139.263 35.9459 139.389 35.6536C139.514 35.3613 139.689 35.1071 139.913 34.8913C140.137 34.6709 140.399 34.5022 140.699 34.3853C141.004 34.2638 141.335 34.2031 141.694 34.2031C142.057 34.2031 142.391 34.2661 142.695 34.392C143.004 34.5135 143.266 34.6956 143.482 34.9385L143.045 35.3635C142.865 35.1746 142.664 35.0352 142.44 34.9452C142.216 34.8508 141.976 34.8036 141.721 34.8036C141.456 34.8036 141.21 34.8485 140.981 34.9385C140.757 35.0284 140.563 35.1544 140.397 35.3163C140.231 35.4782 140.101 35.6716 140.007 35.8965C139.917 36.1168 139.873 36.3575 139.873 36.6183C139.873 36.8792 139.917 37.1221 140.007 37.3469C140.101 37.5673 140.231 37.7585 140.397 37.9204C140.563 38.0823 140.757 38.2082 140.981 38.2982C141.21 38.3881 141.456 38.4331 141.721 38.4331C141.976 38.4331 142.216 38.3881 142.44 38.2982C142.664 38.2037 142.865 38.0598 143.045 37.8664L143.482 38.2914C143.266 38.5343 143.004 38.7187 142.695 38.8446C142.391 38.9706 142.055 39.0335 141.687 39.0335ZM145.187 38.9796V34.2571H145.859V38.9796H145.187ZM148.626 36.2945H151.045V36.8679H148.626V36.2945ZM148.686 38.3926H151.428V38.9796H148.014V34.2571H151.334V34.844H148.686V38.3926ZM153.264 38.9796V34.2571H155.098C155.511 34.2571 155.862 34.3223 156.153 34.4527C156.445 34.5832 156.669 34.7721 156.826 35.0194C156.982 35.2668 157.061 35.5614 157.061 35.9032C157.061 36.245 156.982 36.5396 156.826 36.787C156.669 37.0299 156.445 37.2165 156.153 37.3469C155.862 37.4774 155.511 37.5426 155.098 37.5426H153.633L153.936 37.2322V38.9796H153.264ZM156.409 38.9796L155.213 37.266H155.932L157.141 38.9796H156.409ZM153.936 37.2997L153.633 36.9691H155.078C155.508 36.9691 155.833 36.8769 156.053 36.6925C156.277 36.5036 156.389 36.2405 156.389 35.9032C156.389 35.5659 156.277 35.305 156.053 35.1206C155.833 34.9362 155.508 34.844 155.078 34.844H153.633L153.936 34.5067V37.2997ZM161.017 39.0335C160.654 39.0335 160.32 38.9751 160.016 38.8581C159.711 38.7367 159.447 38.568 159.222 38.3521C158.998 38.1318 158.824 37.8754 158.698 37.5831C158.573 37.2907 158.51 36.9691 158.51 36.6183C158.51 36.2675 158.573 35.9459 158.698 35.6536C158.824 35.3613 158.998 35.1071 159.222 34.8913C159.451 34.6709 159.718 34.5022 160.022 34.3853C160.327 34.2638 160.663 34.2031 161.03 34.2031C161.402 34.2031 161.743 34.2638 162.052 34.3853C162.361 34.5067 162.623 34.6889 162.838 34.9317L162.421 35.35C162.229 35.1611 162.018 35.0239 161.79 34.9385C161.566 34.8485 161.322 34.8036 161.057 34.8036C160.788 34.8036 160.537 34.8485 160.304 34.9385C160.076 35.0284 159.877 35.1544 159.706 35.3163C159.541 35.4782 159.411 35.6716 159.317 35.8965C159.227 36.1168 159.182 36.3575 159.182 36.6183C159.182 36.8747 159.227 37.1153 159.317 37.3402C159.411 37.5606 159.541 37.754 159.706 37.9204C159.877 38.0823 160.076 38.2082 160.304 38.2982C160.533 38.3881 160.782 38.4331 161.05 38.4331C161.301 38.4331 161.541 38.3949 161.77 38.3184C162.003 38.2375 162.218 38.1048 162.415 37.9204L162.798 38.4331C162.565 38.631 162.292 38.7817 161.978 38.8851C161.669 38.9841 161.348 39.0335 161.017 39.0335ZM162.153 38.3454V36.5913H162.798V38.4331L162.153 38.3454ZM165.443 36.2945H167.862V36.8679H165.443V36.2945ZM165.503 38.3926H168.245V38.9796H164.831V34.2571H168.151V34.844H165.503V38.3926Z"
        fill="#737373"
      />
    </g>
    <defs>
      <clipPath id="clip0_3210_3323">
        <rect width="171" height="51.7222" fill="white" />
      </clipPath>
    </defs>
  </svg>
);

export const InputSearchIcon = () => (
  <svg
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clipPath="url(#clip0_3690_2541)">
      <path
        d="M16.25 8.125C16.25 9.91797 15.668 11.5742 14.6875 12.918L19.6328 17.8672C20.1211 18.3555 20.1211 19.1484 19.6328 19.6367C19.1445 20.125 18.3516 20.125 17.8633 19.6367L12.918 14.6875C11.5742 15.6719 9.91797 16.25 8.125 16.25C3.63672 16.25 0 12.6133 0 8.125C0 3.63672 3.63672 0 8.125 0C12.6133 0 16.25 3.63672 16.25 8.125ZM8.125 13.75C8.86369 13.75 9.59514 13.6045 10.2776 13.3218C10.9601 13.0391 11.5801 12.6248 12.1025 12.1025C12.6248 11.5801 13.0391 10.9601 13.3218 10.2776C13.6045 9.59514 13.75 8.86369 13.75 8.125C13.75 7.38631 13.6045 6.65486 13.3218 5.97241C13.0391 5.28995 12.6248 4.66985 12.1025 4.14752C11.5801 3.62519 10.9601 3.21086 10.2776 2.92818C9.59514 2.64549 8.86369 2.5 8.125 2.5C7.38631 2.5 6.65486 2.64549 5.97241 2.92818C5.28995 3.21086 4.66985 3.62519 4.14752 4.14752C3.62519 4.66985 3.21086 5.28995 2.92818 5.97241C2.64549 6.65486 2.5 7.38631 2.5 8.125C2.5 8.86369 2.64549 9.59514 2.92818 10.2776C3.21086 10.9601 3.62519 11.5801 4.14752 12.1025C4.66985 12.6248 5.28995 13.0391 5.97241 13.3218C6.65486 13.6045 7.38631 13.75 8.125 13.75Z"
        fill="#4C4C4C"
      />
    </g>
    <defs>
      <clipPath id="clip0_3690_2541">
        <rect width="20" height="20" fill="white" />
      </clipPath>
    </defs>
  </svg>
);

export const AdminLogo = () => (
  <svg
    width="161"
    height="160"
    viewBox="0 0 161 160"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <circle cx="80.5" cy="80" r="80" fill="#E61E29" />
    <circle cx="80.5" cy="80" r="80" stroke="#E61E29" />
    <path
      d="M105.807 68.6303C105.656 68.5198 105.481 68.4409 105.295 68.399C105.109 68.3571 104.915 68.353 104.727 68.3872C104.448 68.4714 104.213 68.6518 104.07 68.8921L102.955 70.706L105.289 71.9776L106.419 70.1403C106.501 70.0197 106.551 69.8826 106.564 69.7403C106.578 69.598 106.556 69.4547 106.499 69.3222C106.361 69.023 106.116 68.7784 105.807 68.6303Z"
      fill="white"
    />
    <path
      d="M96.8067 86.5907C96.5979 86.3858 96.36 86.2126 96.1006 86.0767C95.859 85.9292 95.5968 85.8183 95.3224 85.7477C95.1265 85.6961 94.9205 85.6961 94.7246 85.7477C94.5543 85.7969 94.3986 85.8869 94.2711 86.0099C94.1315 86.1499 94.0103 86.3071 93.9103 86.4776L92.8384 88.3076L95.8481 90.045L96.9201 88.1945C97.0205 88.0248 97.0952 87.8412 97.1417 87.6496C97.1853 87.4811 97.1853 87.3042 97.1417 87.1356C97.0753 86.9299 96.9604 86.743 96.8067 86.5907Z"
      fill="white"
    />
    <path
      d="M109.96 70.0509C109.712 69.9079 109.429 69.8253 109.138 69.8107C108.886 69.8006 108.636 69.8592 108.419 69.9794C108.192 70.1013 108.004 70.2778 107.874 70.4906L106.567 72.612L109.356 74.1456L110.663 72.0242C110.807 71.8126 110.89 71.5694 110.903 71.3187C110.912 71.082 110.839 70.849 110.696 70.6541C110.502 70.4034 110.251 70.1972 109.96 70.0509Z"
      fill="white"
    />
    <path
      d="M128.379 49.0526C126.814 46.7728 124.71 44.9145 122.253 43.6425C119.796 42.3706 117.062 41.7246 114.295 41.7619H112.075C105.947 42.0198 100.599 46.0569 97.8574 51.5275L94.2074 57.7816C87.0315 70.0271 81.9463 78.8851 80.1238 81.226C78.503 83.3485 76.4102 85.0654 74.0107 86.2412C71.6113 87.417 68.971 88.0195 66.2983 88.001C64.2546 87.9714 62.2284 87.6199 60.2944 86.9594C52.9944 84.3556 48.2965 77.8435 48.2965 70.156C48.2965 64.8144 51.0377 60.3855 53.5158 56.6111C55.9988 52.7029 58.2087 49.3154 56.7735 45.928C56.0222 44.3232 54.7303 43.033 53.1235 42.2826C52.1979 41.827 51.1755 41.6024 50.1439 41.6279H47.7751C42.0393 41.6279 36.1695 44.4946 33.17 49.3154C31.5943 51.8016 30.7359 54.6737 30.6895 57.6157C30.6431 60.5577 31.4103 63.4554 32.9068 65.9899L66.8198 124.603C68.2561 127.062 70.3125 129.102 72.784 130.519C75.2555 131.937 78.0558 132.683 80.9059 132.683C83.756 132.683 86.5563 131.937 89.0279 130.519C91.4994 129.102 93.5557 127.062 94.992 124.603L128.9 65.9899C130.45 63.4144 131.224 60.448 131.132 57.4447C131.039 54.4415 130.084 51.5282 128.379 49.0526ZM97.8078 98.3518L96.9784 98.2328C96.9648 98.6993 96.9116 99.1639 96.8195 99.6215C96.7049 100.223 96.4865 100.801 96.174 101.328C95.883 101.878 95.449 102.341 94.9175 102.667C94.4369 102.931 93.8905 103.051 93.3433 103.014C92.6973 102.962 92.0637 102.808 91.4662 102.558C90.7186 102.253 89.9948 101.894 89.301 101.481C88.5759 101.074 87.8865 100.606 87.2401 100.083C86.7186 99.675 86.2817 99.1696 85.9539 98.5948C85.6692 98.0756 85.5481 97.4827 85.6063 96.8937C85.6922 96.1616 85.9416 95.4582 86.3363 94.8354C86.6044 94.3725 86.8676 93.9608 87.1259 93.6004C87.3841 93.2384 87.6225 92.9061 87.9105 92.6085C88.1985 92.3109 88.4568 92.0084 88.7448 91.7158L90.2892 92.6085C90.1551 92.7821 89.9813 93.0201 89.7926 93.3177C89.6039 93.6153 89.3556 93.9575 89.1073 94.3345C88.859 94.7114 88.6107 95.0983 88.3773 95.5149C88.0787 95.9532 87.9227 96.4727 87.9304 97.0028C87.9967 97.4745 88.2398 97.9035 88.6107 98.203C89.1936 98.7046 89.8278 99.1434 90.5028 99.5124C91.0312 99.8284 91.5803 100.108 92.1465 100.351C92.5106 100.511 92.9011 100.603 93.2986 100.623C93.5884 100.637 93.8741 100.552 94.1081 100.38C94.3625 100.18 94.5737 99.9303 94.7288 99.6463C94.9286 99.2905 95.0948 98.9169 95.2254 98.5304C95.3389 98.2269 95.4351 97.9172 95.5135 97.6029L93.5718 96.4523L92.514 98.2774L90.9298 97.3599C91.0143 97.1565 91.1235 96.9135 91.2576 96.6457C91.3917 96.3779 91.5307 96.0902 91.6847 95.7976C91.8386 95.505 91.9876 95.2272 92.1366 94.9693C92.2856 94.7114 92.4544 94.4188 92.5935 94.1956C92.7325 93.9724 92.8666 93.7641 92.9957 93.5855L98.6818 96.8788L97.8078 98.3518ZM102.724 89.8856L98.0809 89.35L97.8574 89.717C97.7681 89.8559 97.6886 89.9947 97.6042 90.1386L97.3509 90.5701C97.2665 90.7189 97.187 90.8429 97.1125 90.9569L100.847 93.1193L99.6849 95.1032L89.6635 89.3004L92.082 85.1839C92.2955 84.8076 92.5595 84.4622 92.8666 84.1572C93.1456 83.8772 93.4855 83.665 93.8598 83.5372C94.294 83.4096 94.7532 83.3926 95.1956 83.4876C95.8076 83.6201 96.3922 83.8567 96.9238 84.187C97.3236 84.4111 97.6925 84.6862 98.0213 85.0053C98.2653 85.241 98.4654 85.5181 98.6123 85.8237C98.7266 86.0761 98.7971 86.3461 98.8208 86.6222C98.836 86.8771 98.826 87.1329 98.791 87.3859L103.896 87.8422L102.724 89.8856ZM107.621 81.2756C107.422 81.8431 107.167 82.3896 106.861 82.9074C106.566 83.4267 106.22 83.9152 105.828 84.3655C105.486 84.763 105.069 85.0898 104.601 85.3277C104.138 85.5484 103.621 85.6327 103.111 85.5707C102.467 85.4825 101.849 85.2576 101.299 84.9111L94.5004 80.978L95.6625 78.9942L102.451 82.9024C102.747 83.0921 103.092 83.192 103.444 83.1901C103.76 83.1581 104.058 83.026 104.293 82.8131C104.593 82.5401 104.846 82.2201 105.043 81.8658C105.251 81.5243 105.401 81.1505 105.485 80.7598C105.554 80.4486 105.521 80.1234 105.391 79.8324C105.218 79.5193 104.955 79.2654 104.636 79.1033L97.8525 75.1752L99.0245 73.1616L105.823 77.0946C106.404 77.399 106.912 77.8254 107.313 78.3445C107.612 78.7557 107.793 79.2413 107.834 79.748C107.869 80.2665 107.796 80.7864 107.621 81.2756ZM112.373 73.2558L109.989 77.3624L99.968 71.5646L102.252 67.6266C102.828 66.6346 103.476 66.0428 104.194 65.851C104.595 65.7651 105.009 65.7603 105.411 65.837C105.814 65.9136 106.197 66.0702 106.538 66.2974C106.897 66.4976 107.218 66.7595 107.487 67.0711C107.711 67.3349 107.871 67.6474 107.953 67.9837C108.031 68.3114 108.019 68.6541 107.919 68.9756C108.103 68.7817 108.313 68.6147 108.544 68.4797C108.791 68.3415 109.06 68.2459 109.339 68.197C109.654 68.1479 109.976 68.158 110.287 68.2267C110.664 68.3109 111.024 68.4549 111.355 68.6532C111.932 68.9529 112.423 69.3951 112.78 69.9378C113.052 70.3943 113.152 70.9321 113.063 71.4555C112.947 72.0932 112.713 72.7037 112.373 73.2558ZM117.573 63.9663C117.387 64.6518 117.106 65.308 116.738 65.9155C116.589 66.1784 116.425 66.4412 116.242 66.709C116.058 66.9769 115.879 67.2447 115.685 67.5076C115.492 67.7704 115.298 68.0035 115.109 68.2515C114.921 68.4995 114.742 68.683 114.568 68.8566L112.984 67.939C113.168 67.6861 113.366 67.3935 113.585 67.0612C113.803 66.7289 114.022 66.3817 114.245 66.0147C114.469 65.6477 114.677 65.3005 114.871 64.9682C115.047 64.6722 115.19 64.3579 115.298 64.0308C115.375 63.7853 115.375 63.5224 115.298 63.2769C115.209 63.0344 115.032 62.8343 114.802 62.7165L114.434 62.5032C114.313 62.4219 114.175 62.3681 114.031 62.3458C113.887 62.3235 113.74 62.3333 113.6 62.3743C113.306 62.4857 113.065 62.7035 112.924 62.9843L112.428 63.8374C112.027 64.6517 111.354 65.3008 110.526 65.6725C109.811 65.9403 108.947 65.775 107.934 65.1765L107.437 64.8938C106.464 64.3284 105.912 63.6357 105.783 62.8157C105.697 61.8324 105.949 60.8491 106.498 60.0284C106.712 59.6599 106.944 59.3024 107.194 58.9571C107.437 58.6148 107.69 58.2875 107.934 57.9651C108.177 57.6428 108.4 57.3948 108.594 57.1815L110.178 58.099C109.91 58.4958 109.617 58.9422 109.294 59.4382C108.971 59.9341 108.683 60.3954 108.43 60.8269C108.27 61.1016 108.141 61.3926 108.043 61.6948C107.96 61.9343 107.96 62.1944 108.043 62.4338C108.165 62.6898 108.37 62.8976 108.624 63.024L108.897 63.1827C109.03 63.2771 109.183 63.3389 109.345 63.363C109.506 63.3872 109.671 63.373 109.826 63.3216C110.147 63.1617 110.408 62.9002 110.565 62.5776L111.142 61.5857C111.422 61.0557 111.834 60.6066 112.338 60.2813C112.768 60.0245 113.264 59.9019 113.764 59.9292C114.292 59.9773 114.802 60.147 115.253 60.4251L115.825 60.7574C116.481 61.0819 117.021 61.6018 117.369 62.2453C117.639 62.7767 117.711 63.3867 117.573 63.9663Z"
      fill="white"
    />
    <path
      d="M66.099 56.8018C63.526 56.8018 61.0108 57.586 58.8715 59.0553C56.7322 60.5245 55.065 62.6129 54.0805 65.0561C53.0961 67.4994 52.8388 70.1878 53.3411 72.7813C53.8435 75.3749 55.0828 77.7571 56.9026 79.6266C58.7223 81.4962 61.0406 82.7691 63.5642 83.2844C66.0879 83.7997 68.7035 83.5342 71.0804 82.5215C73.4572 81.5089 75.4884 79.7945 76.9172 77.5952C78.346 75.396 79.1081 72.8106 79.1071 70.1662C79.0726 66.6318 77.6909 63.2523 75.2587 60.7535C72.8265 58.2547 69.5378 56.8359 66.099 56.8018ZM67.9965 76.793H64.3779L60.5829 64.0333H63.5787L66.2019 73.6081L68.8006 64.0333H71.7425L67.9965 76.793Z"
      fill="white"
    />
  </svg>
);

export const Logout = ({ $color }: { $color?: string }) => (
  <svg
    width="15"
    height="15"
    viewBox="0 0 15 15"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clipPath="url(#clip0_1780_1813)">
      <path
        d="M14.7246 8.16211C15.0908 7.7959 15.0908 7.20117 14.7246 6.83496L10.9746 3.08496C10.6084 2.71875 10.0137 2.71875 9.64746 3.08496C9.28125 3.45117 9.28125 4.0459 9.64746 4.41211L11.7979 6.5625H5.625C5.10645 6.5625 4.6875 6.98145 4.6875 7.5C4.6875 8.01855 5.10645 8.4375 5.625 8.4375H11.7979L9.64746 10.5879C9.28125 10.9541 9.28125 11.5488 9.64746 11.915C10.0137 12.2812 10.6084 12.2812 10.9746 11.915L14.7246 8.16504V8.16211ZM4.6875 2.8125C5.20606 2.8125 5.625 2.39355 5.625 1.875C5.625 1.35645 5.20606 0.9375 4.6875 0.9375H2.8125C1.25977 0.9375 0 2.19727 0 3.75V11.25C0 12.8027 1.25977 14.0625 2.8125 14.0625H4.6875C5.20606 14.0625 5.625 13.6436 5.625 13.125C5.625 12.6064 5.20606 12.1875 4.6875 12.1875H2.8125C2.29395 12.1875 1.875 11.7686 1.875 11.25V3.75C1.875 3.23145 2.29395 2.8125 2.8125 2.8125H4.6875Z"
        fill={$color || 'white'}
      />
    </g>
    <defs>
      <clipPath id="clip0_1780_1813">
        <rect width="15" height="15" fill={$color || 'white'} />
      </clipPath>
    </defs>
  </svg>
);

export const LocationPinIcon = ({ color }: { color?: string }) => (
  <svg
    width="16"
    height="21"
    viewBox="0 0 16 21"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g opacity="1">
      <g clipPath="url(#clip0_11783_6606)">
        <path
          d="M6.81752 20C4.7616 17.4922 0.188965 11.4141 0.188965 8C0.188965 3.85781 3.57453 0.5 7.75095 0.5C11.9258 0.5 15.3129 3.85781 15.3129 8C15.3129 11.4141 10.7048 17.4922 8.68438 20C8.19994 20.5977 7.30196 20.5977 6.81752 20ZM7.75095 10.5C9.14125 10.5 10.2716 9.37891 10.2716 8C10.2716 6.62109 9.14125 5.5 7.75095 5.5C6.36065 5.5 5.23029 6.62109 5.23029 8C5.23029 9.37891 6.36065 10.5 7.75095 10.5Z"
          fill={color || '#A9A9A9'}
        />
      </g>
    </g>
    <defs>
      <clipPath id="clip0_11783_6606">
        <rect
          x="0.188965"
          y="0.5"
          width="15.124"
          height="20"
          rx="7.56198"
          fill="white"
        />
      </clipPath>
    </defs>
  </svg>
);

export const BrandsIcon = () => (
  <svg
    width="21"
    height="18"
    viewBox="0 0 21 18"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g opacity="1" clipPath="url(#clip0_11783_6614)">
      <path
        d="M17.3477 7.91094C17.2112 7.92754 17.0712 7.9375 16.9241 7.9375C16.0139 7.9375 15.2017 7.55898 14.645 6.97461C14.0884 7.55898 13.2762 7.9375 12.3624 7.9375C11.4487 7.9375 10.6365 7.55898 10.0798 6.97461C9.52318 7.55898 8.71446 7.9375 7.79722 7.9375C6.88698 7.9375 6.07477 7.55898 5.51813 6.97461C4.96148 7.55898 4.14927 7.9375 3.23413 7.9375C3.09199 7.9375 2.9488 7.92754 2.80981 7.91094C0.873107 7.66523 -0.0432586 5.50039 0.992488 3.94648L2.99956 0.935957C3.17811 0.665318 3.49704 0.5 3.83768 0.5H16.329C16.6686 0.5 16.9871 0.665285 17.1657 0.935957L19.1717 3.94648C20.2115 5.50371 19.2907 7.66523 17.3477 7.91094ZM17.4948 8.96348C17.6138 8.94687 17.7853 8.92031 17.9254 8.88711V15.375C17.9254 16.5471 16.9206 17.5 15.6848 17.5H4.48185C3.24463 17.5 2.24127 16.5471 2.24127 15.375V8.88711C2.37675 8.92031 2.51644 8.94687 2.66033 8.96348H2.66453C2.84867 8.98672 3.04053 9 3.23413 9C3.66964 9 4.08975 8.93691 4.48185 8.8207V13.25H15.6848V8.82402C16.0769 8.93691 16.4935 9 16.9241 9C17.1202 9 17.3092 8.98672 17.4948 8.96348Z"
        fill="#A9A9A9"
      />
    </g>
    <defs>
      <clipPath id="clip0_11783_6614">
        <rect
          width="20.1653"
          height="17"
          fill="white"
          transform="translate(0 0.5)"
        />
      </clipPath>
    </defs>
  </svg>
);

export const BrandsRedIcon = () => (
  <svg
    width="20"
    height="18"
    viewBox="0 0 20 18"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M17.2049 7.60234C17.0695 7.61895 16.9306 7.62891 16.7847 7.62891C15.882 7.62891 15.0764 7.25039 14.5243 6.66602C13.9722 7.25039 13.1667 7.62891 12.2604 7.62891C11.3542 7.62891 10.5486 7.25039 9.99655 6.66602C9.44447 7.25039 8.64238 7.62891 7.73266 7.62891C6.82988 7.62891 6.02433 7.25039 5.47224 6.66602C4.92016 7.25039 4.1146 7.62891 3.20697 7.62891C3.06599 7.62891 2.92398 7.61895 2.78613 7.60234C0.8653 7.35664 -0.0435544 5.1918 0.983702 3.63789L2.97433 0.627363C3.15141 0.356725 3.46773 0.191406 3.80558 0.191406H16.1945C16.5313 0.191406 16.8472 0.356691 17.0243 0.627363L19.0139 3.63789C20.0452 5.19512 19.132 7.35664 17.2049 7.60234ZM17.3507 8.65488C17.4688 8.63828 17.6389 8.61172 17.7778 8.57852V15.0664C17.7778 16.2385 16.7813 17.1914 15.5556 17.1914H4.44447C3.21738 17.1914 2.22224 16.2385 2.22224 15.0664V8.57852C2.35662 8.61172 2.49516 8.63828 2.63787 8.65488H2.64204C2.82467 8.67812 3.01495 8.69141 3.20697 8.69141C3.63891 8.69141 4.05558 8.62832 4.44447 8.51211V12.9414H15.5556V8.51543C15.9445 8.62832 16.3577 8.69141 16.7847 8.69141C16.9792 8.69141 17.1667 8.67812 17.3507 8.65488Z"
      fill="#E61E29"
    />
  </svg>
);

export const CalendarIconRed = ({ color }: { color?: string }) => (
  <svg
    width="20"
    height="23"
    viewBox="0 0 20 23"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clipPath="url(#clip0_11803_5586)">
      <path
        d="M4.26419 2.14537C4.26419 1.39239 4.87705 0.781738 5.63562 0.781738C6.39419 0.781738 7.00705 1.39239 7.00705 2.14537V3.50901H12.4928V2.14537C12.4928 1.39239 13.1056 0.781738 13.8642 0.781738C14.6228 0.781738 15.2356 1.39239 15.2356 2.14537V3.50901H17.2928C18.4285 3.50901 19.3499 4.42478 19.3499 5.55447V7.59992H0.149902V5.55447C0.149902 4.42478 1.0709 3.50901 2.20705 3.50901H4.26419V2.14537ZM19.3499 20.5545C19.3499 21.6837 18.4285 22.5999 17.2928 22.5999H2.20705C1.0709 22.5999 0.149902 21.6837 0.149902 20.5545V8.96356H19.3499V20.5545Z"
        fill={color || '#E61E29'}
      />
    </g>
    <defs>
      <clipPath id="clip0_11803_5586">
        <rect
          width="19.2"
          height="21.8182"
          fill="white"
          transform="translate(0.149902 0.781738)"
        />
      </clipPath>
    </defs>
  </svg>
);

export const DashboardIcon = () => (
  <svg
    width="24"
    height="23"
    viewBox="0 0 24 23"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clipPath="url(#clip0_12415_10292)">
      <path
        d="M23.9917 11.3613C23.9917 12.1348 23.3667 12.7406 22.6583 12.7406H21.325L21.3542 19.6199C21.3542 19.7402 21.3458 19.852 21.3333 19.968V20.6641C21.3333 21.6137 20.5875 22.3828 19.6667 22.3828H19C18.9542 22.3828 18.9083 22.3441 18.8625 22.3785C18.8042 22.3441 18.7458 22.3828 18.6875 22.3828H16.3333C15.4125 22.3828 14.6667 21.6137 14.6667 20.6641V16.8828C14.6667 16.1223 14.0708 15.5078 13.3333 15.5078H10.6667C9.92917 15.5078 9.33333 16.1223 9.33333 16.8828V20.6641C9.33333 21.6137 8.5875 22.3828 7.66667 22.3828H5.3375C5.275 22.3828 5.2125 22.3785 5.15 22.3742C5.1 22.3785 5.05 22.3828 5 22.3828H4.33333C3.41292 22.3828 2.66667 21.6137 2.66667 20.6641V15.8516C2.66667 15.8129 2.66792 15.7699 2.67042 15.7313V12.7406H1.33542C0.584167 12.7406 0 12.1348 0 11.3613C0 10.9746 0.125167 10.6309 0.417083 10.3301L11.1 0.72725C11.3917 0.425867 11.725 0.382812 12.0167 0.382812C12.3083 0.382812 12.6417 0.468922 12.8958 0.684195L23.5333 10.3301C23.8667 10.6309 24.0375 10.9746 23.9917 11.3613Z"
        fill="#E61E29"
      />
    </g>
    <defs>
      <clipPath id="clip0_12415_10292">
        <rect
          width="24"
          height="22"
          fill="white"
          transform="translate(0 0.382812)"
        />
      </clipPath>
    </defs>
  </svg>
);

export const OrderIcon = () => (
  <svg
    width="24"
    height="23"
    viewBox="0 0 24 23"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clipPath="url(#clip0_14051_1557)">
      <path
        d="M7.15417 8.40102H16.8458L13.4458 1.69661C13.1917 1.19129 13.3833 0.568719 13.8708 0.305965C14.3625 0.0432115 14.9667 0.239836 15.2208 0.745278L19.1 8.40102H22.6667C23.4042 8.40102 24 9.05414 24 9.77602C24 10.5752 23.4042 11.151 22.6667 11.151L20.5042 20.1057C20.1708 21.3303 19.1417 22.1897 17.9167 22.1897H6.04583C4.85833 22.1897 3.79167 21.3303 3.495 20.1057L1.33333 11.151C0.597083 11.151 0 10.5752 0 9.77602C0 9.05414 0.597083 8.40102 1.33333 8.40102H4.9L8.77917 0.745278C9.03333 0.239836 9.6375 0.0432115 10.1292 0.305965C10.6167 0.568719 10.8083 1.19129 10.5542 1.69661L7.15417 8.40102ZM7.9625 13.2135C7.9625 12.8698 7.7 12.526 7.29583 12.526C6.96667 12.526 6.62917 12.8698 6.62917 13.2135V17.3385C6.62917 17.7553 6.96667 18.026 7.29583 18.026C7.7 18.026 7.9625 17.7553 7.9625 17.3385V13.2135ZM11.2958 13.2135V17.3385C11.2958 17.7553 11.6333 18.026 11.9625 18.026C12.3667 18.026 12.6667 17.7553 12.6667 17.3385V13.2135C12.6667 12.8698 12.3667 12.526 11.9625 12.526C11.6333 12.526 11.2958 12.8698 11.2958 13.2135ZM17.3333 13.2135C17.3333 12.8698 17.0333 12.526 16.6667 12.526C16.3 12.526 16 12.8698 16 13.2135V17.3385C16 17.7553 16.3 18.026 16.6667 18.026C17.0333 18.026 17.3333 17.7553 17.3333 17.3385V13.2135Z"
        fill="white"
      />
    </g>
    <defs>
      <clipPath id="clip0_14051_1557">
        <rect
          width="24"
          height="22"
          fill="white"
          transform="translate(0 0.189453)"
        />
      </clipPath>
    </defs>
  </svg>
);

export const ClientPaymentsIcon = () => (
  <svg
    width="24"
    height="25"
    viewBox="0 0 24 25"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clipPath="url(#clip0_20933_5234)">
      <path
        d="M22.3939 7.62109V15.018C22.3939 17.0117 20.7719 18.6336 18.7783 18.6336H3.0127V21.043C3.0127 22.2612 4.00387 23.2524 5.2221 23.2524H21.7908C23.0091 23.2524 24.0002 22.2612 24.0002 21.043V9.74613C24.0002 8.737 23.3198 7.8843 22.3939 7.62109Z"
        fill="white"
      />
      <path
        d="M20.9875 15.0187V7.4375H0V15.0187C0 16.2389 0.989156 17.2281 2.20936 17.2281H18.7781C19.9983 17.2281 20.9875 16.2389 20.9875 15.0187ZM17.925 14.1156H14.9125C14.5242 14.1156 14.2094 13.8008 14.2094 13.4125C14.2094 13.0242 14.5242 12.7094 14.9125 12.7094H17.925C18.3133 12.7094 18.6281 13.0242 18.6281 13.4125C18.6281 13.8008 18.3134 14.1156 17.925 14.1156Z"
        fill="white"
      />
      <path
        d="M20.9875 3.72108C20.9875 2.50088 19.9983 1.51172 18.7781 1.51172H2.20941C0.989203 1.51172 0 2.50092 0 3.72113V6.03047H20.9875V3.72108Z"
        fill="white"
      />
    </g>
    <defs>
      <clipPath id="clip0_20933_5234">
        <rect
          width="24"
          height="24"
          fill="white"
          transform="translate(0 0.382812)"
        />
      </clipPath>
    </defs>
  </svg>
);

export const ClientPaymentsIconDD = () => (
  <svg
    width="17"
    height="18"
    viewBox="0 0 24 25"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clipPath="url(#clip0_20933_5234)">
      <path
        d="M22.3939 7.62109V15.018C22.3939 17.0117 20.7719 18.6336 18.7783 18.6336H3.0127V21.043C3.0127 22.2612 4.00387 23.2524 5.2221 23.2524H21.7908C23.0091 23.2524 24.0002 22.2612 24.0002 21.043V9.74613C24.0002 8.737 23.3198 7.8843 22.3939 7.62109Z"
        fill="#A9A9A9"
      />
      <path
        d="M20.9875 15.0187V7.4375H0V15.0187C0 16.2389 0.989156 17.2281 2.20936 17.2281H18.7781C19.9983 17.2281 20.9875 16.2389 20.9875 15.0187ZM17.925 14.1156H14.9125C14.5242 14.1156 14.2094 13.8008 14.2094 13.4125C14.2094 13.0242 14.5242 12.7094 14.9125 12.7094H17.925C18.3133 12.7094 18.6281 13.0242 18.6281 13.4125C18.6281 13.8008 18.3134 14.1156 17.925 14.1156Z"
        fill="#A9A9A9"
      />
      <path
        d="M20.9875 3.72108C20.9875 2.50088 19.9983 1.51172 18.7781 1.51172H2.20941C0.989203 1.51172 0 2.50092 0 3.72113V6.03047H20.9875V3.72108Z"
        fill="#A9A9A9"
      />
    </g>
    <defs>
      <clipPath id="clip0_20933_5234">
        <rect
          width="24"
          height="24"
          fill="#A9A9A9"
          transform="translate(0 0.382812)"
        />
      </clipPath>
    </defs>
  </svg>
);

export const VerificationsIcon = () => (
  <svg
    width="19"
    height="26"
    viewBox="0 0 19 26"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clipPath="url(#clip0_12415_9596)">
      <path
        d="M16.625 3.86914H13.9591C13.3049 2.05273 11.5633 0.744141 9.5 0.744141C7.43672 0.744141 5.69505 2.05273 5.04193 3.86914H2.375C1.0638 3.86914 0 4.91797 0 6.21289V23.4004C0 24.6943 1.0638 25.7441 2.375 25.7441H16.625C17.9362 25.7441 19 24.6953 19 23.4004V6.21289C19 4.91797 17.9362 3.86914 16.625 3.86914ZM9.5 3.86914C10.3743 3.86914 11.0833 4.56885 11.0833 5.43164C11.0833 6.29443 10.3743 6.99414 9.5 6.99414C8.6257 6.99414 7.91667 6.2959 7.91667 5.43164C7.91667 4.56738 8.62422 3.86914 9.5 3.86914ZM13.9977 13.5762L9.64349 19.0449C9.44325 19.2967 9.14771 19.4569 8.8256 19.4874C8.7875 19.4502 8.74792 19.4941 8.70833 19.4941C8.42615 19.4941 8.15169 19.395 7.93547 19.2119L5.16464 16.8681C4.66687 16.447 4.60948 15.707 5.03629 15.2158C5.46225 14.7246 6.21241 14.6679 6.71066 15.0891L8.5404 16.6365L12.1286 12.1306C12.5338 11.6208 13.2815 11.5339 13.7961 11.9323C14.3143 12.3311 14.4034 13.0684 13.9977 13.5762Z"
        fill="#E61E29"
      />
    </g>
    <defs>
      <clipPath id="clip0_12415_9596">
        <rect
          width="19"
          height="25"
          fill="white"
          transform="translate(0 0.744141)"
        />
      </clipPath>
    </defs>
  </svg>
);

export const DownloadIcon = () => (
  <svg
    width="25"
    height="30"
    viewBox="0 0 25 30"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clipPath="url(#clip0_11825_6202)">
      <path
        d="M4.75 0.77832C2.54375 0.77832 0.75 2.37588 0.75 4.34082V25.7158C0.75 27.6808 2.54375 29.2783 4.75 29.2783H20.75C22.9562 29.2783 24.75 27.6808 24.75 25.7158V9.68457H16.75C15.6438 9.68457 14.75 8.88857 14.75 7.90332V0.77832H4.75ZM16.75 0.77832V7.90332H24.75L16.75 0.77832ZM14.25 13.6924V19.3757L16.1875 17.6501C16.775 17.1269 17.725 17.1269 18.3062 17.6501C18.8875 18.1733 18.8937 19.0194 18.3062 19.5371L13.8062 23.5449C13.2188 24.0682 12.2688 24.0682 11.6875 23.5449L7.1875 19.5371C6.6 19.0139 6.6 18.1678 7.1875 17.6501C7.775 17.1324 8.725 17.1269 9.30625 17.6501L11.2437 19.3757V13.6924C11.2437 12.9521 11.9125 12.3564 12.7437 12.3564C13.575 12.3564 14.2437 12.9521 14.2437 13.6924H14.25Z"
        fill="#E61E29"
      />
    </g>
    <defs>
      <clipPath id="clip0_11825_6202">
        <rect
          width="24"
          height="28.5"
          fill="white"
          transform="translate(0.75 0.77832)"
        />
      </clipPath>
    </defs>
  </svg>
);

export const DownloadCloudIcon = () => (
  <svg
    width="39"
    height="38"
    viewBox="0 0 39 38"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <circle cx="19.6169" cy="19.1061" r="18.8903" fill="white" />
    <g clipPath="url(#clip0_14245_12016)">
      <path
        d="M13.4476 25.9939C10.6611 25.9939 8.40039 23.6141 8.40039 20.681C8.40039 18.364 9.80942 16.3938 11.7722 15.6669C11.7687 15.5673 11.7652 15.4677 11.7652 15.3681C11.7652 12.1065 14.2748 9.46484 17.3733 9.46484C19.4518 9.46484 21.2639 10.6529 22.2348 12.4238C22.7676 12.0475 23.4125 11.8261 24.103 11.8261C25.9606 11.8261 27.4678 13.4126 27.4678 15.3681C27.4678 15.8182 27.3872 16.2462 27.2435 16.6446C29.2904 17.08 30.8326 18.9875 30.8326 21.2713C30.8326 23.8798 28.8243 25.9939 26.3462 25.9939H13.4476ZM16.2166 19.8324L19.0207 22.784C19.3501 23.1308 19.8829 23.1308 20.2089 22.784L23.0129 19.8324C23.3424 19.4856 23.3424 18.9248 23.0129 18.5816C22.6834 18.2385 22.1507 18.2348 21.8247 18.5816L20.4577 20.0205V15.0729C20.4577 14.5822 20.0827 14.1874 19.6165 14.1874C19.1503 14.1874 18.7753 14.5822 18.7753 15.0729V20.0205L17.4083 18.5816C17.0789 18.2348 16.5461 18.2348 16.2201 18.5816C15.8942 18.9285 15.8907 19.4893 16.2201 19.8324H16.2166Z"
        fill="#E61E29"
      />
    </g>
    <defs>
      <clipPath id="clip0_14245_12016">
        <rect
          width="22.4323"
          height="18.8903"
          fill="white"
          transform="translate(8.40039 8.28418)"
        />
      </clipPath>
    </defs>
  </svg>
);

export const PlusIcon = ({
  color,
  ...props
}: React.SVGProps<SVGSVGElement> & { color?: string }) => (
  <svg
    width="32"
    height="32"
    viewBox="0 0 41.5 41"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M0.75 20.5078C0.75 9.46094 9.70312 0.507812 20.75 0.507812C31.7969 0.507812 40.75 9.46094 40.75 20.5078C40.75 31.5547 31.7969 40.5078 20.75 40.5078C9.70312 40.5078 0.75 31.5547 0.75 20.5078ZM20.75 29.2578C21.7891 29.2578 22.625 28.4219 22.625 27.3828V22.3828H27.625C28.6641 22.3828 29.5 21.5469 29.5 20.5078C29.5 19.4688 28.6641 18.6328 27.625 18.6328H22.625V13.6328C22.625 12.5938 21.7891 11.7578 20.75 11.7578C19.7109 11.7578 18.875 12.5938 18.875 13.6328V18.6328H13.875C12.8359 18.6328 12 19.4688 12 20.5078C12 21.5469 12.8359 22.3828 13.875 22.3828H18.875V27.3828C18.875 28.4219 19.7109 29.2578 20.75 29.2578Z"
      fill={color || '#E61E29'}
    />
  </svg>
);

export const MinusIcon = (props: React.SVGProps<SVGSVGElement>) => (
  <svg
    width="32"
    height="33"
    viewBox="0 0 32 33"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clipPath="url(#clip0_23397_18535)">
      <path
        d="M16 32.2832C20.2435 32.2832 24.3131 30.5975 27.3137 27.5969C30.3143 24.5963 32 20.5267 32 16.2832C32 12.0397 30.3143 7.97008 27.3137 4.96949C24.3131 1.96891 20.2435 0.283203 16 0.283203C11.7565 0.283203 7.68687 1.96891 4.68629 4.96949C1.68571 7.97008 0 12.0397 0 16.2832C0 20.5267 1.68571 24.5963 4.68629 27.5969C7.68687 30.5975 11.7565 32.2832 16 32.2832ZM11.5 14.7832H20.5C21.3312 14.7832 22 15.452 22 16.2832C22 17.1145 21.3312 17.7832 20.5 17.7832H11.5C10.6687 17.7832 10 17.1145 10 16.2832C10 15.452 10.6687 14.7832 11.5 14.7832Z"
        fill="#E61E29"
      />
    </g>
    <defs>
      <clipPath id="clip0_23397_18535">
        <rect
          width="32"
          height="32"
          fill="white"
          transform="translate(0 0.283203)"
        />
      </clipPath>
    </defs>
  </svg>
);

export const EditPenIcon = ({
  backgroundColor,
  iconColor,
}: {
  backgroundColor?: string;
  iconColor?: string;
}) => (
  <svg
    width="33"
    height="33"
    viewBox="0 0 33 33"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M32.377 16.1055C32.377 24.942 25.2135 32.1055 16.377 32.1055C7.5404 32.1055 0.376953 24.942 0.376953 16.1055C0.376953 7.26891 7.5404 0.105469 16.377 0.105469C25.2135 0.105469 32.377 7.26891 32.377 16.1055Z"
      fill={backgroundColor || 'white'}
    />
    <path
      d="M19.7113 8.70922C20.4926 7.92803 21.7613 7.92803 22.5426 8.70922L23.7738 9.94141C24.5551 10.7223 24.5551 11.9898 23.7738 12.7711L22.2613 14.2836L18.1988 10.2217L19.7113 8.70922ZM21.5551 14.9898L14.2676 22.2742C13.9426 22.5992 13.5395 22.8398 13.0988 22.968L9.33852 24.0742C9.07539 24.1523 8.7907 24.0805 8.59664 23.8586C8.40257 23.693 8.33002 23.4086 8.40745 23.143L9.51352 19.3836C9.64352 18.943 9.88195 18.5398 10.2073 18.2148L17.4926 10.9286L21.5551 14.9898Z"
      fill={iconColor || '#E61E29'}
    />
  </svg>
);

export const EditPenDarkBlueIcon = () => (
  <svg
    width="16"
    height="15"
    viewBox="0 0 16 15"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clipPath="url(#clip0_17531_19701)">
      <path
        d="M11.1712 0.61846C11.893 -0.103289 13.0652 -0.103289 13.787 0.61846L14.9246 1.75689C15.6464 2.47841 15.6464 3.64947 14.9246 4.37128L13.5272 5.7687L9.77377 2.01588L11.1712 0.61846ZM12.8747 6.42121L6.14164 13.1513C5.84137 13.4516 5.46891 13.6739 5.06181 13.7923L1.58761 14.8144C1.34451 14.8866 1.08148 14.8202 0.902184 14.6152C0.722882 14.4621 0.655846 14.1994 0.727392 13.954L1.7493 10.4807C1.86941 10.0736 2.0897 9.7011 2.39026 9.40083L9.12126 2.66897L12.8747 6.42121Z"
        fill="#172A55"
      />
    </g>
    <defs>
      <clipPath id="clip0_17531_19701">
        <rect
          width="14.7826"
          height="14.7826"
          fill="white"
          transform="translate(0.699219 0.0605469)"
        />
      </clipPath>
    </defs>
  </svg>
);

export const EditPenIconRed = () => (
  <svg
    width="32"
    height="32"
    viewBox="0 0 34 35"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <circle cx="17" cy="17.5" r="17" fill="#E61E29" />
    <g clipPath="url(#clip0_11855_5701)">
      <path
        d="M20.0809 10.6663C20.8027 9.94456 21.9749 9.94456 22.6967 10.6663L23.8343 11.8047C24.5561 12.5263 24.5561 13.6973 23.8343 14.4191L22.4368 15.8165L18.6834 12.0637L20.0809 10.6663ZM21.7843 16.4691L15.0513 23.1992C14.751 23.4995 14.3786 23.7218 13.9715 23.8402L10.4973 24.8622C10.2542 24.9344 9.99115 24.868 9.81185 24.663C9.63255 24.51 9.56551 24.2473 9.63706 24.0018L10.659 20.5285C10.7791 20.1214 10.9994 19.749 11.2999 19.4487L18.0309 12.7168L21.7843 16.4691Z"
        fill="white"
      />
    </g>
    <defs>
      <clipPath id="clip0_11855_5701">
        <rect
          width="14.7826"
          height="14.7826"
          fill="white"
          transform="translate(9.60889 10.1084)"
        />
      </clipPath>
    </defs>
  </svg>
);

export const EditPenIconDarkGray = () => (
  <svg
    width="33"
    height="33"
    viewBox="0 0 33 33"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <circle cx="16.5664" cy="16.1523" r="16" fill="#4C4C4C" />
    <g clipPath="url(#clip0_130_7970)">
      <path
        d="M19.4673 9.72041C20.1467 9.04111 21.2499 9.04111 21.9293 9.72041L22.9999 10.7919C23.6793 11.471 23.6793 12.5731 22.9999 13.2525L21.6847 14.5677L18.1521 11.0356L19.4673 9.72041ZM21.0706 15.1818L14.7336 21.5161C14.451 21.7987 14.1005 22.0079 13.7173 22.1193L10.4475 23.0813C10.2187 23.1492 9.9711 23.0867 9.80235 22.8938C9.6336 22.7498 9.57051 22.5025 9.63784 22.2715L10.5996 19.0025C10.7127 18.6193 10.92 18.2688 11.2029 17.9862L17.538 11.6503L21.0706 15.1818Z"
        fill="white"
      />
    </g>
    <defs>
      <clipPath id="clip0_130_7970">
        <rect
          width="13.913"
          height="13.913"
          fill="white"
          transform="translate(9.61133 9.19531)"
        />
      </clipPath>
    </defs>
  </svg>
);

/** The filled disc takes `color` so themed apps can tint it (vDrive is navy). */
export const TrashIconRed = ({ color }: { color?: string }) => (
  <svg
    width="33"
    height="33"
    viewBox="0 0 33 33"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M32.957 16.6348c0 8.8365-7.1634 16-16 16-8.83652 0-15.999969-7.1635-15.999969-16C.957031 7.79821 8.12048.634766 16.957.634766c8.8366 0 16 7.163444 16 16.000034Z"
      fill={color || '#E61E29'}
    />
    <path
      d="M14.1035 9.18758c.1736-.33881.5304-.55281.9193-.55281h3.87c.3889 0 .7457.214.9193.55281l.2314.44719h3.0857c.569 0 1.0286.44783 1.0286 1.00003s-.4596 1-1.0286 1H10.7864c-.568 0-1.02859-.4478-1.02859-1s.46059-1.00003 1.02859-1.00003h3.0857l.2314-.44719Zm-3.346 3.44722h12.3717v10c0 1.1031-.9225 2-2.0571 2h-8.2575c-1.1073 0-2.0571-.8969-2.0571-2v-10Zm2.5714 2.5v7c0 .275.2603.5.5143.5.3118 0 .5143-.225.5143-.5v-7c0-.275-.2025-.5-.5143-.5-.254 0-.5143.225-.5143.5Zm3.0857 0v7c0 .275.2604.5.5143.5.3118 0 .5432-.225.5432-.5v-7c0-.275-.2314-.5-.5432-.5-.2539 0-.5143.225-.5143.5Zm3.1146 0v7c0 .275.2315.5.5143.5.2829 0 .5143-.225.5143-.5v-7c0-.275-.2314-.5-.5143-.5-.2828 0-.5143.225-.5143.5Z"
      fill="#fff"
    />
  </svg>
);

export const TrashIconRedBig = () => (
  <svg
    width="41"
    height="41"
    viewBox="0 0 41 41"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <circle cx="20.1169" cy="20.668" r="20" fill="#E61E29" />
    <g clipPath="url(#clip0_13298_8434)">
      <path
        d="M16.5501 11.359C16.767 10.9355 17.213 10.668 17.6992 10.668H22.5367C23.0228 10.668 23.4688 10.9355 23.6858 11.359L23.9751 11.918H27.8322C28.5434 11.918 29.1179 12.4777 29.1179 13.168C29.1179 13.8582 28.5434 14.418 27.8322 14.418H12.4036C11.6937 14.418 11.1179 13.8582 11.1179 13.168C11.1179 12.4777 11.6937 11.918 12.4036 11.918H16.2608L16.5501 11.359ZM12.3675 15.668H27.8322V28.168C27.8322 29.5469 26.6791 30.668 25.2608 30.668H14.9389C13.5548 30.668 12.3675 29.5469 12.3675 28.168V15.668ZM15.5818 18.793V27.543C15.5818 27.8867 15.9072 28.168 16.2246 28.168C16.6143 28.168 16.8675 27.8867 16.8675 27.543V18.793C16.8675 18.4492 16.6143 18.168 16.2246 18.168C15.9072 18.168 15.5818 18.4492 15.5818 18.793ZM19.4389 18.793V27.543C19.4389 27.8867 19.7643 28.168 20.0818 28.168C20.4715 28.168 20.7608 27.8867 20.7608 27.543V18.793C20.7608 18.4492 20.4715 18.168 20.0818 18.168C19.7643 18.168 19.4389 18.4492 19.4389 18.793ZM23.3322 18.793V27.543C23.3322 27.8867 23.6215 28.168 23.9751 28.168C24.3286 28.168 24.6179 27.8867 24.6179 27.543V18.793C24.6179 18.4492 24.3286 18.168 23.9751 18.168C23.6215 18.168 23.3322 18.4492 23.3322 18.793Z"
        fill="white"
      />
    </g>
    <defs>
      <clipPath id="clip0_13298_8434">
        <rect
          width="18"
          height="20"
          fill="white"
          transform="translate(11.1179 10.668)"
        />
      </clipPath>
    </defs>
  </svg>
);

export const NoteIconRed = () => (
  <svg
    width="19"
    height="22"
    viewBox="0 0 19 22"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clipPath="url(#clip0_11855_5695)">
      <path
        d="M3.32143 1.375C1.90313 1.375 0.75 2.6082 0.75 4.125V17.875C0.75 19.3918 1.90313 20.625 3.32143 20.625H12.3214V15.8125C12.3214 14.6738 13.1853 13.75 14.25 13.75H18.75V4.125C18.75 2.6082 17.5969 1.375 16.1786 1.375H3.32143ZM18.75 15.125H16.9299H14.25C13.8964 15.125 13.6071 15.4344 13.6071 15.8125V18.6785V20.625L14.8929 19.25L17.4643 16.5L18.75 15.125Z"
        fill="#E61E29"
      />
    </g>
    <defs>
      <clipPath id="clip0_11855_5695">
        <rect width="18" height="22" fill="white" transform="translate(0.75)" />
      </clipPath>
    </defs>
  </svg>
);

export const UserIcon = () => (
  <svg
    width="20"
    height="23"
    viewBox="0 0 20 23"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clipPath="url(#clip0_12415_9601)">
      <path
        d="M10 11.1055C13.1562 11.1055 15.7143 8.64293 15.7143 5.60547C15.7143 2.56801 13.1562 0.105469 10 0.105469C6.84375 0.105469 4.28571 2.56801 4.28571 5.60547C4.28571 8.64293 6.84375 11.1055 10 11.1055ZM12.2634 13.168H7.73661C3.46473 13.168 0 16.5023 0 20.6145C0 21.4369 0.692857 22.1042 1.54732 22.1042H18.4536C19.308 22.1055 20 21.4395 20 20.6145C20 16.5023 16.5357 13.168 12.2634 13.168Z"
        fill="white"
      />
    </g>
    <defs>
      <clipPath id="clip0_12415_9601">
        <rect
          width="20"
          height="22"
          fill="white"
          transform="translate(0 0.105469)"
        />
      </clipPath>
    </defs>
  </svg>
);

export const SlidersIcon = () => (
  <svg
    width="25"
    height="24"
    viewBox="0 0 25 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clipPath="url(#clip0_11843_5442)">
      <path
        d="M0.75 19.5C0.75 18.6703 1.42031 18 2.25 18H4.81406C5.39062 16.6734 6.7125 15.75 8.25 15.75C9.7875 15.75 11.1094 16.6734 11.6859 18H23.25C24.0797 18 24.75 18.6703 24.75 19.5C24.75 20.3297 24.0797 21 23.25 21H11.6859C11.1094 22.3266 9.7875 23.25 8.25 23.25C6.7125 23.25 5.39062 22.3266 4.81406 21H2.25C1.42031 21 0.75 20.3297 0.75 19.5ZM9.75 19.5C9.75 19.1022 9.59196 18.7206 9.31066 18.4393C9.02936 18.158 8.64782 18 8.25 18C7.85218 18 7.47064 18.158 7.18934 18.4393C6.90804 18.7206 6.75 19.1022 6.75 19.5C6.75 19.8978 6.90804 20.2794 7.18934 20.5607C7.47064 20.842 7.85218 21 8.25 21C8.64782 21 9.02936 20.842 9.31066 20.5607C9.59196 20.2794 9.75 19.8978 9.75 19.5ZM18.75 12C18.75 11.6022 18.592 11.2206 18.3107 10.9393C18.0294 10.658 17.6478 10.5 17.25 10.5C16.8522 10.5 16.4706 10.658 16.1893 10.9393C15.908 11.2206 15.75 11.6022 15.75 12C15.75 12.3978 15.908 12.7794 16.1893 13.0607C16.4706 13.342 16.8522 13.5 17.25 13.5C17.6478 13.5 18.0294 13.342 18.3107 13.0607C18.592 12.7794 18.75 12.3978 18.75 12ZM17.25 8.25C18.7875 8.25 20.1094 9.17344 20.6859 10.5H23.25C24.0797 10.5 24.75 11.1703 24.75 12C24.75 12.8297 24.0797 13.5 23.25 13.5H20.6859C20.1094 14.8266 18.7875 15.75 17.25 15.75C15.7125 15.75 14.3906 14.8266 13.8141 13.5H2.25C1.42031 13.5 0.75 12.8297 0.75 12C0.75 11.1703 1.42031 10.5 2.25 10.5H13.8141C14.3906 9.17344 15.7125 8.25 17.25 8.25ZM9.75 3C9.35218 3 8.97064 3.15804 8.68934 3.43934C8.40804 3.72064 8.25 4.10218 8.25 4.5C8.25 4.89782 8.40804 5.27936 8.68934 5.56066C8.97064 5.84196 9.35218 6 9.75 6C10.1478 6 10.5294 5.84196 10.8107 5.56066C11.092 5.27936 11.25 4.89782 11.25 4.5C11.25 4.10218 11.092 3.72064 10.8107 3.43934C10.5294 3.15804 10.1478 3 9.75 3ZM13.1859 3H23.25C24.0797 3 24.75 3.67031 24.75 4.5C24.75 5.32969 24.0797 6 23.25 6H13.1859C12.6094 7.32656 11.2875 8.25 9.75 8.25C8.2125 8.25 6.89062 7.32656 6.31406 6H2.25C1.42031 6 0.75 5.32969 0.75 4.5C0.75 3.67031 1.42031 3 2.25 3H6.31406C6.89062 1.67344 8.2125 0.75 9.75 0.75C11.2875 0.75 12.6094 1.67344 13.1859 3Z"
        fill="#E61E29"
      />
    </g>
    <defs>
      <clipPath id="clip0_11843_5442">
        <rect width="24" height="24" fill="white" transform="translate(0.75)" />
      </clipPath>
    </defs>
  </svg>
);

export const TrashIcon = (props: React.SVGProps<SVGSVGElement>) => (
  <svg
    width="40"
    height="40"
    viewBox="0 0 40 40"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M12.9019 2.08021C13.3336 1.26494 14.2209 0.75 15.1882 0.75H24.8132C25.7805 0.75 26.6679 1.26494 27.0996 2.08021L27.6751 3.15625H35.3496C36.7645 3.15625 37.9077 4.2338 37.9077 5.5625C37.9077 6.8912 36.7645 7.96875 35.3496 7.96875H4.65189C3.23932 7.96875 2.09375 6.8912 2.09375 5.5625C2.09375 4.2338 3.23932 3.15625 4.65189 3.15625H12.3263L12.9019 2.08021ZM4.57994 10.375H35.3496V34.4375C35.3496 37.0919 33.0552 39.25 30.2333 39.25H9.69622C6.94222 39.25 4.57994 37.0919 4.57994 34.4375V10.375ZM10.9753 16.3906V33.2344C10.9753 33.8961 11.6228 34.4375 12.2544 34.4375C13.0298 34.4375 13.5334 33.8961 13.5334 33.2344V16.3906C13.5334 15.7289 13.0298 15.1875 12.2544 15.1875C11.6228 15.1875 10.9753 15.7289 10.9753 16.3906ZM18.6497 16.3906V33.2344C18.6497 33.8961 19.2972 34.4375 19.9288 34.4375C20.7042 34.4375 21.2798 33.8961 21.2798 33.2344V16.3906C21.2798 15.7289 20.7042 15.1875 19.9288 15.1875C19.2972 15.1875 18.6497 15.7289 18.6497 16.3906ZM26.3961 16.3906V33.2344C26.3961 33.8961 26.9717 34.4375 27.6751 34.4375C28.3786 34.4375 28.9542 33.8961 28.9542 33.2344V16.3906C28.9542 15.7289 28.3786 15.1875 27.6751 15.1875C26.9717 15.1875 26.3961 15.7289 26.3961 16.3906Z"
      fill="white"
    />
  </svg>
);

export const RecoverIcon = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    height="40"
    width="40"
    viewBox="0 0 640 640"
  >
    <path
      fill="rgb(255, 255, 255)"
      d="M263.1 48L377 48C390.8 48 403 56.8 407.4 69.9L416 96L512 96C529.7 96 544 110.3 544 128C544 145.7 529.7 160 512 160L128 160C110.3 160 96 145.7 96 128C96 110.3 110.3 96 128 96L224 96L232.7 69.9C237.1 56.8 249.3 48 263.1 48zM128 208L512 208L490.9 531.1C489.3 556.4 468.3 576 443 576L197 576C171.7 576 150.7 556.4 149.1 531.1L128 208zM337 287C327.6 277.6 312.4 277.6 303.1 287L231.1 359C221.7 368.4 221.7 383.6 231.1 392.9C240.5 402.2 255.7 402.3 265 392.9L296 361.9L296 464C296 477.3 306.7 488 320 488C333.3 488 344 477.3 344 464L344 361.9L375 392.9C384.4 402.3 399.6 402.3 408.9 392.9C418.2 383.5 418.3 368.3 408.9 359L336.9 287z"
    />
  </svg>
);

export const EditBankBlue = (props: React.SVGProps<SVGSVGElement>) => (
  <svg
    width="41"
    height="41"
    viewBox="0 0 41 41"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <circle cx="20.75" cy="20.7725" r="20" fill="#0068EE" />
    <g clipPath="url(#clip0_19266_23507)">
      <path
        d="M24.3743 12.748C25.2235 11.9004 26.6025 11.9004 27.4517 12.748L28.7901 14.0849C29.6392 14.9323 29.6392 16.3075 28.7901 17.1552L27.146 18.7963L22.7303 14.3891L24.3743 12.748ZM26.3784 19.5625L18.4572 27.4662C18.1039 27.8188 17.6657 28.0799 17.1868 28.2189L13.0995 29.4192C12.8135 29.504 12.504 29.426 12.2931 29.1852C12.0822 29.0055 12.0033 28.697 12.0875 28.4088L13.2897 24.3298C13.431 23.8517 13.6902 23.4143 14.0438 23.0617L21.9626 15.156L26.3784 19.5625Z"
        fill="white"
      />
    </g>
    <defs>
      <clipPath id="clip0_19266_23507">
        <rect
          width="17.3913"
          height="17.3602"
          fill="white"
          transform="translate(12.0543 12.0928)"
        />
      </clipPath>
    </defs>
  </svg>
);

export const EditBankWhite = (props: React.SVGProps<SVGSVGElement>) => (
  <svg
    width="41"
    height="41"
    viewBox="0 0 41 41"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <circle cx="20.75" cy="20.7725" r="20" fill="white" />
    <g clipPath="url(#clip0_19152_23567)">
      <path
        d="M24.3743 12.748C25.2235 11.9004 26.6025 11.9004 27.4517 12.748L28.7901 14.0849C29.6392 14.9323 29.6392 16.3075 28.7901 17.1552L27.146 18.7963L22.7303 14.3891L24.3743 12.748ZM26.3784 19.5625L18.4572 27.4662C18.1039 27.8188 17.6657 28.0799 17.1868 28.2189L13.0995 29.4192C12.8135 29.504 12.504 29.426 12.2931 29.1852C12.0822 29.0055 12.0033 28.697 12.0875 28.4088L13.2897 24.3298C13.431 23.8517 13.6902 23.4143 14.0438 23.0617L21.9626 15.156L26.3784 19.5625Z"
        fill="#0068EE"
      />
    </g>
    <defs>
      <clipPath id="clip0_19152_23567">
        <rect
          width="17.3913"
          height="17.3602"
          fill="white"
          transform="translate(12.0543 12.0928)"
        />
      </clipPath>
    </defs>
  </svg>
);

export const LocationsIcon = () => (
  <svg
    width="17"
    height="24"
    viewBox="0 0 17 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clipPath="url(#clip0_12415_9309)">
      <path
        d="M7.45078 22.8918C5.13984 20.0078 0 13.018 0 9.0918C0 4.32828 3.80552 0.466797 8.5 0.466797C13.1927 0.466797 17 4.32828 17 9.0918C17 13.018 11.8203 20.0078 9.54922 22.8918C9.00469 23.5791 7.99531 23.5791 7.45078 22.8918ZM8.5 11.9668C10.0628 11.9668 11.3333 10.6775 11.3333 9.0918C11.3333 7.50606 10.0628 6.2168 8.5 6.2168C6.93724 6.2168 5.66667 7.50606 5.66667 9.0918C5.66667 10.6775 6.93724 11.9668 8.5 11.9668Z"
        fill="white"
      />
    </g>
    <defs>
      <clipPath id="clip0_12415_9309">
        <rect
          width="17"
          height="23"
          fill="white"
          transform="translate(0 0.466797)"
        />
      </clipPath>
    </defs>
  </svg>
);

export const GrubconLogoSimbol = () => (
  <svg
    width="37"
    height="37"
    viewBox="0 0 37 37"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clipPath="url(#clip0_130_6801)">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M22.887 14.933H27.3847C25.9204 11.4899 22.5383 9.07617 18.5984 9.07617C13.2987 9.07617 9.04492 13.4422 9.04492 18.8021C9.04492 24.1974 13.3335 28.5279 18.5984 28.5279C22.5383 28.5279 25.8855 26.1142 27.3847 22.6711H22.887C21.841 23.878 20.3068 24.6234 18.5984 24.6234C15.4255 24.6234 12.8454 21.9967 12.8454 18.7666C12.8454 15.5365 15.4255 12.9097 18.5984 12.9097C20.3068 12.9453 21.841 13.7261 22.887 14.933Z"
        fill="#737373"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M23.9992 20.7548H27.9391H31.8093C31.7047 21.4293 31.5652 22.0682 31.3909 22.7071C29.7522 28.3509 24.6268 32.433 18.56 32.433C11.1683 32.433 5.17126 26.3277 5.17126 18.8025C5.17126 11.2774 11.1683 5.17213 18.56 5.17213C24.6268 5.17213 29.7522 9.28966 31.3909 14.898H35.3308C33.5875 7.08892 26.7537 1.26758 18.56 1.26758C9.04144 1.26758 1.33594 9.11216 1.33594 18.8025C1.33594 28.4929 9.04144 36.3375 18.56 36.3375C26.7537 36.3375 33.6224 30.5162 35.3308 22.7071C35.4703 22.0682 35.5749 21.4293 35.6446 20.7548C35.7144 20.1159 35.7493 19.477 35.7493 18.8025C35.7493 18.1281 35.7144 17.4892 35.6446 16.8503H31.8093H27.9391H23.9992H18.5949V20.7548H23.9992Z"
        fill="#C28831"
      />
    </g>
    <defs>
      <clipPath id="clip0_130_6801">
        <rect
          width="36"
          height="36"
          fill="white"
          transform="translate(0.330078 0.824219)"
        />
      </clipPath>
    </defs>
  </svg>
);

export const GrubconLogoWhiteSimbol = (
  props: React.SVGProps<SVGSVGElement>
) => (
  <svg
    width="76"
    height="76"
    viewBox="0 0 76 76"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M76 38.312C76 59.0284 59.1991 75.8223 38.4741 75.8223C17.7492 75.8223 0.948242 59.0284 0.948242 38.312C0.948242 17.5957 17.7492 0.801758 38.4741 0.801758C59.1991 0.801758 76 17.5957 76 38.312Z"
      fill="#C28831"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M45.06 32.6927H51.9753C49.7238 27.3989 44.5239 23.6877 38.4662 23.6877C30.3178 23.6877 23.7775 30.4005 23.7775 38.6415C23.7775 46.9369 30.3714 53.5951 38.4662 53.5951C44.5239 53.5951 49.6702 49.884 51.9753 44.5902H45.06C43.4518 46.4457 41.093 47.5919 38.4662 47.5919C33.5878 47.5919 29.6209 43.5532 29.6209 38.5868C29.6209 33.6205 33.5878 29.5819 38.4662 29.5819C41.093 29.6365 43.4518 30.8371 45.06 32.6927Z"
      fill="white"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M58.7779 41.643C58.6171 42.68 58.4026 43.6623 58.1347 44.6447C55.6151 53.3222 47.7347 59.5983 38.4069 59.5983C27.042 59.5983 17.8214 50.2113 17.8214 38.6413C17.8214 27.0713 27.042 17.6843 38.4069 17.6843C47.7347 17.6843 55.6151 24.0151 58.1347 32.638H64.1923C61.5119 20.6314 51.0048 11.681 38.4069 11.681C23.7719 11.681 11.9245 23.7422 11.9245 38.6413C11.9245 53.5405 23.7719 65.6017 38.4069 65.6017C51.0048 65.6017 61.5656 56.6512 64.1923 44.6447C64.4068 43.6623 64.5676 42.68 64.6748 41.643C64.782 40.6607 64.8357 39.6783 64.8357 38.6413C64.8357 37.6044 64.782 36.622 64.6748 35.6397H38.4605V41.643H58.7779Z"
      fill="white"
    />
  </svg>
);

export const GrubconLogoWhiteSimbolSmall = (
  props: React.SVGProps<SVGSVGElement>
) => (
  <svg
    width="40"
    height="40"
    viewBox="0 0 40 40"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M40 20C40 31.0457 31.0457 40 20 40C8.95431 40 0 31.0457 0 20C0 8.95431 8.95431 0 20 0C31.0457 0 40 8.95431 40 20Z"
      fill="#C28831"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M23.51 17.0038H27.1957C25.9957 14.1813 23.2243 12.2025 19.9958 12.2025C15.653 12.2025 12.1672 15.7817 12.1672 20.1756C12.1672 24.5987 15.6815 28.1488 19.9958 28.1488C23.2243 28.1488 25.9671 26.17 27.1957 23.3474H23.51C22.6529 24.3368 21.3958 24.9479 19.9958 24.9479C17.3958 24.9479 15.2815 22.7946 15.2815 20.1465C15.2815 17.4985 17.3958 15.3452 19.9958 15.3452C21.3958 15.3743 22.6529 16.0145 23.51 17.0038Z"
      fill="white"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M30.8212 21.7761C30.7355 22.3289 30.6212 22.8527 30.4784 23.3765C29.1355 28.0032 24.9356 31.3496 19.9642 31.3496C13.9071 31.3496 8.99282 26.3446 8.99282 20.1756C8.99282 14.0066 13.9071 9.00157 19.9642 9.00157C24.9356 9.00157 29.1355 12.3771 30.4784 16.9747H33.7069C32.2783 10.5729 26.6784 5.80068 19.9642 5.80068C12.1642 5.80068 5.84999 12.2316 5.84999 20.1756C5.84999 28.1196 12.1642 34.5505 19.9642 34.5505C26.6784 34.5505 32.3069 29.7782 33.7069 23.3765C33.8212 22.8527 33.9069 22.3289 33.9641 21.7761C34.0212 21.2523 34.0498 20.7285 34.0498 20.1756C34.0498 19.6227 34.0212 19.0989 33.9641 18.5752H19.9928V21.7761H30.8212Z"
      fill="white"
    />
  </svg>
);

export const GreenCheckMark = () => (
  <svg
    width="29"
    height="29"
    viewBox="0 0 29 29"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clipPath="url(#clip0_889_5671)">
      <path
        d="M0 14.5C0 6.49102 6.49102 0 14.5 0C22.509 0 29 6.49102 29 14.5C29 22.509 22.509 29 14.5 29C6.49102 29 0 22.509 0 14.5ZM21.059 11.9965C21.6764 11.3791 21.6764 10.3709 21.059 9.75352C20.4416 9.13613 19.4334 9.13613 18.816 9.75352L12.6875 15.882L10.184 13.3785C9.5666 12.7611 8.5584 12.7611 7.94102 13.3785C7.32363 13.9959 7.32363 15.0041 7.94102 15.6215L11.566 19.2465C12.1834 19.8639 13.1916 19.8639 13.809 19.2465L21.059 11.9965Z"
        fill="#00B51D"
      />
    </g>
    <defs>
      <clipPath id="clip0_889_5671">
        <rect width="29" height="29" fill="white" />
      </clipPath>
    </defs>
  </svg>
);

export const XIcon = () => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clipPath="url(#clip0_31594_41571)">
      <path
        d="M0 12C0 5.37188 5.37188 0 12 0C18.6281 0 24 5.37188 24 12C24 18.6281 18.6281 24 12 24C5.37188 24 0 18.6281 0 12ZM8.20312 9.75469L10.4109 11.9578L8.20312 14.2031C7.76719 14.6438 7.76719 15.3563 8.20312 15.7547C8.64375 16.2328 9.35625 16.2328 9.75469 15.7547L11.9578 13.5891L14.2031 15.7547C14.6438 16.2328 15.3563 16.2328 15.7547 15.7547C16.2328 15.3563 16.2328 14.6438 15.7547 14.2031L13.5891 11.9578L15.7547 9.75469C16.2328 9.35625 16.2328 8.64375 15.7547 8.20312C15.3563 7.76719 14.6438 7.76719 14.2031 8.20312L11.9578 10.4109L9.75469 8.20312C9.35625 7.76719 8.64375 7.76719 8.20312 8.20312C7.76719 8.64375 7.76719 9.35625 8.20312 9.75469Z"
        fill="#ffffff"
      />
    </g>
    <defs>
      <clipPath id="clip0_31594_41571">
        <rect width="24" height="24" fill="white" />
      </clipPath>
    </defs>
  </svg>
);

export const OrderInfoIcon = () => {
  return (
    <svg
      width="33"
      height="33"
      viewBox="0 0 33 33"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <circle cx="16.1006" cy="16.7129" r="16" fill="#4C4C4C" />
      <path
        d="M12.4083 14.6849H19.7924L17.202 9.80899C17.0083 9.44149 17.1543 8.98872 17.5258 8.79763C17.9004 8.60653 18.3607 8.74953 18.5543 9.11712L21.5099 14.6849H24.2274C24.7893 14.6849 25.2432 15.1599 25.2432 15.6849C25.2432 16.2661 24.7893 16.6849 24.2274 16.6849L22.5797 23.1973C22.3258 24.0879 21.5416 24.7129 20.6083 24.7129H11.5639C10.6591 24.7129 9.84641 24.0879 9.62038 23.1973L7.97339 16.6849C7.41244 16.6849 6.95752 16.2661 6.95752 15.6849C6.95752 15.1599 7.41244 14.6849 7.97339 14.6849H10.6909L13.6464 9.11712C13.8401 8.74953 14.3004 8.60653 14.675 8.79763C15.0464 8.98872 15.1924 9.44149 14.9988 9.80899L12.4083 14.6849ZM13.0242 18.1848C13.0242 17.9348 12.8242 17.6848 12.5163 17.6848C12.2655 17.6848 12.0083 17.9348 12.0083 18.1848V21.1848C12.0083 21.4879 12.2655 21.6848 12.5163 21.6848C12.8242 21.6848 13.0242 21.4879 13.0242 21.1848V18.1848ZM15.5639 18.1848V21.1848C15.5639 21.4879 15.821 21.6848 16.0718 21.6848C16.3797 21.6848 16.6083 21.4879 16.6083 21.1848V18.1848C16.6083 17.9348 16.3797 17.6848 16.0718 17.6848C15.821 17.6848 15.5639 17.9348 15.5639 18.1848ZM20.1639 18.1848C20.1639 17.9348 19.9353 17.6848 19.6559 17.6848C19.3766 17.6848 19.148 17.9348 19.148 18.1848V21.1848C19.148 21.4879 19.3766 21.6848 19.6559 21.6848C19.9353 21.6848 20.1639 21.4879 20.1639 21.1848V18.1848Z"
        fill="white"
      />
    </svg>
  );
};

export const ThreeDots = () => {
  return (
    <svg
      width="6"
      height="25"
      viewBox="0 0 6 25"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M3 17.375C2.30381 17.375 1.63613 17.6516 1.14384 18.1438C0.651562 18.6361 0.375 19.3038 0.375 20C0.375 20.6962 0.651562 21.3639 1.14384 21.8562C1.63613 22.3484 2.30381 22.625 3 22.625C3.69619 22.625 4.36387 22.3484 4.85616 21.8562C5.34844 21.3639 5.625 20.6962 5.625 20C5.625 19.3038 5.34844 18.6361 4.85616 18.1438C4.36387 17.6516 3.69619 17.375 3 17.375ZM3 9.875C2.30381 9.875 1.63613 10.1516 1.14384 10.6438C0.651562 11.1361 0.375 11.8038 0.375 12.5C0.375 13.1962 0.651562 13.8639 1.14384 14.3562C1.63613 14.8484 2.30381 15.125 3 15.125C3.69619 15.125 4.36387 14.8484 4.85616 14.3562C5.34844 13.8639 5.625 13.1962 5.625 12.5C5.625 11.8038 5.34844 11.1361 4.85616 10.6438C4.36387 10.1516 3.69619 9.875 3 9.875ZM5.625 5C5.625 4.30381 5.34844 3.63613 4.85616 3.14384C4.36387 2.65156 3.69619 2.375 3 2.375C2.30381 2.375 1.63613 2.65156 1.14384 3.14384C0.651562 3.63613 0.375 4.30381 0.375 5C0.375 5.69619 0.651562 6.36387 1.14384 6.85616C1.63613 7.34844 2.30381 7.625 3 7.625C3.69619 7.625 4.36387 7.34844 4.85616 6.85616C5.34844 6.36387 5.625 5.69619 5.625 5Z"
        fill="#4C4C4C"
      />
    </svg>
  );
};

export const InfoDarkBlueIcon = () => {
  return (
    <svg
      width="17"
      height="17"
      viewBox="0 0 17 17"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_15668_14867)">
        <path
          d="M8.5 0.212893C4.08125 0.212892 0.500001 3.79414 0.500001 8.21289C0.5 12.6316 4.08125 16.2129 8.5 16.2129C12.9187 16.2129 16.5 12.6316 16.5 8.21289C16.5 3.79414 12.9188 0.212893 8.5 0.212893ZM8.5 12.2129C8.08438 12.2129 7.75 11.8785 7.75 11.4629L7.75 7.96289C7.75 7.54727 8.08438 7.21289 8.5 7.21289C8.91563 7.21289 9.25 7.54727 9.25 7.96289L9.25 11.4629C9.25 11.8785 8.91563 12.2129 8.5 12.2129ZM7.5 5.21289C7.5 4.65977 7.94688 4.21289 8.5 4.21289C9.05313 4.21289 9.5 4.65977 9.5 5.21289C9.5 5.76602 9.05313 6.21289 8.5 6.21289C7.94688 6.21289 7.5 5.76602 7.5 5.21289Z"
          fill="#172A55"
        />
      </g>
      <defs>
        <clipPath id="clip0_15668_14867">
          <rect
            width="16"
            height="16"
            fill="white"
            transform="translate(16.5 16.2129) rotate(-180)"
          />
        </clipPath>
      </defs>
    </svg>
  );
};

export const OrderCustomerIcon = () => {
  return (
    <svg
      width="33"
      height="33"
      viewBox="0 0 33 33"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <circle cx="16.1006" cy="16.2129" r="16" fill="#4C4C4C" />
      <g clipPath="url(#clip0_11928_6273)">
        <path
          d="M16.0995 15.2716C18.1789 15.2716 19.8642 13.586 19.8642 11.5069C19.8642 9.42778 18.1789 7.74219 16.0995 7.74219C14.0201 7.74219 12.3348 9.42778 12.3348 11.5069C12.3348 13.586 14.0201 15.2716 16.0995 15.2716ZM17.5906 16.6834H14.6083C11.7939 16.6834 9.51123 18.9657 9.51123 21.7804C9.51123 22.3434 9.9677 22.8001 10.5306 22.8001H21.6689C22.2318 22.801 22.6877 22.3451 22.6877 21.7804C22.6877 18.9657 20.4053 16.6834 17.5906 16.6834Z"
          fill="white"
        />
      </g>
      <defs>
        <clipPath id="clip0_11928_6273">
          <rect
            width="13.1765"
            height="15.0588"
            fill="white"
            transform="translate(9.51123 7.74219)"
          />
        </clipPath>
      </defs>
    </svg>
  );
};

export const StoreIcon = () => {
  return (
    <svg
      width="33"
      height="33"
      viewBox="0 0 33 33"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <circle cx="16.1851" cy="16.082" r="16" fill="#4C4C4C" />
      <g clipPath="url(#clip0_21351_20755)">
        <path
          d="M23.3664 11.7466L21.7747 9.16232C21.633 8.93153 21.3802 8.78906 21.1108 8.78906H11.1997C10.9302 8.78906 10.6775 8.93153 10.5358 9.16232L8.94135 11.7466C8.11913 13.0801 8.84691 14.9349 10.383 15.1486C10.4941 15.1629 10.608 15.1714 10.7191 15.1714C11.4441 15.1714 12.0886 14.8466 12.5302 14.3451C12.9719 14.8466 13.6164 15.1714 14.3414 15.1714C15.0664 15.1714 15.7108 14.8466 16.1525 14.3451C16.5941 14.8466 17.2386 15.1714 17.9636 15.1714C18.6914 15.1714 19.333 14.8466 19.7747 14.3451C20.2191 14.8466 20.8608 15.1714 21.5858 15.1714C21.6997 15.1714 21.8108 15.1629 21.9219 15.1486C23.4636 14.9378 24.1941 13.0829 23.3691 11.7466H23.3664ZM22.0358 16.0518C22.0358 16.0518 22.0358 16.0518 22.033 16.0518C21.8858 16.0718 21.7358 16.0832 21.583 16.0832C21.2386 16.0832 20.908 16.029 20.5997 15.9322V19.7302H11.7108V15.9293C11.3997 16.029 11.0664 16.0832 10.7219 16.0832C10.5691 16.0832 10.4164 16.0718 10.2691 16.0518H10.2664C10.1525 16.0347 10.0414 16.0148 9.93302 15.9863V19.7302V21.5538C9.93302 22.5596 10.7302 23.3773 11.7108 23.3773H20.5997C21.5802 23.3773 22.3775 22.5596 22.3775 21.5538V19.7302V15.9863C22.2664 16.0148 22.1552 16.0376 22.0358 16.0518Z"
          fill="white"
        />
      </g>
      <defs>
        <clipPath id="clip0_21351_20755">
          <rect
            width="16"
            height="14.5882"
            fill="white"
            transform="translate(8.15527 8.78906)"
          />
        </clipPath>
      </defs>
    </svg>
  );
};

export const BoxIcon = () => {
  return (
    <svg
      width="33"
      height="33"
      viewBox="0 0 33 33"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <circle cx="16.6353" cy="16.9883" r="16" fill="#4C4C4C" />
      <g clipPath="url(#clip0_21355_21179)">
        <path
          d="M11.6553 10.9715L10.1841 14.0641H16.2198V10.1641H12.9031C12.3749 10.1641 11.8932 10.4779 11.6553 10.9715ZM17.1484 14.0641H23.1841L21.7129 10.9715C21.4749 10.4779 20.9932 10.1641 20.4651 10.1641H17.1484V14.0641ZM23.1841 15.0391H10.1841V21.8641C10.1841 22.9396 11.0169 23.8141 12.0412 23.8141H21.3269C22.3513 23.8141 23.1841 22.9396 23.1841 21.8641V15.0391Z"
          fill="white"
        />
      </g>
      <defs>
        <clipPath id="clip0_21355_21179">
          <rect
            width="13"
            height="15.6"
            fill="white"
            transform="translate(10.1841 9.1875)"
          />
        </clipPath>
      </defs>
    </svg>
  );
};

export const RatingIcon = () => {
  return (
    <svg
      width="32"
      height="32"
      viewBox="0 0 32 32"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <circle cx="16" cy="16" r="16" fill="#4C4C4C" />
      <path
        d="M16.6047 8.26687C16.4893 8.04187 16.2559 7.89844 16.0028 7.89844C15.7497 7.89844 15.5162 8.04187 15.4009 8.26687L13.3309 12.3225L8.83371 13.0369C8.5834 13.0762 8.37527 13.2534 8.29652 13.4953C8.21777 13.7372 8.28246 14.0016 8.45965 14.1816L11.6771 17.4019L10.9684 21.8991C10.929 22.1494 11.0331 22.4025 11.2384 22.5516C11.4437 22.7006 11.7137 22.7231 11.9415 22.6078L16.0028 20.5434L20.0612 22.6078C20.2862 22.7231 20.559 22.7006 20.7643 22.5516C20.9697 22.4025 21.0737 22.1522 21.0343 21.8991L20.3228 17.4019L23.5403 14.1816C23.7203 14.0016 23.7822 13.7372 23.7034 13.4953C23.6247 13.2534 23.4193 13.0762 23.1662 13.0369L18.6718 12.3225L16.6047 8.26687Z"
        fill="white"
      />
    </svg>
  );
};
export const NoteIcon = () => {
  return (
    <svg
      width="33"
      height="33"
      viewBox="0 0 33 33"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <circle cx="16.9517" cy="16.7969" r="16" fill="#4C4C4C" />
      <g clipPath="url(#clip0_21351_20773)">
        <path
          d="M11.9517 11.2969C11.6767 11.2969 11.4517 11.5219 11.4517 11.7969V21.7969C11.4517 22.0719 11.6767 22.2969 11.9517 22.2969H18.9517V19.7969C18.9517 19.2437 19.3985 18.7969 19.9517 18.7969H22.4517V11.7969C22.4517 11.5219 22.2267 11.2969 21.9517 11.2969H11.9517ZM18.9517 23.7969H11.9517C10.8485 23.7969 9.95166 22.9 9.95166 21.7969V11.7969C9.95166 10.6938 10.8485 9.79688 11.9517 9.79688H21.9517C23.0548 9.79688 23.9517 10.6938 23.9517 11.7969V18.7969V18.9688C23.9517 19.5 23.7423 20.0094 23.3673 20.3844L20.5392 23.2125C20.1642 23.5875 19.6548 23.7969 19.1235 23.7969H18.9517Z"
          fill="white"
        />
      </g>
      <defs>
        <clipPath id="clip0_21351_20773">
          <rect
            width="14"
            height="16"
            fill="white"
            transform="translate(9.95166 8.79688)"
          />
        </clipPath>
      </defs>
    </svg>
  );
};

export const PinIcon = () => {
  return (
    <svg
      width="33"
      height="33"
      viewBox="0 0 33 33"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <circle cx="16.1851" cy="16.0469" r="16" fill="#4C4C4C" />
      <g clipPath="url(#clip0_21351_20764)">
        <path
          d="M15.4696 24.4024C13.7024 22.197 9.77197 16.8519 9.77197 13.8495C9.77197 10.2068 12.6821 7.25391 16.272 7.25391C19.8605 7.25391 22.772 10.2068 22.772 13.8495C22.772 16.8519 18.811 22.197 17.0743 24.4024C16.6579 24.928 15.886 24.928 15.4696 24.4024ZM16.272 16.048C17.467 16.048 18.4386 15.0621 18.4386 13.8495C18.4386 12.6369 17.467 11.651 16.272 11.651C15.0769 11.651 14.1053 12.6369 14.1053 13.8495C14.1053 15.0621 15.0769 16.048 16.272 16.048Z"
          fill="white"
        />
      </g>
      <defs>
        <clipPath id="clip0_21351_20764">
          <rect
            width="13"
            height="17.5882"
            fill="white"
            transform="translate(9.77197 7.25391)"
          />
        </clipPath>
      </defs>
    </svg>
  );
};

export const StackIcon = () => {
  return (
    <svg
      width="32"
      height="32"
      viewBox="0 0 32 32"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <circle cx="16" cy="16" r="16" fill="#4C4C4C" />
      <path
        d="M23.3145 14.5484C22.852 14.8547 22.3207 15.1016 21.7676 15.2984C20.2988 15.8234 18.3707 16.1172 16.3145 16.1172C14.2582 16.1172 12.327 15.8203 10.8613 15.2984C10.3113 15.1016 9.77695 14.8547 9.31445 14.5484V17.1172C9.31445 18.4984 12.4488 19.6172 16.3145 19.6172C20.1801 19.6172 23.3145 18.4984 23.3145 17.1172V14.5484ZM23.3145 12.1172V10.6172C23.3145 9.23594 20.1801 8.11719 16.3145 8.11719C12.4488 8.11719 9.31445 9.23594 9.31445 10.6172V12.1172C9.31445 13.4984 12.4488 14.6172 16.3145 14.6172C20.1801 14.6172 23.3145 13.4984 23.3145 12.1172ZM21.7676 20.2984C20.302 20.8203 18.3738 21.1172 16.3145 21.1172C14.2551 21.1172 12.327 20.8203 10.8613 20.2984C10.3113 20.1016 9.77695 19.8547 9.31445 19.5484V21.6172C9.31445 22.9984 12.4488 24.1172 16.3145 24.1172C20.1801 24.1172 23.3145 22.9984 23.3145 21.6172V19.5484C22.852 19.8547 22.3207 20.1016 21.7676 20.2984Z"
        fill="white"
      />
    </svg>
  );
};

export const UserPlusIcon = () => {
  return (
    <svg
      width="32"
      height="32"
      viewBox="0 0 32 32"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <circle cx="16" cy="16" r="16" fill="#4C4C4C" />
      <path
        d="M15.1427 17.2008C17.6052 17.2008 19.6002 19.1958 19.6002 21.6583C19.6002 22.0683 19.2677 22.4008 18.8577 22.4008H9.9427C9.5327 22.4008 9.2002 22.0683 9.2002 21.6583C9.2002 19.1958 11.1952 17.2008 13.6577 17.2008H15.1427ZM21.2002 11.6008C21.5327 11.6008 21.8002 11.8683 21.8002 12.2008V13.4008H23.0002C23.3327 13.4008 23.6002 13.6683 23.6002 14.0008C23.6002 14.3333 23.3327 14.6008 23.0002 14.6008H21.8002V15.8008C21.8002 16.1333 21.5327 16.4008 21.2002 16.4008C20.8677 16.4008 20.6002 16.1333 20.6002 15.8008V14.6008H19.4002C19.0677 14.6008 18.8002 14.3333 18.8002 14.0008C18.8002 13.6683 19.0677 13.4008 19.4002 13.4008H20.6002V12.2008C20.6002 11.8683 20.8677 11.6008 21.2002 11.6008ZM14.4002 15.8008C12.7427 15.8008 11.4002 14.4583 11.4002 12.8008C11.4002 11.1433 12.7427 9.80078 14.4002 9.80078C16.0577 9.80078 17.4002 11.1433 17.4002 12.8008C17.4002 14.4583 16.0577 15.8008 14.4002 15.8008Z"
        fill="white"
      />
    </svg>
  );
};

export const HeadphonesIcon = () => {
  return (
    <svg
      width="32"
      height="32"
      viewBox="0 0 32 32"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <circle cx="16" cy="16" r="16" fill="#4C4C4C" />
      <path
        d="M16 10C13.5312 10 11.4781 11.7906 11.0719 14.1469C11.3625 14.0531 11.675 14 12 14H12.5C13.3281 14 14 14.6719 14 15.5V18.5C14 19.3281 13.3281 20 12.5 20H12C10.3437 20 9 18.6562 9 17V15C9 11.1344 12.1344 8 16 8C19.8656 8 23 11.1344 23 15V20.2531C23 22.325 21.3187 24.0031 19.2469 24.0031L16.5 24H15.5C14.6719 24 14 23.3281 14 22.5C14 21.6719 14.6719 21 15.5 21H16.5C17.3281 21 18 21.6719 18 22.5H19.25C20.4937 22.5 21.5 21.4937 21.5 20.25V19.5969C21.0594 19.8531 20.5469 19.9969 20 19.9969H19.5C18.6719 19.9969 18 19.325 18 18.4969V15.4969C18 14.6687 18.6719 13.9969 19.5 13.9969H20C20.325 13.9969 20.6344 14.0469 20.9281 14.1438C20.5219 11.7906 18.4719 9.99688 16 9.99688V10Z"
        fill="white"
      />
    </svg>
  );
};

/**
 * Font Awesome `comment-dots` (solid) on the same 32px dark disc as
 * `HeadphonesIcon`, so the two sit as a pair of rows in the tracker's sheet:
 * the support chat beside the calls.
 */
export const SupportChatDiscIcon = () => (
  <svg width="32" height="32" viewBox="0 0 32 32" fill="none">
    <circle cx="16" cy="16" r="16" fill="#4C4C4C" />
    <svg x="7" y="7" width="18" height="18" viewBox="0 0 640 640">
      <path
        d="M320 544C461.4 544 576 436.5 576 304C576 171.5 461.4 64 320 64C178.6 64 64 171.5 64 304C64 358.3 83.2 408.3 115.6 448.5L66.8 540.8C62 549.8 63.5 560.8 70.4 568.3C77.3 575.8 88.2 578.1 97.5 574.1L215.9 523.4C247.7 536.6 282.9 544 320 544zM192 272A32 32 0 1 1 192 336A32 32 0 1 1 192 272zM320 272A32 32 0 1 1 320 336A32 32 0 1 1 320 272zM416 304A32 32 0 1 1 480 304A32 32 0 1 1 416 304z"
        fill="white"
      />
    </svg>
  </svg>
);

export const DollarIcon = () => {
  return (
    <svg
      width="33"
      height="33"
      viewBox="0 0 33 33"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <circle cx="16.1851" cy="16.4844" r="16" fill="#4C4C4C" />
      <g clipPath="url(#clip0_21351_20811)">
        <path
          d="M16.1852 6.79297C16.849 6.79297 17.3852 7.33437 17.3852 8.00451V9.35613C17.4452 9.3637 17.5015 9.37127 17.5615 9.38263C17.5765 9.38642 17.5877 9.38642 17.6027 9.3902L19.4027 9.72338C20.0552 9.84453 20.4865 10.4768 20.3665 11.1318C20.2465 11.7868 19.6202 12.226 18.9715 12.1048L17.1902 11.7754C16.0165 11.6013 14.9815 11.7186 14.254 12.0102C13.5265 12.3017 13.234 12.703 13.1665 13.074C13.0915 13.4791 13.1477 13.7063 13.2115 13.8464C13.279 13.9941 13.4177 14.1606 13.6915 14.3462C14.3027 14.7513 15.2402 15.0163 16.4552 15.3419L16.564 15.3722C17.6365 15.6599 18.949 16.0082 19.924 16.6519C20.4565 17.004 20.959 17.481 21.2702 18.1474C21.589 18.8251 21.6565 19.5823 21.5102 20.3887C21.2515 21.8274 20.269 22.7891 19.0502 23.2926C18.5365 23.5046 17.9777 23.6409 17.3852 23.7091V24.9736C17.3852 25.6438 16.849 26.1852 16.1852 26.1852C15.5215 26.1852 14.9852 25.6438 14.9852 24.9736V23.6523C14.9702 23.6485 14.9515 23.6485 14.9365 23.6447H14.929C14.014 23.5008 12.5102 23.1033 11.4977 22.649C10.894 22.3764 10.6202 21.6608 10.8902 21.0513C11.1602 20.4417 11.869 20.1653 12.4727 20.4379C13.2565 20.79 14.5465 21.1383 15.2927 21.2557C16.489 21.4337 17.4752 21.3314 18.1427 21.055C18.7765 20.7938 19.0652 20.4152 19.1477 19.9609C19.219 19.5596 19.1627 19.3286 19.099 19.1885C19.0277 19.0371 18.889 18.8705 18.6115 18.685C17.9965 18.2799 17.0552 18.0148 15.8365 17.6892L15.7315 17.6627C14.6627 17.3674 13.3502 17.0153 12.3752 16.3717C11.8427 16.0196 11.344 15.5388 11.0327 14.8724C10.7177 14.1947 10.654 13.4375 10.804 12.6311C11.074 11.1848 12.1465 10.2459 13.3652 9.75745C13.864 9.55679 14.4115 9.42049 14.9852 9.34099V8.00451C14.9852 7.33437 15.5215 6.79297 16.1852 6.79297Z"
          fill="white"
        />
      </g>
      <defs>
        <clipPath id="clip0_21351_20811">
          <rect
            width="12"
            height="19.3846"
            fill="white"
            transform="translate(10.1851 6.79297)"
          />
        </clipPath>
      </defs>
    </svg>
  );
};
export const OrderCourierIcon = () => {
  return (
    <svg
      width="33"
      height="33"
      viewBox="0 0 33 33"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <circle cx="16.1006" cy="16.7129" r="16" fill="#4C4C4C" />
      <g clipPath="url(#clip0_11928_6268)">
        <path
          d="M18.313 10.125C19.0144 10.125 19.5835 10.6781 19.5835 11.3603V12.5956H20.9256C21.3756 12.5956 21.7832 12.768 22.1247 13.0768L24.1709 15.0662C24.4885 15.375 24.6659 15.7945 24.6659 16.232V19.1838C25.1344 19.1838 25.513 19.5518 25.513 20.0074C25.513 20.4629 25.1344 20.8309 24.6659 20.8309H23.8188C23.8188 22.1949 22.6806 23.3015 21.2777 23.3015C19.8509 23.3015 18.7365 22.1949 18.7365 20.8309H15.3482C15.3482 22.1949 14.21 23.3015 12.8071 23.3015C11.3803 23.3015 10.2659 22.1949 10.2659 20.8309H9.84237C9.14063 20.8309 8.57178 20.2776 8.57178 19.5956V11.3603C8.57178 10.6781 9.14063 10.125 9.84237 10.125H18.313ZM19.5835 14.2426V16.7132H22.9718V16.232L20.9256 14.2426H19.5835ZM12.8071 19.5956C12.1056 19.5956 11.5365 20.1489 11.5365 20.8309C11.5365 21.5129 12.1056 22.0662 12.8071 22.0662C13.5085 22.0662 14.0777 21.5129 14.0777 20.8309C14.0777 20.1489 13.5085 19.5956 12.8071 19.5956ZM21.2777 22.0662C21.9791 22.0662 22.5482 21.5129 22.5482 20.8309C22.5482 20.1489 21.9791 19.5956 21.2777 19.5956C20.5762 19.5956 20.0071 20.1489 20.0071 20.8309C20.0071 21.5129 20.5762 22.0662 21.2777 22.0662Z"
          fill="white"
        />
      </g>
      <defs>
        <clipPath id="clip0_11928_6268">
          <rect
            width="16.9412"
            height="13.1765"
            fill="white"
            transform="translate(8.57178 10.125)"
          />
        </clipPath>
      </defs>
    </svg>
  );
};
export const OptedInIcon = () => {
  return (
    <svg
      width="32"
      height="32"
      viewBox="0 0 32 32"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <circle cx="16" cy="16" r="16" fill="#4C4C4C" />
      <path
        d="M9.01562 11V15.6719C9.01562 16.2031 9.225 16.7125 9.6 17.0875L15.6 23.0875C16.3813 23.8687 17.6469 23.8687 18.4281 23.0875L23.1 18.4156C23.8813 17.6344 23.8813 16.3687 23.1 15.5875L17.1 9.5875C16.725 9.20938 16.2188 9 15.6875 9H11.0156C9.9125 9 9.01562 9.89688 9.01562 11ZM12.5156 11.5C13.0687 11.5 13.5156 11.9469 13.5156 12.5C13.5156 13.0531 13.0687 13.5 12.5156 13.5C11.9625 13.5 11.5156 13.0531 11.5156 12.5C11.5156 11.9469 11.9625 11.5 12.5156 11.5Z"
        fill="white"
      />
    </svg>
  );
};

export const ClockIcon = () => {
  return (
    <svg
      width="33"
      height="33"
      viewBox="0 0 33 33"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <circle cx="16.9517" cy="16.0312" r="16" fill="#4C4C4C" />
      <g clipPath="url(#clip0_21355_21177)">
        <path
          d="M16.9517 7.03125C19.3386 7.03125 21.6278 7.97946 23.3156 9.66729C25.0034 11.3551 25.9517 13.6443 25.9517 16.0312C25.9517 18.4182 25.0034 20.7074 23.3156 22.3952C21.6278 24.083 19.3386 25.0312 16.9517 25.0312C14.5647 25.0312 12.2755 24.083 10.5877 22.3952C8.89987 20.7074 7.95166 18.4182 7.95166 16.0312C7.95166 13.6443 8.89987 11.3551 10.5877 9.66729C12.2755 7.97946 14.5647 7.03125 16.9517 7.03125ZM16.1079 11.25V16.0312C16.1079 16.3125 16.2485 16.5762 16.4841 16.7344L19.8591 18.9844C20.2458 19.2445 20.7696 19.1391 21.0298 18.7488C21.2899 18.3586 21.1845 17.8383 20.7942 17.5781L17.7954 15.5812V11.25C17.7954 10.7824 17.4192 10.4062 16.9517 10.4062C16.4841 10.4062 16.1079 10.7824 16.1079 11.25Z"
          fill="white"
        />
      </g>
      <defs>
        <clipPath id="clip0_21355_21177">
          <rect
            width="18"
            height="18"
            fill="white"
            transform="translate(7.95166 7.03125)"
          />
        </clipPath>
      </defs>
    </svg>
  );
};

export const TruckLeftIcon = () => {
  return (
    <svg
      width="33"
      height="33"
      viewBox="0 0 33 33"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <circle cx="16.1851" cy="16.3789" r="16" fill="#4C4C4C" />
      <g clipPath="url(#clip0_21351_20800)">
        <path
          d="M13.856 9.78906C13.1545 9.78906 12.5854 10.3421 12.5854 11.0244V12.2597H11.2433C10.7933 12.2597 10.3857 12.4321 10.0442 12.7409L7.99805 14.7302C7.6804 15.0391 7.50305 15.4585 7.50305 15.896V18.8479C7.03452 18.8479 6.65599 19.2159 6.65599 19.6714C6.65599 20.1269 7.03452 20.4949 7.50305 20.4949H8.35011C8.35011 21.8589 9.48835 22.9655 10.8913 22.9655C12.3181 22.9655 13.4325 21.8589 13.4325 20.4949H16.8207C16.8207 21.8589 17.9589 22.9655 19.3619 22.9655C20.7886 22.9655 21.9031 21.8589 21.9031 20.4949H22.3266C23.0283 20.4949 23.5972 19.9416 23.5972 19.2597V11.0244C23.5972 10.3421 23.0283 9.78906 22.3266 9.78906H13.856ZM12.5854 13.9067V16.3773H9.19717V15.896L11.2433 13.9067H12.5854ZM19.3619 19.2597C20.0633 19.2597 20.6325 19.813 20.6325 20.4949C20.6325 21.1769 20.0633 21.7302 19.3619 21.7302C18.6604 21.7302 18.0913 21.1769 18.0913 20.4949C18.0913 19.813 18.6604 19.2597 19.3619 19.2597ZM10.8913 21.7302C10.1898 21.7302 9.6207 21.1769 9.6207 20.4949C9.6207 19.813 10.1898 19.2597 10.8913 19.2597C11.5928 19.2597 12.1619 19.813 12.1619 20.4949C12.1619 21.1769 11.5928 21.7302 10.8913 21.7302Z"
          fill="white"
        />
      </g>
      <defs>
        <clipPath id="clip0_21351_20800">
          <rect
            width="16.9412"
            height="13.1765"
            fill="white"
            transform="matrix(-1 0 0 1 23.5972 9.78906)"
          />
        </clipPath>
      </defs>
    </svg>
  );
};

export const CarWheelIcon = () => {
  return (
    <svg
      width="33"
      height="33"
      viewBox="0 0 33 33"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <circle cx="16.1851" cy="16.2656" r="16" fill="#4C4C4C" />
      <g clipPath="url(#clip0_20554_27507)">
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M16.2604 25.8358H16.2373C14.4841 25.8405 12.8325 25.3699 11.4069 24.5486H11.4022C11.3469 24.5164 11.2961 24.4841 11.2408 24.4518L11.1762 24.4102C11.1393 24.3872 11.0977 24.3641 11.0608 24.3364C11.0285 24.318 11.0009 24.2949 10.9686 24.2764C10.9363 24.2534 10.904 24.2349 10.8717 24.2119C10.8348 24.1888 10.8025 24.1657 10.7656 24.138C10.7379 24.1196 10.7148 24.1011 10.6871 24.0827C10.6502 24.055 10.6133 24.0319 10.5764 24.0042C10.5487 23.9858 10.5257 23.9673 10.498 23.9489C10.4611 23.9212 10.4288 23.8981 10.3919 23.8704C10.3642 23.8474 10.3365 23.8243 10.3042 23.8059C10.2719 23.7828 10.2396 23.7551 10.2119 23.732C10.1843 23.709 10.152 23.6859 10.1243 23.6628C10.0966 23.6398 10.0689 23.6167 10.0412 23.5936C10.0043 23.5659 9.97203 23.5337 9.93512 23.5014L9.88437 23.4552C8.55104 22.2926 7.54065 20.7655 7.01009 19.0215C6.99625 18.98 6.98241 18.9339 6.97318 18.8924V18.8877L6.96857 18.8647C6.95934 18.8324 6.95011 18.7955 6.94089 18.7632V18.7586V18.754V18.7493L6.93166 18.7124L6.92704 18.6986L6.9132 18.6525C6.89936 18.5971 6.88552 18.5463 6.87168 18.491L6.86707 18.4679L6.86245 18.4448C6.70559 17.7851 6.61793 17.0977 6.60871 16.3964C6.60871 16.3826 6.60871 16.3641 6.60871 16.3503C6.56257 14.9616 6.82554 13.6328 7.33766 12.4287C7.3515 12.3964 7.36534 12.3687 7.37918 12.3364L7.40686 12.2672C7.42993 12.2119 7.453 12.1611 7.48068 12.1057L7.49452 12.0734C7.64677 11.7505 7.81747 11.4368 8.00663 11.1369C9.70905 8.37333 12.814 6.58325 16.2558 6.6017H16.2788C19.7252 6.58325 22.8255 8.37333 24.528 11.1369C24.7171 11.4368 24.8878 11.7505 25.0401 12.0734L25.0539 12.1057C25.077 12.1565 25.1047 12.2119 25.1277 12.2672L25.1554 12.3364C25.1693 12.3687 25.1831 12.3964 25.1969 12.4287C25.709 13.6328 25.972 14.9616 25.9259 16.3503V16.3964C25.9121 17.0977 25.8244 17.7805 25.6721 18.4448L25.6675 18.4679L25.6629 18.491C25.6491 18.5463 25.6352 18.6017 25.6214 18.6525L25.6076 18.6986L25.6029 18.7124L25.5937 18.7493V18.754V18.7586V18.7632C25.5845 18.7955 25.5753 18.8324 25.566 18.8647L25.5614 18.8877V18.8924C25.5476 18.9339 25.5383 18.98 25.5245 19.0215C24.9939 20.7655 23.9836 22.2926 22.6502 23.4552L22.5995 23.5014C22.5626 23.5337 22.5303 23.5613 22.4934 23.5936C22.4657 23.6167 22.438 23.6398 22.4103 23.6628C22.3826 23.6859 22.3503 23.709 22.3227 23.732C22.2904 23.7551 22.2581 23.7828 22.2304 23.8059C22.2027 23.8289 22.175 23.852 22.1427 23.8704C22.1104 23.8981 22.0735 23.9212 22.0366 23.9489C22.0089 23.9673 21.9859 23.9858 21.9582 24.0042C21.9213 24.0319 21.8844 24.055 21.8475 24.0827C21.8198 24.1011 21.7967 24.1196 21.769 24.138C21.7321 24.1611 21.6998 24.1842 21.6629 24.2119C21.6306 24.2349 21.5983 24.2534 21.566 24.2764C21.5337 24.2949 21.5061 24.318 21.4738 24.3364C21.4368 24.3595 21.3953 24.3826 21.3584 24.4102L21.2938 24.4518C21.2385 24.4841 21.1877 24.5164 21.1323 24.5486H21.1277C19.7021 25.3745 18.0505 25.8405 16.2973 25.8358H16.2604ZM24.1543 18.085C23.5222 20.7563 21.5706 22.92 19.0285 23.8428C18.4518 23.9904 18.0735 24.0273 18.0735 24.0273C18.0412 24.0135 18.0089 23.9996 17.9813 23.9812C17.9536 23.9673 17.9259 23.9489 17.8982 23.9304C17.8198 23.8704 17.7367 23.7828 17.686 23.709C17.6352 23.6305 17.6076 23.5798 17.5753 23.5014C17.5568 23.4644 17.543 23.4229 17.5291 23.3814C17.5153 23.3399 17.5014 23.2937 17.4876 23.2476C17.4738 23.2015 17.4645 23.1507 17.4553 23.1C17.4461 23.0492 17.4368 22.9939 17.4276 22.9385C17.2938 21.4345 17.5291 19.9304 17.8936 19.5014C18.4565 19.243 19.8498 19.1553 20.2558 18.3802C20.3065 18.2926 20.3526 18.1957 20.3942 18.0896C20.4588 17.9696 20.5187 17.8312 20.5649 17.6698H20.5787L20.611 17.6651L20.6433 17.6605H20.6756H20.7079H20.7402H20.7725H20.8048C21.0908 17.6513 23.7529 17.905 23.8636 17.9466L23.8913 17.9558L23.919 17.965L23.9467 17.9743L23.9743 17.9881L23.9974 18.0019L24.0205 18.0158L24.0435 18.0296L24.0666 18.0435L24.0897 18.0573L24.1127 18.0711L24.1358 18.085L24.145 18.0942L24.1543 18.085ZM13.4691 23.8428C10.927 22.9154 8.97549 20.7563 8.34342 18.085L8.35265 18.0758L8.37572 18.0619L8.39879 18.0481L8.42185 18.0342L8.44492 18.0204L8.46799 18.0065L8.49106 17.9927L8.51413 17.9789L8.54181 17.965L8.56949 17.9558L8.59717 17.9466L8.62485 17.9373C8.74019 17.8958 11.4022 17.6421 11.6837 17.6513H11.716H11.7483H11.7806H11.8129H11.8452L11.8774 17.6559L11.9097 17.6605H11.9236C11.9697 17.822 12.0297 17.9604 12.0943 18.0804C12.1358 18.1865 12.1819 18.2834 12.2327 18.371C12.6387 19.1461 14.032 19.2384 14.5949 19.4921C14.964 19.9212 15.1992 21.4252 15.0608 22.9293C15.0516 22.9846 15.047 23.0354 15.0332 23.0907C15.0239 23.1415 15.0101 23.1922 15.0009 23.2384C14.987 23.2845 14.9732 23.3307 14.9593 23.3722C14.9455 23.4137 14.9317 23.4552 14.9132 23.4921C14.8809 23.5706 14.8532 23.6213 14.8025 23.6997C14.7517 23.7782 14.6687 23.8658 14.5903 23.9212C14.5626 23.9396 14.5349 23.9581 14.5072 23.9719C14.4749 23.9904 14.4472 24.0042 14.4149 24.0181C14.4149 24.0181 14.032 23.9858 13.4599 23.8335L13.4691 23.8428ZM16.2512 8.71012H16.2465C16.1543 8.71012 16.0574 8.71012 15.9651 8.71474C11.0239 8.88083 7.17618 14.8924 9.7921 15.6121C9.80132 15.6121 9.81055 15.6121 9.82439 15.6167H9.85669H9.88898H9.92128H9.95357C9.9628 15.6167 9.97664 15.6167 9.98587 15.6121L10.0182 15.6075C10.0274 15.6075 10.0412 15.6029 10.0505 15.6029C10.0597 15.6029 10.0735 15.5982 10.0828 15.5982C10.092 15.5982 10.1058 15.5936 10.115 15.5936L10.1473 15.589L10.1796 15.5798L10.2165 15.5706L10.2535 15.5613L10.2904 15.5521L10.3273 15.5429L10.3642 15.5337L10.4011 15.5198L10.438 15.506L10.4749 15.4921L10.5118 15.4783L10.5487 15.4644C15.0608 13.7159 17.1508 13.4668 21.8475 15.4183L21.8844 15.4322L21.9213 15.446L21.9582 15.4598L21.9951 15.4737L22.032 15.4875L22.0689 15.5014L22.1058 15.5152L22.1427 15.529L22.1796 15.5383L22.2165 15.5475L22.2535 15.5567L22.2904 15.5659L22.3273 15.5752L22.3596 15.5844L22.3919 15.589C22.4011 15.589 22.4149 15.5936 22.4242 15.5936C22.4334 15.5936 22.4472 15.5982 22.4565 15.5982C22.4657 15.5982 22.4795 15.6029 22.4888 15.6029L22.521 15.6075C22.5303 15.6075 22.5441 15.6075 22.5533 15.6121H22.5856H22.6179H22.6502H22.6825C22.6917 15.6121 22.701 15.6121 22.7148 15.6075C25.3307 14.8924 21.483 8.88083 16.5418 8.71012C16.4449 8.70551 16.3526 8.70551 16.2604 8.70551L16.2512 8.71012Z"
          fill="white"
        />
      </g>
      <defs>
        <clipPath id="clip0_20554_27507">
          <rect
            width="20"
            height="20"
            fill="white"
            transform="translate(6.18408 6.26562)"
          />
        </clipPath>
      </defs>
    </svg>
  );
};

export const DropoffHouseIcon = () => {
  return (
    <svg
      width="40"
      height="40"
      viewBox="0 0 40 40"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <circle cx="20" cy="20" r="20" fill="#4C4C4C" />
      <g clipPath="url(#clip0_32107_42321)">
        <path
          d="M28.9945 19.9844C28.9945 20.5569 28.5258 21.0054 27.9945 21.0054H26.9945L27.0164 26.1011C27.0164 26.1869 27.0102 26.2728 27.0008 26.3587V26.874C27.0008 27.577 26.4414 28.1463 25.7508 28.1463H25.2508C25.2164 28.1463 25.182 28.1463 25.1477 28.1431C25.1039 28.1463 25.0602 28.1463 25.0164 28.1463L24.0008 28.1431H23.2508C22.5602 28.1431 22.0008 27.5738 22.0008 26.8708V26.1074V24.0717C22.0008 23.5087 21.5539 23.0539 21.0008 23.0539H19.0008C18.4477 23.0539 18.0008 23.5087 18.0008 24.0717V26.1074V26.8708C18.0008 27.5738 17.4414 28.1431 16.7508 28.1431H16.0008H15.0039C14.957 28.1431 14.9102 28.14 14.8633 28.1368C14.8258 28.14 14.7883 28.1431 14.7508 28.1431H14.2508C13.5602 28.1431 13.0008 27.5738 13.0008 26.8708V23.3083C13.0008 23.2797 13.0008 23.2479 13.0039 23.2193V21.0022H12.0039C11.4414 21.0022 11.0039 20.5569 11.0039 19.9812C11.0039 19.6949 11.0977 19.4405 11.3164 19.2178L19.3258 12.1119C19.5445 11.8892 19.7945 11.8574 20.0133 11.8574C20.232 11.8574 20.482 11.921 20.6695 12.0801L28.6508 19.221C28.9008 19.4436 29.0258 19.6981 28.9945 19.9844Z"
          fill="white"
        />
      </g>
      <defs>
        <clipPath id="clip0_32107_42321">
          <rect
            width="18"
            height="16.2857"
            fill="white"
            transform="translate(11 11.8574)"
          />
        </clipPath>
      </defs>
    </svg>
  );
};

export const AddressIcon = () => {
  return (
    <svg
      width="40"
      height="40"
      viewBox="0 0 40 40"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <circle cx="20" cy="20" r="20" fill="#4C4C4C" />
      <g clipPath="url(#clip0_32107_42330)">
        <path
          d="M19.1055 30.4435C16.8965 27.6867 11.9834 21.0053 11.9834 17.2523C11.9834 12.6989 15.621 9.00781 20.1084 9.00781C24.5941 9.00781 28.2334 12.6989 28.2334 17.2523C28.2334 21.0053 23.2822 27.6867 21.1113 30.4435C20.5908 31.1005 19.626 31.1005 19.1055 30.4435ZM20.1084 20.0005C21.6022 20.0005 22.8167 18.7681 22.8167 17.2523C22.8167 15.7365 21.6022 14.5041 20.1084 14.5041C18.6146 14.5041 17.4001 15.7365 17.4001 17.2523C17.4001 18.7681 18.6146 20.0005 20.1084 20.0005Z"
          fill="white"
        />
      </g>
      <defs>
        <clipPath id="clip0_32107_42330">
          <rect
            width="16.25"
            height="21.9853"
            fill="white"
            transform="translate(11.9834 9.00781)"
          />
        </clipPath>
      </defs>
    </svg>
  );
};

export const OrderNotesIcon = () => {
  return (
    <svg
      width="33"
      height="33"
      viewBox="0 0 33 33"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <circle cx="16.4873" cy="16.2129" r="16" fill="#4C4C4C" />
      <g clipPath="url(#clip0_11928_6260)">
        <path
          d="M21.8661 8.80078C23.0526 8.80078 24.0173 9.74876 24.0173 10.9184V21.5067C24.0173 22.6747 23.0526 23.6243 21.8661 23.6243H11.1098C9.92152 23.6243 8.9585 22.6747 8.9585 21.5067V10.9184C8.9585 9.74876 9.92152 8.80078 11.1098 8.80078H21.8661ZM19.9098 12.3644C19.382 11.8482 18.5316 11.8482 18.0072 12.3644L17.2879 13.0725L19.6711 15.4217L20.3904 14.7136C20.9182 14.1942 20.9182 13.357 20.3904 12.8409L19.9098 12.3644ZM12.7064 17.7942L12.2015 19.7563C12.1555 19.9648 12.2093 20.1567 12.3434 20.289C12.4778 20.4181 12.6694 20.471 12.8543 20.428L14.8745 19.9284C15.0627 19.882 15.2375 19.7861 15.3753 19.6504L18.9114 16.1695L16.5249 13.8236L12.9887 17.2747C12.8509 17.4401 12.7535 17.6089 12.7064 17.7942Z"
          fill="white"
        />
      </g>
      <defs>
        <clipPath id="clip0_11928_6260">
          <rect
            width="15.0588"
            height="16.9412"
            fill="white"
            transform="translate(8.9585 7.74219)"
          />
        </clipPath>
      </defs>
    </svg>
  );
};

export const GrayCircleEarphoneIcon = () => {
  return (
    <svg
      width="32"
      height="32"
      viewBox="0 0 32 32"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <circle cx="16" cy="16" r="16" fill="#4C4C4C" />
      <path
        d="M17.1768 8C20.9442 8 24 11.0558 24 14.8232C24 15.2144 23.6853 15.5291 23.2941 15.5291C22.903 15.5291 22.5883 15.2144 22.5883 14.8232C22.5883 11.8351 20.1649 9.41171 17.1768 9.41171C16.7856 9.41171 16.4709 9.09701 16.4709 8.70585C16.4709 8.31469 16.7856 8 17.1768 8ZM17.412 13.6468C17.9326 13.6468 18.3532 14.0674 18.3532 14.588C18.3532 15.1085 17.9326 15.5291 17.412 15.5291C16.8915 15.5291 16.4709 15.1085 16.4709 14.588C16.4709 14.0674 16.8915 13.6468 17.412 13.6468ZM16.4709 11.5293C16.4709 11.1381 16.7856 10.8234 17.1768 10.8234C19.3855 10.8234 21.1766 12.6145 21.1766 14.8232C21.1766 15.2144 20.8619 15.5291 20.4707 15.5291C20.0796 15.5291 19.7649 15.2144 19.7649 14.8232C19.7649 13.3939 18.6061 12.2351 17.1768 12.2351C16.7856 12.2351 16.4709 11.9204 16.4709 11.5293ZM11.2976 8.98231C11.877 8.82349 12.4828 9.12054 12.7122 9.67346L13.9034 12.5351C14.1063 13.0204 13.9651 13.5821 13.5563 13.9174L12.2593 14.9791C13.2152 17.0849 14.8769 18.8025 16.9444 19.8289L18.0797 18.4407C18.412 18.0319 18.9737 17.8937 19.462 18.0937L22.3236 19.2878C22.8765 19.5172 23.1736 20.123 23.0147 20.7024L22.9706 20.8642C22.453 22.767 20.6148 24.3905 18.3708 23.917C13.224 22.8258 9.17416 18.776 8.08303 13.6292C7.60952 11.3852 9.23298 9.54699 11.1329 9.02643L11.2947 8.98231H11.2976Z"
        fill="white"
      />
    </svg>
  );
};

export const OrderUtilsIcon = () => {
  return (
    <svg
      width="33"
      height="33"
      viewBox="0 0 33 33"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <circle cx="16.75" cy="16.3662" r="16" fill="#4C4C4C" />
      <g clipPath="url(#clip0_11931_6711)">
        <path
          d="M22.5459 8.36621C22.0153 8.36621 18.301 9.36621 18.301 13.8662V17.3662C18.301 18.4693 19.2528 19.3662 20.4235 19.3662H21.4847V23.3662C21.4847 23.9193 21.9589 24.3662 22.5459 24.3662C23.1329 24.3662 23.6071 23.9193 23.6071 23.3662V19.3662V15.8662V9.36621C23.6071 8.81309 23.1329 8.36621 22.5459 8.36621ZM10.8724 8.86621C10.8724 8.60996 10.6702 8.39746 10.3982 8.36934C10.1263 8.34121 9.88418 8.50996 9.82449 8.75684L8.81964 13.0162C8.77321 13.2131 8.75 13.4131 8.75 13.6131C8.75 15.0475 9.91403 16.2256 11.4031 16.3537V23.3662C11.4031 23.9193 11.8773 24.3662 12.4643 24.3662C13.0513 24.3662 13.5255 23.9193 13.5255 23.3662V16.3537C15.0145 16.2256 16.1786 15.0475 16.1786 13.6131C16.1786 13.4131 16.1554 13.2131 16.1089 13.0162L15.1041 8.75684C15.0444 8.50684 14.7957 8.34121 14.527 8.36934C14.2584 8.39746 14.0561 8.60996 14.0561 8.86621V13.06C14.0561 13.2287 13.9102 13.3662 13.7311 13.3662C13.562 13.3662 13.4227 13.2443 13.4061 13.085L12.9916 8.82246C12.9684 8.56309 12.7395 8.36621 12.4643 8.36621C12.189 8.36621 11.9602 8.56309 11.937 8.82246L11.5258 13.085C11.5092 13.2443 11.3699 13.3662 11.2008 13.3662C11.0217 13.3662 10.8758 13.2287 10.8758 13.06V8.86621H10.8724ZM12.4742 13.6162H12.4643H12.4543L12.4643 13.5943L12.4742 13.6162Z"
          fill="white"
        />
      </g>
      <defs>
        <clipPath id="clip0_11931_6711">
          <rect
            width="14.8571"
            height="16"
            fill="white"
            transform="translate(8.75 8.36621)"
          />
        </clipPath>
      </defs>
    </svg>
  );
};

export const OrderDetailsIcon = () => {
  return (
    <svg
      width="33"
      height="33"
      viewBox="0 0 33 33"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <circle cx="16.75" cy="16.3662" r="16" fill="#4C4C4C" />
      <g clipPath="url(#clip0_11928_6264)">
        <path
          d="M9.22119 11.6597C9.22119 10.62 10.0638 9.77734 11.1035 9.77734H22.3977C23.4359 9.77734 24.28 10.62 24.28 11.6597V21.0715C24.28 22.1097 23.4359 22.9538 22.3977 22.9538H11.1035C10.0638 22.9538 9.22119 22.1097 9.22119 21.0715V11.6597ZM11.1035 13.542H12.9859V11.6597H11.1035V13.542ZM22.3977 11.6597H14.8683V13.542H22.3977V11.6597ZM11.1035 17.3068H12.9859V15.4244H11.1035V17.3068ZM22.3977 15.4244H14.8683V17.3068H22.3977V15.4244ZM11.1035 21.0715H12.9859V19.1891H11.1035V21.0715ZM22.3977 19.1891H14.8683V21.0715H22.3977V19.1891Z"
          fill="white"
        />
      </g>
      <defs>
        <clipPath id="clip0_11928_6264">
          <rect
            width="15.0588"
            height="15.0588"
            fill="white"
            transform="translate(9.22119 8.83594)"
          />
        </clipPath>
      </defs>
    </svg>
  );
};

export const RecoveryIcon = () => {
  return (
    <svg
      width="32"
      height="32"
      viewBox="0 0 32 32"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M16.347 1.00419C15.905 0.99319 15.463 1.00419 15.023 1.03319C12.169 1.22019 9.47505 2.14219 7.10105 3.92819V2.99619C7.09905 2.44719 6.65405 2.00219 6.10505 2.00019C5.55305 1.99819 5.10305 2.44419 5.10105 2.99619V6.09619C5.10105 6.98719 6.17505 7.43219 6.80605 6.80519C11.425 2.18719 18.736 1.70819 23.917 5.68419C29.098 9.66019 30.526 16.8442 27.262 22.5002C23.996 28.1562 17.064 30.5062 11.03 28.0062C4.99605 25.5062 1.75905 18.9452 3.45005 12.6372C3.59405 12.1032 3.27605 11.5542 2.74105 11.4122C2.20905 11.2672 1.66005 11.5812 1.51405 12.1132C-0.431954 19.3772 3.31505 26.9802 10.262 29.8592C17.209 32.7372 25.231 30.0062 28.991 23.4962C32.751 16.9862 31.103 8.67319 25.137 4.09619C22.527 2.09319 19.439 1.07319 16.347 1.00419ZM16.004 5.76619C10.363 5.76619 5.76405 10.3582 5.76405 15.9982C5.76405 21.6382 10.364 26.2362 16.004 26.2362C21.644 26.2362 26.234 21.6372 26.234 15.9982C26.234 10.3592 21.644 5.76619 16.004 5.76619ZM16.004 9.71519C16.556 9.71719 17.002 10.1672 17 10.7192V10.8732C18 11.0092 18.857 11.6292 19.312 12.4922C19.568 12.9812 19.379 13.5852 18.889 13.8422C18.402 14.0982 17.797 13.9102 17.539 13.4222C17.36 13.0812 17.014 12.8462 16.586 12.8462H15.656C15.042 12.8462 14.578 13.3102 14.578 13.9242C14.578 14.5382 15.042 15.0022 15.656 15.0022H16.004H16.053H16.35C18.038 15.0022 19.42 16.3932 19.42 18.0802C19.42 19.5452 18.379 20.7812 17 21.0842V21.2832C16.998 21.8322 16.553 22.2772 16.004 22.2792C15.451 22.2822 15 21.8362 14.998 21.2832V21.1272C14 20.9892 13.143 20.3732 12.689 19.5122C12.431 19.0242 12.62 18.4172 13.109 18.1602C13.599 17.9022 14.204 18.0922 14.461 18.5822C14.64 18.9232 14.993 19.1562 15.42 19.1562H16.35C16.965 19.1562 17.42 18.6942 17.42 18.0802C17.42 17.4662 16.965 17.0022 16.35 17.0022H16.004H15.656C13.968 17.0022 12.578 15.6112 12.578 13.9242C12.578 12.4632 13.622 11.2282 14.998 10.9222V10.7192C14.996 10.1632 15.447 9.71219 16.004 9.71519Z"
        fill="#E61E29"
      />
    </svg>
  );
};

export const SettingsPageIcon = () => {
  return (
    <svg
      width="23"
      height="25"
      viewBox="0 0 23 25"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M22.2767 8.44414C22.425 8.84727 22.2992 9.30195 21.9937 9.59727L20.0486 11.4441C20.098 11.8332 20.125 12.2316 20.125 12.6348C20.125 13.0379 20.098 13.4363 20.0486 13.8254L21.9937 15.6723C22.2992 15.9676 22.425 16.4223 22.2767 16.8254C22.0791 17.3832 21.841 17.9223 21.5715 18.4332L21.3603 18.8129C21.0638 19.3285 20.7314 19.816 20.3676 20.2801C20.098 20.6129 19.6623 20.7301 19.267 20.5988L16.7648 19.7645C16.1629 20.2473 15.4576 20.6504 14.7883 20.9598L14.2267 23.6363C14.1369 24.0582 13.8224 24.3582 13.4092 24.4707C12.7892 24.5785 12.1513 24.6348 11.4595 24.6348C10.8486 24.6348 10.2107 24.5785 9.59079 24.4707C9.17751 24.3582 8.86306 24.0582 8.77321 23.6363L8.21169 20.9598C7.50192 20.6504 6.83708 20.2473 6.23512 19.7645L3.73477 20.5988C3.33766 20.7301 2.89967 20.6129 2.63373 20.2801C2.26942 19.816 1.93699 19.3285 1.64051 18.8129L1.43028 18.4332C1.1576 17.9223 0.920412 17.3832 0.721408 16.8254C0.575861 16.4223 0.698498 15.9676 1.00666 15.6723L2.94998 13.8254C2.90057 13.4363 2.87496 13.0379 2.87496 12.6348C2.87496 12.2316 2.90057 11.8332 2.94998 11.4441L1.00666 9.59727C0.698498 9.30195 0.575861 8.85195 0.721408 8.44414C0.920412 7.88633 1.15805 7.34727 1.43028 6.83633L1.64006 6.45664C1.93699 5.94102 2.26942 5.45352 2.63373 4.9918C2.89967 4.65664 3.33766 4.54039 3.73477 4.67258L6.23512 5.50508C6.83708 5.02039 7.50192 4.61727 8.21169 4.31117L8.77321 1.63461C8.86306 1.20898 9.17751 0.871016 9.59079 0.799297C10.2107 0.691062 10.8486 0.634766 11.5 0.634766C12.1513 0.634766 12.7892 0.691062 13.4092 0.799297C13.8224 0.871016 14.1369 1.20898 14.2267 1.63461L14.7883 4.31117C15.4576 4.61727 16.1629 5.02039 16.7648 5.50508L19.267 4.67258C19.6623 4.54039 20.098 4.65664 20.3676 4.9918C20.7314 5.45352 21.0638 5.94102 21.3603 6.45664L21.5715 6.83633C21.841 7.34727 22.0791 7.88633 22.2767 8.44414ZM11.5 16.3848C13.4855 16.3848 15.0937 14.7066 15.0937 12.5926C15.0937 10.5629 13.4855 8.84258 11.5 8.84258C9.51442 8.84258 7.90622 10.5629 7.90622 12.5926C7.90622 14.7066 9.51442 16.3848 11.5 16.3848Z"
        fill="white"
      />
    </svg>
  );
};

export const ClosingDaysPageIcon = () => {
  return (
    <svg
      width="21"
      height="25"
      viewBox="0 0 21 25"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_12415_6349)">
        <path
          d="M6 0.550781C6.82969 0.550781 7.5 1.22109 7.5 2.05078V3.55078H13.5V2.05078C13.5 1.22109 14.1703 0.550781 15 0.550781C15.8297 0.550781 16.5 1.22109 16.5 2.05078V3.55078H18.75C19.9922 3.55078 21 4.55859 21 5.80078V8.05078H0V5.80078C0 4.55859 1.00781 3.55078 2.25 3.55078H4.5V2.05078C4.5 1.22109 5.17031 0.550781 6 0.550781ZM0 9.55078H21V22.3008C21 23.543 19.9922 24.5508 18.75 24.5508H2.25C1.00781 24.5508 0 23.543 0 22.3008V9.55078ZM14.2969 14.8477C14.7375 14.407 14.7375 13.6945 14.2969 13.2586C13.8562 12.8227 13.1438 12.818 12.7078 13.2586L10.5047 15.4617L8.30156 13.2586C7.86094 12.818 7.14844 12.818 6.7125 13.2586C6.27656 13.6992 6.27187 14.4117 6.7125 14.8477L8.91562 17.0508L6.7125 19.2539C6.27187 19.6945 6.27187 20.407 6.7125 20.843C7.15312 21.2789 7.86563 21.2836 8.30156 20.843L10.5047 18.6398L12.7078 20.843C13.1484 21.2836 13.8609 21.2836 14.2969 20.843C14.7328 20.4023 14.7375 19.6898 14.2969 19.2539L12.0938 17.0508L14.2969 14.8477Z"
          fill="white"
        />
      </g>
      <defs>
        <clipPath id="clip0_12415_6349">
          <rect
            width="21"
            height="24"
            fill="white"
            transform="translate(0 0.550781)"
          />
        </clipPath>
      </defs>
    </svg>
  );
};

export const AuditLogIcon = () => {
  return (
    <svg
      width="24"
      height="25"
      viewBox="0 0 24 25"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_18947_9123)">
        <path
          d="M11.9999 3.67969C8.63327 3.67969 5.93744 5.17158 3.97494 6.94726C2.02494 8.70671 0.720768 10.8148 0.104102 12.2621C-0.0333984 12.5824 -0.0333984 12.9391 0.104102 13.2594C0.720768 14.7067 2.02494 16.8148 3.97494 18.5743C5.93744 20.35 8.63327 21.8419 11.9999 21.8419C15.3666 21.8419 18.0624 20.35 20.0249 18.5743C21.9749 16.8108 23.2791 14.7067 23.8999 13.2594C24.0374 12.9391 24.0374 12.5824 23.8999 12.2621C23.2791 10.8148 21.9749 8.70671 20.0249 6.94726C18.0624 5.17158 15.3666 3.67969 11.9999 3.67969ZM5.99994 12.7608C5.99994 11.2125 6.63208 9.7276 7.75729 8.63279C8.88251 7.53799 10.4086 6.92293 11.9999 6.92293C13.5912 6.92293 15.1174 7.53799 16.2426 8.63279C17.3678 9.7276 17.9999 11.2125 17.9999 12.7608C17.9999 14.3091 17.3678 15.7939 16.2426 16.8887C15.1174 17.9836 13.5912 18.5986 11.9999 18.5986C10.4086 18.5986 8.88251 17.9836 7.75729 16.8887C6.63208 15.7939 5.99994 14.3091 5.99994 12.7608ZM11.9999 10.1662C11.9999 11.5973 10.8041 12.7608 9.33327 12.7608C9.03744 12.7608 8.7541 12.7121 8.48744 12.627C8.25827 12.554 7.9916 12.6919 7.99994 12.927C8.01243 13.2067 8.0541 13.4864 8.13327 13.7662C8.7041 15.8418 10.8999 17.0743 13.0333 16.5189C15.1666 15.9635 16.4333 13.827 15.8624 11.7513C15.3999 10.0689 13.8708 8.9378 12.1708 8.86888C11.9291 8.86077 11.7874 9.11617 11.8624 9.3432C11.9499 9.60266 11.9999 9.87834 11.9999 10.1662Z"
          fill="white"
        />
      </g>
      <defs>
        <clipPath id="clip0_18947_9123">
          <rect
            width="24"
            height="24"
            fill="white"
            transform="translate(0 0.882812)"
          />
        </clipPath>
      </defs>
    </svg>
  );
};

export const WorkingHoursIcon = () => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_12456_7357)">
        <path
          d="M12 0C15.1826 0 18.2348 1.26428 20.4853 3.51472C22.7357 5.76516 24 8.8174 24 12C24 15.1826 22.7357 18.2348 20.4853 20.4853C18.2348 22.7357 15.1826 24 12 24C8.8174 24 5.76516 22.7357 3.51472 20.4853C1.26428 18.2348 0 15.1826 0 12C0 8.8174 1.26428 5.76516 3.51472 3.51472C5.76516 1.26428 8.8174 0 12 0ZM10.875 5.625V12C10.875 12.375 11.0625 12.7266 11.3766 12.9375L15.8766 15.9375C16.3922 16.2844 17.0906 16.1437 17.4375 15.6234C17.7844 15.1031 17.6437 14.4094 17.1234 14.0625L13.125 11.4V5.625C13.125 5.00156 12.6234 4.5 12 4.5C11.3766 4.5 10.875 5.00156 10.875 5.625Z"
          fill="white"
        />
      </g>
      <defs>
        <clipPath id="clip0_12456_7357">
          <rect width="24" height="24" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};

export const CopyIcon = ({
  width = 17,
  height = 17,
  color,
  ...props
}: React.SVGProps<SVGSVGElement>) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 640 640"
      width={width}
      height={height}
      {...props}
    >
      <path
        fill={color || lightTheme.lightGray}
        d="M288 64C252.7 64 224 92.7 224 128L224 384C224 419.3 252.7 448 288 448L480 448C515.3 448 544 419.3 544 384L544 183.4C544 166 536.9 149.3 524.3 137.2L466.6 81.8C454.7 70.4 438.8 64 422.3 64L288 64zM160 192C124.7 192 96 220.7 96 256L96 512C96 547.3 124.7 576 160 576L352 576C387.3 576 416 547.3 416 512L416 496L352 496L352 512L160 512L160 256L176 256L176 192L160 192z"
      />
    </svg>
  );
};

/** Font Awesome `language` (solid). Translate, on a chat message. */
export const ChatTranslateIcon = ({ color }: { color?: string }) => (
  <svg width="17" height="17" viewBox="0 0 640 512" fill="none">
    <path
      d="M0 128C0 92.7 28.7 64 64 64H256h48 16H576c35.3 0 64 28.7 64 64V384c0 35.3-28.7 64-64 64H320 304 256 64c-35.3 0-64-28.7-64-64V128zm320 0V384H576V128H320zM178.3 175.9c-3.2-7.2-10.4-11.9-18.3-11.9s-15.1 4.7-18.3 11.9l-64 144c-4.5 10.1 .1 21.9 10.2 26.4s21.9-.1 26.4-10.2l8.9-20.1h73.6l8.9 20.1c4.5 10.1 16.3 14.6 26.4 10.2s14.6-16.3 10.2-26.4l-64-144zM160 233.2L179 276H141l19-42.8zM448 164c11 0 20 9 20 20v4h44 16c11 0 20 9 20 20s-9 20-20 20h-2l-1.6 4.5c-8.9 24.4-22.4 46.6-39.6 65.4c.9 .6 1.8 1.1 2.7 1.6l18.9 11.3c9.5 5.7 12.5 18 6.9 27.4s-18 12.5-27.4 6.9l-18.9-11.3c-4.5-2.7-8.8-5.5-13.1-8.5c-10.6 7.5-21.9 14-34 19.4l-3.6 1.6c-10.1 4.5-21.9-.1-26.4-10.2s.1-21.9 10.2-26.4l3.6-1.6c6.4-2.9 12.6-6.1 18.5-9.8l-12.2-12.2c-7.8-7.8-7.8-20.5 0-28.3s20.5-7.8 28.3 0l14.6 14.6 .5 .5c12.4-13.1 22.5-28.3 29.8-45H448 376c-11 0-20-9-20-20s9-20 20-20h52v-4c0-11 9-20 20-20z"
      fill={color || '#4C4C4C'}
    />
  </svg>
);

export const FilterIcon = () => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 640 640">
      <path
        fill="#4c4c4c"
        d="M96 128C83.1 128 71.4 135.8 66.4 147.8C61.4 159.8 64.2 173.5 73.4 182.6L256 365.3L256 480C256 488.5 259.4 496.6 265.4 502.6L329.4 566.6C338.6 575.8 352.3 578.5 364.3 573.5C376.3 568.5 384 556.9 384 544L384 365.3L566.6 182.7C575.8 173.5 578.5 159.8 573.5 147.8C568.5 135.8 556.9 128 544 128L96 128z"
      />
    </svg>
  );
};

export const ReferralIcon = () => {
  return (
    <svg
      width="41"
      height="41"
      viewBox="0 0 41 41"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <circle cx="20.6992" cy="20.9492" r="20" fill="#E61E29" />
      <path
        d="M16.4863 12.5024C15.2606 12.7351 14.2909 13.6117 13.9108 14.8219C13.7634 15.3028 13.7479 16.1794 13.8875 16.6371C14.2056 17.6999 15.0201 18.5532 16.0596 18.9101C16.4009 19.0264 17.2465 19.0963 17.5646 19.0342L17.7352 19.0032L17.7663 18.6153C17.8749 17.2034 18.8135 15.745 19.9539 15.202C20.2952 15.0391 20.2952 15.0391 20.2642 14.8684C20.2487 14.7753 20.1478 14.5038 20.0315 14.2711C19.76 13.7048 19.1471 13.0842 18.5963 12.8204C17.9214 12.4868 17.1612 12.3705 16.4863 12.5024Z"
        fill="white"
      />
      <path
        d="M21.9627 15.0387C20.3724 15.3955 19.1545 16.5592 18.7434 18.1262C18.596 18.6925 18.596 19.6079 18.7434 20.1664C19.1467 21.6869 20.3026 22.8428 21.8076 23.2306C22.6066 23.4323 23.7314 23.347 24.4839 23.0134C25.632 22.5092 26.5164 21.4852 26.8655 20.2828C27.0129 19.763 27.0517 18.8942 26.9431 18.3434C26.5397 16.3575 24.8253 14.9534 22.8083 14.9689C22.5135 14.9689 22.1256 15.0077 21.9627 15.0387Z"
        fill="white"
      />
      <path
        d="M14.0115 18.8246C13.3444 19.259 12.7625 19.8718 12.3436 20.57C12.0799 21.0044 11.7928 21.7181 11.661 22.2612C11.4748 23.0059 11.4205 22.9361 12.2661 22.9361C12.7379 22.9361 13.1905 22.7486 13.5241 22.415L14.0115 21.9276L14.2287 21.7104C14.6657 21.2734 15.3742 21.2734 15.8112 21.7104L16.1836 22.0827C16.415 22.3141 16.7901 22.3141 17.0214 22.0827C17.3783 21.7259 18.0609 21.1984 18.2549 21.1286C18.3014 21.113 18.2781 20.9269 18.154 20.4226L18.0673 20.0591C18.0239 19.8772 17.851 19.7566 17.6653 19.7788C16.4629 19.9261 15.4699 19.6158 14.5933 18.8323C14.4434 18.6961 14.2193 18.6811 14.0526 18.7962L14.0115 18.8246Z"
        fill="white"
      />
      <path
        d="M13.3279 23.6964L12.481 24.5107C12.2707 24.713 12.4079 25.0686 12.6995 25.0773L12.9473 25.0846C13.2687 25.094 13.5447 25.3161 13.6227 25.6281C14.0804 27.4278 15.2828 28.6457 17.1989 29.2431C17.4549 29.3206 17.7497 29.406 17.8428 29.4215C17.8847 29.4291 17.9081 29.3749 17.8738 29.3496L17.866 29.3439C17.5247 29.0957 17.0205 28.5604 16.7722 28.188C16.3068 27.4666 16.043 26.6133 15.981 25.597C15.9641 25.3143 16.1874 25.0751 16.4706 25.0724L16.78 25.0695C17.0853 25.0638 17.2307 24.6913 17.01 24.4802L16.1904 23.6964C15.4069 22.9517 14.763 22.3389 14.7553 22.3389C14.7475 22.3389 14.1036 22.944 13.3279 23.6964Z"
        fill="white"
      />
      <path
        d="M18.8742 23.0683C18.6259 23.2312 18.2846 23.4795 18.1062 23.6191C17.9382 23.7661 17.9296 24.0244 18.0874 24.1822L18.6492 24.744C19.1146 25.2094 19.5025 25.6128 19.5025 25.6361C19.5025 25.6593 18.8974 25.6749 18.1682 25.6749H17.1399C16.9747 25.6749 16.8482 25.8218 16.8727 25.9852C16.927 26.4351 17.1442 27.0867 17.3459 27.4669C17.7028 28.1262 18.0596 28.4908 19.0216 29.1813C19.279 29.363 19.5864 29.4605 19.9015 29.4605H24.6302H29.4399C29.667 29.4605 29.8511 29.2765 29.8511 29.0494C29.8433 26.4351 28.8193 24.4414 26.8024 23.1071L26.7572 23.0773C26.4994 22.9068 26.1598 22.9285 25.9258 23.1304C25.2896 23.6812 24.6302 24.0225 23.8467 24.2242C23.3115 24.3561 22.2254 24.3406 21.6901 24.1932C20.9144 23.9837 20.0998 23.526 19.6034 23.0218C19.487 22.8977 19.3706 22.7968 19.3551 22.7968C19.3396 22.7968 19.1224 22.9132 18.8742 23.0683Z"
        fill="white"
      />
    </svg>
  );
};

export const DeleteIconRed = () => (
  <svg
    width="22"
    height="24"
    viewBox="0 0 22 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clipPath="url(#clip0_445_57)">
      <mask
        id="mask0_445_57"
        maskUnits="userSpaceOnUse"
        x="0"
        y="0"
        width="22"
        height="24"
      >
        <path
          d="M21.426 0.64978H0.151245V23.3493H21.426V0.64978Z"
          fill="white"
        />
      </mask>
      <g mask="url(#mask0_445_57)">
        <path
          d="M6.57166 1.43406C6.82809 0.953384 7.35521 0.64978 7.92982 0.64978H13.6474C14.222 0.64978 14.7492 0.953384 15.0056 1.43406L15.3475 2.0685H19.9064C20.7469 2.0685 21.426 2.70382 21.426 3.48722C21.426 4.27062 20.7469 4.90594 19.9064 4.90594H1.67087C0.831752 4.90594 0.151245 4.27062 0.151245 3.48722C0.151245 2.70382 0.831752 2.0685 1.67087 2.0685H6.22973L6.57166 1.43406ZM1.62813 6.32466H19.9064V20.5119C19.9064 22.0769 18.5434 23.3493 16.8671 23.3493H4.66738C3.03141 23.3493 1.62813 22.0769 1.62813 20.5119V6.32466ZM5.42718 9.87144V19.8025C5.42718 20.1926 5.81184 20.5119 6.18699 20.5119C6.64763 20.5119 6.94681 20.1926 6.94681 19.8025V9.87144C6.94681 9.48132 6.64763 9.16212 6.18699 9.16212C5.81184 9.16212 5.42718 9.48132 5.42718 9.87144ZM9.98608 9.87144V19.8025C9.98608 20.1926 10.3707 20.5119 10.7458 20.5119C11.2065 20.5119 11.5484 20.1926 11.5484 19.8025V9.87144C11.5484 9.48132 11.2065 9.16212 10.7458 9.16212C10.3707 9.16212 9.98608 9.48132 9.98608 9.87144ZM14.5876 9.87144V19.8025C14.5876 20.1926 14.9296 20.5119 15.3475 20.5119C15.7654 20.5119 16.1073 20.1926 16.1073 19.8025V9.87144C16.1073 9.48132 15.7654 9.16212 15.3475 9.16212C14.9296 9.16212 14.5876 9.48132 14.5876 9.87144Z"
          fill="#E61E29"
        />
      </g>
    </g>
    <defs>
      <clipPath id="clip0_445_57">
        <rect width="22" height="24" fill="white" />
      </clipPath>
    </defs>
  </svg>
);

export const PrinterIcon = (props: React.SVGProps<SVGSVGElement>) => (
  <svg
    width="25"
    height="24"
    viewBox="0 0 25 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <g clipPath="url(#clip0_15521_14441)">
      <path
        d="M6.04102 0C4.38633 0 3.04102 1.34531 3.04102 3V7.5H6.04102V3H16.6676L18.041 4.37344V7.5H21.041V4.37344C21.041 3.57656 20.727 2.8125 20.1645 2.25L18.791 0.876563C18.2285 0.314063 17.4645 0 16.6676 0H6.04102ZM18.041 16.5V18V21H6.04102V18V17.25V16.5H18.041ZM21.041 18H22.541C23.3707 18 24.041 17.3297 24.041 16.5V12C24.041 10.3453 22.6957 9 21.041 9H3.04102C1.38633 9 0.0410156 10.3453 0.0410156 12V16.5C0.0410156 17.3297 0.711328 18 1.54102 18H3.04102V21C3.04102 22.6547 4.38633 24 6.04102 24H18.041C19.6957 24 21.041 22.6547 21.041 21V18ZM20.291 11.625C20.5894 11.625 20.8755 11.7435 21.0865 11.9545C21.2975 12.1655 21.416 12.4516 21.416 12.75C21.416 13.0484 21.2975 13.3345 21.0865 13.5455C20.8755 13.7565 20.5894 13.875 20.291 13.875C19.9926 13.875 19.7065 13.7565 19.4955 13.5455C19.2845 13.3345 19.166 13.0484 19.166 12.75C19.166 12.4516 19.2845 12.1655 19.4955 11.9545C19.7065 11.7435 19.9926 11.625 20.291 11.625Z"
        fill="#E61E29"
      />
    </g>
    <defs>
      <clipPath id="clip0_15521_14441">
        <rect
          width="24"
          height="24"
          fill="white"
          transform="translate(0.0410156)"
        />
      </clipPath>
    </defs>
  </svg>
);

export const VDriveIcon = (props: React.SVGProps<SVGSVGElement>) => (
  <svg
    width="31"
    height="28"
    viewBox="0 0 31 28"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M11.1493 5.16797C9.06398 5.16797 7.31177 6.92018 7.31177 9.00547C7.31177 11.0907 9.02054 12.843 11.1493 12.843C13.278 12.843 14.9868 11.0907 14.9868 9.00547C14.9868 6.92018 13.278 5.16797 11.1493 5.16797ZM11.6995 10.9025H10.6279L9.5129 7.23877H10.3962L11.1637 9.9757L11.9312 7.22429H12.8001L11.6995 10.9025Z"
      fill="#172A55"
    />
    <path
      d="M19.9539 13.046C19.8091 12.9591 19.6643 12.9301 19.534 12.9591C19.4036 12.9881 19.3023 13.075 19.2154 13.2198L18.8823 13.7845L19.8526 14.3493L20.1856 13.77C20.2725 13.6252 20.287 13.4949 20.2436 13.3646C20.2001 13.2342 20.0987 13.1329 19.9539 13.046Z"
      fill="#172A55"
    />
    <path
      d="M29.3955 3.02538C29.1928 2.66335 28.9466 2.34476 28.657 2.05514C27.7447 1.15731 26.4848 0.664955 25.167 0.664955H24.5154C22.7632 0.824247 21.2137 1.92481 20.3738 3.51774L19.3166 5.35684C18.4043 6.9208 17.6079 8.2965 16.9562 9.41155C16.8404 9.59981 16.739 9.77358 16.6376 9.94735C16.5652 10.0632 16.4928 10.1791 16.4349 10.2949C16.348 10.4252 16.2756 10.5556 16.2032 10.6859C16.0874 10.8741 15.986 11.0479 15.8846 11.2072C15.8557 11.2651 15.8267 11.3086 15.7833 11.3665C15.7253 11.4679 15.6674 11.5548 15.6095 11.6416C15.4502 11.9023 15.3054 12.0906 15.2185 12.2209C14.2338 13.5097 12.7422 14.2048 11.1927 14.2048C11.1203 14.2048 11.0334 14.2048 10.961 14.2048C10.4542 14.1758 9.93288 14.0745 9.44052 13.9007C7.31179 13.1766 5.93609 11.2362 5.93609 8.9916C5.93609 8.57165 5.99401 8.18066 6.09538 7.80415C6.12434 7.67382 6.16779 7.55797 6.21123 7.42764C6.29812 7.16698 6.39948 6.9208 6.51533 6.6891C6.57326 6.57325 6.6167 6.47188 6.67463 6.37052C6.79047 6.1533 6.90632 5.93608 7.03665 5.73335C7.05113 5.70438 7.0801 5.66094 7.09458 5.63198C7.22491 5.42924 7.34076 5.22651 7.47109 5.03825C8.06481 4.11146 8.60061 3.28604 8.55717 2.47509C8.55717 2.35925 8.52821 2.2434 8.49925 2.14203C8.48477 2.11307 8.48477 2.06962 8.47028 2.04066C8.4558 1.99722 8.44132 1.96826 8.42684 1.92481C8.23859 1.4759 7.87656 1.15731 7.52901 0.954577C7.41316 0.882171 7.28283 0.824247 7.16698 0.780804C7.09458 0.751842 7.00769 0.737361 6.93529 0.708398C6.93529 0.708398 6.93529 0.708398 6.92081 0.708398H6.90632H6.87736C6.05194 0.563587 5.0817 0.722879 4.90793 0.751842C4.89345 0.751842 4.87897 0.751842 4.87897 0.751842C3.51774 0.98354 2.22892 1.76552 1.51935 2.90953C0.563592 4.3866 0.563592 6.25467 1.44694 7.77518L11.3375 24.8919C12.2064 26.3689 13.7269 27.2378 15.4212 27.2523C17.13 27.2523 18.636 26.3689 19.5049 24.8919L29.3955 7.77518C30.2789 6.26915 30.2789 4.51693 29.3955 3.02538ZM20.2869 16.9707C20.2579 17.1879 20.1565 17.4196 19.9973 17.6948L19.4035 18.7229L16.3625 16.9562L16.9562 15.9281C17.1155 15.6674 17.2603 15.4647 17.4196 15.3198C17.5789 15.175 17.7382 15.1026 17.9265 15.0882C18.1147 15.0737 18.2885 15.0882 18.4912 15.1461C18.6795 15.204 18.9112 15.3198 19.1863 15.4791C19.4615 15.6384 19.6787 15.7832 19.838 15.9281C19.9973 16.0584 20.1276 16.2177 20.2145 16.3915C20.2869 16.5652 20.3158 16.768 20.2869 16.9707ZM21.9667 14.2917L20.7358 14.06L20.3882 14.6537L21.4164 15.2474L21.0544 15.8701L18.0133 14.1034L18.694 12.916C19.1139 12.1919 19.6497 12.0326 20.3158 12.4236C20.7068 12.6553 20.924 12.9739 20.9385 13.3794L22.3577 13.6256L21.9667 14.2917ZM22.6618 13.0753L19.6207 11.3086L19.9828 10.6859L23.0238 12.4526L22.6618 13.0753ZM23.661 11.352L20.2 10.2949L20.5765 9.64325L23.3858 10.57L23.5017 10.3673L21.3006 8.38339L21.6771 7.73174L24.3126 10.208L23.661 11.352ZM24.9788 9.09297L21.9377 7.32627L23.0817 5.35684L23.6175 5.67542L22.8356 7.02217L23.5451 7.42764L24.1678 6.34155L24.7036 6.64566L24.0809 7.73174L24.805 8.15169L25.587 6.80495L26.1228 7.12353L24.9788 9.09297Z"
      fill="#172A55"
    />
    <path
      d="M19.1574 16.3485C19.0705 16.2905 18.9401 16.2037 18.7664 16.1168C18.5926 16.0154 18.4623 15.943 18.3464 15.8996C18.2306 15.8561 18.1292 15.8271 18.0133 15.8271C17.8975 15.8271 17.8106 15.8561 17.7237 15.9285C17.6368 16.0009 17.55 16.1023 17.4775 16.2616L17.2458 16.6671L19.2153 17.8111L19.447 17.4056C19.5773 17.1884 19.6208 16.9856 19.5628 16.8119C19.5339 16.6526 19.3891 16.5078 19.1574 16.3485Z"
      fill="#172A55"
    />
  </svg>
);

export const VDriveSuccessIcon = () => (
  <svg
    width="41"
    height="40"
    viewBox="0 0 41 40"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <circle cx="18" cy="18" r="18" fill="#172A55" />
    <path
      d="M14.2199 12.5508C12.656 12.5508 11.3418 13.8649 11.3418 15.4289C11.3418 16.9929 12.6234 18.307 14.2199 18.307C15.8165 18.307 17.098 16.9929 17.098 15.4289C17.098 13.8649 15.8165 12.5508 14.2199 12.5508ZM14.6326 16.8517H13.8289L12.9926 14.1039H13.6552L14.2308 16.1566L14.8064 14.093H15.4581L14.6326 16.8517Z"
      fill="white"
    />
    <path
      d="M20.9282 18.4581C20.8196 18.3929 20.711 18.3712 20.6132 18.3929C20.5155 18.4146 20.4395 18.4798 20.3743 18.5884L20.1245 19.012L20.8522 19.4356L21.102 19.0011C21.1672 18.8925 21.178 18.7948 21.1454 18.697C21.1128 18.5993 21.0368 18.5232 20.9282 18.4581Z"
      fill="white"
    />
    <path
      d="M28.0103 10.9429C27.8583 10.6713 27.6736 10.4324 27.4564 10.2152C26.7722 9.54181 25.8273 9.17254 24.8389 9.17254H24.3502C23.036 9.29201 21.8739 10.1174 21.244 11.3121L20.4512 12.6915C19.7669 13.8644 19.1696 14.8962 18.6809 15.7325C18.594 15.8737 18.5179 16.004 18.4419 16.1343C18.3876 16.2212 18.3333 16.3081 18.2899 16.395C18.2247 16.4928 18.1704 16.5905 18.1161 16.6882C18.0292 16.8294 17.9532 16.9598 17.8771 17.0792C17.8554 17.1227 17.8337 17.1553 17.8011 17.1987C17.7577 17.2747 17.7142 17.3399 17.6708 17.4051C17.5513 17.6006 17.4427 17.7417 17.3775 17.8395C16.639 18.8061 15.5203 19.3274 14.3582 19.3274C14.3039 19.3274 14.2388 19.3274 14.1845 19.3274C13.8043 19.3057 13.4133 19.2297 13.0441 19.0994C11.4475 18.5563 10.4158 17.101 10.4158 15.4175C10.4158 15.1026 10.4592 14.8093 10.5352 14.5269C10.5569 14.4292 10.5895 14.3423 10.6221 14.2446C10.6873 14.0491 10.7633 13.8644 10.8502 13.6907C10.8936 13.6038 10.9262 13.5277 10.9697 13.4517C11.0565 13.2888 11.1434 13.1259 11.2412 12.9738C11.252 12.9521 11.2738 12.9195 11.2846 12.8978C11.3824 12.7458 11.4693 12.5937 11.567 12.4525C12.0123 11.7574 12.4141 11.1384 12.3816 10.5301C12.3816 10.4433 12.3598 10.3564 12.3381 10.2804C12.3273 10.2586 12.3273 10.226 12.3164 10.2043C12.3055 10.1717 12.2947 10.15 12.2838 10.1174C12.1426 9.78075 11.8711 9.54181 11.6104 9.38976C11.5236 9.33546 11.4258 9.29201 11.3389 9.25943C11.2846 9.23771 11.2195 9.22685 11.1651 9.20513C11.1651 9.20513 11.1651 9.20513 11.1543 9.20513H11.1434H11.1217C10.5026 9.09652 9.77496 9.21599 9.64463 9.23771C9.63377 9.23771 9.62291 9.23771 9.62291 9.23771C8.60199 9.41148 7.63538 9.99797 7.10319 10.856C6.38638 11.9638 6.38638 13.3648 7.04889 14.5052L14.4668 27.3427C15.1185 28.4505 16.2589 29.1022 17.5296 29.113C18.8112 29.113 19.9407 28.4505 20.5924 27.3427L28.0103 14.5052C28.6728 13.3757 28.6728 12.0615 28.0103 10.9429ZM21.1788 21.4018C21.1571 21.5648 21.0811 21.7385 20.9616 21.9449L20.5163 22.716L18.2356 21.391L18.6809 20.6199C18.8003 20.4244 18.9089 20.2723 19.0284 20.1637C19.1479 20.0551 19.2673 20.0008 19.4085 19.9899C19.5497 19.9791 19.68 19.9899 19.8321 20.0334C19.9733 20.0768 20.1471 20.1637 20.3534 20.2832C20.5598 20.4027 20.7227 20.5113 20.8422 20.6199C20.9616 20.7176 21.0594 20.8371 21.1245 20.9674C21.1788 21.0977 21.2006 21.2498 21.1788 21.4018ZM22.4387 19.3926L21.5155 19.2188L21.2549 19.6641L22.026 20.1094L21.7545 20.5764L19.4737 19.2514L19.9842 18.3608C20.2991 17.8178 20.701 17.6983 21.2006 17.9915C21.4938 18.1653 21.6567 18.4043 21.6676 18.7084L22.7319 18.893L22.4387 19.3926ZM22.96 18.4803L20.6792 17.1553L20.9508 16.6882L23.2315 18.0133L22.96 18.4803ZM23.7094 17.1878L21.1137 16.395L21.3961 15.9063L23.5031 16.6014L23.5899 16.4493L21.9391 14.9614L22.2215 14.4726L24.1982 16.3298L23.7094 17.1878ZM24.6978 15.4936L22.417 14.1685L23.275 12.6915L23.6768 12.9304L23.0903 13.9405L23.6225 14.2446L24.0895 13.43L24.4914 13.6581L24.0244 14.4726L24.5674 14.7876L25.1539 13.7775L25.5558 14.0165L24.6978 15.4936Z"
      fill="white"
    />
    <path
      d="M20.3321 20.9359C20.2669 20.8925 20.1692 20.8273 20.0388 20.7621C19.9085 20.6861 19.8107 20.6318 19.7239 20.5992C19.637 20.5666 19.5609 20.5449 19.4741 20.5449C19.3872 20.5449 19.322 20.5666 19.2568 20.6209C19.1917 20.6753 19.1265 20.7513 19.0722 20.8707L18.8984 21.1749L20.3755 22.0329L20.5493 21.7288C20.647 21.5658 20.6796 21.4138 20.6362 21.2835C20.6144 21.164 20.5058 21.0554 20.3321 20.9359Z"
      fill="white"
    />
    <ellipse cx="31.5338" cy="31.5793" rx="8.46641" ry="8.42105" fill="white" />
    <g clipPath="url(#clip0_34535_26368)">
      <path
        d="M23.0674 31.5793C23.0674 26.9279 26.8574 23.1582 31.5338 23.1582C36.2102 23.1582 40.0002 26.9279 40.0002 31.5793C40.0002 36.2306 36.2102 40.0003 31.5338 40.0003C26.8574 40.0003 23.0674 36.2306 23.0674 31.5793ZM35.3635 30.1253C35.724 29.7668 35.724 29.1812 35.3635 28.8227C35.003 28.4641 34.4144 28.4641 34.0539 28.8227L30.4755 32.3819L29.0137 30.9279C28.6532 30.5694 28.0645 30.5694 27.7041 30.9279C27.3436 31.2865 27.3436 31.872 27.7041 32.2306L29.8207 34.3358C30.1812 34.6944 30.7698 34.6944 31.1303 34.3358L35.3635 30.1253Z"
        fill="#00B51D"
      />
    </g>
    <defs>
      <clipPath id="clip0_34535_26368">
        <rect
          width="16.9328"
          height="16.8421"
          fill="white"
          transform="translate(23.0674 23.1582)"
        />
      </clipPath>
    </defs>
  </svg>
);

export const VDrivePendingIcon = () => (
  <svg
    width="41"
    height="40"
    viewBox="0 0 41 40"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <circle cx="18" cy="18" r="18" fill="#172A55" />
    <path
      d="M14.6872 12.6855C13.1232 12.6855 11.8091 13.9997 11.8091 15.5637C11.8091 17.1276 13.0907 18.4418 14.6872 18.4418C16.2837 18.4418 17.5653 17.1276 17.5653 15.5637C17.5653 13.9997 16.2837 12.6855 14.6872 12.6855ZM15.0999 16.9864H14.2962L13.4599 14.2386H14.1224L14.6981 16.2913L15.2737 14.2278H15.9253L15.0999 16.9864Z"
      fill="white"
    />
    <path
      d="M21.3955 18.5928C21.2869 18.5277 21.1783 18.506 21.0805 18.5277C20.9828 18.5494 20.9068 18.6146 20.8416 18.7232L20.5918 19.1467L21.3195 19.5703L21.5693 19.1359C21.6344 19.0273 21.6453 18.9295 21.6127 18.8318C21.5801 18.734 21.5041 18.658 21.3955 18.5928Z"
      fill="white"
    />
    <path
      d="M28.4776 11.0776C28.3255 10.8061 28.1409 10.5672 27.9237 10.35C27.2395 9.67658 26.2946 9.30731 25.3062 9.30731H24.8175C23.5033 9.42678 22.3412 10.2522 21.7113 11.4469L20.9185 12.8262C20.2342 13.9992 19.6369 15.031 19.1481 15.8673C19.0612 16.0084 18.9852 16.1388 18.9092 16.2691C18.8549 16.356 18.8006 16.4429 18.7571 16.5298C18.692 16.6275 18.6377 16.7253 18.5834 16.823C18.4965 16.9642 18.4205 17.0945 18.3444 17.214C18.3227 17.2574 18.301 17.29 18.2684 17.3335C18.225 17.4095 18.1815 17.4747 18.1381 17.5398C18.0186 17.7353 17.91 17.8765 17.8448 17.9743C17.1063 18.9409 15.9876 19.4622 14.8255 19.4622C14.7712 19.4622 14.7061 19.4622 14.6517 19.4622C14.2716 19.4405 13.8806 19.3644 13.5114 19.2341C11.9148 18.6911 10.883 17.2357 10.883 15.5523C10.883 15.2373 10.9265 14.9441 11.0025 14.6617C11.0242 14.564 11.0568 14.4771 11.0894 14.3793C11.1546 14.1838 11.2306 13.9992 11.3175 13.8254C11.3609 13.7385 11.3935 13.6625 11.4369 13.5865C11.5238 13.4236 11.6107 13.2607 11.7085 13.1086C11.7193 13.0869 11.741 13.0543 11.7519 13.0326C11.8497 12.8805 11.9365 12.7285 12.0343 12.5873C12.4796 11.8922 12.8814 11.2731 12.8488 10.6649C12.8488 10.578 12.8271 10.4911 12.8054 10.4151C12.7945 10.3934 12.7945 10.3608 12.7837 10.3391C12.7728 10.3065 12.762 10.2848 12.7511 10.2522C12.6099 9.91552 12.3384 9.67658 12.0777 9.52453C11.9908 9.47022 11.8931 9.42678 11.8062 9.3942C11.7519 9.37248 11.6867 9.36161 11.6324 9.33989C11.6324 9.33989 11.6324 9.33989 11.6216 9.33989H11.6107H11.589C10.9699 9.23128 10.2422 9.35075 10.1119 9.37248C10.1011 9.37248 10.0902 9.37248 10.0902 9.37248C9.06927 9.54625 8.10266 10.1327 7.57048 10.9907C6.85366 12.0985 6.85366 13.4996 7.51617 14.64L14.9341 27.4775C15.5858 28.5853 16.7262 29.2369 17.9969 29.2478C19.2785 29.2478 20.408 28.5853 21.0596 27.4775L28.4776 14.64C29.1401 13.5105 29.1401 12.1963 28.4776 11.0776ZM21.6461 21.5366C21.6244 21.6995 21.5484 21.8733 21.4289 22.0797L20.9836 22.8508L18.7028 21.5258L19.1481 20.7546C19.2676 20.5591 19.3762 20.4071 19.4957 20.2985C19.6152 20.1899 19.7346 20.1356 19.8758 20.1247C20.017 20.1138 20.1473 20.1247 20.2994 20.1681C20.4406 20.2116 20.6143 20.2985 20.8207 20.4179C21.0271 20.5374 21.19 20.646 21.3094 20.7546C21.4289 20.8524 21.5267 20.9719 21.5918 21.1022C21.6461 21.2325 21.6678 21.3846 21.6461 21.5366ZM22.906 19.5274L21.9828 19.3536L21.7222 19.7989L22.4933 20.2442L22.2218 20.7112L19.941 19.3862L20.4514 18.4956C20.7664 17.9525 21.1683 17.8331 21.6678 18.1263C21.9611 18.3001 22.124 18.539 22.1349 18.8431L23.1992 19.0278L22.906 19.5274ZM23.4273 18.615L21.1465 17.29L21.418 16.823L23.6988 18.148L23.4273 18.615ZM24.1767 17.3226L21.581 16.5298L21.8633 16.041L23.9703 16.7361L24.0572 16.5841L22.4064 15.0961L22.6888 14.6074L24.6654 16.4646L24.1767 17.3226ZM25.165 15.6283L22.8843 14.3033L23.7423 12.8262L24.1441 13.0652L23.5576 14.0752L24.0898 14.3793L24.5568 13.5648L24.9587 13.7928L24.4917 14.6074L25.0347 14.9224L25.6212 13.9123L26.023 14.1512L25.165 15.6283Z"
      fill="white"
    />
    <path
      d="M20.7994 21.0707C20.7342 21.0272 20.6364 20.9621 20.5061 20.8969C20.3758 20.8209 20.278 20.7666 20.1911 20.734C20.1043 20.7014 20.0282 20.6797 19.9413 20.6797C19.8545 20.6797 19.7893 20.7014 19.7241 20.7557C19.659 20.81 19.5938 20.886 19.5395 21.0055L19.3657 21.3096L20.8428 22.1676L21.0166 21.8635C21.1143 21.7006 21.1469 21.5486 21.1035 21.4182C21.0817 21.2988 20.9731 21.1901 20.7994 21.0707Z"
      fill="white"
    />
    <ellipse
      cx="31.5338"
      cy="31.5793"
      rx="8.46641"
      ry="8.42105"
      fill="#FF9900"
    />
    <g clipPath="url(#clip0_34535_26315)">
      <path
        d="M32.5259 27.3032C32.5259 27.8483 32.0814 28.2901 31.5337 28.2901C30.9859 28.2901 30.5415 27.8483 30.5415 27.3032C30.5415 26.7582 30.9859 26.3164 31.5337 26.3164C32.0814 26.3164 32.5259 26.7582 32.5259 27.3032ZM32.5259 35.8559C32.5259 36.4007 32.0814 36.8427 31.5337 36.8427C30.9859 36.8427 30.5415 36.4007 30.5415 35.8559C30.5415 35.3111 30.9859 34.869 31.5337 34.869C32.0814 34.869 32.5259 35.3111 32.5259 35.8559ZM26.2422 31.5796C26.2422 31.0347 26.6864 30.5927 27.2343 30.5927C27.7823 30.5927 28.2265 31.0347 28.2265 31.5796C28.2265 32.1244 27.7823 32.5664 27.2343 32.5664C26.6864 32.5664 26.2422 32.1244 26.2422 31.5796ZM36.8252 31.5796C36.8252 32.1244 36.3808 32.5664 35.833 32.5664C35.2853 32.5664 34.8409 32.1244 34.8409 31.5796C34.8409 31.0347 35.2853 30.5927 35.833 30.5927C36.3808 30.5927 36.8252 31.0347 36.8252 31.5796ZM27.792 35.3008C27.4045 34.9163 27.4045 34.2913 27.792 33.9048C28.1796 33.5204 28.8073 33.5204 29.1959 33.9048C29.5825 34.2913 29.5825 34.9163 29.1959 35.3008C28.8073 35.6873 28.1796 35.6873 27.792 35.3008ZM29.1959 29.2543C28.8073 29.6388 28.1796 29.6388 27.792 29.2543C27.4047 28.8678 27.4047 28.2434 27.792 27.8579C28.1796 27.4725 28.8073 27.4725 29.1959 27.8579C29.5825 28.2434 29.5825 28.8678 29.1959 29.2543ZM33.8715 33.9048C34.2601 33.5204 34.8884 33.5204 35.275 33.9048C35.6635 34.2913 35.6635 34.9163 35.275 35.3008C34.8884 35.6873 34.2601 35.6873 33.8715 35.3008C33.4849 34.9163 33.4849 34.2913 33.8715 33.9048Z"
        fill="white"
      />
    </g>
    <defs>
      <clipPath id="clip0_34535_26315">
        <rect
          width="10.583"
          height="10.5263"
          fill="white"
          transform="translate(26.2422 26.3164)"
        />
      </clipPath>
    </defs>
  </svg>
);

export const VDriveCancelledIcon = () => (
  <svg
    width="41"
    height="40"
    viewBox="0 0 41 40"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <ellipse cx="18" cy="17.9036" rx="18" ry="17.9036" fill="#172A55" />
    <path
      d="M14.22 12.4839C12.6561 12.4839 11.3419 13.791 11.3419 15.3466C11.3419 16.9022 12.6235 18.2093 14.22 18.2093C15.8166 18.2093 17.0982 16.9022 17.0982 15.3466C17.0982 13.791 15.8166 12.4839 14.22 12.4839ZM14.6328 16.7617H13.8291L12.9928 14.0287H13.6553L14.2309 16.0704L14.8065 14.0179H15.4582L14.6328 16.7617Z"
      fill="white"
    />
    <path
      d="M20.9283 18.3605C20.8197 18.2957 20.7111 18.2741 20.6134 18.2957C20.5156 18.3173 20.4396 18.3821 20.3744 18.4901L20.1246 18.9115L20.8523 19.3328L21.1021 18.9006C21.1673 18.7926 21.1781 18.6954 21.1456 18.5982C21.113 18.501 21.0369 18.4253 20.9283 18.3605Z"
      fill="white"
    />
    <path
      d="M28.0104 10.8845C27.8584 10.6144 27.6737 10.3768 27.4565 10.1607C26.7723 9.49094 25.8274 9.12365 24.8391 9.12365H24.3503C23.0362 9.24248 21.8741 10.0635 21.2441 11.2518L20.4513 12.6237C19.7671 13.7904 19.1697 14.8166 18.681 15.6485C18.5941 15.7889 18.5181 15.9185 18.442 16.0482C18.3877 16.1346 18.3334 16.221 18.29 16.3074C18.2248 16.4046 18.1705 16.5019 18.1162 16.5991C18.0293 16.7395 17.9533 16.8692 17.8773 16.988C17.8555 17.0312 17.8338 17.0636 17.8012 17.1068C17.7578 17.1824 17.7144 17.2472 17.6709 17.3121C17.5514 17.5065 17.4428 17.6469 17.3777 17.7442C16.6391 18.7056 15.5205 19.2241 14.3584 19.2241C14.3041 19.2241 14.2389 19.2241 14.1846 19.2241C13.8045 19.2025 13.4135 19.1269 13.0442 18.9973C11.4477 18.4571 10.4159 17.0096 10.4159 15.3352C10.4159 15.0219 10.4593 14.7302 10.5353 14.4494C10.5571 14.3521 10.5896 14.2657 10.6222 14.1685C10.6874 13.974 10.7634 13.7904 10.8503 13.6176C10.8937 13.5311 10.9263 13.4555 10.9698 13.3799C11.0567 13.2179 11.1435 13.0558 11.2413 12.9046C11.2522 12.883 11.2739 12.8506 11.2847 12.829C11.3825 12.6777 11.4694 12.5265 11.5671 12.3861C12.0124 11.6947 12.4143 11.0789 12.3817 10.474C12.3817 10.3876 12.36 10.3011 12.3382 10.2255C12.3274 10.2039 12.3274 10.1715 12.3165 10.1499C12.3057 10.1175 12.2948 10.0959 12.2839 10.0635C12.1427 9.7286 11.8712 9.49094 11.6106 9.3397C11.5237 9.28569 11.4259 9.24248 11.339 9.21007C11.2847 9.18847 11.2196 9.17766 11.1653 9.15606C11.1653 9.15606 11.1653 9.15606 11.1544 9.15606H11.1435H11.1218C10.5028 9.04803 9.77508 9.16686 9.64475 9.18847C9.63389 9.18847 9.62303 9.18847 9.62303 9.18847C8.60211 9.36131 7.6355 9.94465 7.10332 10.7981C6.3865 11.8999 6.3865 13.2935 7.04901 14.4278L14.467 27.1965C15.1186 28.2984 16.259 28.9465 17.5297 28.9573C18.8113 28.9573 19.9408 28.2984 20.5925 27.1965L28.0104 14.4278C28.6729 13.3043 28.6729 11.9972 28.0104 10.8845ZM21.179 21.2874C21.1572 21.4495 21.0812 21.6223 20.9617 21.8276L20.5165 22.5946L18.2357 21.2766L18.681 20.5097C18.8004 20.3152 18.909 20.164 19.0285 20.0559C19.148 19.9479 19.2675 19.8939 19.4086 19.8831C19.5498 19.8723 19.6802 19.8831 19.8322 19.9263C19.9734 19.9695 20.1472 20.0559 20.3535 20.1748C20.5599 20.2936 20.7228 20.4016 20.8423 20.5097C20.9617 20.6069 21.0595 20.7257 21.1247 20.8553C21.179 20.985 21.2007 21.1362 21.179 21.2874ZM22.4388 19.2889L21.5157 19.1161L21.255 19.559L22.0261 20.0019L21.7546 20.4664L19.4738 19.1485L19.9843 18.2627C20.2992 17.7226 20.7011 17.6037 21.2007 17.8954C21.4939 18.0683 21.6568 18.3059 21.6677 18.6084L22.7321 18.792L22.4388 19.2889ZM22.9601 18.3815L20.6794 17.0636L20.9509 16.5991L23.2317 17.917L22.9601 18.3815ZM23.7095 17.096L21.1138 16.3074L21.3962 15.8213L23.5032 16.5127L23.5901 16.3614L21.9392 14.8815L22.2216 14.3953L24.1983 16.2426L23.7095 17.096ZM24.6979 15.4108L22.4171 14.0929L23.2751 12.6237L23.677 12.8614L23.0905 13.866L23.6227 14.1685L24.0897 13.3583L24.4915 13.5851L24.0245 14.3953L24.5675 14.7086L25.154 13.704L25.5559 13.9416L24.6979 15.4108Z"
      fill="white"
    />
    <path
      d="M20.3322 20.8235C20.267 20.7803 20.1693 20.7154 20.0389 20.6506C19.9086 20.575 19.8109 20.521 19.724 20.4886C19.6371 20.4562 19.5611 20.4346 19.4742 20.4346C19.3873 20.4346 19.3221 20.4562 19.257 20.5102C19.1918 20.5642 19.1266 20.6398 19.0723 20.7587L18.8986 21.0611L20.3756 21.9145L20.5494 21.6121C20.6472 21.45 20.6797 21.2988 20.6363 21.1692C20.6146 21.0503 20.506 20.9423 20.3322 20.8235Z"
      fill="white"
    />
    <ellipse
      cx="31.5335"
      cy="31.5788"
      rx="8.46641"
      ry="8.42105"
      fill="#E61E29"
    />
    <g clipPath="url(#clip0_19711_24503)">
      <path
        d="M35.4476 34.3618C35.7783 34.6702 35.7783 35.1698 35.4476 35.4782C35.2835 35.6323 35.0666 35.7088 34.8496 35.7088C34.6327 35.7088 34.4163 35.6317 34.2512 35.4775L31.4631 32.8791L28.6752 35.4769C28.5099 35.6323 28.2932 35.7088 28.0765 35.7088C27.8598 35.7088 27.6434 35.6323 27.4779 35.4769C27.1472 35.1685 27.1472 34.6689 27.4779 34.3606L30.2665 31.7602L27.4779 29.1611C27.1472 28.8527 27.1472 28.3532 27.4779 28.0448C27.8086 27.7364 28.3444 27.7364 28.6751 28.0448L31.4631 30.6463L34.2517 28.046C34.5824 27.7376 35.1182 27.7376 35.4489 28.046C35.7796 28.3544 35.7796 28.854 35.4489 29.1624L32.6603 31.7627L35.4476 34.3618Z"
        fill="white"
      />
    </g>
    <defs>
      <clipPath id="clip0_19711_24503">
        <rect
          width="8.46641"
          height="12.6316"
          fill="white"
          transform="translate(27.2299 25.4458)"
        />
      </clipPath>
    </defs>
  </svg>
);

export const VDriveTruckIcon = () => (
  <svg
    width="41"
    height="40"
    viewBox="0 0 41 40"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <circle cx="18" cy="18.1577" r="18" fill="#172A55" />
    <path
      d="M14.6876 12.8418C13.1236 12.8418 11.8094 14.156 11.8094 15.7199C11.8094 17.2839 13.091 18.598 14.6876 18.598C16.2841 18.598 17.5657 17.2839 17.5657 15.7199C17.5657 14.156 16.2841 12.8418 14.6876 12.8418ZM15.1003 17.1427H14.2966L13.4603 14.3949H14.1228L14.6984 16.4476L15.2741 14.384H15.9257L15.1003 17.1427Z"
      fill="white"
    />
    <path
      d="M21.3957 18.7501C21.2871 18.6849 21.1785 18.6632 21.0808 18.6849C20.983 18.7066 20.907 18.7718 20.8418 18.8804L20.592 19.304L21.3197 19.7275L21.5695 19.2931C21.6347 19.1845 21.6455 19.0868 21.613 18.989C21.5804 18.8913 21.5044 18.8152 21.3957 18.7501Z"
      fill="white"
    />
    <path
      d="M28.4778 11.2344C28.3258 10.9628 28.1412 10.7239 27.9239 10.5067C27.2397 9.83332 26.2948 9.46405 25.3065 9.46405H24.8177C23.5036 9.58352 22.3415 10.4089 21.7115 11.6036L20.9187 12.983C20.2345 14.1559 19.6371 15.1877 19.1484 16.024C19.0615 16.1652 18.9855 16.2955 18.9094 16.4258C18.8551 16.5127 18.8008 16.5996 18.7574 16.6865C18.6922 16.7843 18.6379 16.882 18.5836 16.9797C18.4967 17.1209 18.4207 17.2513 18.3447 17.3707C18.323 17.4142 18.3012 17.4468 18.2687 17.4902C18.2252 17.5662 18.1818 17.6314 18.1383 17.6966C18.0189 17.8921 17.9102 18.0332 17.8451 18.131C17.1065 19.0976 15.9879 19.6189 14.8258 19.6189C14.7715 19.6189 14.7063 19.6189 14.652 19.6189C14.2719 19.5972 13.8809 19.5212 13.5116 19.3909C11.9151 18.8478 10.8833 17.3925 10.8833 15.709C10.8833 15.3941 10.9267 15.1008 11.0027 14.8184C11.0245 14.7207 11.0571 14.6338 11.0896 14.5361C11.1548 14.3406 11.2308 14.1559 11.3177 13.9822C11.3612 13.8953 11.3937 13.8192 11.4372 13.7432C11.5241 13.5803 11.611 13.4174 11.7087 13.2653C11.7196 13.2436 11.7413 13.211 11.7521 13.1893C11.8499 13.0373 11.9368 12.8852 12.0345 12.744C12.4798 12.0489 12.8817 11.4299 12.8491 10.8217C12.8491 10.7348 12.8274 10.6479 12.8056 10.5719C12.7948 10.5501 12.7948 10.5175 12.7839 10.4958C12.7731 10.4632 12.7622 10.4415 12.7513 10.4089C12.6102 10.0723 12.3386 9.83332 12.078 9.68126C11.9911 9.62696 11.8933 9.58352 11.8065 9.55094C11.7521 9.52921 11.687 9.51835 11.6327 9.49663C11.6327 9.49663 11.6327 9.49663 11.6218 9.49663H11.611H11.5892C10.9702 9.38802 10.2425 9.50749 10.1122 9.52921C10.1013 9.52921 10.0904 9.52921 10.0904 9.52921C9.06952 9.70299 8.1029 10.2895 7.57072 11.1475C6.85391 12.2553 6.85391 13.6563 7.51642 14.7967L14.9344 27.6342C15.586 28.742 16.7264 29.3937 17.9971 29.4046C19.2787 29.4046 20.4082 28.742 21.0599 27.6342L28.4778 14.7967C29.1404 13.6672 29.1404 12.353 28.4778 11.2344ZM21.6464 21.6934C21.6247 21.8563 21.5486 22.03 21.4292 22.2364L20.9839 23.0075L18.7031 21.6825L19.1484 20.9114C19.2678 20.7159 19.3765 20.5638 19.4959 20.4552C19.6154 20.3466 19.7349 20.2923 19.8761 20.2814C20.0172 20.2706 20.1476 20.2814 20.2996 20.3249C20.4408 20.3683 20.6146 20.4552 20.8209 20.5747C21.0273 20.6942 21.1902 20.8028 21.3097 20.9114C21.4292 21.0091 21.5269 21.1286 21.5921 21.2589C21.6464 21.3892 21.6681 21.5413 21.6464 21.6934ZM22.9062 19.6841L21.9831 19.5103L21.7224 19.9556L22.4935 20.4009L22.222 20.8679L19.9412 19.5429L20.4517 18.6523C20.7666 18.1093 21.1685 17.9898 21.6681 18.2831C21.9613 18.4568 22.1242 18.6958 22.1351 18.9999L23.1995 19.1845L22.9062 19.6841ZM23.4275 18.7718L21.1468 17.4468L21.4183 16.9797L23.6991 18.3048L23.4275 18.7718ZM24.1769 17.4793L21.5812 16.6865L21.8636 16.1978L23.9706 16.8929L24.0575 16.7408L22.4066 15.2529L22.689 14.7641L24.6657 16.6213L24.1769 17.4793ZM25.1653 15.7851L22.8845 14.46L23.7425 12.983L24.1444 13.2219L23.5579 14.232L24.0901 14.5361L24.5571 13.7215L24.9589 13.9496L24.4919 14.7641L25.035 15.0791L25.6214 14.069L26.0233 14.308L25.1653 15.7851Z"
      fill="white"
    />
    <path
      d="M20.7996 21.2264C20.7344 21.183 20.6367 21.1178 20.5064 21.0527C20.376 20.9766 20.2783 20.9223 20.1914 20.8898C20.1045 20.8572 20.0285 20.8354 19.9416 20.8354C19.8547 20.8354 19.7895 20.8572 19.7244 20.9115C19.6592 20.9658 19.594 21.0418 19.5397 21.1613L19.366 21.4654L20.843 22.3234L21.0168 22.0193C21.1146 21.8564 21.1471 21.7043 21.1037 21.574C21.082 21.4545 20.9734 21.3459 20.7996 21.2264Z"
      fill="white"
    />
    <ellipse
      cx="31.5335"
      cy="31.5788"
      rx="8.46641"
      ry="8.42105"
      fill="#0068EE"
    />
    <g clipPath="url(#clip0_23594_22828)">
      <path
        d="M27.176 27C26.6938 27 26.3025 27.3779 26.3025 27.8438V33.4688C26.3025 33.9346 26.6938 34.3125 27.176 34.3125H27.4672C27.4672 35.2441 28.2497 36 29.2143 36C30.1788 36 30.9613 35.2441 30.9613 34.3125H33.2907C33.2907 35.2441 34.0733 36 35.0378 36C36.0023 36 36.7848 35.2441 36.7848 34.3125H37.3672C37.6893 34.3125 37.9495 34.0611 37.9495 33.75C37.9495 33.4389 37.6893 33.1875 37.3672 33.1875V32.0625V31.5V31.1713C37.3672 30.8725 37.2453 30.5859 37.0269 30.375L35.6201 29.0162C35.4018 28.8053 35.1051 28.6875 34.7957 28.6875H33.8731V27.8438C33.8731 27.3779 33.4818 27 32.9995 27H27.176ZM33.8731 29.8125H34.7957L36.2025 31.1713V31.5H33.8731V29.8125ZM28.3407 34.3125C28.3407 34.0887 28.4328 33.8741 28.5966 33.7159C28.7604 33.5576 28.9826 33.4688 29.2143 33.4688C29.4459 33.4688 29.6681 33.5576 29.8319 33.7159C29.9958 33.8741 30.0878 34.0887 30.0878 34.3125C30.0878 34.5363 29.9958 34.7509 29.8319 34.9091C29.6681 35.0674 29.4459 35.1562 29.2143 35.1562C28.9826 35.1562 28.7604 35.0674 28.5966 34.9091C28.4328 34.7509 28.3407 34.5363 28.3407 34.3125ZM35.0378 33.4688C35.2695 33.4688 35.4916 33.5576 35.6555 33.7159C35.8193 33.8741 35.9113 34.0887 35.9113 34.3125C35.9113 34.5363 35.8193 34.7509 35.6555 34.9091C35.4916 35.0674 35.2695 35.1562 35.0378 35.1562C34.8061 35.1562 34.5839 35.0674 34.4201 34.9091C34.2563 34.7509 34.1643 34.5363 34.1643 34.3125C34.1643 34.0887 34.2563 33.8741 34.4201 33.7159C34.5839 33.5576 34.8061 33.4688 35.0378 33.4688Z"
        fill="white"
      />
    </g>
    <defs>
      <clipPath id="clip0_23594_22828">
        <rect
          width="11"
          height="9"
          fill="white"
          transform="translate(26.3025 27)"
        />
      </clipPath>
    </defs>
  </svg>
);

export const TruckIcon = (props: React.SVGProps<SVGSVGElement>) => (
  <svg
    width="64"
    height="64"
    viewBox="0 0 64 64"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <circle cx="32" cy="32" r="32" fill="#0068EE" />
    <g clipPath="url(#clip0_35576_43676)">
      <path
        d="M19.2 24.0008C19.2 22.2358 20.635 20.8008 22.4 20.8008H36.8C38.565 20.8008 40 22.2358 40 24.0008V25.6008H42.535C43.385 25.6008 44.2 25.9358 44.8 26.5358L47.065 28.8008C47.665 29.4008 48 30.2158 48 31.0658V38.4008C48 40.1658 46.565 41.6008 44.8 41.6008H44.635C44.115 43.4458 42.415 44.8008 40.4 44.8008C38.385 44.8008 36.69 43.4458 36.165 41.6008H31.035C30.515 43.4458 28.815 44.8008 26.8 44.8008C24.785 44.8008 23.09 43.4458 22.565 41.6008H22.4C20.635 41.6008 19.2 40.1658 19.2 38.4008V36.0008H17.2C16.535 36.0008 16 35.4658 16 34.8008C16 34.1358 16.535 33.6008 17.2 33.6008H22.8C23.465 33.6008 24 33.0658 24 32.4008C24 31.7358 23.465 31.2008 22.8 31.2008H17.2C16.535 31.2008 16 30.6658 16 30.0008C16 29.3358 16.535 28.8008 17.2 28.8008H26C26.665 28.8008 27.2 28.2658 27.2 27.6008C27.2 26.9358 26.665 26.4008 26 26.4008H17.2C16.535 26.4008 16 25.8658 16 25.2008C16 24.5358 16.535 24.0008 17.2 24.0008H19.2ZM44.8 33.6008V31.0658L42.535 28.8008H40V33.6008H44.8ZM28.8 40.4008C28.8 39.2958 27.905 38.4008 26.8 38.4008C25.695 38.4008 24.8 39.2958 24.8 40.4008C24.8 41.5058 25.695 42.4008 26.8 42.4008C27.905 42.4008 28.8 41.5058 28.8 40.4008ZM40.4 42.4008C41.505 42.4008 42.4 41.5058 42.4 40.4008C42.4 39.2958 41.505 38.4008 40.4 38.4008C39.295 38.4008 38.4 39.2958 38.4 40.4008C38.4 41.5058 39.295 42.4008 40.4 42.4008Z"
        fill="white"
      />
    </g>
    <defs>
      <clipPath id="clip0_35576_43676">
        <rect
          width="32"
          height="32"
          fill="white"
          transform="translate(16 16)"
        />
      </clipPath>
    </defs>
  </svg>
);

export const VDriveLogo = (props: React.SVGProps<SVGSVGElement>) => (
  <svg
    width="125"
    height="125"
    viewBox="0 0 125 125"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <circle cx="62.5" cy="62.5" r="62.5" fill="#172A55" />
    <path
      d="M51.5408 44.582C46.1966 44.582 41.7061 49.0726 41.7061 54.4168C41.7061 59.761 46.0853 64.2515 51.5408 64.2515C56.9963 64.2515 61.3756 59.761 61.3756 54.4168C61.3756 49.0726 56.9963 44.582 51.5408 44.582ZM52.9511 59.2785H50.2048L47.3471 49.8891H49.611L51.5779 56.9033L53.5449 49.852H55.7716L52.9511 59.2785Z"
      fill="white"
    />
    <path
      d="M74.105 64.7759C73.7338 64.5532 73.3627 64.479 73.0287 64.5532C72.6947 64.6274 72.4349 64.8501 72.2122 65.2212L71.3586 66.6686L73.8452 68.116L74.6987 66.6315C74.9214 66.2604 74.9585 65.9264 74.8472 65.5924C74.7359 65.2584 74.4761 64.9986 74.105 64.7759Z"
      fill="white"
    />
    <path
      d="M98.3021 39.0916C97.7825 38.1638 97.1516 37.3474 96.4094 36.6051C94.0713 34.3041 90.8425 33.0423 87.4653 33.0423H85.7953C81.3047 33.4506 77.3337 36.2711 75.1811 40.3535L72.472 45.0667C70.1339 49.0748 68.0927 52.6005 66.4227 55.4582C66.1258 55.9406 65.866 56.386 65.6062 56.8313C65.4206 57.1282 65.2351 57.4251 65.0866 57.722C64.8639 58.056 64.6784 58.39 64.4928 58.724C64.1959 59.2065 63.9361 59.6518 63.6763 60.0601C63.6021 60.2085 63.5279 60.3199 63.4166 60.4683C63.2681 60.7281 63.1197 60.9508 62.9712 61.1735C62.563 61.8415 62.1918 62.3239 61.9692 62.6579C59.4455 65.9609 55.623 67.7423 51.652 67.7423C51.4664 67.7423 51.2437 67.7423 51.0582 67.7423C49.7592 67.6681 48.4232 67.4083 47.1614 66.963C41.7059 65.1074 38.1802 60.1343 38.1802 54.3819C38.1802 53.3056 38.3286 52.3036 38.5884 51.3387C38.6626 51.0047 38.774 50.7078 38.8853 50.3738C39.108 49.7058 39.3678 49.0748 39.6647 48.481C39.8131 48.1841 39.9245 47.9244 40.0729 47.6646C40.3698 47.1079 40.6667 46.5512 41.0007 46.0316C41.0378 45.9574 41.1121 45.8461 41.1492 45.7718C41.4832 45.2523 41.7801 44.7327 42.1141 44.2502C43.6357 41.8751 45.0089 39.7597 44.8975 37.6814C44.8975 37.3845 44.8233 37.0876 44.7491 36.8278C44.712 36.7536 44.712 36.6422 44.6748 36.568C44.6377 36.4567 44.6006 36.3824 44.5635 36.2711C44.081 35.1206 43.1532 34.3041 42.2625 33.7846C41.9656 33.599 41.6316 33.4506 41.3347 33.3392C41.1492 33.265 40.9265 33.2279 40.7409 33.1537C40.7409 33.1537 40.7409 33.1537 40.7038 33.1537H40.6667H40.5925C38.4771 32.7825 35.9906 33.1908 35.5452 33.265C35.5081 33.265 35.471 33.265 35.471 33.265C31.9824 33.8588 28.6794 35.8629 26.8609 38.7947C24.4115 42.5802 24.4115 47.3677 26.6754 51.2645L52.0231 95.1312C54.2498 98.9167 58.1466 101.143 62.4887 101.181C66.868 101.181 70.7277 98.9167 72.9544 95.1312L98.3021 51.2645C100.566 47.4048 100.566 42.9142 98.3021 39.0916ZM74.9585 74.8308C74.8843 75.3875 74.6245 75.9813 74.2162 76.6864L72.6946 79.3214L64.901 74.7937L66.4227 72.1587C66.8309 71.4907 67.202 70.9711 67.6102 70.6C68.0185 70.2289 68.4267 70.0433 68.9092 70.0062C69.3916 69.9691 69.837 70.0062 70.3566 70.1546C70.839 70.3031 71.4328 70.6 72.1379 71.0082C72.8431 71.4164 73.3998 71.7876 73.808 72.1587C74.2162 72.4927 74.5502 72.9009 74.7729 73.3463C74.9585 73.7916 75.0327 74.3112 74.9585 74.8308ZM79.2635 67.965L76.109 67.3712L75.2183 68.8928L77.8532 70.4144L76.9254 72.0102L69.1318 67.4825L70.8761 64.4393C71.9524 62.5837 73.3255 62.1755 75.0327 63.1775C76.0347 63.7713 76.5914 64.5878 76.6285 65.6269L80.2655 66.2578L79.2635 67.965ZM81.0449 64.8476L73.2513 60.3199L74.1791 58.724L81.9727 63.2517L81.0449 64.8476ZM83.6056 60.4312L74.7358 57.722L75.7007 56.052L82.9005 58.4271L83.1974 57.9076L77.5563 52.8232L78.5213 51.1531L85.2757 57.4993L83.6056 60.4312ZM86.9829 54.6417L79.1893 50.114L82.1211 45.0667L83.4943 45.8832L81.4902 49.3346L83.3087 50.3738L84.9046 47.5904L86.2777 48.3697L84.6819 51.1531L86.5375 52.2294L88.5416 48.7779L89.9147 49.5944L86.9829 54.6417Z"
      fill="white"
    />
    <path
      d="M72.0639 73.2325C71.8412 73.0841 71.5072 72.8614 71.0618 72.6387C70.6165 72.3789 70.2825 72.1934 69.9856 72.082C69.6887 71.9707 69.4289 71.8965 69.132 71.8965C68.8351 71.8965 68.6124 71.9707 68.3897 72.1563C68.1671 72.3418 67.9444 72.6016 67.7588 73.0099L67.165 74.049L72.2123 76.9809L72.8061 75.9417C73.1401 75.385 73.2515 74.8655 73.103 74.4201C73.0288 74.0119 72.6577 73.6408 72.0639 73.2325Z"
      fill="white"
    />
  </svg>
);

export const StopVDriveLogo = (props: React.SVGProps<SVGSVGElement>) => (
  <svg
    width="128"
    height="120"
    viewBox="0 0 128 120"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <circle cx="59.9995" cy="59.9995" r="59.9995" fill="#172A55" />
    <path
      d="M48.5823 42.3965C43.1917 42.3965 38.6621 46.9261 38.6621 52.3167C38.6621 57.7072 43.0794 62.2368 48.5823 62.2368C54.0852 62.2368 58.5024 57.7072 58.5024 52.3167C58.5024 46.9261 54.0852 42.3965 48.5823 42.3965ZM50.0048 57.2206H47.2346L44.3522 47.7496H46.6357L48.6197 54.8248L50.6037 47.7122H52.8498L50.0048 57.2206Z"
      fill="white"
    />
    <path
      d="M71.3424 62.7625C70.9681 62.5378 70.5937 62.463 70.2568 62.5378C69.9199 62.6127 69.6579 62.8373 69.4333 63.2117L68.5723 64.6716L71.0804 66.1316L71.9414 64.6342C72.166 64.2598 72.2034 63.9229 72.0911 63.586C71.9788 63.2491 71.7168 62.9871 71.3424 62.7625Z"
      fill="white"
    />
    <path
      d="M95.7492 36.8574C95.2252 35.9216 94.5888 35.098 93.8401 34.3493C91.4817 32.0284 88.2249 30.7556 84.8183 30.7556H83.1338C78.6042 31.1674 74.5987 34.0124 72.4275 38.1302L69.6948 42.8844C67.3364 46.9273 65.2775 50.4836 63.5929 53.3661C63.2934 53.8527 63.0314 54.3019 62.7694 54.7512C62.5822 55.0506 62.395 55.3501 62.2453 55.6496C62.0207 55.9865 61.8335 56.3234 61.6463 56.6603C61.3468 57.147 61.0848 57.5962 60.8228 58.008C60.7479 58.1577 60.673 58.27 60.5607 58.4198C60.411 58.6818 60.2612 58.9064 60.1115 59.131C59.6997 59.8048 59.3254 60.2915 59.1008 60.6284C56.5552 63.9601 52.6995 65.7569 48.694 65.7569C48.5068 65.7569 48.2822 65.7569 48.095 65.7569C46.7848 65.6821 45.4371 65.42 44.1644 64.9708C38.6615 63.0991 35.1052 58.0828 35.1052 52.2805C35.1052 51.1949 35.2549 50.1841 35.517 49.2108C35.5918 48.8739 35.7042 48.5745 35.8165 48.2375C36.0411 47.5637 36.3031 46.9273 36.6026 46.3284C36.7523 46.0289 36.8646 45.7669 37.0144 45.5048C37.3138 44.9433 37.6133 44.3818 37.9502 43.8577C37.9877 43.7828 38.0625 43.6705 38.1 43.5957C38.4369 43.0716 38.7364 42.5475 39.0733 42.0608C40.6081 39.665 41.9932 37.5312 41.8809 35.4349C41.8809 35.1354 41.806 34.836 41.7311 34.5739C41.6937 34.499 41.6937 34.3867 41.6563 34.3119C41.6188 34.1996 41.5814 34.1247 41.5439 34.0124C41.0573 32.8519 40.1214 32.0284 39.223 31.5043C38.9235 31.3171 38.5866 31.1674 38.2871 31.0551C38.1 30.9802 37.8754 30.9428 37.6882 30.8679C37.6882 30.8679 37.6882 30.8679 37.6508 30.8679H37.6133H37.5384C35.4047 30.4935 32.8966 30.9053 32.4473 30.9802C32.4099 30.9802 32.3725 30.9802 32.3725 30.9802C28.8536 31.5792 25.5219 33.6006 23.6876 36.5579C21.217 40.3763 21.217 45.2053 23.5005 49.136L49.0683 93.3837C51.3144 97.202 55.245 99.4481 59.6249 99.4855C64.0421 99.4855 67.9353 97.202 70.1814 93.3837L95.7492 49.136C98.0327 45.2428 98.0327 40.7132 95.7492 36.8574ZM72.2029 72.9069C72.128 73.4685 71.866 74.0674 71.4542 74.7787L69.9194 77.4365L62.0581 72.8695L63.5929 70.2116C64.0047 69.5378 64.379 69.0137 64.7908 68.6394C65.2026 68.265 65.6144 68.0779 66.101 68.0404C66.5877 68.003 67.0369 68.0404 67.561 68.1902C68.0476 68.3399 68.6466 68.6394 69.3578 69.0512C70.0691 69.463 70.6306 69.8373 71.0424 70.2116C71.4542 70.5486 71.7911 70.9603 72.0157 71.4096C72.2029 71.8588 72.2777 72.3829 72.2029 72.9069ZM76.5453 65.9815L73.3633 65.3826L72.4649 66.9174L75.1228 68.4522L74.1869 70.0619L66.3256 65.4949L68.0851 62.4253C69.1707 60.5535 70.5558 60.1417 72.2777 61.1525C73.2885 61.7514 73.85 62.575 73.8874 63.6232L77.556 64.2595L76.5453 65.9815ZM78.3421 62.837L70.4809 58.27L71.4167 56.6603L79.278 61.2273L78.3421 62.837ZM80.9251 58.3823L71.9783 55.6496L72.9516 53.965L80.2139 56.3608L80.5134 55.8368L74.8233 50.7082L75.7966 49.0237L82.6097 55.425L80.9251 58.3823ZM84.3317 52.5425L76.4704 47.9755L79.4278 42.8844L80.8128 43.708L78.7914 47.1894L80.6257 48.2375L82.2353 45.4299L83.6204 46.2161L82.0107 49.0237L83.8825 50.1093L85.9039 46.6279L87.289 47.4514L84.3317 52.5425Z"
      fill="white"
    />
    <path
      d="M69.2832 71.2969C69.0586 71.1471 68.7216 70.9225 68.2724 70.6979C67.8232 70.4359 67.4863 70.2487 67.1868 70.1364C66.8873 70.0241 66.6253 69.9492 66.3258 69.9492C66.0263 69.9492 65.8017 70.0241 65.5771 70.2113C65.3525 70.3984 65.1279 70.6605 64.9407 71.0723L64.3418 72.1204L69.4329 75.0778L70.0319 74.0296C70.3688 73.4681 70.4811 72.944 70.3313 72.4948C70.2565 72.083 69.8821 71.7086 69.2832 71.2969Z"
      fill="white"
    />
    <circle cx="103.75" cy="95.9883" r="24" fill="#E61E29" />
    <g clipPath="url(#clip0_19667_16352)">
      <path
        d="M93.75 89.1966C93.75 87.3581 95.2448 85.8633 97.0833 85.8633H110.417C112.255 85.8633 113.75 87.3581 113.75 89.1966V102.53C113.75 104.368 112.255 105.863 110.417 105.863H97.0833C95.2448 105.863 93.75 104.368 93.75 102.53V89.1966Z"
        fill="white"
      />
    </g>
    <defs>
      <clipPath id="clip0_19667_16352">
        <rect
          width="20"
          height="24"
          fill="white"
          transform="translate(93.75 83.9883)"
        />
      </clipPath>
    </defs>
  </svg>
);

export const VDriveWhiteIcon = (props: React.SVGProps<SVGSVGElement>) => (
  <svg
    width="24"
    height="21"
    viewBox="0 0 24 21"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M8.17467 3.56738C6.52864 3.56738 5.14551 4.95051 5.14551 6.59655C5.14551 8.24258 6.49434 9.62571 8.17467 9.62571C9.855 9.62571 11.2038 8.24258 11.2038 6.59655C11.2038 4.95051 9.855 3.56738 8.17467 3.56738ZM8.60904 8.09398H7.76316L6.88299 5.20199H7.58027L8.1861 7.36241L8.79194 5.19056H9.47778L8.60904 8.09398Z"
      fill="white"
    />
    <path
      d="M15.1252 9.78712C15.0109 9.71853 14.8966 9.69567 14.7937 9.71853C14.6908 9.7414 14.6108 9.80998 14.5422 9.92429L14.2793 10.3701L15.0452 10.8159L15.3081 10.3587C15.3767 10.2444 15.3881 10.1415 15.3538 10.0386C15.3195 9.93572 15.2395 9.8557 15.1252 9.78712Z"
      fill="white"
    />
    <path
      d="M22.5775 1.87626C22.4175 1.59049 22.2231 1.33901 21.9945 1.1104C21.2744 0.401685 20.2799 0.013038 19.2397 0.013038H18.7253C17.3422 0.138777 16.1191 1.00752 15.4561 2.26491L14.6216 3.71662C13.9015 4.95115 13.2728 6.03707 12.7584 6.91725C12.667 7.06585 12.587 7.20302 12.5069 7.34018C12.4498 7.43163 12.3926 7.52308 12.3469 7.61453C12.2783 7.7174 12.2212 7.82028 12.164 7.92316C12.0726 8.07176 11.9926 8.20893 11.9125 8.33466C11.8897 8.38039 11.8668 8.41468 11.8325 8.4604C11.7868 8.54042 11.7411 8.609 11.6954 8.67759C11.5696 8.88334 11.4553 9.03194 11.3867 9.13482C10.6094 10.1522 9.43206 10.7008 8.20896 10.7008C8.15181 10.7008 8.08322 10.7008 8.02607 10.7008C7.62599 10.678 7.21448 10.598 6.82583 10.4608C5.1455 9.88926 4.05958 8.35753 4.05958 6.58575C4.05958 6.25426 4.1053 5.94563 4.18532 5.64843C4.20818 5.54555 4.24247 5.4541 4.27676 5.35123C4.34535 5.14547 4.42536 4.95115 4.51681 4.76825C4.56253 4.67681 4.59682 4.59679 4.64255 4.51678C4.73399 4.34531 4.82544 4.17385 4.92832 4.01382C4.93975 3.99096 4.96261 3.95667 4.97404 3.9338C5.07692 3.77377 5.16836 3.61374 5.27124 3.46514C5.73991 2.73357 6.16285 2.08201 6.12855 1.44189C6.12855 1.35044 6.10569 1.259 6.08283 1.17898C6.0714 1.15612 6.0714 1.12183 6.05997 1.09896C6.04854 1.06467 6.03711 1.04181 6.02568 1.00752C5.87707 0.653164 5.5913 0.401685 5.31697 0.241654C5.22552 0.1845 5.12264 0.138777 5.0312 0.104485C4.97404 0.0816232 4.90546 0.0701923 4.8483 0.0473307C4.8483 0.0473307 4.8483 0.0473307 4.83687 0.0473307H4.82544H4.80258C4.15102 -0.0669773 3.38516 0.0587615 3.24799 0.0816231C3.23656 0.0816231 3.22513 0.0816231 3.22513 0.0816231C2.15063 0.264516 1.13329 0.881779 0.57318 1.78481C-0.181253 2.95076 -0.181253 4.42533 0.516026 5.62556L8.32327 19.1368C9.00912 20.3027 10.2094 20.9886 11.5468 21C12.8956 21 14.0844 20.3027 14.7702 19.1368L22.5775 5.62556C23.2748 4.43676 23.2748 3.05363 22.5775 1.87626ZM15.3875 12.8841C15.3646 13.0556 15.2846 13.2385 15.1589 13.4557L14.6902 14.2673L12.2898 12.8727L12.7584 12.0611C12.8842 11.8554 12.9985 11.6953 13.1242 11.581C13.2499 11.4667 13.3757 11.4096 13.5243 11.3981C13.6729 11.3867 13.8101 11.3981 13.9701 11.4438C14.1187 11.4896 14.3016 11.581 14.5188 11.7068C14.736 11.8325 14.9074 11.9468 15.0332 12.0611C15.1589 12.164 15.2618 12.2897 15.3304 12.4269C15.3875 12.5641 15.4104 12.7241 15.3875 12.8841ZM16.7135 10.7694L15.7419 10.5865L15.4675 11.0552L16.2791 11.5239L15.9933 12.0154L13.5929 10.6208L14.1301 9.6835C14.4616 9.11196 14.8846 8.98622 15.4104 9.29485C15.719 9.47775 15.8905 9.72922 15.9019 10.0493L17.0221 10.2436L16.7135 10.7694ZM17.2622 9.80924L14.8617 8.41468L15.1475 7.92316L17.5479 9.31771L17.2622 9.80924ZM18.0509 8.44897L15.3189 7.61453L15.6161 7.10014L17.8337 7.83171L17.9251 7.67168L16.1877 6.10566L16.4849 5.59127L18.5653 7.54594L18.0509 8.44897ZM19.0911 6.66577L16.6906 5.27121L17.5937 3.71662L18.0166 3.9681L17.3993 5.03116L17.9594 5.35123L18.451 4.49391L18.8739 4.73396L18.3824 5.59127L18.9539 5.92277L19.5712 4.8597L19.9941 5.11118L19.0911 6.66577Z"
      fill="white"
    />
    <path
      d="M14.4952 12.392C14.4266 12.3463 14.3237 12.2777 14.1866 12.2091C14.0494 12.1291 13.9465 12.0719 13.8551 12.0376C13.7636 12.0033 13.6836 11.9805 13.5922 11.9805C13.5007 11.9805 13.4321 12.0033 13.3635 12.0605C13.295 12.1176 13.2264 12.1977 13.1692 12.3234L12.9863 12.6435L14.5409 13.5465L14.7238 13.2264C14.8267 13.055 14.861 12.8949 14.8153 12.7578C14.7924 12.632 14.6781 12.5177 14.4952 12.392Z"
      fill="white"
    />
  </svg>
);

export const LocationPinSmallIcon = (props: React.SVGProps<SVGSVGElement>) => (
  <svg
    width="21"
    height="21"
    viewBox="0 0 21 21"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <circle cx="10.5254" cy="10.3555" r="10" fill="#4C4C4C" />
    <g clipPath="url(#clip0_19232_14350)">
      <path
        d="M10.0107 15.8105C8.87793 14.4391 6.3584 11.1151 6.3584 9.24805C6.3584 6.98279 8.22385 5.14648 10.5251 5.14648C12.8254 5.14648 14.6917 6.98279 14.6917 9.24805C14.6917 11.1151 12.1527 14.4391 11.0394 15.8105C10.7725 16.1374 10.2777 16.1374 10.0107 15.8105ZM10.5251 10.6152C11.2911 10.6152 11.914 10.0021 11.914 9.24805C11.914 8.49396 11.2911 7.88086 10.5251 7.88086C9.75901 7.88086 9.13618 8.49396 9.13618 9.24805C9.13618 10.0021 9.75901 10.6152 10.5251 10.6152Z"
        fill="#E8EAEE"
      />
    </g>
    <defs>
      <clipPath id="clip0_19232_14350">
        <rect
          x="4.27539"
          y="4.10547"
          width="12.5"
          height="12.5"
          rx="6.25"
          fill="white"
        />
      </clipPath>
    </defs>
  </svg>
);

export const StopIcon = (props: React.SVGProps<SVGSVGElement>) => (
  <svg
    width="21"
    height="21"
    viewBox="0 0 21 21"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <circle cx="10.5" cy="10.7852" r="10" fill="#E61E29" />
    <g clipPath="url(#clip0_19568_7062)">
      <path
        d="M6.33398 7.9553C6.33398 7.18924 6.95681 6.56641 7.72287 6.56641H13.2784C14.0445 6.56641 14.6673 7.18924 14.6673 7.9553V13.5109C14.6673 14.2769 14.0445 14.8997 13.2784 14.8997H7.72287C6.95681 14.8997 6.33398 14.2769 6.33398 13.5109V7.9553Z"
        fill="white"
      />
    </g>
    <defs>
      <clipPath id="clip0_19568_7062">
        <rect
          width="8.33333"
          height="10"
          fill="white"
          transform="translate(6.33398 5.78516)"
        />
      </clipPath>
    </defs>
  </svg>
);

export const VPayLogo = (props: React.SVGProps<SVGSVGElement>) => (
  <svg
    width="318"
    height="289"
    viewBox="0 0 318 289"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M308.984 23.3504C299.069 8.4792 282.242 0.260894 264.5 0.260894C261.631 0.260894 259.152 0.260894 257.456 0.260894C238.15 1.04359 221.191 13.8276 212.582 31.1774L201.102 51.0056C178.404 89.7491 162.359 117.796 156.619 125.231C145.922 139.189 129.877 146.625 112.918 146.625C106.787 146.625 100.134 145.451 94.0033 143.364C70.9138 135.145 56.0426 114.534 56.0426 90.2709C56.0426 73.3125 64.6522 59.3544 72.4792 47.3531C80.3062 34.9604 87.3504 24.2636 82.7847 13.5667C80.3062 7.82695 75.3491 4.04392 71.3052 2.08719C68.8266 0.913143 65.9567 0 61.7824 0H54.3468C36.2143 0 17.6905 9.00099 8.16774 24.2636C-2.13775 40.3088 -2.13775 60.5284 7.38504 76.965L114.484 262.333C124.007 278.379 140.443 287.901 158.967 287.901C177.491 287.901 193.927 278.379 203.45 262.333L310.549 76.965C320.594 60.0066 320.202 39.9175 308.984 23.3504ZM231.236 144.146L199.537 125.753L207.233 112.447C207.885 111.404 208.538 110.49 209.451 109.577C210.364 108.664 211.408 107.881 212.582 107.49C213.886 106.968 215.321 106.968 217.147 107.229C218.974 107.49 221.061 108.403 223.409 109.708C225.757 111.143 227.583 112.447 228.757 113.882C229.931 115.317 230.584 116.622 230.845 118.057C231.105 119.361 231.105 120.666 230.714 121.84C230.323 123.014 229.931 124.057 229.41 125.101C229.149 125.623 228.757 126.144 228.236 126.927C227.844 127.579 227.322 128.232 226.801 128.884C226.279 129.536 225.887 130.188 225.496 130.71C225.105 131.232 224.713 131.754 224.453 132.015L234.758 138.015L231.236 144.146ZM256.413 100.576L248.586 98.75L242.324 109.577L247.803 115.448L244.02 121.97L218.061 93.6625L222.757 85.7051L260.196 94.1843L256.413 100.576ZM265.153 85.4442L255.63 79.8349L227.975 76.5737L231.758 70.0512L250.934 72.7907L238.932 57.5281L242.585 51.1361L259.152 73.4429L268.675 79.0522L265.153 85.4442Z"
      fill="white"
    />
    <path
      d="M242.064 97.0543L225.888 92.8799L237.498 104.751L242.064 97.0543Z"
      fill="white"
    />
    <path
      d="M219.757 115.969C218.452 115.187 217.408 114.795 216.495 114.665C215.582 114.534 214.799 114.534 214.147 114.926C213.495 115.187 212.973 115.709 212.582 116.361L208.799 122.753L219.365 128.884L223.018 122.622C223.409 121.84 223.67 121.187 223.54 120.405C223.54 119.622 223.148 118.97 222.496 118.187C222.105 117.535 221.061 116.752 219.757 115.969Z"
      fill="url(#paint0_linear_15974_7403)"
    />
    <path
      d="M112.527 48.9185C89.8287 48.9185 70.9136 67.8336 70.9136 90.5318C70.9136 113.23 89.4374 132.145 112.527 132.145C135.616 132.145 154.14 113.23 154.14 90.5318C154.14 67.8336 135.486 48.9185 112.527 48.9185ZM118.528 111.143H106.918L94.7858 71.3557H104.439L112.788 101.098L121.137 71.3557H130.659L118.528 111.143Z"
      fill="white"
    />
    <defs>
      <linearGradient
        id="paint0_linear_15974_7403"
        x1="343.823"
        y1="-5.28032"
        x2="62.6498"
        y2="275.893"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#CECECE" />
        <stop offset="0.514" stopColor="white" />
        <stop offset="1" stopColor="#C5C5C5" />
      </linearGradient>
    </defs>
  </svg>
);

export const VPayLogoBlue = (props: React.SVGProps<SVGSVGElement>) => (
  <svg
    width="98"
    height="88"
    viewBox="0 0 98 88"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M95.0697 7.30815C92.0409 2.77445 86.9 0.26899 81.4802 0.26899C80.6034 0.26899 79.8462 0.26899 79.3282 0.26899C73.4301 0.507606 68.2493 4.405 65.6191 9.69431L62.1121 15.7392C55.1778 27.5507 50.276 36.1011 48.5225 38.3679C45.2547 42.6233 40.3529 44.8901 35.1721 44.8901C33.2991 44.8901 31.2666 44.5322 29.3936 43.8959C22.3398 41.3904 17.7966 35.1069 17.7966 27.7098C17.7966 22.5398 20.4269 18.2845 22.818 14.6257C25.2091 10.8476 27.3611 7.58653 25.9663 4.32546C25.2091 2.57561 23.6947 1.4223 22.4593 0.825761C21.7021 0.467837 20.8254 0.189453 19.5501 0.189453H17.2786C11.7391 0.189453 6.08014 2.93353 3.17094 7.58654C0.0226277 12.4782 0.0226268 18.6424 2.93182 23.6533L35.6503 80.1654C38.5595 85.0571 43.5809 87.9602 49.2399 87.9602C54.8989 87.9602 59.9202 85.0571 62.8294 80.1654L95.5479 23.6533C98.6165 18.4833 98.497 12.3588 95.0697 7.30815ZM71.3179 44.1345L61.6339 38.527L63.9851 34.4706C64.1844 34.1524 64.3836 33.874 64.6626 33.5956C64.9416 33.3172 65.2604 33.0786 65.6191 32.9593C66.0176 32.8002 66.4559 32.8002 67.0139 32.8798C67.5718 32.9593 68.2094 33.2377 68.9268 33.6354C69.6441 34.0729 70.202 34.4706 70.5607 34.908C70.9194 35.3455 71.1186 35.7432 71.1983 36.1806C71.278 36.5783 71.278 36.976 71.1585 37.3339C71.0389 37.6919 70.9194 38.01 70.76 38.3282C70.6803 38.4873 70.5607 38.6463 70.4013 38.8849C70.2817 39.0838 70.1223 39.2826 69.9629 39.4815C69.8035 39.6803 69.684 39.8792 69.5644 40.0383C69.4448 40.1973 69.3253 40.3564 69.2456 40.4359L72.3939 42.2653L71.3179 44.1345ZM79.0093 30.8516L76.6182 30.2948L74.7053 33.5956L76.3791 35.3852L75.2234 37.3737L67.2928 28.7438L68.7275 26.3179L80.165 28.9029L79.0093 30.8516ZM81.6794 26.2383L78.7702 24.5282L70.3216 23.534L71.4773 21.5455L77.3355 22.3807L73.6692 17.7277L74.785 15.779L79.8462 22.5795L82.7554 24.2896L81.6794 26.2383Z"
      fill="#0068EE"
    />
    <path
      d="M74.6257 29.7775L69.6841 28.5049L73.2309 32.1239L74.6257 29.7775Z"
      fill="#0068EE"
    />
    <path
      d="M67.811 35.5445C67.4124 35.3059 67.0936 35.1866 66.8147 35.1468C66.5357 35.1071 66.2966 35.1071 66.0973 35.2264C65.8981 35.3059 65.7386 35.465 65.6191 35.6638L64.4634 37.6125L67.6914 39.4817L68.8073 37.5728C68.9268 37.3341 69.0065 37.1353 68.9667 36.8967C68.9667 36.6581 68.8471 36.4592 68.6478 36.2206C68.5283 36.0218 68.2095 35.7831 67.811 35.5445Z"
      fill="#0068EE"
    />
    <path
      d="M35.0525 15.1035C28.1183 15.1035 22.3397 20.8701 22.3397 27.7899C22.3397 34.7098 27.9987 40.4763 35.0525 40.4763C42.1063 40.4763 47.7653 34.7098 47.7653 27.7899C47.7653 20.8701 42.0665 15.1035 35.0525 15.1035ZM36.8857 34.0735H33.3389L29.6326 21.9438H32.5817L35.1322 31.0112L37.6827 21.9438H40.5919L36.8857 34.0735Z"
      fill="#0068EE"
    />
  </svg>
);

export const ResumeLogo = (props: React.SVGProps<SVGSVGElement>) => (
  <svg
    width="41"
    height="41"
    viewBox="0 0 41 41"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M0.116943 20.9082C0.116943 9.86251 9.07125 0.908203 20.1169 0.908203C31.1626 0.908203 40.1169 9.86251 40.1169 20.9082C40.1169 31.9539 31.1626 40.9082 20.1169 40.9082C9.07125 40.9082 0.116943 31.9539 0.116943 20.9082ZM16.781 14.4217C17.1921 14.1831 17.6991 14.1814 18.1118 14.4172L27.4451 19.7505C27.8606 19.9879 28.1169 20.4297 28.1169 20.9082C28.1169 21.3867 27.8606 21.8285 27.4451 22.0659L18.1118 27.3992C17.6991 27.635 17.1921 27.6333 16.781 27.3948C16.37 27.1562 16.1169 26.7168 16.1169 26.2415V15.5749C16.1169 15.0996 16.37 14.6602 16.781 14.4217Z"
      fill="#4C4C4C"
    />
  </svg>
);

export const PauseLogo = (props: React.SVGProps<SVGSVGElement>) => (
  <svg
    width="41"
    height="41"
    viewBox="0 0 41 41"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M0.116943 20.168C0.116943 9.12227 9.07125 0.167969 20.1169 0.167969C31.1626 0.167969 40.1169 9.12227 40.1169 20.168C40.1169 31.2137 31.1626 40.168 20.1169 40.168C9.07125 40.168 0.116943 31.2137 0.116943 20.168ZM18.7836 26.8346H16.1169V13.5013H18.7836V26.8346ZM24.1169 26.8346H21.4503V13.5013H24.1169V26.8346Z"
      fill="#00B51D"
    />
  </svg>
);

export const ImportMenuIcon = (props: React.SVGProps<SVGSVGElement>) => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clipPath="url(#clip0_13298_8394)">
      <path
        d="M6 3C6 1.34531 7.34531 0 9 0H16.5V6C16.5 6.82969 17.1703 7.5 18 7.5H24V21C24 22.6547 22.6547 24 21 24H9C7.34531 24 6 22.6547 6 21V15.75H14.1609L12.3328 17.5781C11.8922 18.0187 11.8922 18.7312 12.3328 19.1672C12.7734 19.6031 13.4859 19.6078 13.9219 19.1672L17.6719 15.4172C18.1125 14.9766 18.1125 14.2641 17.6719 13.8281L13.9219 10.0781C13.4812 9.6375 12.7688 9.6375 12.3328 10.0781C11.8969 10.5188 11.8922 11.2312 12.3328 11.6672L14.1609 13.4953H6V3ZM6 13.5V15.75H1.125C0.501562 15.75 0 15.2484 0 14.625C0 14.0016 0.501562 13.5 1.125 13.5H6ZM24 6H18V0L24 6Z"
        fill="#E61E29"
      />
    </g>
    <defs>
      <clipPath id="clip0_13298_8394">
        <rect width="24" height="24" fill="white" />
      </clipPath>
    </defs>
  </svg>
);

/**
 * Font Awesome `circle-check` (solid): the same shape CheckCircleIcon draws,
 * without its fixed clip-path id (two instances share that id, and one inside
 * a hidden subtree blanks the others). The checked state of CheckmarkInput.
 * The tick is cut out, so it shows the surface underneath.
 */
export const CheckmarkCheckedIcon = ({ color }: { color?: string }) => (
  <svg
    width="24"
    height="24"
    viewBox="0.97168 0.521484 32 32"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M0.97168 16.5215C0.97168 7.68398 8.13418 0.521484 16.9717 0.521484C25.8092 0.521484 32.9717 7.68398 32.9717 16.5215C32.9717 25.359 25.8092 32.5215 16.9717 32.5215C8.13418 32.5215 0.97168 25.359 0.97168 16.5215ZM24.2092 13.759C24.8904 13.0777 24.8904 11.9652 24.2092 11.284C23.5279 10.6027 22.4154 10.6027 21.7342 11.284L14.9717 18.0465L12.2092 15.284C11.5279 14.6027 10.4154 14.6027 9.73418 15.284C9.05293 15.9652 9.05293 17.0777 9.73418 17.759L13.7342 21.759C14.4154 22.4402 15.5279 22.4402 16.2092 21.759L24.2092 13.759Z"
      fill={color || '#E61E29'}
    />
  </svg>
);

export const CheckCircleIcon = (props: React.SVGProps<SVGSVGElement>) => (
  <svg
    width="33"
    height="33"
    viewBox="0 0 33 33"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clipPath="url(#clip0_15707_18567)">
      <path
        d="M0.97168 16.5215C0.97168 7.68398 8.13418 0.521484 16.9717 0.521484C25.8092 0.521484 32.9717 7.68398 32.9717 16.5215C32.9717 25.359 25.8092 32.5215 16.9717 32.5215C8.13418 32.5215 0.97168 25.359 0.97168 16.5215ZM24.2092 13.759C24.8904 13.0777 24.8904 11.9652 24.2092 11.284C23.5279 10.6027 22.4154 10.6027 21.7342 11.284L14.9717 18.0465L12.2092 15.284C11.5279 14.6027 10.4154 14.6027 9.73418 15.284C9.05293 15.9652 9.05293 17.0777 9.73418 17.759L13.7342 21.759C14.4154 22.4402 15.5279 22.4402 16.2092 21.759L24.2092 13.759Z"
        fill={props.fill || '#E61E29'}
      />
    </g>
    <defs>
      <clipPath id="clip0_15707_18567">
        <rect
          width="32"
          height="32"
          fill="white"
          transform="translate(0.97168 0.521484)"
        />
      </clipPath>
    </defs>
  </svg>
);

export const XCircleIcon = (props: React.SVGProps<SVGSVGElement>) => (
  <svg
    width="33"
    height="33"
    viewBox="0 0 33 33"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clipPath="url(#clip0_15708_18571)">
      <path
        d="M16.5947 32.5215C20.8382 32.5215 24.9079 30.8358 27.9084 27.8352C30.909 24.8346 32.5947 20.7649 32.5947 16.5215C32.5947 12.278 30.909 8.20836 27.9084 5.20778C24.9079 2.20719 20.8382 0.521484 16.5947 0.521484C12.3513 0.521484 8.2816 2.20719 5.28102 5.20778C2.28044 8.20836 0.594727 12.278 0.594727 16.5215C0.594727 20.7649 2.28044 24.8346 5.28102 27.8352C8.2816 30.8358 12.3513 32.5215 16.5947 32.5215ZM11.5322 11.459C12.1197 10.8715 13.0697 10.8715 13.651 11.459L16.5885 14.3965L19.526 11.459C20.1135 10.8715 21.0635 10.8715 21.6447 11.459C22.226 12.0465 22.2322 12.9965 21.6447 13.5777L18.7072 16.5152L21.6447 19.4527C22.2322 20.0402 22.2322 20.9902 21.6447 21.5715C21.0572 22.1527 20.1072 22.159 19.526 21.5715L16.5885 18.634L13.651 21.5715C13.0635 22.159 12.1135 22.159 11.5322 21.5715C10.951 20.984 10.9447 20.034 11.5322 19.4527L14.4697 16.5152L11.5322 13.5777C10.9447 12.9902 10.9447 12.0402 11.5322 11.459Z"
        fill="#A9A9A9"
      />
    </g>
    <defs>
      <clipPath id="clip0_15708_18571">
        <rect
          width="32"
          height="32"
          fill="white"
          transform="translate(0.594727 0.521484)"
        />
      </clipPath>
    </defs>
  </svg>
);

export const InfoIcon = (props: React.SVGProps<SVGSVGElement>) => (
  <svg
    width="17"
    height="17"
    viewBox="0 0 17 17"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M8.70313 0.490236C4.28438 0.490235 0.703126 4.07148 0.703126 8.49023C0.703125 12.909 4.28438 16.4902 8.70312 16.4902C13.1219 16.4902 16.7031 12.909 16.7031 8.49024C16.7031 4.07149 13.1219 0.490236 8.70313 0.490236ZM8.70313 12.4902C8.2875 12.4902 7.95313 12.1559 7.95313 11.7402L7.95313 8.24023C7.95313 7.82461 8.2875 7.49023 8.70313 7.49023C9.11875 7.49023 9.45313 7.82461 9.45313 8.24023L9.45313 11.7402C9.45313 12.1559 9.11875 12.4902 8.70313 12.4902ZM7.70313 5.49023C7.70313 4.93711 8.15 4.49024 8.70313 4.49024C9.25625 4.49024 9.70313 4.93711 9.70313 5.49023C9.70313 6.04336 9.25625 6.49023 8.70313 6.49023C8.15 6.49023 7.70313 6.04336 7.70313 5.49023Z"
      fill="#4C4C4C"
    />
  </svg>
);

export const StripeLogo = ({ color = '#4C4C4C' }: { color?: string }) => (
  <svg
    width="77"
    height="41"
    viewBox="0 0 77 41"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M71.4888 20.1595C71.4888 15.5572 69.2367 11.9258 64.9322 11.9258C60.6095 11.9258 57.9941 15.5572 57.9941 20.1235C57.9941 25.5348 61.0817 28.2674 65.5134 28.2674C67.6747 28.2674 69.3093 27.782 70.5443 27.0988V23.5033C69.3093 24.1145 67.8926 24.4921 66.0946 24.4921C64.3328 24.4921 62.7708 23.8808 62.5711 21.7595H71.4525C71.4525 21.5258 71.4888 20.591 71.4888 20.1595ZM62.5166 18.4516C62.5166 16.4202 63.7698 15.5752 64.914 15.5752C66.0219 15.5752 67.2025 16.4202 67.2025 18.4516H62.5166Z"
      fill={color}
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M50.9831 11.9258C49.2032 11.9258 48.0589 12.7527 47.4232 13.328L47.1871 12.2134H43.1914V33.1752L47.732 32.2224L47.7502 27.1348C48.404 27.6022 49.3666 28.2674 50.9649 28.2674C54.216 28.2674 57.1764 25.6786 57.1764 19.9797C57.1583 14.7662 54.1615 11.9258 50.9831 11.9258ZM49.8933 24.3123C48.8217 24.3123 48.1861 23.9348 47.7502 23.4674L47.732 16.7977C48.2042 16.2763 48.8581 15.9168 49.8933 15.9168C51.5461 15.9168 52.6903 17.7505 52.6903 20.1056C52.6903 22.5145 51.5643 24.3123 49.8933 24.3123Z"
      fill={color}
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M36.9438 10.8653L41.5026 9.89456V6.24512L36.9438 7.19793V10.8653Z"
      fill={color}
    />
    <path d="M41.5026 12.2314H36.9438V27.9618H41.5026V12.2314Z" fill={color} />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M32.0579 13.5619L31.7673 12.2316H27.8442V27.9619H32.3848V17.3013C33.4564 15.917 35.2727 16.1687 35.8357 16.3664V12.2316C35.2545 12.0159 33.1295 11.6204 32.0579 13.5619Z"
      fill={color}
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M22.9766 8.33008L18.545 9.26491L18.5269 23.6649C18.5269 26.3256 20.5429 28.2851 23.2309 28.2851C24.7202 28.2851 25.81 28.0155 26.4093 27.6919V24.0424C25.8281 24.2761 22.9585 25.1031 22.9585 22.4424V16.0604H26.4093V12.2312H22.9585L22.9766 8.33008Z"
      fill={color}
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M10.6991 16.7979C10.6991 16.0968 11.2803 15.8271 12.2429 15.8271C13.6232 15.8271 15.3668 16.2406 16.7472 16.9777V12.753C15.2397 12.1597 13.7504 11.926 12.2429 11.926C8.55593 11.926 6.104 13.8316 6.104 17.0137C6.104 21.9755 13.0057 21.1845 13.0057 23.3238C13.0057 24.1507 12.2792 24.4204 11.2621 24.4204C9.75465 24.4204 7.82943 23.8092 6.30379 22.9822V27.2609C7.99289 27.98 9.70016 28.2856 11.2621 28.2856C15.0399 28.2856 17.6371 26.4339 17.6371 23.2159C17.619 17.8586 10.6991 18.8114 10.6991 16.7979Z"
      fill={color}
    />
  </svg>
);

export const VDriveLogoSmall = (props: React.SVGProps<SVGSVGElement>) => (
  <svg
    width="41"
    height="41"
    viewBox="0 0 41 41"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <circle cx="20.4937" cy="20.3584" r="20" fill="#172A55" />
    <path
      d="M16.6876 14.4912C14.8907 14.4912 13.3809 16.0011 13.3809 17.798C13.3809 19.5948 14.8533 21.1047 16.6876 21.1047C18.5219 21.1047 19.9944 19.5948 19.9944 17.798C19.9944 16.0011 18.5219 14.4912 16.6876 14.4912ZM17.1618 19.4326H16.2384L15.2776 16.2756H16.0387L16.7001 18.634L17.3614 16.2631H18.1101L17.1618 19.4326Z"
      fill="white"
    />
    <path
      d="M24.2745 21.2795C24.1497 21.2047 24.0249 21.1797 23.9126 21.2047C23.8003 21.2296 23.7129 21.3045 23.6381 21.4293L23.3511 21.9159L24.1871 22.4026L24.4741 21.9035C24.549 21.7787 24.5615 21.6664 24.524 21.5541C24.4866 21.4418 24.3993 21.3544 24.2745 21.2795Z"
      fill="white"
    />
    <path
      d="M32.4104 12.6449C32.2357 12.3329 32.0235 12.0584 31.774 11.8088C30.9878 11.0352 29.9022 10.6109 28.7667 10.6109H28.2052C26.6953 10.7482 25.3601 11.6965 24.6364 13.0691L23.7255 14.6539C22.9393 16.0015 22.253 17.187 21.6915 18.1478C21.5917 18.31 21.5043 18.4598 21.417 18.6095C21.3546 18.7093 21.2922 18.8092 21.2423 18.909C21.1674 19.0213 21.105 19.1336 21.0426 19.2459C20.9428 19.4081 20.8554 19.5579 20.7681 19.6951C20.7431 19.745 20.7182 19.7825 20.6807 19.8324C20.6308 19.9197 20.5809 19.9946 20.531 20.0695C20.3937 20.2941 20.269 20.4563 20.1941 20.5686C19.3456 21.6792 18.0603 22.2781 16.7251 22.2781C16.6627 22.2781 16.5879 22.2781 16.5255 22.2781C16.0887 22.2532 15.6395 22.1658 15.2153 22.0161C13.3809 21.3922 12.1955 19.7201 12.1955 17.7859C12.1955 17.4241 12.2454 17.0872 12.3328 16.7627C12.3577 16.6504 12.3952 16.5506 12.4326 16.4383C12.5075 16.2137 12.5948 16.0015 12.6946 15.8019C12.7445 15.7021 12.782 15.6147 12.8319 15.5274C12.9317 15.3402 13.0315 15.153 13.1439 14.9783C13.1563 14.9534 13.1813 14.9159 13.1938 14.891C13.3061 14.7163 13.4059 14.5416 13.5182 14.3794C14.0298 13.5807 14.4915 12.8695 14.4541 12.1707C14.4541 12.0709 14.4291 11.971 14.4042 11.8837C14.3917 11.8587 14.3917 11.8213 14.3792 11.7964C14.3667 11.7589 14.3542 11.734 14.3418 11.6965C14.1796 11.3097 13.8676 11.0352 13.5681 10.8605C13.4683 10.7981 13.356 10.7482 13.2562 10.7107C13.1938 10.6858 13.1189 10.6733 13.0565 10.6483C13.0565 10.6483 13.0565 10.6483 13.044 10.6483H13.0315H13.0066C12.2953 10.5236 11.4593 10.6608 11.3095 10.6858C11.2971 10.6858 11.2846 10.6858 11.2846 10.6858C10.1116 10.8854 9.00106 11.5593 8.38962 12.545C7.56605 13.8178 7.56605 15.4275 8.32723 16.7378L16.8499 31.4871C17.5986 32.7599 18.9088 33.5086 20.3688 33.5211C21.8412 33.5211 23.139 32.7599 23.8877 31.4871L32.4104 16.7378C33.1715 15.44 33.1715 13.9301 32.4104 12.6449ZM24.5615 24.6615C24.5365 24.8487 24.4492 25.0483 24.3119 25.2854L23.8003 26.1714L21.1799 24.649L21.6915 23.763C21.8288 23.5384 21.9535 23.3637 22.0908 23.239C22.2281 23.1142 22.3653 23.0518 22.5275 23.0393C22.6898 23.0268 22.8395 23.0393 23.0142 23.0892C23.1764 23.1391 23.3761 23.239 23.6131 23.3762C23.8502 23.5135 24.0374 23.6383 24.1747 23.763C24.3119 23.8753 24.4242 24.0126 24.4991 24.1623C24.5615 24.3121 24.5865 24.4868 24.5615 24.6615ZM26.009 22.353L24.9483 22.1533L24.6488 22.665L25.5348 23.1766L25.2228 23.7131L22.6024 22.1908L23.1889 21.1676C23.5508 20.5436 24.0125 20.4064 24.5865 20.7433C24.9234 20.9429 25.1105 21.2175 25.123 21.5669L26.3459 21.779L26.009 22.353ZM26.6079 21.3048L23.9875 19.7825L24.2995 19.2459L26.9199 20.7682L26.6079 21.3048ZM27.4689 19.8199L24.4866 18.909L24.8111 18.3475L27.2319 19.1461L27.3317 18.9714L25.435 17.2618L25.7594 16.7003L28.0305 18.8341L27.4689 19.8199ZM28.6045 17.8733L25.984 16.3509L26.9698 14.6539L27.4315 14.9284L26.7577 16.0889L27.3691 16.4383L27.9057 15.5024L28.3674 15.7645L27.8308 16.7003L28.4547 17.0622L29.1286 15.9017L29.5903 16.1762L28.6045 17.8733Z"
      fill="white"
    />
    <path
      d="M23.5883 24.125C23.5134 24.0751 23.4011 24.0002 23.2514 23.9253C23.1016 23.838 22.9893 23.7756 22.8895 23.7382C22.7897 23.7007 22.7023 23.6758 22.6025 23.6758C22.5027 23.6758 22.4278 23.7007 22.3529 23.7631C22.2781 23.8255 22.2032 23.9129 22.1408 24.0501L21.9412 24.3995L23.6382 25.3853L23.8379 25.0359C23.9502 24.8487 23.9876 24.674 23.9377 24.5243C23.9127 24.387 23.788 24.2623 23.5883 24.125Z"
      fill="white"
    />
  </svg>
);

export const VGrubsLogoSmall = (props: React.SVGProps<SVGSVGElement>) => (
  <svg
    width="41"
    height="41"
    viewBox="0 0 41 41"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <ellipse
      cx="20.4936"
      cy="20.3193"
      rx="19.9609"
      ry="19.9609"
      fill="#E61E29"
    />
    <path
      d="M26.8046 17.1024C26.7661 17.0725 26.7216 17.0511 26.6741 17.0397C26.6267 17.0283 26.5773 17.0272 26.5294 17.0365C26.4583 17.0593 26.3985 17.1083 26.362 17.1735L26.0779 17.6656L26.6727 18.0106L26.9606 17.5121C26.9814 17.4794 26.9941 17.4422 26.9977 17.4036C27.0012 17.365 26.9954 17.3261 26.9809 17.2902C26.9458 17.209 26.8834 17.1426 26.8046 17.1024V17.1024Z"
      fill="white"
    />
    <path
      d="M24.4229 21.781C24.3715 21.7305 24.313 21.6877 24.2491 21.6542C24.1897 21.6178 24.1251 21.5905 24.0576 21.573C24.0094 21.5603 23.9587 21.5603 23.9105 21.573C23.8686 21.5852 23.8303 21.6074 23.7989 21.6377C23.7645 21.6723 23.7347 21.7111 23.7101 21.7531L23.4463 22.2047L24.187 22.6333L24.4508 22.1767C24.4755 22.1349 24.4939 22.0896 24.5053 22.0423C24.5161 22.0007 24.5161 21.9571 24.5053 21.9155C24.489 21.8647 24.4607 21.8186 24.4229 21.781Z"
      fill="white"
    />
    <path
      d="M27.8561 17.6009C27.7982 17.5654 27.7324 17.5449 27.6646 17.5413C27.6059 17.5388 27.5477 17.5533 27.4971 17.5831C27.4443 17.6134 27.4006 17.6572 27.3703 17.71L27.0659 18.2363L27.7153 18.6168L28.0197 18.0905C28.0532 18.038 28.0724 17.9776 28.0755 17.9154C28.0776 17.8567 28.0607 17.7989 28.0273 17.7506C27.9823 17.6884 27.9237 17.6372 27.8561 17.6009Z"
      fill="white"
    />
    <path
      d="M32.5768 12.1531C32.1772 11.5701 31.6398 11.0949 31.0123 10.7696C30.3848 10.4443 29.6866 10.2791 28.9799 10.2887H28.413C26.8479 10.3546 25.4819 11.387 24.7818 12.786L23.8496 14.3853C22.0169 17.5168 20.7181 19.782 20.2526 20.3806C19.8387 20.9234 19.3042 21.3625 18.6914 21.6631C18.0786 21.9638 17.4042 22.1179 16.7217 22.1131C16.1997 22.1056 15.6822 22.0157 15.1883 21.8468C13.3238 21.1809 12.124 19.5156 12.124 17.5498C12.124 16.1838 12.8241 15.0512 13.457 14.086C14.0912 13.0866 14.6556 12.2203 14.289 11.354C14.0971 10.9437 13.7672 10.6137 13.3568 10.4218C13.1204 10.3053 12.8593 10.2479 12.5958 10.2544H11.9908C10.5259 10.2544 9.02679 10.9875 8.26073 12.2203C7.85829 12.8561 7.63908 13.5905 7.62722 14.3429C7.61536 15.0952 7.81131 15.8362 8.19351 16.4844L16.8548 31.4733C17.2217 32.102 17.7468 32.6236 18.3781 32.9861C19.0093 33.3487 19.7245 33.5394 20.4524 33.5394C21.1803 33.5394 21.8955 33.3487 22.5267 32.9861C23.1579 32.6236 23.6831 32.102 24.05 31.4733L32.71 16.4844C33.1057 15.8257 33.3036 15.0672 33.28 14.2991C33.2564 13.5311 33.0123 12.7861 32.5768 12.1531V12.1531ZM24.7691 24.7601L24.5573 24.7297C24.5538 24.849 24.5402 24.9678 24.5167 25.0848C24.4874 25.2387 24.4316 25.3863 24.3518 25.5211C24.2775 25.662 24.1667 25.7802 24.0309 25.8635C23.9082 25.931 23.7686 25.9618 23.6289 25.9523C23.4639 25.9391 23.3021 25.8997 23.1495 25.8356C22.9585 25.7578 22.7737 25.6658 22.5965 25.5604C22.4113 25.4562 22.2352 25.3365 22.0701 25.2028C21.9369 25.0985 21.8254 24.9692 21.7416 24.8223C21.6689 24.6895 21.638 24.5379 21.6529 24.3872C21.6748 24.2 21.7385 24.0201 21.8393 23.8609C21.9078 23.7425 21.975 23.6372 22.041 23.5451C22.1069 23.4525 22.1678 23.3675 22.2414 23.2914C22.3149 23.2153 22.3809 23.1379 22.4544 23.0631L22.8489 23.2914C22.8146 23.3358 22.7702 23.3967 22.722 23.4728C22.6738 23.5489 22.6104 23.6364 22.547 23.7328C22.4836 23.8292 22.4202 23.9281 22.3606 24.0346C22.2843 24.1467 22.2445 24.2796 22.2464 24.4151C22.2634 24.5358 22.3255 24.6455 22.4202 24.7221C22.5691 24.8503 22.731 24.9626 22.9034 25.0569C23.0384 25.1377 23.1786 25.2093 23.3232 25.2712C23.4162 25.3123 23.516 25.3359 23.6175 25.341C23.6915 25.3446 23.7644 25.3226 23.8242 25.2789C23.8892 25.2276 23.9431 25.1638 23.9827 25.0911C24.0338 25.0001 24.0762 24.9046 24.1096 24.8058C24.1386 24.7282 24.1631 24.649 24.1831 24.5686L23.6872 24.2744L23.4171 24.7411L23.0125 24.5065C23.034 24.4544 23.062 24.3923 23.0962 24.3238C23.1304 24.2553 23.166 24.1818 23.2053 24.1069C23.2446 24.0321 23.2826 23.9611 23.3207 23.8951C23.3587 23.8292 23.4019 23.7543 23.4374 23.6973C23.4729 23.6402 23.5071 23.5869 23.5401 23.5413L24.9923 24.3834L24.7691 24.7601ZM26.0247 22.5951L24.8389 22.4581L24.7818 22.552C24.759 22.5875 24.7387 22.623 24.7171 22.6598L24.6524 22.7701C24.6309 22.8082 24.6106 22.8399 24.5915 22.8691L25.5453 23.422L25.2485 23.9294L22.6891 22.4454L23.3067 21.3927C23.3613 21.2965 23.4287 21.2082 23.5071 21.1302C23.5784 21.0586 23.6652 21.0043 23.7608 20.9717C23.8717 20.939 23.989 20.9347 24.102 20.959C24.2583 20.9929 24.4076 21.0533 24.5433 21.1378C24.6454 21.1951 24.7397 21.2655 24.8236 21.3471C24.8859 21.4073 24.937 21.4782 24.9746 21.5564C25.0038 21.6209 25.0218 21.69 25.0278 21.7606C25.0317 21.8258 25.0292 21.8912 25.0202 21.9559L26.3241 22.0726L26.0247 22.5951ZM27.2753 20.3933C27.2244 20.5384 27.1594 20.6782 27.0812 20.8106C27.006 20.9434 26.9176 21.0683 26.8174 21.1835C26.73 21.2851 26.6236 21.3687 26.5042 21.4295C26.3858 21.486 26.2538 21.5075 26.1237 21.4917C25.9591 21.4691 25.8012 21.4116 25.6607 21.323L23.9244 20.3172L24.2212 19.8099L25.955 20.8093C26.0307 20.8578 26.1188 20.8834 26.2086 20.8829C26.2894 20.8747 26.3653 20.8409 26.4255 20.7865C26.5021 20.7167 26.5668 20.6348 26.617 20.5442C26.6701 20.4569 26.7083 20.3613 26.7299 20.2614C26.7475 20.1818 26.739 20.0987 26.7058 20.0242C26.6617 19.9442 26.5945 19.8792 26.513 19.8378L24.7805 18.8333L25.0798 18.3183L26.8162 19.3241C26.9646 19.402 27.0944 19.511 27.1967 19.6437C27.2731 19.7489 27.3192 19.8731 27.3298 20.0027C27.3386 20.1352 27.3201 20.2682 27.2753 20.3933V20.3933ZM28.4891 18.3424L27.8803 19.3926L25.3208 17.91L25.9042 16.9029C26.0514 16.6492 26.2167 16.4979 26.4002 16.4489C26.5025 16.4269 26.6082 16.4257 26.711 16.4453C26.8139 16.4649 26.9117 16.5049 26.9988 16.563C27.0905 16.6142 27.1725 16.6812 27.241 16.7609C27.2984 16.8283 27.3392 16.9082 27.3603 16.9942C27.3801 17.078 27.3771 17.1657 27.3514 17.2479C27.3984 17.1983 27.4522 17.1556 27.5112 17.1211C27.5743 17.0857 27.6429 17.0613 27.7141 17.0488C27.7946 17.0362 27.8768 17.0388 27.9564 17.0564C28.0525 17.0779 28.1446 17.1147 28.2291 17.1655C28.3765 17.2421 28.5018 17.3552 28.5931 17.4939C28.6624 17.6107 28.688 17.7482 28.6654 17.882C28.6357 18.0451 28.5759 18.2013 28.4891 18.3424V18.3424ZM29.817 15.9669C29.7696 16.1422 29.6979 16.31 29.6039 16.4653C29.5659 16.5326 29.524 16.5998 29.4771 16.6683C29.4302 16.7368 29.3845 16.8052 29.335 16.8725C29.2856 16.9397 29.2361 16.9993 29.1879 17.0627C29.1397 17.1261 29.094 17.1731 29.0497 17.2175L28.6451 16.9828C28.692 16.9181 28.7427 16.8433 28.7985 16.7583C28.8543 16.6733 28.9101 16.5846 28.9672 16.4907C29.0243 16.3969 29.0776 16.3081 29.127 16.2231C29.172 16.1474 29.2086 16.067 29.2361 15.9834C29.2556 15.9206 29.2556 15.8534 29.2361 15.7906C29.2134 15.7286 29.1681 15.6774 29.1093 15.6473L29.0154 15.5927C28.9845 15.5719 28.9494 15.5582 28.9126 15.5525C28.8757 15.5468 28.8381 15.5493 28.8023 15.5598C28.7273 15.5883 28.6657 15.644 28.6298 15.7158L28.503 15.9339C28.4007 16.1422 28.2289 16.3081 28.0173 16.4032C27.8346 16.4717 27.6139 16.4294 27.3552 16.2764L27.2284 16.2041C26.9798 16.0595 26.839 15.8823 26.806 15.6726C26.784 15.4212 26.8484 15.1697 26.9886 14.9599C27.0432 14.8656 27.1025 14.7742 27.1662 14.6859C27.2284 14.5984 27.293 14.5147 27.3552 14.4322C27.4173 14.3498 27.4744 14.2864 27.5239 14.2318L27.9285 14.4665C27.86 14.5679 27.7851 14.6821 27.7027 14.8089C27.6203 14.9358 27.5467 15.0537 27.482 15.1641C27.4412 15.2343 27.4081 15.3087 27.3831 15.386C27.362 15.4472 27.362 15.5138 27.3831 15.575C27.4143 15.6405 27.4666 15.6936 27.5315 15.7259L27.6012 15.7665C27.6352 15.7906 27.6744 15.8064 27.7156 15.8126C27.7568 15.8188 27.7989 15.8152 27.8384 15.802C27.9206 15.7611 27.9871 15.6942 28.0274 15.6118L28.1745 15.3581C28.2462 15.2226 28.3514 15.1077 28.4802 15.0245C28.5898 14.9589 28.7166 14.9275 28.8442 14.9345C28.9791 14.9468 29.1094 14.9902 29.2247 15.0613L29.3705 15.1463C29.5382 15.2293 29.676 15.3622 29.765 15.5268C29.834 15.6627 29.8525 15.8187 29.817 15.9669V15.9669Z"
      fill="white"
    />
    <path
      d="M16.6873 14.2139C16.0218 14.2139 15.3712 14.4112 14.8178 14.781C14.2644 15.1508 13.8332 15.6764 13.5785 16.2913C13.3239 16.9062 13.2573 17.5829 13.3873 18.2356C13.5172 18.8884 13.8378 19.4879 14.3085 19.9585C14.7792 20.429 15.3789 20.7494 16.0317 20.879C16.6845 21.0087 17.3611 20.9419 17.9759 20.687C18.5907 20.4322 19.1161 20.0007 19.4857 19.4472C19.8553 18.8937 20.0524 18.243 20.0522 17.5774C20.0433 16.6879 19.6858 15.8374 19.0567 15.2085C18.4276 14.5795 17.5769 14.2225 16.6873 14.2139V14.2139ZM17.1782 19.2453H16.2422L15.2605 16.0339H16.0354L16.714 18.4437L17.3862 16.0339H18.1472L17.1782 19.2453Z"
      fill="white"
    />
  </svg>
);

export const VOrdersLogoSmall = (props: React.SVGProps<SVGSVGElement>) => (
  <svg
    width="41"
    height="41"
    viewBox="0 0 41 41"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <ellipse
      cx="20.4936"
      cy="20.3193"
      rx="19.9609"
      ry="19.9609"
      fill="#4C4C4C"
    />
    <path
      d="M13.5527 17.9149C13.5527 19.6841 15.0136 21.1706 16.8335 21.1706C18.6534 21.1706 20.1143 19.6841 20.1143 17.9149C20.1143 16.1458 18.6534 14.6592 16.8335 14.6592C15.0507 14.6592 13.5527 16.1458 13.5527 17.9149ZM16.2021 16.4283L16.8583 18.7503L17.5144 16.4283H18.2572L17.304 19.5366H16.3878L15.4345 16.4283H16.2021Z"
      fill="white"
    />
    <path
      d="M14.4939 11.8954C14.333 11.5023 14.0234 11.2443 13.7263 11.0723C14.0234 11.2443 14.333 11.5146 14.4939 11.8954Z"
      fill="white"
    />
    <path
      d="M28.9172 10.8633H28.8181C29.9323 10.8633 31.0094 11.281 31.8018 12.0427C31.0466 11.281 30.019 10.8633 28.9172 10.8633Z"
      fill="white"
    />
    <path
      d="M20.3123 20.6309C19.4333 21.7243 18.1705 22.3017 16.8706 22.3017C18.1953 22.3017 19.4581 21.7243 20.3123 20.6309Z"
      fill="white"
    />
    <path
      d="M13.2684 10.8633H13.2065C13.2932 10.8756 13.3675 10.9002 13.4294 10.9248C13.3675 10.9002 13.318 10.8756 13.2684 10.8633Z"
      fill="white"
    />
    <path
      d="M16.9946 31.3558L8.55127 16.8586C7.80845 15.5686 7.80845 13.996 8.61317 12.7306C9.23218 11.7477 10.334 11.0966 11.5102 10.8877C10.2597 11.0351 9.17028 11.7477 8.51413 12.8534C7.79607 14.1066 7.79607 15.5932 8.51413 16.8463L16.9575 31.3435C17.7003 32.5967 19.0002 33.3461 20.4611 33.3461H20.4735C19.0374 33.3461 17.7374 32.609 16.9946 31.3558Z"
      fill="white"
    />
    <path
      d="M13.5901 10.986C13.5406 10.9613 13.4911 10.9367 13.4292 10.9121C13.5282 10.949 13.6273 10.9983 13.7387 11.0598C13.6892 11.0475 13.6397 11.0106 13.5901 10.986Z"
      fill="white"
    />
    <path
      d="M28.2605 10.8633C26.7377 10.9247 25.4006 11.9321 24.7197 13.2836C25.4378 11.9199 26.7749 10.9861 28.2605 10.8633Z"
      fill="white"
    />
    <path
      d="M32.3214 12.6695C32.1604 12.4361 31.9871 12.2273 31.789 12.043C32.0243 12.2887 32.2471 12.559 32.4204 12.8661C33.1632 14.1193 33.1632 15.6058 32.4204 16.859L23.9771 31.3562C23.2343 32.6094 21.9467 33.3465 20.4858 33.3588H20.4982C21.9591 33.3588 23.259 32.6217 24.0018 31.3562L32.4452 16.859C33.2375 15.5321 33.2004 13.9596 32.3214 12.6695Z"
      fill="white"
    />
    <path
      d="M13.2062 10.8631C13.0948 10.8385 12.9833 10.8262 12.8471 10.8262H12.2653C12.0177 10.8262 11.7701 10.8508 11.5225 10.8877C11.6958 10.8631 11.8691 10.8508 12.0424 10.8508H13.2062V10.8631Z"
      fill="white"
    />
    <path
      d="M15.3726 22.0432C13.5527 21.4044 12.3889 19.7826 12.3889 17.8906C12.3889 19.7826 13.5527 21.4289 15.3726 22.0432Z"
      fill="white"
    />
    <path
      d="M23.0982 24.1198C23.0611 24.083 22.9992 24.0338 22.9249 23.997C22.8506 23.9601 22.7887 23.9356 22.7392 23.9233C22.6897 23.911 22.6402 23.911 22.5906 23.9233C22.5411 23.9356 22.5164 23.9601 22.4792 23.9847C22.4545 24.0093 22.4173 24.0461 22.3926 24.0953L22.1326 24.5376L22.8506 24.9553L23.1106 24.513C23.1354 24.4638 23.1601 24.427 23.1601 24.3779C23.1725 24.341 23.1725 24.2918 23.1601 24.255C23.1725 24.2058 23.1478 24.1567 23.0982 24.1198Z"
      fill="white"
    />
    <path
      d="M25.3263 22.5469C25.3015 22.4487 25.2396 22.3627 25.1406 22.2644C25.0415 22.1661 24.893 22.0678 24.7196 21.9695C24.5587 21.8712 24.4225 21.8098 24.2987 21.7606C24.1873 21.7238 24.0882 21.6992 24.014 21.6992C23.9397 21.6992 23.8654 21.7238 23.8159 21.7606C23.7664 21.7975 23.7168 21.8589 23.6797 21.9204L23.3826 22.4241L24.9796 23.3455L25.2767 22.8418C25.3263 22.7435 25.351 22.6452 25.3263 22.5469Z"
      fill="white"
    />
    <path
      d="M22.5658 26.6134C22.4667 26.5397 22.3306 26.4414 22.1696 26.3431C21.9839 26.2448 21.8353 26.1711 21.7239 26.122C21.6001 26.0728 21.5011 26.0605 21.4268 26.0605C21.3525 26.0605 21.2782 26.0974 21.2163 26.1465C21.1544 26.208 21.0925 26.2817 21.043 26.38C20.9811 26.4783 20.944 26.5643 20.9316 26.638C20.9068 26.7117 20.9192 26.7977 20.9563 26.8714C20.9935 26.9451 21.0554 27.0188 21.1544 27.1048C21.2535 27.1908 21.3897 27.2768 21.5754 27.3874C21.7487 27.4857 21.8849 27.5594 22.0087 27.5963C22.1201 27.6454 22.2191 27.6577 22.3058 27.6577C22.3925 27.6454 22.4544 27.6208 22.5163 27.5594C22.5782 27.5103 22.6401 27.4243 22.702 27.326C22.7639 27.2277 22.801 27.1294 22.8134 27.0557C22.8258 26.9697 22.8258 26.896 22.7886 26.8223C22.7267 26.7608 22.6648 26.6871 22.5658 26.6134Z"
      fill="white"
    />
    <path
      d="M23.9767 31.356L32.42 16.8587C33.1628 15.6056 33.1628 14.119 32.42 12.8659C32.2467 12.5587 32.0362 12.2884 31.7886 12.0427C31.0086 11.281 29.9316 10.8633 28.805 10.8633H28.2478C26.7498 10.9861 25.4251 11.9321 24.7071 13.2836L23.8033 14.8316C22.0206 17.8662 20.7454 20.0531 20.2997 20.6305C19.4579 21.7239 18.1951 22.3013 16.858 22.3013C16.3752 22.3013 15.8552 22.2031 15.36 22.0433C13.5401 21.4291 12.3763 19.7828 12.3763 17.8908C12.3763 16.5639 13.0573 15.4705 13.6763 14.5367C14.2953 13.5662 14.84 12.7307 14.4934 11.8953C14.3324 11.5144 14.0229 11.2441 13.7258 11.0721C13.6267 11.0107 13.5153 10.9616 13.4163 10.9247C13.342 10.9001 13.2677 10.8756 13.1934 10.8633H12.0173C11.844 10.8633 11.6707 10.8756 11.4973 10.9001C10.346 11.0967 9.23175 11.7479 8.61273 12.7307C7.79564 13.9839 7.79564 15.5687 8.55083 16.8587L16.9942 31.356C17.737 32.6091 19.0245 33.3463 20.4854 33.3586C21.9463 33.3463 23.2338 32.6091 23.9767 31.356ZM26.7746 15.5442C26.8241 15.4582 26.886 15.3599 26.9479 15.2739C27.0098 15.1879 27.0717 15.1019 27.1336 15.0282C27.1955 14.9544 27.245 14.893 27.2946 14.8316L27.6907 15.0527C27.6288 15.151 27.5546 15.2616 27.4679 15.3845C27.3936 15.5073 27.3193 15.6179 27.2574 15.7285C27.2079 15.8022 27.1831 15.8759 27.1584 15.9496C27.1336 16.0233 27.1336 16.0725 27.1584 16.1339C27.1831 16.183 27.2327 16.2322 27.3069 16.2813L27.3688 16.3182C27.4555 16.3673 27.5298 16.3796 27.6041 16.355C27.666 16.3305 27.7279 16.269 27.7898 16.1707L27.9383 15.925C28.025 15.7776 28.124 15.667 28.2355 15.6056C28.3469 15.5442 28.4707 15.5073 28.5945 15.5196C28.7183 15.5319 28.8421 15.5687 28.9659 15.6425L29.1021 15.7285C29.3002 15.839 29.424 15.9619 29.4859 16.097C29.5478 16.2322 29.5602 16.3673 29.523 16.5147C29.4859 16.6622 29.4116 16.8219 29.3125 16.9939C29.2754 17.0553 29.2383 17.129 29.1887 17.1905C29.1516 17.2519 29.1021 17.3256 29.0526 17.387C29.003 17.4485 28.9535 17.5099 28.904 17.5713C28.8545 17.6328 28.8173 17.6819 28.7678 17.7188L28.3717 17.4976C28.4212 17.4362 28.4707 17.3625 28.5202 17.2765C28.5697 17.1905 28.6316 17.1045 28.6812 17.0185C28.7431 16.9325 28.7926 16.8465 28.8421 16.7605C28.8916 16.6745 28.9288 16.6007 28.9535 16.527C28.9783 16.4533 28.9783 16.3919 28.9535 16.3427C28.9411 16.2936 28.8916 16.2445 28.8297 16.2076L28.7431 16.1585C28.6688 16.1216 28.5945 16.1093 28.5326 16.1216C28.4707 16.1462 28.4088 16.1953 28.3593 16.269L28.2355 16.4779C28.0993 16.7113 27.9383 16.871 27.765 16.9325C27.5917 16.9939 27.3688 16.957 27.1212 16.8096L26.9974 16.7359C26.7498 16.6007 26.6136 16.4287 26.5889 16.2199C26.5641 16.0356 26.626 15.8022 26.7746 15.5442ZM25.7347 17.3747C25.7966 17.2765 25.8585 17.1905 25.9327 17.1167C26.007 17.043 26.0937 16.9939 26.1927 16.9693C26.2918 16.9447 26.4032 16.9325 26.527 16.957C26.6508 16.9816 26.7994 17.043 26.9603 17.129C27.0717 17.1905 27.1708 17.2642 27.2327 17.3256C27.2946 17.3993 27.3441 17.4607 27.3812 17.5345C27.406 17.5959 27.4307 17.6696 27.4307 17.731C27.4307 17.7925 27.4307 17.8539 27.4184 17.9153L28.6935 18.0259L28.3964 18.5296L27.245 18.3945C27.2327 18.419 27.2079 18.4559 27.1955 18.4805C27.1708 18.5173 27.1584 18.5542 27.1336 18.5788C27.1089 18.6156 27.0965 18.6525 27.0717 18.6893C27.047 18.7262 27.0346 18.7508 27.0098 18.7876L27.9383 19.3282L27.6536 19.8196L25.1528 18.3822L25.7347 17.3747ZM24.2119 20.0408C24.2366 19.967 24.2614 19.8933 24.2985 19.8319C24.3976 19.6599 24.4842 19.5125 24.5585 19.3896C24.6328 19.2668 24.7071 19.1562 24.7814 19.0579C24.8433 18.9596 24.9052 18.8736 24.9671 18.7876L25.388 19.0333L24.8433 19.9548C24.8061 20.0285 24.7938 20.0899 24.8061 20.1391C24.8185 20.2005 24.8557 20.2496 24.9299 20.2865L25.289 20.4953L25.8832 19.5248L26.2794 19.7459L25.7347 20.7411L26.0813 20.9376C26.1432 20.9745 26.1927 20.9868 26.2299 20.9868C26.2794 20.9868 26.3165 20.9745 26.3413 20.9499C26.366 20.9253 26.4032 20.8885 26.4156 20.8639L26.9603 19.9302L27.3812 20.1759C27.3317 20.2865 27.2822 20.3971 27.2203 20.5199C27.1584 20.6428 27.0965 20.7656 27.0222 20.8885C26.9603 21.0113 26.886 21.1342 26.8241 21.2325C26.787 21.2816 26.7498 21.3431 26.7003 21.4045C26.6508 21.4659 26.5889 21.5151 26.5146 21.5642C26.4403 21.6011 26.3537 21.6256 26.2546 21.6256C26.1556 21.6256 26.0442 21.5888 25.9204 21.5151L24.5338 20.7165C24.4223 20.6551 24.3357 20.5813 24.2862 20.5076C24.2366 20.4339 24.1995 20.3479 24.1871 20.2742C24.1871 20.2005 24.1871 20.1145 24.2119 20.0408ZM23.2462 21.6256C23.3453 21.4536 23.4567 21.3308 23.5805 21.2571C23.7043 21.1833 23.8405 21.1342 23.989 21.1342C24.1376 21.1342 24.2985 21.1588 24.4719 21.2202C24.6452 21.2816 24.8185 21.3676 25.0042 21.4659C25.289 21.6256 25.4994 21.7976 25.648 21.9573C25.7966 22.1293 25.8832 22.3013 25.8956 22.4856C25.908 22.6699 25.8585 22.8542 25.747 23.0508L25.1404 24.0951L22.6396 22.6576L23.2462 21.6256ZM22.0082 23.7388C22.0701 23.6405 22.132 23.5545 22.2063 23.4808C22.2806 23.4071 22.3672 23.3579 22.4663 23.3334C22.5653 23.2965 22.6767 23.2965 22.8005 23.3211C22.9243 23.3456 23.0729 23.4071 23.2338 23.4931C23.3453 23.5545 23.4443 23.6282 23.5062 23.6896C23.5681 23.7511 23.6176 23.8248 23.6548 23.8985C23.6919 23.9722 23.7043 24.0336 23.7043 24.0951C23.7043 24.1565 23.7043 24.2179 23.6919 24.2794L24.9671 24.3899L24.6699 24.8937L23.5186 24.7585C23.5062 24.7831 23.4814 24.8199 23.4691 24.8445C23.4443 24.8814 23.4319 24.9182 23.4072 24.9428C23.3824 24.9797 23.37 25.0165 23.3453 25.0534C23.3205 25.0902 23.3081 25.1148 23.2834 25.1517L24.2119 25.6922L23.9271 26.1837L21.4263 24.7462L22.0082 23.7388ZM22.8129 28.0142C22.7015 28.1248 22.5777 28.1985 22.4415 28.2231C22.3053 28.26 22.132 28.2477 21.9463 28.1985C21.7606 28.1494 21.5254 28.0388 21.253 27.8914C20.9806 27.7317 20.7825 27.5965 20.634 27.4491C20.4978 27.314 20.3988 27.1665 20.3616 27.0314C20.3245 26.8962 20.3245 26.7488 20.3616 26.6014C20.3988 26.4539 20.473 26.2942 20.5721 26.1222C20.6711 25.9502 20.7702 25.8151 20.8816 25.7045C20.993 25.5939 21.1168 25.5325 21.253 25.4957C21.3892 25.4588 21.5625 25.4711 21.7482 25.5325C21.9463 25.5817 22.1691 25.6922 22.4415 25.8397C22.7139 25.9994 22.9119 26.1345 23.0605 26.2819C23.1967 26.4171 23.2957 26.5522 23.3329 26.6874C23.37 26.8225 23.37 26.9699 23.3329 27.1051C23.2957 27.2525 23.2215 27.4122 23.1224 27.5842C23.0234 27.7685 22.9243 27.9037 22.8129 28.0142Z"
      fill="white"
    />
    <path
      d="M26.8243 17.7429C26.7872 17.706 26.7253 17.6569 26.651 17.62C26.5767 17.5832 26.5148 17.5586 26.4653 17.5463C26.4158 17.534 26.3662 17.534 26.3167 17.5463C26.2672 17.5586 26.2424 17.5832 26.2053 17.6078C26.1681 17.6323 26.1434 17.6692 26.1186 17.7183L25.8586 18.1606L26.5767 18.5783L26.8367 18.136C26.8614 18.0869 26.8862 18.05 26.8862 18.0009C26.8986 17.964 26.8986 17.9149 26.8862 17.878C26.8862 17.8289 26.8614 17.792 26.8243 17.7429Z"
      fill="white"
    />
  </svg>
);

export const VTabletLogoSmall = (props: React.SVGProps<SVGSVGElement>) => (
  <svg
    width="42"
    height="41"
    viewBox="0 0 42 41"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <ellipse
      cx="20.9999"
      cy="19.9952"
      rx="20.0257"
      ry="19.9883"
      fill="#212121"
    />
    <path
      d="M13.9165 17.3437C13.9165 19.1586 15.4065 20.6835 17.2626 20.6835C19.1187 20.6835 20.6086 19.1586 20.6086 17.3437C20.6086 15.5289 19.1187 14.0039 17.2626 14.0039C15.4443 14.0039 13.9165 15.5289 13.9165 17.3437ZM16.6186 15.8187L17.2878 18.2007L17.957 15.8187H18.7146L17.7424 19.0073H16.808L15.8358 15.8187H16.6186Z"
      fill="white"
    />
    <path
      d="M14.8761 11.1676C14.712 10.7643 14.3963 10.4997 14.0933 10.3232C14.3963 10.4997 14.712 10.777 14.8761 11.1676Z"
      fill="white"
    />
    <path
      d="M29.5861 10.1094H29.4851C30.6215 10.1094 31.72 10.5379 32.5281 11.3193C31.7579 10.5379 30.7099 10.1094 29.5861 10.1094Z"
      fill="white"
    />
    <path
      d="M20.8108 20.1289C19.9143 21.2506 18.6263 21.8429 17.3005 21.8429C18.6516 21.8429 19.9395 21.2506 20.8108 20.1289Z"
      fill="white"
    />
    <path
      d="M13.6261 10.1094H13.563C13.6514 10.122 13.7271 10.1472 13.7903 10.1724C13.7271 10.1472 13.6766 10.122 13.6261 10.1094Z"
      fill="white"
    />
    <path
      d="M17.4268 31.1315L8.81541 16.2599C8.05781 14.9365 8.05781 13.3233 8.87854 12.0252C9.50988 11.017 10.6337 10.349 11.8332 10.1348C10.5579 10.286 9.44675 11.017 8.77753 12.1513C8.04518 13.4368 8.04518 14.9617 8.77753 16.2473L17.3889 31.1189C18.1465 32.4044 19.4723 33.1732 20.9623 33.1732H20.9749C19.5102 33.1732 18.1844 32.417 17.4268 31.1315Z"
      fill="white"
    />
    <path
      d="M13.9544 10.2358C13.9039 10.2106 13.8534 10.1854 13.7903 10.1602C13.8913 10.198 13.9923 10.2484 14.1059 10.3114C14.0554 10.2988 14.0049 10.261 13.9544 10.2358Z"
      fill="white"
    />
    <path
      d="M28.9169 10.1094C27.3638 10.1724 26.0001 11.2058 25.3057 12.5922C26.038 11.1932 27.4017 10.2354 28.9169 10.1094Z"
      fill="white"
    />
    <path
      d="M33.0586 11.9621C32.8945 11.7226 32.7177 11.5084 32.5157 11.3193C32.7556 11.5714 32.9829 11.8487 33.1597 12.1637C33.9173 13.4493 33.9173 14.9742 33.1597 16.2597L24.5483 31.1314C23.7907 32.4169 22.4775 33.1731 20.9875 33.1857H21.0002C22.4901 33.1857 23.8159 32.4295 24.5735 31.1314L33.1849 16.2597C33.993 14.8986 33.9551 13.2854 33.0586 11.9621Z"
      fill="white"
    />
    <path
      d="M13.5629 10.1091C13.4493 10.0839 13.3356 10.0713 13.1968 10.0713H12.6033C12.3508 10.0713 12.0982 10.0965 11.8457 10.1343C12.0225 10.1091 12.1992 10.0965 12.376 10.0965H13.5629V10.1091Z"
      fill="white"
    />
    <path
      d="M15.7725 21.5782C13.9164 20.9228 12.7295 19.2592 12.7295 17.3184C12.7295 19.2592 13.9164 20.948 15.7725 21.5782Z"
      fill="white"
    />
    <path
      d="M23.6516 23.7082C23.6137 23.6704 23.5506 23.6199 23.4749 23.5821C23.3991 23.5443 23.336 23.5191 23.2855 23.5065C23.2349 23.4939 23.1844 23.4939 23.1339 23.5065C23.0834 23.5191 23.0582 23.5443 23.0203 23.5695C22.995 23.5947 22.9572 23.6326 22.9319 23.683L22.6667 24.1367L23.3991 24.5652L23.6643 24.1115C23.6895 24.0611 23.7148 24.0232 23.7148 23.9728C23.7274 23.935 23.7274 23.8846 23.7148 23.8468C23.7274 23.7964 23.7021 23.746 23.6516 23.7082Z"
      fill="white"
    />
    <path
      d="M25.9245 22.0952C25.8993 21.9944 25.8361 21.9062 25.7351 21.8053C25.6341 21.7045 25.4826 21.6037 25.3058 21.5029C25.1417 21.402 25.0028 21.339 24.8765 21.2886C24.7629 21.2508 24.6619 21.2256 24.5861 21.2256C24.5103 21.2256 24.4346 21.2508 24.3841 21.2886C24.3336 21.3264 24.2831 21.3894 24.2452 21.4524L23.9421 21.9692L25.571 22.9144L25.874 22.3977C25.9245 22.2968 25.9498 22.196 25.9245 22.0952Z"
      fill="white"
    />
    <path
      d="M23.1088 26.2664C23.0078 26.1907 22.8689 26.0899 22.7048 25.9891C22.5154 25.8883 22.3638 25.8126 22.2502 25.7622C22.1239 25.7118 22.0229 25.6992 21.9472 25.6992C21.8714 25.6992 21.7956 25.737 21.7325 25.7874C21.6694 25.8505 21.6062 25.9261 21.5557 26.0269C21.4926 26.1277 21.4547 26.2159 21.4421 26.2916C21.4168 26.3672 21.4295 26.4554 21.4673 26.531C21.5052 26.6066 21.5684 26.6823 21.6694 26.7705C21.7704 26.8587 21.9093 26.9469 22.0987 27.0604C22.2755 27.1612 22.4143 27.2368 22.5406 27.2746C22.6543 27.325 22.7553 27.3376 22.8437 27.3376C22.932 27.325 22.9952 27.2998 23.0583 27.2368C23.1214 27.1864 23.1846 27.0982 23.2477 26.9973C23.3108 26.8965 23.3487 26.7957 23.3613 26.7201C23.374 26.6318 23.374 26.5562 23.3361 26.4806C23.273 26.4176 23.2098 26.342 23.1088 26.2664Z"
      fill="white"
    />
    <path
      d="M24.5482 31.1313L33.1596 16.2597C33.9172 14.9742 33.9172 13.4492 33.1596 12.1637C32.9828 11.8486 32.7682 11.5713 32.5156 11.3193C31.7201 10.5379 30.6216 10.1094 29.4726 10.1094H28.9044C27.3766 10.2354 26.0255 11.2058 25.2932 12.5922L24.3714 14.1802C22.5532 17.2931 21.2526 19.5365 20.7981 20.1288C19.9395 21.2505 18.6515 21.8428 17.2879 21.8428C16.7954 21.8428 16.2651 21.742 15.76 21.5782C13.9039 20.948 12.717 19.2592 12.717 17.3183C12.717 15.9572 13.4115 14.8355 14.0428 13.8777C14.6741 12.882 15.2297 12.025 14.8762 11.168C14.712 10.7773 14.3964 10.5001 14.0933 10.3236C13.9923 10.2606 13.8787 10.2102 13.7777 10.1724C13.7019 10.1472 13.6261 10.122 13.5504 10.1094H12.3508C12.1741 10.1094 11.9973 10.122 11.8205 10.1472C10.6462 10.3488 9.50984 11.0168 8.87851 12.025C8.04515 13.3106 8.04515 14.9363 8.81537 16.2597L17.4268 31.1313C18.1844 32.4168 19.4975 33.173 20.9875 33.1856C22.4774 33.173 23.7906 32.4168 24.5482 31.1313ZM27.4018 14.9111C27.4523 14.8229 27.5155 14.7221 27.5786 14.6339C27.6417 14.5457 27.7049 14.4574 27.768 14.3818C27.8311 14.3062 27.8816 14.2432 27.9321 14.1802L28.3362 14.407C28.2731 14.5078 28.1973 14.6213 28.1089 14.7473C28.0332 14.8733 27.9574 14.9868 27.8943 15.1002C27.8438 15.1758 27.8185 15.2514 27.7933 15.327C27.768 15.4027 27.768 15.4531 27.7933 15.5161C27.8185 15.5665 27.869 15.6169 27.9448 15.6673L28.0079 15.7051C28.0963 15.7555 28.1721 15.7682 28.2478 15.7429C28.3109 15.7177 28.3741 15.6547 28.4372 15.5539L28.5887 15.3018C28.6771 15.1506 28.7781 15.0372 28.8918 14.9742C29.0054 14.9111 29.1317 14.8733 29.2579 14.8859C29.3842 14.8985 29.5105 14.9363 29.6367 15.012L29.7756 15.1002C29.9777 15.2136 30.1039 15.3396 30.1671 15.4783C30.2302 15.6169 30.2428 15.7555 30.2049 15.9068C30.1671 16.058 30.0913 16.2219 29.9903 16.3983C29.9524 16.4613 29.9145 16.5369 29.864 16.6C29.8261 16.663 29.7756 16.7386 29.7251 16.8016C29.6746 16.8646 29.6241 16.9276 29.5736 16.9906C29.5231 17.0537 29.4852 17.1041 29.4347 17.1419L29.0307 16.915C29.0812 16.852 29.1317 16.7764 29.1822 16.6882C29.2327 16.6 29.2958 16.5117 29.3463 16.4235C29.4095 16.3353 29.46 16.2471 29.5105 16.1588C29.561 16.0706 29.5989 15.995 29.6241 15.9194C29.6494 15.8438 29.6494 15.7808 29.6241 15.7303C29.6115 15.6799 29.561 15.6295 29.4979 15.5917L29.4095 15.5413C29.3337 15.5035 29.2579 15.4909 29.1948 15.5035C29.1317 15.5287 29.0685 15.5791 29.018 15.6547L28.8918 15.869C28.7529 16.1084 28.5887 16.2723 28.412 16.3353C28.2352 16.3983 28.0079 16.3605 27.7554 16.2093L27.6291 16.1336C27.3766 15.995 27.2377 15.8186 27.2124 15.6043C27.1872 15.4153 27.2503 15.1758 27.4018 14.9111ZM26.3412 16.789C26.4043 16.6882 26.4675 16.6 26.5432 16.5243C26.619 16.4487 26.7074 16.3983 26.8084 16.3731C26.9094 16.3479 27.023 16.3353 27.1493 16.3605C27.2756 16.3857 27.4271 16.4487 27.5912 16.5369C27.7049 16.6 27.8059 16.6756 27.869 16.7386C27.9321 16.8142 27.9827 16.8772 28.0205 16.9528C28.0458 17.0159 28.071 17.0915 28.071 17.1545C28.071 17.2175 28.071 17.2805 28.0584 17.3435L29.359 17.457L29.0559 17.9737L27.8816 17.8351C27.869 17.8603 27.8438 17.8981 27.8311 17.9233C27.8059 17.9611 27.7933 17.9989 27.768 18.0241C27.7427 18.0619 27.7301 18.0997 27.7049 18.1375C27.6796 18.1753 27.667 18.2005 27.6417 18.2384L28.5887 18.7929L28.2983 19.297L25.7477 17.8225L26.3412 16.789ZM24.7881 19.5239C24.8134 19.4482 24.8386 19.3726 24.8765 19.3096C24.9775 19.1332 25.0659 18.9819 25.1417 18.8559C25.2174 18.7299 25.2932 18.6164 25.3689 18.5156C25.4321 18.4148 25.4952 18.3266 25.5583 18.2384L25.9876 18.4904L25.4321 19.4356C25.3942 19.5113 25.3816 19.5743 25.3942 19.6247C25.4068 19.6877 25.4447 19.7381 25.5205 19.7759L25.8866 19.9902L26.4927 18.9945L26.8968 19.2214L26.3412 20.2422L26.6947 20.4439C26.7579 20.4817 26.8084 20.4943 26.8463 20.4943C26.8968 20.4943 26.9346 20.4817 26.9599 20.4565C26.9851 20.4313 27.023 20.3935 27.0357 20.3683L27.5912 19.4104L28.0205 19.6625C27.97 19.7759 27.9195 19.8894 27.8564 20.0154C27.7933 20.1414 27.7301 20.2674 27.6544 20.3935C27.5912 20.5195 27.5155 20.6455 27.4523 20.7464C27.4145 20.7968 27.3766 20.8598 27.3261 20.9228C27.2756 20.9858 27.2124 21.0362 27.1367 21.0866C27.0609 21.1245 26.9725 21.1497 26.8715 21.1497C26.7705 21.1497 26.6569 21.1119 26.5306 21.0362L25.1164 20.217C25.0028 20.154 24.9144 20.0784 24.8639 20.0028C24.8134 19.9272 24.7755 19.8389 24.7629 19.7633C24.7629 19.6877 24.7629 19.5995 24.7881 19.5239ZM23.8032 21.1497C23.9042 20.9732 24.0179 20.8472 24.1441 20.7716C24.2704 20.6959 24.4093 20.6455 24.5608 20.6455C24.7123 20.6455 24.8765 20.6707 25.0533 20.7338C25.23 20.7968 25.4068 20.885 25.5962 20.9858C25.8866 21.1497 26.1013 21.3261 26.2528 21.4899C26.4043 21.6664 26.4927 21.8428 26.5053 22.0319C26.518 22.2209 26.4675 22.41 26.3538 22.6116L25.7351 23.6829L23.1845 22.2083L23.8032 21.1497ZM22.5406 23.3174C22.6037 23.2166 22.6668 23.1283 22.7426 23.0527C22.8183 22.9771 22.9067 22.9267 23.0077 22.9015C23.1088 22.8637 23.2224 22.8637 23.3487 22.8889C23.4749 22.9141 23.6265 22.9771 23.7906 23.0653C23.9042 23.1283 24.0053 23.204 24.0684 23.267C24.1315 23.33 24.182 23.4056 24.2199 23.4812C24.2578 23.5568 24.2704 23.6199 24.2704 23.6829C24.2704 23.7459 24.2704 23.8089 24.2578 23.8719L25.5583 23.9853L25.2553 24.5021L24.081 24.3634C24.0684 24.3886 24.0431 24.4265 24.0305 24.4517C24.0053 24.4895 23.9926 24.5273 23.9674 24.5525C23.9421 24.5903 23.9295 24.6281 23.9042 24.6659C23.879 24.7037 23.8664 24.7289 23.8411 24.7667L24.7881 25.3213L24.4977 25.8254L21.9471 24.3508L22.5406 23.3174ZM23.3613 27.7033C23.2477 27.8167 23.1214 27.8923 22.9825 27.9175C22.8436 27.9553 22.6668 27.9427 22.4774 27.8923C22.288 27.8419 22.0481 27.7285 21.7703 27.5772C21.4925 27.4134 21.2905 27.2747 21.139 27.1235C21.0001 26.9849 20.8991 26.8336 20.8612 26.695C20.8233 26.5564 20.8233 26.4051 20.8612 26.2539C20.8991 26.1027 20.9749 25.9388 21.0759 25.7624C21.1769 25.5859 21.2779 25.4473 21.3915 25.3339C21.5052 25.2205 21.6314 25.1574 21.7703 25.1196C21.9092 25.0818 22.086 25.0944 22.2754 25.1574C22.4774 25.2078 22.7047 25.3213 22.9825 25.4725C23.2603 25.6364 23.4623 25.775 23.6138 25.9262C23.7527 26.0649 23.8537 26.2035 23.8916 26.3421C23.9295 26.4808 23.9295 26.632 23.8916 26.7706C23.8537 26.9219 23.778 27.0857 23.677 27.2621C23.5759 27.4512 23.4749 27.5898 23.3613 27.7033Z"
      fill="white"
    />
    <path
      d="M27.4524 17.1672C27.4145 17.1293 27.3514 17.0789 27.2756 17.0411C27.1999 17.0033 27.1367 16.9781 27.0862 16.9655C27.0357 16.9529 26.9852 16.9529 26.9347 16.9655C26.8842 16.9781 26.859 17.0033 26.8211 17.0285C26.7832 17.0537 26.7579 17.0915 26.7327 17.142L26.4675 17.5957L27.1999 18.0242L27.465 17.5705C27.4903 17.52 27.5155 17.4822 27.5155 17.4318C27.5282 17.394 27.5282 17.3436 27.5155 17.3058C27.5155 17.2554 27.4903 17.2176 27.4524 17.1672Z"
      fill="white"
    />
    <path
      d="M23.2401 29.6799L19.1201 26.9199L27.5201 12.9199L31.6001 15.0399L23.2401 29.6799Z"
      fill="white"
    />
    <path
      d="M21.5753 24.865L23.9513 26.2694L23.6398 26.7963L21.2639 25.3919L21.5753 24.865ZM21.9986 24.1488L22.4118 24.393L21.2558 26.3489L20.8425 26.1047L21.9986 24.1488ZM22.7272 22.9162C22.753 22.8726 22.788 22.8422 22.8322 22.825C22.8778 22.8055 22.9247 22.8022 22.9728 22.8151L25.6181 23.4494L25.3006 23.9866L23.2678 23.4402C23.2233 23.4263 23.1789 23.4124 23.1344 23.3985C23.0877 23.3833 23.0439 23.3683 23.0031 23.3534L22.9481 23.4464C22.9808 23.475 23.0151 23.5061 23.051 23.5397C23.0859 23.5697 23.1195 23.6019 23.1518 23.6365L24.6106 25.1539L24.291 25.6945L22.4619 23.6794C22.4274 23.6435 22.407 23.602 22.4007 23.555C22.3958 23.5056 22.4063 23.4591 22.4321 23.4155L22.7272 22.9162ZM24.2962 23.3511L24.6922 23.5852L23.9635 24.8179L23.5675 24.5839L24.2962 23.3511ZM23.891 20.8844C24.0131 20.6778 24.1285 20.5245 24.2371 20.4246C24.3448 20.321 24.4597 20.2681 24.5818 20.2659C24.7039 20.2637 24.8465 20.3108 25.0095 20.4071C25.1793 20.5075 25.2894 20.6175 25.3395 20.737C25.3888 20.8528 25.3762 20.9894 25.3018 21.1468L25.3224 21.159C25.447 20.9848 25.585 20.8929 25.7363 20.8832C25.8854 20.8722 26.0551 20.923 26.2457 21.0356C26.4087 21.132 26.518 21.2353 26.5736 21.3456C26.6305 21.4536 26.6421 21.5782 26.6083 21.7192C26.5735 21.8567 26.4998 22.0206 26.3872 22.2112C26.2963 22.365 26.2157 22.4986 26.1456 22.612C26.0791 22.7245 26.0151 22.8276 25.9535 22.9213C25.8919 23.015 25.8278 23.1103 25.7612 23.2073L25.4268 22.9399C25.4616 22.8861 25.5263 22.7819 25.6209 22.6271C25.7168 22.4701 25.8265 22.2871 25.95 22.0782C26.007 21.9818 26.0426 21.9006 26.0568 21.8347C26.071 21.7687 26.0601 21.7112 26.0241 21.662C25.9872 21.6092 25.9228 21.5557 25.831 21.5014C25.7322 21.4431 25.6508 21.4104 25.5868 21.4035C25.5204 21.3953 25.4599 21.4137 25.4053 21.4589C25.3521 21.5018 25.2952 21.5719 25.2345 21.6693L24.7257 22.5301L24.3917 22.3327L24.8965 21.4787C24.9444 21.3924 24.9745 21.3204 24.987 21.2627C25.0007 21.2027 24.9908 21.1488 24.9571 21.101C24.9234 21.0532 24.8652 21.0049 24.7826 20.9561C24.6976 20.9059 24.6266 20.8793 24.5694 20.8765C24.5113 20.87 24.4586 20.8884 24.4113 20.9317C24.364 20.9751 24.3125 21.0438 24.2569 21.1379C24.1809 21.2664 24.1138 21.3801 24.0554 21.4788C23.9971 21.5775 23.946 21.6666 23.9021 21.746C23.856 21.824 23.8155 21.8977 23.7808 21.967L23.3853 21.8029C23.4303 21.7056 23.4769 21.6138 23.5248 21.5276C23.5717 21.4376 23.6251 21.3421 23.6848 21.2411C23.7422 21.1388 23.8109 21.0199 23.891 20.8844ZM23.6906 21.2864L26.0665 22.6908L25.7612 23.2073L23.3853 21.8029L23.6906 21.2864ZM24.9945 19.0803L26.7713 20.1306C26.8287 20.1645 26.8818 20.1742 26.9307 20.1597C26.9795 20.1452 27.0216 20.1081 27.0569 20.0484L27.5474 19.2186L27.9576 19.4285C27.8796 19.6024 27.7889 19.7795 27.6853 19.9599C27.5855 20.1394 27.4833 20.3175 27.3788 20.4943C27.277 20.6664 27.1538 20.7702 27.009 20.8054C26.8633 20.837 26.7182 20.8101 26.5736 20.7246L24.6831 19.6072L24.9945 19.0803ZM26.0571 17.2591C26.1331 17.1305 26.2109 17.0015 26.2905 16.872C26.3679 16.7411 26.4462 16.6139 26.5254 16.4904C26.6046 16.3668 26.6825 16.2534 26.7591 16.15L27.1271 16.4L26.5877 17.3125C26.5538 17.3699 26.5429 17.4223 26.5551 17.4698C26.5687 17.515 26.6042 17.5546 26.6616 17.5885L27.8737 18.3049C27.9311 18.3389 27.9828 18.3509 28.0289 18.341C28.0764 18.3288 28.1171 18.294 28.151 18.2366L28.6904 17.3241L29.0869 17.5259C29.0309 17.6415 28.9691 17.7645 28.9014 17.8948C28.8313 18.0238 28.7576 18.1537 28.6803 18.2845C28.6052 18.4167 28.5297 18.5471 28.4537 18.6757C28.3642 18.8272 28.248 18.9242 28.1051 18.9668C27.9613 19.0057 27.8182 18.9831 27.6759 18.8989L26.2365 18.0482C26.0919 17.9627 26.0031 17.8482 25.9702 17.7049C25.9386 17.5592 25.9675 17.4106 26.0571 17.2591ZM26.7587 18.2732L27.5993 16.851L27.9712 17.0708L27.1306 18.493L26.7587 18.2732ZM27.582 14.7028L29.958 16.1072L29.6465 16.6341L27.2706 15.2297L27.582 14.7028ZM28.0053 13.9866L28.4186 14.2308L27.2625 16.1867L26.8493 15.9425L28.0053 13.9866Z"
      fill="#212121"
    />
  </svg>
);

export const VGrubsDisabledIcon = () => (
  <svg
    width="40"
    height="41"
    viewBox="0 0 40 41"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g opacity="0.5">
      <ellipse cx="20" cy="20.8437" rx="19.9609" ry="19.9609" fill="#A9A9A9" />
      <path
        d="M26.311 17.6269C26.2724 17.5969 26.228 17.5755 26.1805 17.5641C26.133 17.5527 26.0837 17.5516 26.0357 17.5609C25.9646 17.5838 25.9048 17.6327 25.8683 17.6979L25.5842 18.19L26.1791 18.535L26.467 18.0365C26.4878 18.0038 26.5005 17.9666 26.504 17.928C26.5075 17.8894 26.5018 17.8505 26.4873 17.8146C26.4521 17.7334 26.3898 17.667 26.311 17.6269Z"
        fill="white"
      />
      <path
        d="M23.9292 22.3055C23.8778 22.2549 23.8193 22.2122 23.7555 22.1786C23.696 22.1422 23.6315 22.1149 23.564 22.0974C23.5157 22.0847 23.4651 22.0847 23.4168 22.0974C23.3749 22.1096 23.3366 22.1318 23.3052 22.1621C23.2709 22.1967 23.241 22.2355 23.2164 22.2775L22.9526 22.7291L23.6933 23.1578L23.9571 22.7012C23.9819 22.6593 24.0002 22.614 24.0117 22.5667C24.0224 22.5251 24.0224 22.4815 24.0117 22.4399C23.9953 22.3891 23.9671 22.343 23.9292 22.3055Z"
        fill="white"
      />
      <path
        d="M27.3624 18.1253C27.3045 18.0898 27.2387 18.0693 27.1709 18.0657C27.1122 18.0632 27.0541 18.0777 27.0035 18.1076C26.9507 18.1378 26.9069 18.1816 26.8767 18.2344L26.5723 18.7607L27.2216 19.1412L27.526 18.6149C27.5596 18.5624 27.5788 18.5021 27.5818 18.4399C27.584 18.3811 27.5671 18.3233 27.5336 18.275C27.4886 18.2128 27.4301 18.1616 27.3624 18.1253Z"
        fill="white"
      />
      <path
        d="M32.0832 12.6775C31.6836 12.0945 31.1461 11.6193 30.5186 11.294C29.8911 10.9687 29.193 10.8035 28.4862 10.8131H27.9193C26.3542 10.879 24.9882 11.9114 24.2881 13.3104L23.3559 14.9097C21.5232 18.0412 20.2245 20.3064 19.759 20.905C19.345 21.4478 18.8105 21.8869 18.1977 22.1876C17.5849 22.4882 16.9106 22.6423 16.228 22.6376C15.706 22.63 15.1885 22.5401 14.6946 22.3712C12.8302 21.7053 11.6304 20.0401 11.6304 18.0742C11.6304 16.7082 12.3305 15.5756 12.9634 14.6104C13.5975 13.611 14.1619 12.7447 13.7954 11.8785C13.6035 11.4681 13.2735 11.1381 12.8632 10.9462C12.6268 10.8297 12.3656 10.7723 12.1022 10.7788H11.4972C10.0323 10.7788 8.53314 11.5119 7.76708 12.7447C7.36464 13.3805 7.14542 14.115 7.13356 14.8673C7.1217 15.6196 7.31766 16.3606 7.69986 17.0088L16.3612 31.9977C16.728 32.6264 17.2532 33.148 17.8844 33.5106C18.5156 33.8731 19.2308 34.0638 19.9587 34.0638C20.6867 34.0638 21.4019 33.8731 22.0331 33.5106C22.6643 33.148 23.1895 32.6264 23.5563 31.9977L32.2164 17.0088C32.6121 16.3502 32.8099 15.5916 32.7863 14.8236C32.7627 14.0556 32.5186 13.3106 32.0832 12.6775ZM24.2754 25.2845L24.0636 25.2541C24.0602 25.3734 24.0466 25.4922 24.0231 25.6092C23.9938 25.7631 23.938 25.9107 23.8582 26.0455C23.7839 26.1864 23.673 26.3047 23.5373 26.388C23.4145 26.4554 23.275 26.4862 23.1352 26.4767C22.9702 26.4635 22.8084 26.4242 22.6558 26.3601C22.4649 26.2822 22.28 26.1902 22.1028 26.0848C21.9177 25.9806 21.7416 25.861 21.5765 25.7272C21.4433 25.6229 21.3317 25.4937 21.248 25.3467C21.1753 25.2139 21.1443 25.0623 21.1592 24.9116C21.1811 24.7244 21.2449 24.5446 21.3456 24.3853C21.4141 24.2669 21.4814 24.1616 21.5473 24.0695C21.6133 23.9769 21.6741 23.8919 21.7477 23.8158C21.8213 23.7397 21.8872 23.6624 21.9608 23.5875L22.3552 23.8158C22.321 23.8602 22.2766 23.9211 22.2284 23.9972C22.1802 24.0733 22.1168 24.1608 22.0534 24.2572C21.9899 24.3536 21.9265 24.4525 21.8669 24.5591C21.7907 24.6711 21.7508 24.804 21.7528 24.9395C21.7697 25.0602 21.8318 25.1699 21.9265 25.2465C22.0754 25.3747 22.2374 25.487 22.4098 25.5813C22.5447 25.6621 22.685 25.7337 22.8296 25.7957C22.9226 25.8367 23.0223 25.8603 23.1238 25.8654C23.1978 25.869 23.2708 25.8471 23.3306 25.8033C23.3955 25.752 23.4495 25.6882 23.4891 25.6156C23.5401 25.5246 23.5826 25.429 23.6159 25.3302C23.6449 25.2526 23.6695 25.1734 23.6895 25.093L23.1936 24.7988L22.9234 25.2655L22.5188 25.0309C22.5404 24.9789 22.5683 24.9167 22.6025 24.8482C22.6368 24.7797 22.6723 24.7062 22.7116 24.6313C22.7509 24.5565 22.789 24.4855 22.827 24.4195C22.8651 24.3536 22.9082 24.2788 22.9437 24.2217C22.9792 24.1646 23.0135 24.1113 23.0465 24.0657L24.4987 24.9078L24.2754 25.2845ZM25.5311 23.1195L24.3452 22.9825L24.2881 23.0764C24.2653 23.1119 24.245 23.1474 24.2234 23.1842L24.1588 23.2945C24.1372 23.3326 24.1169 23.3643 24.0979 23.3935L25.0517 23.9465L24.7549 24.4538L22.1954 22.9699L22.8131 21.9172C22.8676 21.8209 22.935 21.7326 23.0135 21.6546C23.0847 21.583 23.1715 21.5288 23.2671 21.4961C23.378 21.4634 23.4953 21.4591 23.6083 21.4834C23.7646 21.5173 23.9139 21.5778 24.0497 21.6622C24.1518 21.7195 24.246 21.7899 24.33 21.8715C24.3923 21.9318 24.4434 22.0026 24.4809 22.0808C24.5101 22.1453 24.5281 22.2144 24.5342 22.285C24.5381 22.3502 24.5355 22.4156 24.5266 22.4803L25.8304 22.597L25.5311 23.1195ZM26.7816 20.9177C26.7308 21.0628 26.6658 21.2026 26.5876 21.335C26.5123 21.4678 26.424 21.5927 26.3238 21.7079C26.2364 21.8095 26.13 21.8931 26.0105 21.9539C25.8922 22.0104 25.7602 22.0319 25.63 22.0161C25.4654 21.9935 25.3076 21.936 25.1671 21.8474L23.4307 20.8416L23.7275 20.3343L25.4613 21.3337C25.537 21.3822 25.6251 21.4078 25.715 21.4073C25.7957 21.3991 25.8717 21.3653 25.9319 21.3109C26.0084 21.2411 26.0731 21.1593 26.1234 21.0687C26.1765 20.9813 26.2146 20.8857 26.2363 20.7858C26.2538 20.7062 26.2454 20.6231 26.2122 20.5486C26.168 20.4686 26.1009 20.4036 26.0194 20.3622L24.2869 19.3577L24.5862 18.8428L26.3225 19.8485C26.4709 19.9264 26.6007 20.0354 26.703 20.1681C26.7795 20.2733 26.8255 20.3975 26.8362 20.5271C26.845 20.6597 26.8264 20.7926 26.7816 20.9177ZM27.9954 18.8669L27.3866 19.917L24.8272 18.4344L25.4106 17.4273C25.5577 17.1737 25.723 17.0223 25.9065 16.9733C26.0088 16.9513 26.1146 16.9501 26.2174 16.9697C26.3202 16.9893 26.4181 17.0293 26.5051 17.0874C26.5969 17.1386 26.6789 17.2056 26.7474 17.2853C26.8047 17.3527 26.8456 17.4326 26.8666 17.5186C26.8865 17.6025 26.8834 17.6901 26.8577 17.7723C26.9048 17.7227 26.9586 17.68 27.0175 17.6455C27.0806 17.6101 27.1492 17.5857 27.2205 17.5732C27.301 17.5606 27.3831 17.5632 27.4627 17.5808C27.5589 17.6023 27.6509 17.6392 27.7354 17.6899C27.8828 17.7665 28.0081 17.8796 28.0994 18.0184C28.1687 18.1351 28.1943 18.2726 28.1717 18.4065C28.142 18.5695 28.0822 18.7257 27.9954 18.8669ZM29.3233 16.4913C29.276 16.6666 29.2043 16.8344 29.1103 16.9898C29.0722 17.057 29.0304 17.1242 28.9834 17.1927C28.9365 17.2612 28.8908 17.3297 28.8414 17.3969C28.7919 17.4641 28.7424 17.5237 28.6943 17.5871C28.6461 17.6505 28.6004 17.6975 28.556 17.7419L28.1514 17.5072C28.1983 17.4425 28.2491 17.3677 28.3049 17.2827C28.3607 17.1978 28.4165 17.109 28.4736 17.0151C28.5306 16.9213 28.5839 16.8325 28.6334 16.7475C28.6784 16.6718 28.7149 16.5914 28.7424 16.5078C28.762 16.445 28.762 16.3778 28.7424 16.315C28.7197 16.253 28.6744 16.2018 28.6156 16.1717L28.5218 16.1172C28.4908 16.0963 28.4557 16.0826 28.4189 16.0769C28.3821 16.0712 28.3444 16.0737 28.3087 16.0842C28.2336 16.1127 28.1721 16.1684 28.1362 16.2402L28.0094 16.4583C27.9071 16.6666 27.7353 16.8326 27.5236 16.9276C27.341 16.9961 27.1203 16.9538 26.8615 16.8008L26.7347 16.7285C26.4861 16.5839 26.3453 16.4068 26.3124 16.1971C26.2903 15.9456 26.3547 15.6941 26.495 15.4843C26.5496 15.39 26.6088 15.2986 26.6726 15.2103C26.7347 15.1228 26.7994 15.0391 26.8615 14.9566C26.9237 14.8742 26.9808 14.8108 27.0302 14.7563L27.4348 14.9909C27.3663 15.0924 27.2915 15.2065 27.2091 15.3333C27.1266 15.4602 27.0531 15.5781 26.9884 15.6885C26.9476 15.7587 26.9144 15.8331 26.8894 15.9104C26.8684 15.9717 26.8684 16.0382 26.8894 16.0994C26.9207 16.1649 26.9729 16.218 27.0378 16.2503L27.1076 16.2909C27.1416 16.3151 27.1807 16.3309 27.2219 16.337C27.2631 16.3432 27.3052 16.3396 27.3448 16.3264C27.427 16.2855 27.4934 16.2187 27.5337 16.1362L27.6809 15.8825C27.7525 15.747 27.8578 15.6321 27.9865 15.549C28.0962 15.4833 28.2229 15.4519 28.3505 15.4589C28.4855 15.4712 28.6157 15.5146 28.731 15.5857L28.8769 15.6707C29.0446 15.7537 29.1824 15.8866 29.2713 16.0512C29.3404 16.1871 29.3588 16.3431 29.3233 16.4913Z"
        fill="white"
      />
      <path
        d="M16.1937 14.7383C15.5281 14.7383 14.8775 14.9357 14.3242 15.3054C13.7708 15.6752 13.3395 16.2008 13.0849 16.8157C12.8302 17.4307 12.7637 18.1073 12.8936 18.76C13.0235 19.4128 13.3441 20.0123 13.8148 20.4829C14.2856 20.9534 14.8852 21.2738 15.538 21.4035C16.1908 21.5331 16.8674 21.4663 17.4822 21.2115C18.0971 20.9566 18.6225 20.5251 18.9921 19.9716C19.3617 19.4181 19.5588 18.7674 19.5585 18.1018C19.5496 17.2123 19.1922 16.3618 18.5631 15.7329C17.9339 15.104 17.0832 14.7469 16.1937 14.7383ZM16.6845 19.7697H15.7485L14.7668 16.5583H15.5418L16.2203 18.9681L16.8925 16.5583H17.6535L16.6845 19.7697Z"
        fill="white"
      />
    </g>
  </svg>
);

export const LocationsPinRedIcon = () => (
  <svg
    width="47"
    height="47"
    viewBox="0 0 47 47"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <circle cx="23.75" cy="23.3809" r="23" fill="#E61E29" />
    <path
      d="M22.6391 33.8865C20.1922 31.1208 14.75 24.4175 14.75 20.6523C14.75 16.084 18.7794 12.3809 23.75 12.3809C28.7188 12.3809 32.75 16.084 32.75 20.6523C32.75 24.4175 27.2656 31.1208 24.8609 33.8865C24.2844 34.5456 23.2156 34.5456 22.6391 33.8865ZM23.75 23.4094C25.4047 23.4094 26.75 22.173 26.75 20.6523C26.75 19.1315 25.4047 17.8951 23.75 17.8951C22.0953 17.8951 20.75 19.1315 20.75 20.6523C20.75 22.173 22.0953 23.4094 23.75 23.4094Z"
      fill="white"
    />
  </svg>
);

export const UserTicketRedIcon = () => (
  <svg
    width="47"
    height="47"
    viewBox="0 0 47 47"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <circle cx="23.75" cy="23.3809" r="23" fill="#E61E29" />
    <g clipPath="url(#clip0_20670_19447)">
      <path
        d="M26.3928 26.2937V24.7434C25.5555 24.3039 24.6175 24.0684 23.622 24.0684H19.978C16.5377 24.0684 13.75 26.7982 13.75 30.1645C13.75 30.8359 14.3077 31.3809 14.9956 31.3809H28.6051C29.0313 31.3809 29.3893 31.1581 29.6139 30.8384L27.3983 28.6738C26.7486 28.0375 26.3928 27.1937 26.3928 26.2937ZM21.8 22.3809C24.3408 22.3809 26.4 20.3661 26.4 17.8809C26.4 15.3957 24.3408 13.3809 21.8 13.3809C19.2592 13.3809 17.2 15.3957 17.2 17.8809C17.2 20.3661 19.2592 22.3809 21.8 22.3809ZM36.4122 26.2059L33.167 23.0418C32.7358 22.6199 32.15 22.3809 31.5391 22.3809H28.6917C28.0538 22.3809 27.5421 22.8818 27.5421 23.5059L27.5426 26.2902C27.5426 26.8879 27.7815 27.4557 28.2129 27.8775L31.4584 31.0511C31.9076 31.4905 32.635 31.4905 33.0842 31.0511L36.408 27.7991C36.8614 27.359 36.8614 26.6453 36.4122 26.2059ZM29.8428 25.4711C29.3666 25.4711 28.9803 25.0977 28.9803 24.6273C28.9803 24.1615 29.3666 23.7836 29.8428 23.7836C30.3237 23.7836 30.7053 24.1615 30.7053 24.6273C30.7053 25.0932 30.3208 25.4711 29.8428 25.4711Z"
        fill="white"
      />
    </g>
    <defs>
      <clipPath id="clip0_20670_19447">
        <rect
          width="23"
          height="18"
          fill="white"
          transform="translate(13.75 13.3809)"
        />
      </clipPath>
    </defs>
  </svg>
);

export const RefreshIcon = () => (
  <svg
    width="25"
    height="25"
    viewBox="0 0 25 25"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clipPath="url(#clip0_20630_27235)">
      <path
        d="M22.5256 10.9998H22.924C23.5475 10.9998 24.049 10.4983 24.049 9.87485V3.87485C24.049 3.42016 23.7771 3.00766 23.3553 2.83422C22.9334 2.66078 22.4506 2.75453 22.1271 3.07797L20.1771 5.02797C16.0709 0.973285 9.45684 0.987348 5.37402 5.07485C1.27246 9.17641 1.27246 15.8233 5.37402 19.9248C9.47559 24.0264 16.1225 24.0264 20.224 19.9248C20.81 19.3389 20.81 18.3873 20.224 17.8014C19.6381 17.2155 18.6865 17.2155 18.1006 17.8014C15.1709 20.7311 10.4225 20.7311 7.49277 17.8014C4.56309 14.8717 4.56309 10.1233 7.49277 7.1936C10.4084 4.27797 15.1193 4.26391 18.0537 7.14672L16.1271 9.07797C15.8037 9.40141 15.71 9.88422 15.8834 10.3061C16.0568 10.728 16.4693 10.9998 16.924 10.9998H22.5256Z"
        fill="#A9A9A9"
      />
    </g>
    <defs>
      <clipPath id="clip0_20630_27235">
        <rect
          width="24"
          height="24"
          fill="white"
          transform="translate(0.798828 0.5)"
        />
      </clipPath>
    </defs>
  </svg>
);

export const ProgressBarPending = () => (
  <svg
    width="638"
    height="40"
    viewBox="0 0 638 40"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    style={{ width: '100%', height: 'auto' }} // Makes it responsive
  >
    <rect
      opacity="0.5"
      x="0.640625"
      y="13.707"
      width="636.251"
      height="12.5859"
      rx="6.29297"
      fill="#F2F2F2"
      stroke="#A9A9A9"
      strokeWidth="0.5"
    />
    <rect
      y="13.457"
      width="44.8906"
      height="13.0859"
      rx="6.54297"
      fill="#FF9900"
    />
    <circle cx="43" cy="20" r="20" fill="#FF9900" />
    <path
      d="M38.7531 14.6703L37.8355 17.293H48.1645L47.2469 14.6703C47.0887 14.2203 46.6633 13.918 46.1852 13.918H39.8148C39.3367 13.918 38.9113 14.2203 38.7531 14.6703ZM35.3922 17.4617L36.6297 13.9285C37.1043 12.575 38.3805 11.668 39.8148 11.668H46.1852C47.6195 11.668 48.8957 12.575 49.3703 13.9285L50.6078 17.4617C51.4234 17.7992 52 18.6043 52 19.543V24.6055V26.293C52 26.9152 51.4973 27.418 50.875 27.418H49.75C49.1277 27.418 48.625 26.9152 48.625 26.293V24.6055H37.375V26.293C37.375 26.9152 36.8723 27.418 36.25 27.418H35.125C34.5027 27.418 34 26.9152 34 26.293V24.6055V19.543C34 18.6043 34.5766 17.7992 35.3922 17.4617ZM38.5 20.668C38.5 20.3696 38.3815 20.0835 38.1705 19.8725C37.9595 19.6615 37.6734 19.543 37.375 19.543C37.0766 19.543 36.7905 19.6615 36.5795 19.8725C36.3685 20.0835 36.25 20.3696 36.25 20.668C36.25 20.9663 36.3685 21.2525 36.5795 21.4635C36.7905 21.6744 37.0766 21.793 37.375 21.793C37.6734 21.793 37.9595 21.6744 38.1705 21.4635C38.3815 21.2525 38.5 20.9663 38.5 20.668ZM48.625 21.793C48.9234 21.793 49.2095 21.6744 49.4205 21.4635C49.6315 21.2525 49.75 20.9663 49.75 20.668C49.75 20.3696 49.6315 20.0835 49.4205 19.8725C49.2095 19.6615 48.9234 19.543 48.625 19.543C48.3266 19.543 48.0405 19.6615 47.8295 19.8725C47.6185 20.0835 47.5 20.3696 47.5 20.668C47.5 20.9663 47.6185 21.2525 47.8295 21.4635C48.0405 21.6744 48.3266 21.793 48.625 21.793Z"
      fill="white"
    />
  </svg>
);

export const ProgressBarInProgress = () => (
  <svg
    width="638"
    height="41"
    viewBox="0 0 638 41"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    style={{ width: '100%', height: 'auto' }} // Makes it responsive
  >
    <rect
      opacity="0.5"
      x="0.25"
      y="14.375"
      width="636.642"
      height="12.5859"
      rx="6.29297"
      fill="#F2F2F2"
      stroke="#A9A9A9"
      strokeWidth="0.5"
    />
    <circle cx="318.571" cy="20.668" r="20" fill="#172A55" />
    <g clipPath="url(#clip0_21389_20873)">
      <path
        d="M314.324 15.3383L313.407 17.9609H323.735L322.818 15.3383C322.66 14.8883 322.234 14.5859 321.756 14.5859H315.386C314.908 14.5859 314.482 14.8883 314.324 15.3383ZM310.963 18.1297L312.201 14.5965C312.675 13.243 313.952 12.3359 315.386 12.3359H321.756C323.191 12.3359 324.467 13.243 324.941 14.5965L326.179 18.1297C326.994 18.4672 327.571 19.2723 327.571 20.2109V25.2734V26.9609C327.571 27.5832 327.068 28.0859 326.446 28.0859H325.321C324.699 28.0859 324.196 27.5832 324.196 26.9609V25.2734H312.946V26.9609C312.946 27.5832 312.443 28.0859 311.821 28.0859H310.696C310.074 28.0859 309.571 27.5832 309.571 26.9609V25.2734V20.2109C309.571 19.2723 310.148 18.4672 310.963 18.1297ZM314.071 21.3359C314.071 21.0376 313.953 20.7514 313.742 20.5404C313.531 20.3295 313.244 20.2109 312.946 20.2109C312.648 20.2109 312.362 20.3295 312.151 20.5404C311.94 20.7514 311.821 21.0376 311.821 21.3359C311.821 21.6343 311.94 21.9205 312.151 22.1314C312.362 22.3424 312.648 22.4609 312.946 22.4609C313.244 22.4609 313.531 22.3424 313.742 22.1314C313.953 21.9205 314.071 21.6343 314.071 21.3359ZM324.196 22.4609C324.494 22.4609 324.781 22.3424 324.992 22.1314C325.203 21.9205 325.321 21.6343 325.321 21.3359C325.321 21.0376 325.203 20.7514 324.992 20.5404C324.781 20.3295 324.494 20.2109 324.196 20.2109C323.898 20.2109 323.612 20.3295 323.401 20.5404C323.19 20.7514 323.071 21.0376 323.071 21.3359C323.071 21.6343 323.19 21.9205 323.401 22.1314C323.612 22.3424 323.898 22.4609 324.196 22.4609Z"
        fill="white"
      />
    </g>
    <rect
      y="14.125"
      width="309.571"
      height="13.0859"
      rx="6.54297"
      fill="#172A55"
    />
    <defs>
      <clipPath id="clip0_21389_20873">
        <rect
          width="18"
          height="18"
          fill="white"
          transform="translate(309.571 11.2109)"
        />
      </clipPath>
    </defs>
  </svg>
);

export const ProgressBarCancelled = () => (
  <svg
    width="638"
    height="41"
    viewBox="0 0 638 41"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    style={{ width: '100%', height: 'auto' }} // Makes it responsive
  >
    <rect
      opacity="0.5"
      x="0.25"
      y="14.043"
      width="636.642"
      height="12.5859"
      rx="6.29297"
      fill="#F2F2F2"
      stroke="#A9A9A9"
      strokeWidth="0.5"
    />
    <circle cx="318.571" cy="20.3359" r="20" fill="#E61E29" />
    <g clipPath="url(#clip0_21389_20874)">
      <path
        d="M314.324 15.0063L313.407 17.6289H323.735L322.818 15.0063C322.66 14.5563 322.234 14.2539 321.756 14.2539H315.386C314.908 14.2539 314.482 14.5563 314.324 15.0063ZM310.963 17.7977L312.201 14.2645C312.675 12.9109 313.952 12.0039 315.386 12.0039H321.756C323.191 12.0039 324.467 12.9109 324.941 14.2645L326.179 17.7977C326.994 18.1352 327.571 18.9402 327.571 19.8789V24.9414V26.6289C327.571 27.2512 327.068 27.7539 326.446 27.7539H325.321C324.699 27.7539 324.196 27.2512 324.196 26.6289V24.9414H312.946V26.6289C312.946 27.2512 312.443 27.7539 311.821 27.7539H310.696C310.074 27.7539 309.571 27.2512 309.571 26.6289V24.9414V19.8789C309.571 18.9402 310.148 18.1352 310.963 17.7977ZM314.071 21.0039C314.071 20.7055 313.953 20.4194 313.742 20.2084C313.531 19.9974 313.244 19.8789 312.946 19.8789C312.648 19.8789 312.362 19.9974 312.151 20.2084C311.94 20.4194 311.821 20.7055 311.821 21.0039C311.821 21.3023 311.94 21.5884 312.151 21.7994C312.362 22.0104 312.648 22.1289 312.946 22.1289C313.244 22.1289 313.531 22.0104 313.742 21.7994C313.953 21.5884 314.071 21.3023 314.071 21.0039ZM324.196 22.1289C324.494 22.1289 324.781 22.0104 324.992 21.7994C325.203 21.5884 325.321 21.3023 325.321 21.0039C325.321 20.7055 325.203 20.4194 324.992 20.2084C324.781 19.9974 324.494 19.8789 324.196 19.8789C323.898 19.8789 323.612 19.9974 323.401 20.2084C323.19 20.4194 323.071 20.7055 323.071 21.0039C323.071 21.3023 323.19 21.5884 323.401 21.7994C323.612 22.0104 323.898 22.1289 324.196 22.1289Z"
        fill="white"
      />
    </g>
    <rect
      y="13.793"
      width="309.571"
      height="13.0859"
      rx="6.54297"
      fill="#E61E29"
    />
    <defs>
      <clipPath id="clip0_21389_20874">
        <rect
          width="18"
          height="18"
          fill="white"
          transform="translate(309.571 10.8789)"
        />
      </clipPath>
    </defs>
  </svg>
);

export const ProgressBarCompleted = () => (
  <svg
    width="638"
    height="40"
    viewBox="0 0 638 40"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    style={{ width: '100%', height: 'auto' }} // Makes it responsive
  >
    <rect
      opacity="0.5"
      x="0.25"
      y="13.707"
      width="636.642"
      height="12.5859"
      rx="6.29297"
      fill="#F2F2F2"
      stroke="#A9A9A9"
      stroke-width="0.5"
    />
    <rect
      y="13.457"
      width="604.571"
      height="13.0859"
      rx="6.54297"
      fill="#00B51D"
    />
    <circle cx="617.142" cy="20" r="20" fill="#00B51D" />
    <g clipPath="url(#clip0_21389_20875)">
      <path
        d="M612.895 14.6703L611.978 17.293H622.307L621.389 14.6703C621.231 14.2203 620.805 13.918 620.327 13.918H613.957C613.479 13.918 613.053 14.2203 612.895 14.6703ZM609.534 17.4617L610.772 13.9285C611.246 12.575 612.523 11.668 613.957 11.668H620.327C621.762 11.668 623.038 12.575 623.512 13.9285L624.75 17.4617C625.566 17.7992 626.142 18.6043 626.142 19.543V24.6055V26.293C626.142 26.9152 625.639 27.418 625.017 27.418H623.892C623.27 27.418 622.767 26.9152 622.767 26.293V24.6055H611.517V26.293C611.517 26.9152 611.014 27.418 610.392 27.418H609.267C608.645 27.418 608.142 26.9152 608.142 26.293V24.6055V19.543C608.142 18.6043 608.719 17.7992 609.534 17.4617ZM612.642 20.668C612.642 20.3696 612.524 20.0835 612.313 19.8725C612.102 19.6615 611.815 19.543 611.517 19.543C611.219 19.543 610.933 19.6615 610.722 19.8725C610.511 20.0835 610.392 20.3696 610.392 20.668C610.392 20.9663 610.511 21.2525 610.722 21.4635C610.933 21.6744 611.219 21.793 611.517 21.793C611.815 21.793 612.102 21.6744 612.313 21.4635C612.524 21.2525 612.642 20.9663 612.642 20.668ZM622.767 21.793C623.065 21.793 623.352 21.6744 623.563 21.4635C623.774 21.2525 623.892 20.9663 623.892 20.668C623.892 20.3696 623.774 20.0835 623.563 19.8725C623.352 19.6615 623.065 19.543 622.767 19.543C622.469 19.543 622.183 19.6615 621.972 19.8725C621.761 20.0835 621.642 20.3696 621.642 20.668C621.642 20.9663 621.761 21.2525 621.972 21.4635C622.183 21.6744 622.469 21.793 622.767 21.793Z"
        fill="white"
      />
    </g>
    <defs>
      <clipPath id="clip0_21389_20875">
        <rect
          width="18"
          height="18"
          fill="white"
          transform="translate(608.142 10.543)"
        />
      </clipPath>
    </defs>
  </svg>
);

export const ProgressBarUnknown = () => (
  <svg
    width="638"
    height="40"
    viewBox="0 0 638 40"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    style={{ width: '100%', height: 'auto' }} // Makes it responsive
  >
    <rect
      opacity="0.5"
      x="0.25"
      y="13.707"
      width="636.642"
      height="12.5859"
      rx="6.29297"
      fill="#F2F2F2"
      stroke="#A9A9A9"
      strokeWidth="0.5"
    />
    <circle cx="318.571" cy="20" r="20" fill="#A9A9A9" />
    <g clipPath="url(#clip0_21390_20892)">
      <path
        d="M314.324 14.6703L313.407 17.293H323.735L322.818 14.6703C322.66 14.2203 322.234 13.918 321.756 13.918H315.386C314.908 13.918 314.482 14.2203 314.324 14.6703ZM310.963 17.4617L312.201 13.9285C312.675 12.575 313.952 11.668 315.386 11.668H321.756C323.191 11.668 324.467 12.575 324.941 13.9285L326.179 17.4617C326.994 17.7992 327.571 18.6043 327.571 19.543V24.6055V26.293C327.571 26.9152 327.068 27.418 326.446 27.418H325.321C324.699 27.418 324.196 26.9152 324.196 26.293V24.6055H312.946V26.293C312.946 26.9152 312.443 27.418 311.821 27.418H310.696C310.074 27.418 309.571 26.9152 309.571 26.293V24.6055V19.543C309.571 18.6043 310.148 17.7992 310.963 17.4617ZM314.071 20.668C314.071 20.3696 313.953 20.0835 313.742 19.8725C313.531 19.6615 313.244 19.543 312.946 19.543C312.648 19.543 312.362 19.6615 312.151 19.8725C311.94 20.0835 311.821 20.3696 311.821 20.668C311.821 20.9663 311.94 21.2525 312.151 21.4635C312.362 21.6744 312.648 21.793 312.946 21.793C313.244 21.793 313.531 21.6744 313.742 21.4635C313.953 21.2525 314.071 20.9663 314.071 20.668ZM324.196 21.793C324.494 21.793 324.781 21.6744 324.992 21.4635C325.203 21.2525 325.321 20.9663 325.321 20.668C325.321 20.3696 325.203 20.0835 324.992 19.8725C324.781 19.6615 324.494 19.543 324.196 19.543C323.898 19.543 323.612 19.6615 323.401 19.8725C323.19 20.0835 323.071 20.3696 323.071 20.668C323.071 20.9663 323.19 21.2525 323.401 21.4635C323.612 21.6744 323.898 21.793 324.196 21.793Z"
        fill="white"
      />
    </g>
    <rect
      y="13.457"
      width="309.571"
      height="13.0859"
      rx="6.54297"
      fill="#A9A9A9"
    />
    <defs>
      <clipPath id="clip0_21390_20892">
        <rect
          width="18"
          height="18"
          fill="white"
          transform="translate(309.571 10.543)"
        />
      </clipPath>
    </defs>
  </svg>
);

export const DeliveriesIcon = () => (
  <svg
    width="24"
    height="20"
    viewBox="0 0 24 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clipPath="url(#clip0_21670_12490)">
      <path
        d="M1.8 0.294922C0.80625 0.294922 0 1.09277 0 2.07617V13.9512C0 14.9346 0.80625 15.7324 1.8 15.7324H2.4C2.4 17.6992 4.0125 19.2949 6 19.2949C7.9875 19.2949 9.6 17.6992 9.6 15.7324H14.4C14.4 17.6992 16.0125 19.2949 18 19.2949C19.9875 19.2949 21.6 17.6992 21.6 15.7324H22.8C23.4638 15.7324 24 15.2018 24 14.5449C24 13.8881 23.4638 13.3574 22.8 13.3574V10.9824V9.79492V9.10098C22.8 8.47012 22.5487 7.86523 22.0988 7.41992L19.2 4.55137C18.75 4.10605 18.1388 3.85742 17.5013 3.85742H15.6V2.07617C15.6 1.09277 14.7938 0.294922 13.8 0.294922H1.8ZM15.6 6.23242H17.5013L20.4 9.10098V9.79492H15.6V6.23242ZM4.2 15.7324C4.2 15.26 4.38964 14.8069 4.72721 14.4729C5.06477 14.1388 5.52261 13.9512 6 13.9512C6.47739 13.9512 6.93523 14.1388 7.27279 14.4729C7.61036 14.8069 7.8 15.26 7.8 15.7324C7.8 16.2048 7.61036 16.6579 7.27279 16.992C6.93523 17.326 6.47739 17.5137 6 17.5137C5.52261 17.5137 5.06477 17.326 4.72721 16.992C4.38964 16.6579 4.2 16.2048 4.2 15.7324ZM18 13.9512C18.4774 13.9512 18.9352 14.1388 19.2728 14.4729C19.6104 14.8069 19.8 15.26 19.8 15.7324C19.8 16.2048 19.6104 16.6579 19.2728 16.992C18.9352 17.326 18.4774 17.5137 18 17.5137C17.5226 17.5137 17.0648 17.326 16.7272 16.992C16.3896 16.6579 16.2 16.2048 16.2 15.7324C16.2 15.26 16.3896 14.8069 16.7272 14.4729C17.0648 14.1388 17.5226 13.9512 18 13.9512Z"
        fill="white"
      />
    </g>
    <defs>
      <clipPath id="clip0_21670_12490">
        <rect
          width="24"
          height="19"
          fill="white"
          transform="translate(0 0.294922)"
        />
      </clipPath>
    </defs>
  </svg>
);

export const NewPillIcon = () => (
  <svg
    width="48"
    height="19"
    viewBox="0 0 48 19"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <rect y="0.5" width="48" height="18" rx="9" fill="white" />
    <path
      d="M11.1797 13.5V5.04492H12.7266L16.5469 10.541H16.582V5.04492H18.3457V13.5H16.8105L12.9785 7.96289H12.9434V13.5H11.1797ZM19.7578 13.5V5.04492H25.3594V6.50391H21.5273V8.53125H25.1426V9.91406H21.5273V12.041H25.3594V13.5H19.7578ZM28.4238 13.5L26.1855 5.04492H28.0195L29.3555 11.1035H29.3906L30.9492 5.04492H32.502L34.0605 11.1035H34.0957L35.4375 5.04492H37.2715L35.0273 13.5H33.2988L31.7461 7.83398H31.7109L30.1523 13.5H28.4238Z"
      fill="#E61E29"
    />
  </svg>
);

export const ExportIcon = () => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M1.99805 4.875C1.99805 3.56504 3.09423 2.5 4.44249 2.5H10.5536V7.25C10.5536 7.90684 11.0998 8.4375 11.7758 8.4375H16.6647V13.1875H10.248C9.74006 13.1875 9.33138 13.5846 9.33138 14.0781C9.33138 14.5717 9.74006 14.9688 10.248 14.9688H16.6647V19.125C16.6647 20.435 15.5685 21.5 14.2203 21.5H4.44249C3.09423 21.5 1.99805 20.435 1.99805 19.125V4.875ZM16.6647 14.9688V13.1875H20.8699L19.3803 11.7402C19.0213 11.3914 19.0213 10.8273 19.3803 10.4822C19.7394 10.1371 20.3199 10.1334 20.6751 10.4822L23.7307 13.451C24.0897 13.7998 24.0897 14.3639 23.7307 14.709L20.6751 17.6777C20.3161 18.0266 19.7355 18.0266 19.3803 17.6777C19.0251 17.3289 19.0213 16.7648 19.3803 16.4197L20.8699 14.9725L16.6647 14.9688ZM16.6647 7.25H11.7758V2.5L16.6647 7.25Z"
      fill="#E61E29"
    />
  </svg>
);

export const DropdownLocationIcon = () => (
  <svg
    width="17"
    height="21"
    viewBox="0 0 17 21"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clipPath="url(#clip0_23138_19824)">
      <path
        d="M9.87422 20.2117C12.0117 17.6481 16.8867 11.4349 16.8867 7.94499C16.8867 3.71235 13.3034 0.27832 8.88672 0.27832C4.47005 0.27832 0.886719 3.71235 0.886719 7.94499C0.886719 11.4349 5.76172 17.6481 7.89922 20.2117C8.41172 20.8226 9.36172 20.8226 9.87422 20.2117ZM8.88672 5.38943C9.59396 5.38943 10.2722 5.65868 10.7723 6.13794C11.2724 6.6172 11.5534 7.26721 11.5534 7.94499C11.5534 8.62276 11.2724 9.27278 10.7723 9.75204C10.2722 10.2313 9.59396 10.5005 8.88672 10.5005C8.17947 10.5005 7.5012 10.2313 7.0011 9.75204C6.501 9.27278 6.22005 8.62276 6.22005 7.94499C6.22005 7.26721 6.501 6.6172 7.0011 6.13794C7.5012 5.65868 8.17947 5.38943 8.88672 5.38943Z"
        fill="#A9A9A9"
      />
    </g>
    <defs>
      <clipPath id="clip0_23138_19824">
        <rect
          width="16"
          height="20.4444"
          fill="white"
          transform="translate(0.886719 0.27832)"
        />
      </clipPath>
    </defs>
  </svg>
);

export const DropdownProvidersIcon = () => (
  <svg
    width="19"
    height="18"
    viewBox="0 0 19 18"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clipPath="url(#clip0_23138_19854)">
      <path
        d="M17.4664 0.757129C16.6965 -0.012793 15.452 -0.012793 14.682 0.757129L13.6238 1.81182L17.0656 5.25361L18.1238 4.19541C18.8937 3.42549 18.8937 2.18096 18.1238 1.41104L17.4664 0.757129ZM6.94766 8.4915C6.7332 8.70596 6.56797 8.96963 6.47305 9.26143L5.43242 12.3833C5.33047 12.6856 5.41133 13.0196 5.63633 13.2481C5.86133 13.4767 6.19531 13.554 6.50117 13.4521L9.62305 12.4114C9.91133 12.3165 10.175 12.1513 10.393 11.9368L16.2746 6.05166L12.8293 2.60635L6.94766 8.4915ZM4.26172 2.24424C2.39844 2.24424 0.886719 3.75596 0.886719 5.61924V14.6192C0.886719 16.4825 2.39844 17.9942 4.26172 17.9942H13.2617C15.125 17.9942 16.6367 16.4825 16.6367 14.6192V11.2442C16.6367 10.622 16.134 10.1192 15.5117 10.1192C14.8895 10.1192 14.3867 10.622 14.3867 11.2442V14.6192C14.3867 15.2415 13.884 15.7442 13.2617 15.7442H4.26172C3.63945 15.7442 3.13672 15.2415 3.13672 14.6192V5.61924C3.13672 4.99697 3.63945 4.49424 4.26172 4.49424H7.63672C8.25898 4.49424 8.76172 3.9915 8.76172 3.36924C8.76172 2.74697 8.25898 2.24424 7.63672 2.24424H4.26172Z"
        fill="#A9A9A9"
      />
    </g>
    <defs>
      <clipPath id="clip0_23138_19854">
        <rect
          width="18"
          height="18"
          fill="white"
          transform="translate(0.886719 -0.00585938)"
        />
      </clipPath>
    </defs>
  </svg>
);

export const DropdownVDriveIcon = () => (
  <svg
    width="21"
    height="17"
    viewBox="0 0 21 17"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M2.38672 0.84668C1.55859 0.84668 0.886719 1.51855 0.886719 2.34668V12.3467C0.886719 13.1748 1.55859 13.8467 2.38672 13.8467H2.88672C2.88672 15.5029 4.23047 16.8467 5.88672 16.8467C7.54297 16.8467 8.88672 15.5029 8.88672 13.8467H12.8867C12.8867 15.5029 14.2305 16.8467 15.8867 16.8467C17.543 16.8467 18.8867 15.5029 18.8867 13.8467H19.8867C20.4398 13.8467 20.8867 13.3998 20.8867 12.8467C20.8867 12.2936 20.4398 11.8467 19.8867 11.8467V9.84668V8.84668V8.2623C19.8867 7.73105 19.6773 7.22168 19.3023 6.84668L16.8867 4.43105C16.5117 4.05605 16.0023 3.84668 15.4711 3.84668H13.8867V2.34668C13.8867 1.51855 13.2148 0.84668 12.3867 0.84668H2.38672ZM13.8867 5.84668H15.4711L17.8867 8.2623V8.84668H13.8867V5.84668ZM4.38672 13.8467C4.38672 13.4489 4.54475 13.0673 4.82606 12.786C5.10736 12.5047 5.48889 12.3467 5.88672 12.3467C6.28454 12.3467 6.66607 12.5047 6.94738 12.786C7.22868 13.0673 7.38672 13.4489 7.38672 13.8467C7.38672 14.2445 7.22868 14.626 6.94738 14.9073C6.66607 15.1886 6.28454 15.3467 5.88672 15.3467C5.48889 15.3467 5.10736 15.1886 4.82606 14.9073C4.54475 14.626 4.38672 14.2445 4.38672 13.8467ZM15.8867 12.3467C16.2845 12.3467 16.6661 12.5047 16.9474 12.786C17.2287 13.0673 17.3867 13.4489 17.3867 13.8467C17.3867 14.2445 17.2287 14.626 16.9474 14.9073C16.6661 15.1886 16.2845 15.3467 15.8867 15.3467C15.4889 15.3467 15.1074 15.1886 14.8261 14.9073C14.5448 14.626 14.3867 14.2445 14.3867 13.8467C14.3867 13.4489 14.5448 13.0673 14.8261 12.786C15.1074 12.5047 15.4889 12.3467 15.8867 12.3467Z"
      fill="#A9A9A9"
    />
  </svg>
);

export const DropdownMenuIcon = () => (
  <svg
    width="18"
    height="19"
    viewBox="0 0 18 19"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clipPath="url(#clip0_23138_19834)">
      <path
        d="M4.02958 0.0771484C2.01842 0.0771484 0.386719 1.66352 0.386719 3.61882V15.4244C0.386719 17.3797 2.01842 18.966 4.02958 18.966H14.9581H16.1724C16.8441 18.966 17.3867 18.4385 17.3867 17.7855C17.3867 17.1325 16.8441 16.6049 16.1724 16.6049V14.2438C16.8441 14.2438 17.3867 13.7163 17.3867 13.0633V1.2577C17.3867 0.604709 16.8441 0.0771484 16.1724 0.0771484H14.9581H4.02958ZM4.02958 14.2438H13.7439V16.6049H4.02958C3.35792 16.6049 2.81529 16.0774 2.81529 15.4244C2.81529 14.7714 3.35792 14.2438 4.02958 14.2438ZM5.24386 5.38965C5.24386 5.065 5.51708 4.79937 5.851 4.79937H13.1367C13.4706 4.79937 13.7439 5.065 13.7439 5.38965C13.7439 5.7143 13.4706 5.97993 13.1367 5.97993H5.851C5.51708 5.97993 5.24386 5.7143 5.24386 5.38965ZM5.851 7.16048H13.1367C13.4706 7.16048 13.7439 7.42611 13.7439 7.75076C13.7439 8.07541 13.4706 8.34104 13.1367 8.34104H5.851C5.51708 8.34104 5.24386 8.07541 5.24386 7.75076C5.24386 7.42611 5.51708 7.16048 5.851 7.16048Z"
        fill="#A9A9A9"
      />
    </g>
    <defs>
      <clipPath id="clip0_23138_19834">
        <rect
          width="17"
          height="18.8889"
          fill="white"
          transform="translate(0.386719 0.0771484)"
        />
      </clipPath>
    </defs>
  </svg>
);

export const DropdownNotesIcon = () => (
  <svg
    width="17"
    height="20"
    viewBox="0 0 17 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clipPath="url(#clip0_23138_19829)">
      <path
        d="M3.17243 1.26465C1.91172 1.26465 0.886719 2.32969 0.886719 3.63965V15.5146C0.886719 16.8246 1.91172 17.8896 3.17243 17.8896H11.1724V13.7334C11.1724 12.75 11.9403 11.9521 12.8867 11.9521H16.8867V3.63965C16.8867 2.32969 15.8617 1.26465 14.601 1.26465H3.17243ZM16.8867 13.1396H15.2689H12.8867C12.5724 13.1396 12.3153 13.4068 12.3153 13.7334V16.2086V17.8896L13.4581 16.7021L15.7439 14.3271L16.8867 13.1396Z"
        fill="#A9A9A9"
      />
    </g>
    <defs>
      <clipPath id="clip0_23138_19829">
        <rect
          width="16"
          height="19"
          fill="white"
          transform="translate(0.886719 0.0771484)"
        />
      </clipPath>
    </defs>
  </svg>
);

export const DropdownSyncIcon = () => (
  <svg
    width="19"
    height="18"
    viewBox="0 0 19 18"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clipPath="url(#clip0_23138_19852)">
      <path
        d="M5.91055 5.0242C5.29531 5.63944 4.85234 6.36014 4.58164 7.12655C4.37422 7.71365 3.73086 8.01951 3.14727 7.81209C2.56367 7.60467 2.2543 6.96131 2.46172 6.37772C2.84141 5.29842 3.46016 4.28944 4.31797 3.43162C7.38359 0.365999 12.3441 0.355452 15.4203 3.39647L16.8828 1.93397C17.1254 1.69139 17.4875 1.62108 17.8039 1.75116C18.1203 1.88123 18.3242 2.19061 18.3242 2.53162V7.03162C18.3242 7.4992 17.948 7.87537 17.4805 7.87537H17.1852H12.9805C12.6395 7.87537 12.3301 7.67147 12.2 7.35506C12.0699 7.03865 12.1402 6.67655 12.3828 6.43397L13.8277 4.98905C11.627 2.82694 8.09375 2.83748 5.90703 5.0242H5.91055ZM1.44922 10.9691C1.44922 10.5015 1.82539 10.1254 2.29297 10.1254H2.56016H2.58477H6.79297C7.13398 10.1254 7.44336 10.3293 7.57344 10.6457C7.70352 10.9621 7.6332 11.3242 7.39062 11.5668L5.9457 13.0117C8.14648 15.1738 11.6797 15.1633 13.8664 12.9765C14.4816 12.3613 14.9246 11.6406 15.1953 10.8742C15.4027 10.2871 16.0461 9.98123 16.6297 10.1887C17.2133 10.3961 17.5227 11.0394 17.3152 11.623C16.9355 12.6988 16.3168 13.7078 15.4555 14.5691C12.3898 17.6347 7.4293 17.6453 4.35312 14.6043L2.89062 16.0668C2.64805 16.3094 2.28594 16.3797 1.96953 16.2496C1.65312 16.1195 1.44922 15.8101 1.44922 15.4691V11.2644V11.2398V10.9726V10.9691Z"
        fill="#A9A9A9"
      />
    </g>
    <defs>
      <clipPath id="clip0_23138_19852">
        <rect
          width="18"
          height="18"
          fill="white"
          transform="translate(0.886719)"
        />
      </clipPath>
    </defs>
  </svg>
);

export const DropdownCommissionsIcon = () => (
  <svg
    width="17"
    height="22"
    viewBox="0 0 17 22"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clipPath="url(#clip0_23138_19846)">
      <path
        d="M16.495 5.35137C17.0158 4.83053 17.0158 3.9847 16.495 3.46387C15.9742 2.94303 15.1283 2.94303 14.6075 3.46387L1.27417 16.7972C0.753337 17.318 0.753337 18.1639 1.27417 18.6847C1.795 19.2055 2.64084 19.2055 3.16167 18.6847L16.495 5.35137ZM6.22 5.74303C6.22 5.03579 5.93905 4.35751 5.43895 3.85742C4.93886 3.35732 4.26058 3.07637 3.55334 3.07637C2.84609 3.07637 2.16782 3.35732 1.66772 3.85742C1.16762 4.35751 0.88667 5.03579 0.88667 5.74303C0.88667 6.45028 1.16762 7.12856 1.66772 7.62865C2.16782 8.12875 2.84609 8.4097 3.55334 8.4097C4.26058 8.4097 4.93886 8.12875 5.43895 7.62865C5.93905 7.12856 6.22 6.45028 6.22 5.74303ZM16.8867 16.4097C16.8867 15.7025 16.6057 15.0242 16.1056 14.5241C15.6055 14.024 14.9272 13.743 14.22 13.743C13.5128 13.743 12.8345 14.024 12.3344 14.5241C11.8343 15.0242 11.5533 15.7025 11.5533 16.4097C11.5533 17.1169 11.8343 17.7952 12.3344 18.2953C12.8345 18.7954 13.5128 19.0764 14.22 19.0764C14.9272 19.0764 15.6055 18.7954 16.1056 18.2953C16.6057 17.7952 16.8867 17.1169 16.8867 16.4097Z"
        fill="#A9A9A9"
      />
    </g>
    <defs>
      <clipPath id="clip0_23138_19846">
        <rect
          width="16"
          height="21.3333"
          fill="white"
          transform="translate(0.886719 0.410156)"
        />
      </clipPath>
    </defs>
  </svg>
);

/**
 * Font Awesome `receipt` (solid). Tax rates - the location's dropdown entry
 * and the per-item picker. Defaults to the dropdown grey the other entries
 * use; the menu passes a colour.
 */
export const TaxRatesIcon = ({ color }: { color?: string }) => (
  <svg width="15" height="20" viewBox="0 0 384 512" fill="none">
    <path
      d="M14 2.2C22.5-1.7 32.5-.3 39.6 5.8L80 40.4 120.4 5.8c9-7.7 22.3-7.7 31.2 0L192 40.4 232.4 5.8c9-7.7 22.3-7.7 31.2 0L304 40.4 344.4 5.8c7.1-6.1 17.1-7.5 25.6-3.6S384 14.7 384 24l0 464c0 9.3-5.4 17.7-13.9 21.6s-18.5 2.5-25.6-3.6L304 471.6l-40.4 34.6c-9 7.7-22.3 7.7-31.2 0L192 471.6l-40.4 34.6c-9 7.7-22.3 7.7-31.2 0L80 471.6 39.6 506.2c-7.1 6.1-17.1 7.5-25.6 3.6S0 497.3 0 488L0 24C0 14.7 5.4 6.3 14 2.2zM96 144c-8.8 0-16 7.2-16 16s7.2 16 16 16l192 0c8.8 0 16-7.2 16-16s-7.2-16-16-16L96 144zM80 352c0 8.8 7.2 16 16 16l192 0c8.8 0 16-7.2 16-16s-7.2-16-16-16L96 336c-8.8 0-16 7.2-16 16zM96 240c-8.8 0-16 7.2-16 16s7.2 16 16 16l192 0c8.8 0 16-7.2 16-16s-7.2-16-16-16L96 240z"
      fill={color || '#A9A9A9'}
    />
  </svg>
);

export const DropdownDeleteIcon = () => (
  <svg
    width="17"
    height="19"
    viewBox="0 0 17 19"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clipPath="url(#clip0_23138_19850)">
      <path
        d="M5.71529 0.703432C5.90815 0.314146 6.30458 0.0712891 6.73672 0.0712891H11.0367C11.4689 0.0712891 11.8653 0.314146 12.0581 0.703432L12.3153 1.21415H15.7439C16.376 1.21415 16.8867 1.72486 16.8867 2.357C16.8867 2.98915 16.376 3.49986 15.7439 3.49986H2.02958C1.39743 3.49986 0.886719 2.98915 0.886719 2.357C0.886719 1.72486 1.39743 1.21415 2.02958 1.21415H5.45815L5.71529 0.703432ZM2.02958 4.64272H15.7439V16.0713C15.7439 17.332 14.7189 18.357 13.4581 18.357H4.31529C3.05458 18.357 2.02958 17.332 2.02958 16.0713V4.64272ZM5.45815 6.92843C5.14386 6.92843 4.88672 7.18558 4.88672 7.49986V15.4999C4.88672 15.8141 5.14386 16.0713 5.45815 16.0713C5.77243 16.0713 6.02958 15.8141 6.02958 15.4999V7.49986C6.02958 7.18558 5.77243 6.92843 5.45815 6.92843ZM8.88672 6.92843C8.57243 6.92843 8.31529 7.18558 8.31529 7.49986V15.4999C8.31529 15.8141 8.57243 16.0713 8.88672 16.0713C9.201 16.0713 9.45815 15.8141 9.45815 15.4999V7.49986C9.45815 7.18558 9.201 6.92843 8.88672 6.92843ZM12.3153 6.92843C12.001 6.92843 11.7439 7.18558 11.7439 7.49986V15.4999C11.7439 15.8141 12.001 16.0713 12.3153 16.0713C12.6296 16.0713 12.8867 15.8141 12.8867 15.4999V7.49986C12.8867 7.18558 12.6296 6.92843 12.3153 6.92843Z"
        fill="#A9A9A9"
      />
    </g>
    <defs>
      <clipPath id="clip0_23138_19850">
        <rect
          width="16"
          height="18.2857"
          fill="white"
          transform="translate(0.886719 0.0712891)"
        />
      </clipPath>
    </defs>
  </svg>
);

export const PaperPlaneIcon = () => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 640 640">
    <path d="M568.4 37.7C578.2 34.2 589 36.7 596.4 44C603.8 51.3 606.2 62.2 602.7 72L424.7 568.9C419.7 582.8 406.6 592 391.9 592C377.7 592 364.9 583.4 359.6 570.3L295.4 412.3C290.9 401.3 292.9 388.7 300.6 379.7L395.1 267.3C400.2 261.2 399.8 252.3 394.2 246.7C388.6 241.1 379.6 240.7 373.6 245.8L261.2 340.1C252.1 347.7 239.6 349.7 228.6 345.3L70.1 280.8C57 275.5 48.4 262.7 48.4 248.5C48.4 233.8 57.6 220.7 71.5 215.7L568.4 37.7z" />
  </svg>
);

export const DropdownBrandIcon = () => (
  <svg
    width="21"
    height="17"
    viewBox="0 0 21 17"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M17.3479 7.41094C17.2114 7.42754 17.0713 7.4375 16.9243 7.4375C16.0141 7.4375 15.2018 7.05898 14.6452 6.47461C14.0886 7.05898 13.2763 7.4375 12.3626 7.4375C11.4489 7.4375 10.6367 7.05898 10.08 6.47461C9.52336 7.05898 8.71465 7.4375 7.79741 7.4375C6.88717 7.4375 6.07495 7.05898 5.51831 6.47461C4.96166 7.05898 4.14945 7.4375 3.23431 7.4375C3.09217 7.4375 2.94898 7.42754 2.81 7.41094C0.87329 7.16523 -0.0430755 5.00039 0.992671 3.44648L2.99975 0.435957C3.17829 0.165318 3.49723 0 3.83787 0H16.3291C16.6687 0 16.9873 0.165285 17.1659 0.435957L19.1719 3.44648C20.2117 5.00371 19.2909 7.16523 17.3479 7.41094ZM17.4949 8.46348C17.614 8.44687 17.7855 8.42031 17.9256 8.38711V14.875C17.9256 16.0471 16.9208 17 15.685 17H4.48204C3.24481 17 2.24145 16.0471 2.24145 14.875V8.38711C2.37693 8.42031 2.51662 8.44687 2.66051 8.46348H2.66471C2.84886 8.48672 3.04071 8.5 3.23431 8.5C3.66982 8.5 4.08993 8.43691 4.48204 8.3207V12.75H15.685V8.32402C16.0771 8.43691 16.4937 8.5 16.9243 8.5C17.1204 8.5 17.3094 8.48672 17.4949 8.46348Z"
      fill="#A9A9A9"
    />
  </svg>
);

export const DragSortIcon = () => (
  <svg
    width="17"
    height="17"
    viewBox="0 0 17 17"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M7.86997 2.00977C8.22323 1.61914 8.79692 1.61914 9.15019 2.00977L12.7676 6.00977C13.0276 6.29727 13.1039 6.72539 12.9626 7.10039C12.8213 7.47539 12.4934 7.71914 12.1261 7.71914H4.89127C4.52671 7.71914 4.19606 7.47539 4.05475 7.10039C3.91345 6.72539 3.99258 6.29727 4.24975 6.00977L7.86714 2.00977H7.86997ZM7.86997 15.4254L4.25258 11.4254C3.99258 11.1379 3.91627 10.7098 4.05758 10.3348C4.19888 9.95977 4.52671 9.71602 4.8941 9.71602H12.1261C12.4906 9.71602 12.8213 9.95977 12.9626 10.3348C13.1039 10.7098 13.0248 11.1379 12.7676 11.4254L9.15019 15.4254C8.79692 15.816 8.22323 15.816 7.86997 15.4254Z"
      fill="#A9A9A9"
    />
  </svg>
);

export const ManualIcon = () => (
  <svg
    width="22"
    height="22"
    viewBox="0 0 22 22"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M11 22C17.0751 22 22 17.0751 22 11C22 4.92487 17.0751 0 11 0C4.92487 0 0 4.92487 0 11C0 17.0751 4.92487 22 11 22Z"
      fill="#E61E29"
    />
    <path
      d="M7 15.4551V7H8.21875L11.1484 14.125H11.1836L14.1133 7H15.332V15.4551H14.3477V8.92188H14.3125L11.6113 15.4551H10.7207L8.01953 8.92188H7.98438V15.4551H7Z"
      fill="white"
    />
  </svg>
);

export const ScheduledIcon = () => (
  <svg
    width="22"
    height="22"
    viewBox="0 0 22 22"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <circle cx="11" cy="11" r="11" fill="white" />
    <path
      d="M11 0C17.0758 0 22 4.92422 22 11C22 17.0758 17.0758 22 11 22C4.92422 22 0 17.0758 0 11C0 4.92422 4.92422 0 11 0ZM9.96875 5.15625V11C9.96875 11.3438 10.1406 11.666 10.4285 11.8594L14.5535 14.6094C15.0262 14.9273 15.6664 14.7984 15.9844 14.3215C16.3023 13.8445 16.1734 13.2086 15.6965 12.8906L12.0312 10.45V5.15625C12.0312 4.58477 11.5715 4.125 11 4.125C10.4285 4.125 9.96875 4.58477 9.96875 5.15625Z"
      fill="#F6AE00"
    />
  </svg>
);

export const PendingLoadRedIcon = () => (
  <svg
    width="25"
    height="25"
    viewBox="0 0 25 25"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clipPath="url(#clip0_22258_70712)">
      <path
        d="M14.4453 2.63184C14.4453 3.87449 13.4375 4.88184 12.1953 4.88184C10.9531 4.88184 9.94531 3.87449 9.94531 2.63184C9.94531 1.38918 10.9531 0.381836 12.1953 0.381836C13.4375 0.381836 14.4453 1.38918 14.4453 2.63184ZM14.4453 22.1318C14.4453 23.374 13.4375 24.3818 12.1953 24.3818C10.9531 24.3818 9.94531 23.374 9.94531 22.1318C9.94531 20.8896 10.9531 19.8818 12.1953 19.8818C13.4375 19.8818 14.4453 20.8896 14.4453 22.1318ZM0.195312 12.3818C0.195312 11.1396 1.20266 10.1318 2.44531 10.1318C3.68797 10.1318 4.69531 11.1396 4.69531 12.3818C4.69531 13.624 3.68797 14.6318 2.44531 14.6318C1.20266 14.6318 0.195312 13.624 0.195312 12.3818ZM24.1953 12.3818C24.1953 13.624 23.1875 14.6318 21.9453 14.6318C20.7031 14.6318 19.6953 13.624 19.6953 12.3818C19.6953 11.1396 20.7031 10.1318 21.9453 10.1318C23.1875 10.1318 24.1953 11.1396 24.1953 12.3818ZM3.71 20.8662C2.83109 19.9896 2.83109 18.5646 3.71 17.6834C4.58891 16.8068 6.0125 16.8068 6.89375 17.6834C7.77031 18.5646 7.77031 19.9896 6.89375 20.8662C6.0125 21.7475 4.58891 21.7475 3.71 20.8662ZM6.89375 7.08027C6.0125 7.95684 4.58891 7.95684 3.71 7.08027C2.83156 6.19902 2.83156 4.77543 3.71 3.89652C4.58891 3.01762 6.0125 3.01762 6.89375 3.89652C7.77031 4.77543 7.77031 6.19902 6.89375 7.08027ZM17.4969 17.6834C18.3781 16.8068 19.8031 16.8068 20.6797 17.6834C21.5609 18.5646 21.5609 19.9896 20.6797 20.8662C19.8031 21.7475 18.3781 21.7475 17.4969 20.8662C16.6203 19.9896 16.6203 18.5646 17.4969 17.6834Z"
        fill="#E61E29"
      />
    </g>
    <defs>
      <clipPath id="clip0_22258_70712">
        <rect
          width="24"
          height="24"
          fill="white"
          transform="translate(0.195312 0.381836)"
        />
      </clipPath>
    </defs>
  </svg>
);

export const ThreeDotsHorizontal = () => {
  return (
    <svg
      width="24"
      height="29"
      viewBox="0 0 24 29"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M0.427734 14.3726C0.427734 13.5769 0.743805 12.8138 1.30641 12.2512C1.86902 11.6886 2.63208 11.3726 3.42773 11.3726C4.22338 11.3726 4.98645 11.6886 5.54905 12.2512C6.11166 12.8138 6.42773 13.5769 6.42773 14.3726C6.42773 15.1682 6.11166 15.9313 5.54905 16.4939C4.98645 17.0565 4.22338 17.3726 3.42773 17.3726C2.63208 17.3726 1.86902 17.0565 1.30641 16.4939C0.743805 15.9313 0.427734 15.1682 0.427734 14.3726ZM8.99916 14.3726C8.99916 13.5769 9.31523 12.8138 9.87784 12.2512C10.4405 11.6886 11.2035 11.3726 11.9992 11.3726C12.7948 11.3726 13.5579 11.6886 14.1205 12.2512C14.6831 12.8138 14.9992 13.5769 14.9992 14.3726C14.9992 15.1682 14.6831 15.9313 14.1205 16.4939C13.5579 17.0565 12.7948 17.3726 11.9992 17.3726C11.2035 17.3726 10.4405 17.0565 9.87784 16.4939C9.31523 15.9313 8.99916 15.1682 8.99916 14.3726ZM20.5706 11.3726C21.3662 11.3726 22.1293 11.6886 22.6919 12.2512C23.2545 12.8138 23.5706 13.5769 23.5706 14.3726C23.5706 15.1682 23.2545 15.9313 22.6919 16.4939C22.1293 17.0565 21.3662 17.3726 20.5706 17.3726C19.7749 17.3726 19.0119 17.0565 18.4493 16.4939C17.8867 15.9313 17.5706 15.1682 17.5706 14.3726C17.5706 13.5769 17.8867 12.8138 18.4493 12.2512C19.0119 11.6886 19.7749 11.3726 20.5706 11.3726Z"
        fill="#A9A9A9"
      />
    </svg>
  );
};

export const ClockSolidIcon = ({ color = 'white' }: { color?: string }) => (
  <svg
    width="25"
    height="24"
    viewBox="0 0 25 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clipPath="url(#clip0_22763_22611)">
      <path
        d="M12.6895 0.0078125C15.8721 0.0078125 18.9243 1.27209 21.1747 3.52253C23.4252 5.77297 24.6895 8.82521 24.6895 12.0078C24.6895 15.1904 23.4252 18.2427 21.1747 20.4931C18.9243 22.7435 15.8721 24.0078 12.6895 24.0078C9.50686 24.0078 6.45461 22.7435 4.20417 20.4931C1.95374 18.2427 0.689453 15.1904 0.689453 12.0078C0.689453 8.82521 1.95374 5.77297 4.20417 3.52253C6.45461 1.27209 9.50686 0.0078125 12.6895 0.0078125ZM11.5645 5.63281V12.0078C11.5645 12.3828 11.752 12.7344 12.066 12.9453L16.566 15.9453C17.0816 16.2922 17.7801 16.1516 18.127 15.6312C18.4738 15.1109 18.3332 14.4172 17.8129 14.0703L13.8145 11.4078V5.63281C13.8145 5.00938 13.3129 4.50781 12.6895 4.50781C12.066 4.50781 11.5645 5.00938 11.5645 5.63281Z"
        fill={color}
      />
    </g>
    <defs>
      <clipPath id="clip0_22763_22611">
        <rect
          width="24"
          height="24"
          fill={color}
          transform="translate(0.689453 0.0078125)"
        />
      </clipPath>
    </defs>
  </svg>
);

export const PercentSolidIcon = () => (
  <svg
    width="25"
    height="24"
    viewBox="0 0 25 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M21.1442 5.59285C21.7279 5.00922 21.7279 4.0614 21.1442 3.47776C20.5606 2.89413 19.6128 2.89413 19.0291 3.47776L4.08812 18.4188C3.50448 19.0024 3.50448 19.9503 4.08812 20.5339C4.67175 21.1175 5.61957 21.1175 6.20321 20.5339L21.1442 5.59285ZM9.6303 6.03175C9.6303 5.23923 9.31548 4.47916 8.75508 3.91877C8.19468 3.35837 7.43462 3.04354 6.6421 3.04354C5.84958 3.04354 5.08952 3.35837 4.52912 3.91877C3.96872 4.47916 3.65389 5.23923 3.65389 6.03175C3.65389 6.82427 3.96872 7.58433 4.52912 8.14473C5.08952 8.70513 5.84958 9.01995 6.6421 9.01995C7.43462 9.01995 8.19468 8.70513 8.75508 8.14473C9.31548 7.58433 9.6303 6.82427 9.6303 6.03175ZM21.5831 17.9846C21.5831 17.1921 21.2683 16.432 20.7079 15.8716C20.1475 15.3112 19.3874 14.9964 18.5949 14.9964C17.8024 14.9964 17.0423 15.3112 16.4819 15.8716C15.9215 16.432 15.6067 17.1921 15.6067 17.9846C15.6067 18.7771 15.9215 19.5372 16.4819 20.0976C17.0423 20.6579 17.8024 20.9728 18.5949 20.9728C19.3874 20.9728 20.1475 20.6579 20.7079 20.0976C21.2683 19.5372 21.5831 18.7771 21.5831 17.9846Z"
      fill="white"
    />
  </svg>
);

export const DollarHandIcon = () => (
  <svg
    width="27"
    height="24"
    viewBox="0 0 27 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M14.9974 2.01416V2.48584C15.2863 2.53975 15.5661 2.60713 15.8189 2.67451C16.3967 2.82725 16.7398 3.42021 16.5863 3.99521C16.4328 4.57021 15.837 4.91162 15.2592 4.75889C14.7672 4.62861 14.3068 4.53877 13.896 4.53428C13.5665 4.52979 13.2325 4.61064 13.0203 4.73193C12.9255 4.79033 12.8804 4.83975 12.8623 4.8667C12.8488 4.88916 12.8307 4.92061 12.8307 4.99248C12.8307 5.00596 12.8307 5.01494 12.8307 5.01943C12.8398 5.02842 12.8714 5.07334 12.9797 5.13623C13.2415 5.29346 13.6297 5.41475 14.2165 5.58994L14.2571 5.60342C14.7582 5.75166 15.4262 5.95381 15.9679 6.29072C16.5863 6.67705 17.146 7.31943 17.1595 8.30771C17.1731 9.31846 16.645 10.0552 15.9543 10.4864C15.6519 10.6706 15.3269 10.8009 14.9929 10.8817V11.3579C14.9929 11.9554 14.5099 12.436 13.9095 12.436C13.3092 12.436 12.8262 11.9554 12.8262 11.3579V10.8458C12.3974 10.7425 12.0047 10.6077 11.6707 10.4954C11.5759 10.464 11.4856 10.4325 11.3998 10.4056C10.8311 10.2169 10.5241 9.60596 10.7137 9.03994C10.9033 8.47393 11.5172 8.16846 12.0859 8.35713C12.2033 8.39756 12.3116 8.4335 12.4155 8.46943C13.0293 8.67607 13.4717 8.82432 13.9457 8.84229C14.3068 8.85576 14.6273 8.77041 14.8123 8.65811C14.8981 8.6042 14.9387 8.55928 14.9568 8.52783C14.9748 8.50088 14.9974 8.44697 14.9929 8.34365V8.33467C14.9929 8.28975 14.9929 8.24033 14.8123 8.12803C14.555 7.96631 14.1668 7.84053 13.5891 7.66533L13.5033 7.63838C13.0158 7.49463 12.3748 7.30147 11.8602 6.9915C11.2509 6.62764 10.6641 6.00322 10.6595 5.01045C10.655 3.98174 11.2418 3.27646 11.9099 2.88115C12.1988 2.71045 12.5102 2.59365 12.8217 2.51279L12.8307 2.01416C12.8307 1.4167 13.3137 0.936035 13.9141 0.936035C14.5144 0.936035 14.9974 1.4167 14.9974 2.01416ZM26.562 16.0433C27.1533 16.8429 26.9818 17.9659 26.1783 18.5544L20.4637 22.7456C19.4075 23.5183 18.1346 23.936 16.821 23.936H9.58073H2.35851C1.55955 23.936 0.914062 23.2937 0.914062 22.4985V19.6235C0.914062 18.8284 1.55955 18.186 2.35851 18.186H4.01962L6.04635 16.5688C7.07101 15.7513 8.34392 15.311 9.65747 15.311H13.1918H13.9141H16.803C17.6019 15.311 18.2474 15.9534 18.2474 16.7485C18.2474 17.5437 17.6019 18.186 16.803 18.186H13.9141H13.1918C12.7946 18.186 12.4696 18.5095 12.4696 18.9048C12.4696 19.3001 12.7946 19.6235 13.1918 19.6235H18.6356L24.0387 15.6614C24.8422 15.0729 25.9707 15.2437 26.562 16.0433ZM9.65295 18.186H9.61233C9.62587 18.186 9.63941 18.186 9.65295 18.186Z"
      fill="white"
    />
  </svg>
);

export const DollarSignSolidIcon = () => {
  return (
    <svg
      width="17"
      height="26"
      viewBox="0 0 17 26"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_23408_18579)">
        <path
          d="M8.33874 0.65918C9.22374 0.65918 9.93874 1.35432 9.93874 2.21474V3.95015C10.0187 3.95987 10.0937 3.9696 10.1737 3.98418C10.1937 3.98904 10.2087 3.98904 10.2287 3.9939L12.6287 4.42168C13.4987 4.57724 14.0737 5.38904 13.9137 6.23001C13.7537 7.07099 12.9187 7.63487 12.0537 7.47932L9.67874 7.0564C8.11374 6.83279 6.73374 6.98349 5.76374 7.35779C4.79374 7.7321 4.40374 8.24737 4.31374 8.72376C4.21374 9.2439 4.28874 9.53557 4.37374 9.71543C4.46374 9.90501 4.64874 10.1189 5.01374 10.3571C5.82874 10.8772 7.07874 11.2175 8.69874 11.6356L8.84374 11.6745C10.2737 12.0439 12.0237 12.4911 13.3237 13.3175C14.0337 13.7696 14.7037 14.3821 15.1187 15.2377C15.5437 16.1078 15.6337 17.08 15.4387 18.1154C15.0937 19.9627 13.7837 21.1974 12.1587 21.8439C11.4737 22.1161 10.7287 22.2911 9.93874 22.3786V24.0022C9.93874 24.8627 9.22374 25.5578 8.33874 25.5578C7.45374 25.5578 6.73874 24.8627 6.73874 24.0022V22.3057C6.71874 22.3008 6.69374 22.3008 6.67374 22.296H6.66374C5.44374 22.1113 3.43874 21.6008 2.08874 21.0175C1.28374 20.6675 0.918744 19.7488 1.27874 18.9661C1.63874 18.1835 2.58374 17.8286 3.38874 18.1786C4.43374 18.6307 6.15374 19.0779 7.14874 19.2286C8.74374 19.4571 10.0587 19.3258 10.9487 18.971C11.7937 18.6356 12.1787 18.1495 12.2887 17.5661C12.3837 17.0508 12.3087 16.7543 12.2237 16.5745C12.1287 16.38 11.9437 16.1661 11.5737 15.9279C10.7537 15.4078 9.49874 15.0675 7.87374 14.6495L7.73374 14.6154C6.30874 14.2363 4.55874 13.7842 3.25874 12.9578C2.54874 12.5057 1.88374 11.8883 1.46874 11.0328C1.04874 10.1627 0.963744 9.19043 1.16374 8.15501C1.52374 6.29807 2.95374 5.09251 4.57874 4.46543C5.24374 4.20779 5.97374 4.03279 6.73874 3.93071V2.21474C6.73874 1.35432 7.45374 0.65918 8.33874 0.65918Z"
          fill="white"
        />
      </g>
      <defs>
        <clipPath id="clip0_23408_18579">
          <rect
            width="16"
            height="24.8889"
            fill="white"
            transform="translate(0.337891 0.65918)"
          />
        </clipPath>
      </defs>
    </svg>
  );
};

export const WalletSolidIcon = () => (
  <svg
    width="25"
    height="25"
    viewBox="0 0 25 25"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clipPath="url(#clip0_22665_21233)">
      <path
        d="M3.69423 2.3418C2.05253 2.3418 0.717773 3.68711 0.717773 5.3418V20.3418C0.717773 21.9965 2.05253 23.3418 3.69423 23.3418H21.553C23.1947 23.3418 24.5294 21.9965 24.5294 20.3418V9.8418C24.5294 8.18711 23.1947 6.8418 21.553 6.8418H4.43835C4.02908 6.8418 3.69423 6.5043 3.69423 6.0918C3.69423 5.6793 4.02908 5.3418 4.43835 5.3418H21.553C22.3762 5.3418 23.0412 4.67148 23.0412 3.8418C23.0412 3.01211 22.3762 2.3418 21.553 2.3418H3.69423ZM20.0648 13.5918C20.4595 13.5918 20.838 13.7498 21.1171 14.0311C21.3962 14.3124 21.553 14.694 21.553 15.0918C21.553 15.4896 21.3962 15.8712 21.1171 16.1525C20.838 16.4338 20.4595 16.5918 20.0648 16.5918C19.67 16.5918 19.2915 16.4338 19.0124 16.1525C18.7333 15.8712 18.5765 15.4896 18.5765 15.0918C18.5765 14.694 18.7333 14.3124 19.0124 14.0311C19.2915 13.7498 19.67 13.5918 20.0648 13.5918Z"
        fill="white"
      />
    </g>
    <defs>
      <clipPath id="clip0_22665_21233">
        <rect
          width="23.8117"
          height="24"
          fill="white"
          transform="translate(0.717773 0.841797)"
        />
      </clipPath>
    </defs>
  </svg>
);

/** Font Awesome `basket-shopping` (solid). Orders: white on the dashboard
 *  tiles, grey on the per-order SaaS card in Finances. */
export const BasketShoppingSolidIcon = ({
  color = 'white',
}: { color?: string } = {}) => (
  <svg
    width="25"
    height="22"
    viewBox="0 0 25 22"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clipPath="url(#clip0_22665_21276)">
      <path
        d="M7.79792 8.23104H17.4515L14.0648 1.55299C13.8117 1.04966 14.0026 0.429533 14.4882 0.167812C14.9779 -0.0939089 15.5797 0.101943 15.8329 0.605397L19.6968 8.23104H23.2494C23.984 8.23104 24.5775 8.8816 24.5775 9.60064C24.5775 10.3967 23.984 10.9702 23.2494 10.9702L21.0954 19.8897C20.7634 21.1095 19.7383 21.9655 18.5181 21.9655H6.69394C5.51111 21.9655 4.44864 21.1095 4.15313 19.8897L1.99997 10.9702C1.26661 10.9702 0.671875 10.3967 0.671875 9.60064C0.671875 8.8816 1.26661 8.23104 1.99997 8.23104H5.55261L9.41653 0.605397C9.66969 0.101943 10.2715 -0.0939089 10.7612 0.167812C11.2468 0.429533 11.4377 1.04966 11.1845 1.55299L7.79792 8.23104ZM8.60307 13.0246C8.60307 12.6822 8.3416 12.3398 7.93903 12.3398C7.61115 12.3398 7.27498 12.6822 7.27498 13.0246V17.1334C7.27498 17.5486 7.61115 17.8182 7.93903 17.8182C8.3416 17.8182 8.60307 17.5486 8.60307 17.1334V13.0246ZM11.9233 13.0246V17.1334C11.9233 17.5486 12.2595 17.8182 12.5873 17.8182C12.9899 17.8182 13.2887 17.5486 13.2887 17.1334V13.0246C13.2887 12.6822 12.9899 12.3398 12.5873 12.3398C12.2595 12.3398 11.9233 12.6822 11.9233 13.0246ZM17.9371 13.0246C17.9371 12.6822 17.6382 12.3398 17.273 12.3398C16.9078 12.3398 16.609 12.6822 16.609 13.0246V17.1334C16.609 17.5486 16.9078 17.8182 17.273 17.8182C17.6382 17.8182 17.9371 17.5486 17.9371 17.1334V13.0246Z"
        fill={color}
      />
    </g>
    <defs>
      <clipPath id="clip0_22665_21276">
        <rect
          width="23.9056"
          height="21.9135"
          fill="white"
          transform="translate(0.671875 0.0517578)"
        />
      </clipPath>
    </defs>
  </svg>
);

export const GrubconIcon = () => (
  <svg
    width="33"
    height="32"
    viewBox="0 0 33 32"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clipPath="url(#clip0_22665_21293)">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M20.6372 12.5498H24.6038C23.3124 9.48931 20.3297 7.34375 16.855 7.34375C12.1811 7.34375 8.42969 11.2246 8.42969 15.989C8.42969 20.7849 12.2119 24.6342 16.855 24.6342C20.3297 24.6342 23.2816 22.4887 24.6038 19.4281H20.6372C19.7147 20.5009 18.3617 21.1635 16.855 21.1635C14.0568 21.1635 11.7814 18.8287 11.7814 15.9574C11.7814 13.0862 14.0568 10.7514 16.855 10.7514C18.3617 10.7829 19.7147 11.477 20.6372 12.5498Z"
        fill="white"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M21.6179 17.7244H25.0926H28.5057C28.4135 18.3238 28.2905 18.8917 28.1368 19.4597C26.6916 24.4765 22.1714 28.1049 16.821 28.1049C10.3022 28.1049 5.01328 22.678 5.01328 15.989C5.01328 9.29999 10.3022 3.87305 16.821 3.87305C22.1714 3.87305 26.6916 7.53308 28.1368 12.5183H31.6114C30.0739 5.57687 24.0471 0.402344 16.821 0.402344C8.42645 0.402344 1.63086 7.37531 1.63086 15.989C1.63086 24.6027 8.42645 31.5756 16.821 31.5756C24.0471 31.5756 30.1047 26.4011 31.6114 19.4597C31.7344 18.8917 31.8267 18.3238 31.8882 17.7244C31.9497 17.1564 31.9804 16.5885 31.9804 15.989C31.9804 15.3895 31.9497 14.8215 31.8882 14.2536H28.5057H25.0926H21.6179H16.8518V17.7244H21.6179Z"
        fill="white"
      />
    </g>
    <defs>
      <clipPath id="clip0_22665_21293">
        <rect
          width="31.7489"
          height="32"
          fill="white"
          transform="translate(0.744141 0.0078125)"
        />
      </clipPath>
    </defs>
  </svg>
);

export const InputArrowIcon = ({ color }: { color?: string }) => (
  <svg
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M7.29365 12.7066C7.68428 13.0973 8.31865 13.0973 8.70928 12.7066L14.7093 6.70664C15.0999 6.31602 15.0999 5.68164 14.7093 5.29102C14.3187 4.90039 13.6843 4.90039 13.2937 5.29102L7.9999 10.5848L2.70615 5.29414C2.31553 4.90352 1.68115 4.90352 1.29053 5.29414C0.899902 5.68477 0.899902 6.31914 1.29053 6.70977L7.29053 12.7098L7.29365 12.7066Z"
      fill={color || '#4C4C4C'}
    />
  </svg>
);

export const XModalIcon = ({ color }: { color?: string }) => (
  <svg
    width="18"
    height="19"
    viewBox="0 0 18 19"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className="redSvgHover"
  >
    <path
      d="M17.4716 3.6638C18.1747 2.94469 18.1747 1.77687 17.4716 1.05776C16.7684 0.338656 15.6266 0.338656 14.9234 1.05776L9.00031 7.12126L3.07156 1.06351C2.36844 0.344409 1.22656 0.344409 0.523437 1.06351C-0.179687 1.78262 -0.179687 2.95045 0.523437 3.66955L6.45219 9.72729L0.529062 15.7908C-0.174063 16.5099 -0.174063 17.6777 0.529062 18.3968C1.23219 19.1159 2.37406 19.1159 3.07719 18.3968L9.00031 12.3333L14.9291 18.3911C15.6322 19.1102 16.7741 19.1102 17.4772 18.3911C18.1803 17.672 18.1803 16.5041 17.4772 15.785L11.5484 9.72729L17.4716 3.6638Z"
      fill={color || '#A9A9A9'}
    />
  </svg>
);

export const LockIcon = () => (
  <svg
    width="17"
    height="17"
    viewBox="0 0 17 17"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M7.3709 4.22539V5.82539H10.5709V4.22539C10.5709 3.34289 9.8534 2.62539 8.9709 2.62539C8.0884 2.62539 7.3709 3.34289 7.3709 4.22539ZM5.7709 5.82539V4.22539C5.7709 2.45789 7.2034 1.02539 8.9709 1.02539C10.7384 1.02539 12.1709 2.45789 12.1709 4.22539V5.82539C13.0534 5.82539 13.7709 6.54289 13.7709 7.42539V13.0254C13.7709 13.9079 13.0534 14.6254 12.1709 14.6254H5.7709C4.8884 14.6254 4.1709 13.9079 4.1709 13.0254V7.42539C4.1709 6.54289 4.8884 5.82539 5.7709 5.82539Z"
      fill="#4C4C4C"
    />
  </svg>
);

/** The three stars of the AI mark, in its own 21 x 18 box. */
const AI_STARS_PATHS = [
  'M0.716227 4.90082C4.06397 4.24715 4.71505 3.59608 5.36871 0.248331C5.3863 0.158271 5.51505 0.158271 5.53264 0.248331C6.1863 3.59608 6.83737 4.24715 10.1851 4.90082C10.2752 4.91841 10.2752 5.04715 10.1851 5.06474C6.83737 5.7184 6.18626 6.36948 5.53264 9.71723C5.51505 9.80729 5.3863 9.80729 5.36871 9.71723C4.71505 6.36948 4.06397 5.71836 0.716227 5.06474C0.626167 5.04715 0.626167 4.91841 0.716227 4.90082Z',
  'M1.35396 14.6867C3.07091 14.3522 3.40214 14.0211 3.73663 12.3041C3.74527 12.2597 3.80882 12.2597 3.81746 12.3041C4.15195 14.021 4.48314 14.3522 6.20013 14.6867C6.24451 14.6954 6.24451 14.7589 6.20013 14.7676C4.48318 15.1021 4.15195 15.4332 3.81746 17.1502C3.80882 17.1946 3.74527 17.1946 3.73663 17.1502C3.40214 15.4333 3.07095 15.1021 1.35396 14.7676C1.30959 14.7589 1.30959 14.6954 1.35396 14.6867Z',
  'M7.83893 10.4637C12.2217 9.58616 13.1488 8.65906 14.0264 4.27627C14.0602 4.10758 14.301 4.10758 14.3348 4.27627C15.2123 8.65906 16.1394 9.58616 20.5222 10.4637C20.6909 10.4975 20.6909 10.7384 20.5222 10.7721C16.1394 11.6497 15.2123 12.5768 14.3348 16.9596C14.301 17.1282 14.0601 17.1282 14.0264 16.9596C13.1488 12.5768 12.2217 11.6497 7.83893 10.7721C7.67023 10.7384 7.67023 10.4975 7.83893 10.4637Z',
];

/**
 * The AI mark: three stars on the AI gradient, or in one flat `color` where
 * the surface is already that gradient (the vGrubs AI chat's avatar disc).
 */
export const AIStarsIcon = ({ color }: { color?: string } = {}) => {
  // Unique gradient ids per instance. The AI icon renders in several places on
  // the menu screen at once; with hardcoded ids (`paint0_linear_420_5`, …) every
  // instance shared one id, so `url(#…)` resolved to whichever came first in the
  // DOM. When that first instance sits inside a `display:none` container (e.g. a
  // collapsed dropdown or a toolbar action collapsed on mobile), the browser
  // doesn't paint its gradient and every icon referencing it renders empty -
  // the icon vanishes.
  const raw = useId();
  const uid = raw.replace(/:/g, '');
  const g0 = `aiStars_${uid}_0`;
  const g1 = `aiStars_${uid}_1`;
  const g2 = `aiStars_${uid}_2`;
  const fills = [g0, g1, g2].map((id) => color || `url(#${id})`);
  return (
    <svg
      width="21"
      height="18"
      viewBox="0 0 21 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      {AI_STARS_PATHS.map((d, i) => (
        <path key={i} d={d} fill={fills[i]} />
      ))}
      {!color && (
        <defs>
          <linearGradient
            id={g0}
            x1="0.658803"
            y1="4.98278"
            x2="10.299"
            y2="4.98278"
            gradientUnits="userSpaceOnUse"
          >
            <stop stopColor="#306FDE" />
            <stop offset="0.322115" stopColor="#3A6BDB" />
            <stop offset="0.682692" stopColor="#7F50C7" />
            <stop offset="1" stopColor="#BA39B5" />
          </linearGradient>
          <linearGradient
            id={g1}
            x1="1.32586"
            y1="14.7271"
            x2="6.25711"
            y2="14.7271"
            gradientUnits="userSpaceOnUse"
          >
            <stop stopColor="#306FDE" />
            <stop offset="0.322115" stopColor="#3A6BDB" />
            <stop offset="0.682692" stopColor="#7F50C7" />
            <stop offset="1" stopColor="#BA39B5" />
          </linearGradient>
          <linearGradient
            id={g2}
            x1="7.72604"
            y1="10.6179"
            x2="20.7111"
            y2="10.6179"
            gradientUnits="userSpaceOnUse"
          >
            <stop stopColor="#306FDE" />
            <stop offset="0.322115" stopColor="#3A6BDB" />
            <stop offset="0.682692" stopColor="#7F50C7" />
            <stop offset="1" stopColor="#BA39B5" />
          </linearGradient>
        </defs>
      )}
    </svg>
  );
};

export const VPayLogoBlueCircle = () => (
  <svg
    width="116"
    height="116"
    viewBox="0 0 116 116"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <circle cx="58" cy="58.0215" r="57.5" fill="#0068EE" />
    <path
      d="M92.0191 36.236C89.7704 32.9051 85.9534 31.0643 81.9294 31.0643C81.2784 31.0643 80.7162 31.0643 80.3316 31.0643C75.9525 31.2396 72.1059 34.1031 70.1531 37.9892L67.5493 42.4304C62.4009 51.1084 58.7615 57.3905 57.4596 59.056C55.0333 62.1824 51.3939 63.8479 47.5474 63.8479C46.1567 63.8479 44.6477 63.5849 43.257 63.1174C38.0198 61.2766 34.6467 56.66 34.6467 51.2253C34.6467 47.4269 36.5996 44.3004 38.3749 41.6123C40.1502 38.8365 41.748 36.4406 40.7124 34.0446C40.1502 32.759 39.0258 31.9116 38.1086 31.4734C37.5464 31.2104 36.8955 31.0059 35.9486 31.0059H34.2621C30.1493 31.0059 25.9477 33.022 23.7877 36.4406C21.4502 40.0345 21.4502 44.5634 23.6102 48.245L47.9024 89.765C50.0624 93.3589 53.7906 95.4919 57.9922 95.4919C62.1938 95.4919 65.9219 93.3589 68.0819 89.765L92.3742 48.245C94.6525 44.4465 94.5637 39.9468 92.0191 36.236ZM74.3843 63.2927L67.1942 59.1729L68.94 56.1925C69.0879 55.9588 69.2358 55.7542 69.443 55.5497C69.6501 55.3452 69.8868 55.1699 70.1531 55.0822C70.449 54.9653 70.7745 54.9653 71.1887 55.0238C71.6029 55.0822 72.0764 55.2867 72.609 55.5789C73.1415 55.9003 73.5558 56.1925 73.8221 56.5139C74.0884 56.8353 74.2363 57.1275 74.2955 57.4489C74.3547 57.7411 74.3547 58.0333 74.2659 58.2963C74.1772 58.5593 74.0884 58.793 73.97 59.0268C73.9109 59.1436 73.8221 59.2605 73.7037 59.4358C73.615 59.5819 73.4966 59.728 73.3783 59.8741C73.2599 60.0202 73.1711 60.1663 73.0824 60.2832C72.9936 60.4 72.9048 60.5169 72.8457 60.5754L75.1832 61.9194L74.3843 63.2927ZM80.0949 53.5336L78.3196 53.1245L76.8993 55.5497L78.142 56.8646L77.284 58.3255L71.3958 51.985L72.461 50.2027L80.953 52.1019L80.0949 53.5336ZM82.0773 50.1442L79.9174 48.8878L73.6446 48.1573L74.5026 46.6964L78.8522 47.31L76.13 43.8914L76.9585 42.4597L80.7162 47.4561L82.8762 48.7125L82.0773 50.1442Z"
      fill="white"
    />
    <path
      d="M76.837 52.7456L73.168 51.8105L75.8014 54.4695L76.837 52.7456Z"
      fill="white"
    />
    <path
      d="M71.7745 56.9815C71.4786 56.8062 71.2419 56.7186 71.0348 56.6894C70.8277 56.6601 70.6501 56.6601 70.5022 56.7478C70.3543 56.8062 70.2359 56.9231 70.1471 57.0692L69.2891 58.5009L71.6857 59.8742L72.5142 58.4717C72.603 58.2964 72.6622 58.1503 72.6326 57.975C72.6326 57.7997 72.5438 57.6536 72.3959 57.4783C72.3071 57.3322 72.0704 57.1569 71.7745 56.9815Z"
      fill="white"
    />
    <path
      d="M47.4603 41.9619C42.3118 41.9619 38.0215 46.1987 38.0215 51.2827C38.0215 56.3668 42.2231 60.6036 47.4603 60.6036C52.6975 60.6036 56.899 56.3668 56.899 51.2827C56.899 46.1987 52.6679 41.9619 47.4603 41.9619ZM48.8213 55.8993H46.188L43.4362 46.9876H45.6258L47.5194 53.6495L49.4131 46.9876H51.5731L48.8213 55.8993Z"
      fill="white"
    />
  </svg>
);

export const CheckRedIcon = ({ $color }: { $color?: string }) => (
  <svg
    width="28"
    height="28"
    viewBox="0 0 28 28"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clipPath="url(#clip0_444_52)">
      <path
        d="M0 14C0 6.26719 6.26719 0 14 0C21.7328 0 28 6.26719 28 14C28 21.7328 21.7328 28 14 28C6.26719 28 0 21.7328 0 14ZM20.3328 11.5828C20.9289 10.9867 20.9289 10.0133 20.3328 9.41719C19.7367 8.82109 18.7633 8.82109 18.1672 9.41719L12.25 15.3344L9.83281 12.9172C9.23672 12.3211 8.26328 12.3211 7.66719 12.9172C7.07109 13.5133 7.07109 14.4867 7.66719 15.0828L11.1672 18.5828C11.7633 19.1789 12.7367 19.1789 13.3328 18.5828L20.3328 11.5828Z"
        fill={$color || '#E61E29'}
      />
    </g>
    <defs>
      <clipPath id="clip0_444_52">
        <rect width="28" height="28" fill="white" />
      </clipPath>
    </defs>
  </svg>
);

export const KitchenHubLogo = () => (
  <svg
    width="133"
    height="24"
    viewBox="0 0 133 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clipPath="url(#clip0_585_2)">
      <path
        d="M20.8146 0H3.20225C1.43369 0 0 1.43269 0 3.2V20.8C0 22.5673 1.43369 24 3.20225 24H20.8146C22.5832 24 24.0169 22.5673 24.0169 20.8V3.2C24.0169 1.43269 22.5832 0 20.8146 0Z"
        fill="black"
      />
      <path
        d="M12.0274 14.7146C11.2964 13.5139 10.5657 12.3133 9.8351 11.1126C9.79266 11.0434 9.80143 11.0037 9.8552 10.9481C10.5734 10.2067 11.2904 9.4644 12.0061 8.72112C12.0218 8.70658 12.0386 8.69341 12.0566 8.68175V7.89331C11.1981 7.89331 10.3399 7.89384 9.48175 7.89492C9.44001 7.89653 9.39987 7.91156 9.36722 7.93782C9.30341 7.99133 9.24662 8.05463 9.18728 8.11456L6.83624 10.4823C6.80722 10.5115 6.77642 10.5392 6.72458 10.5883V7.90038H4.18164V16.2031H6.72873V16.0631C6.72873 15.4746 6.72634 14.8863 6.73208 14.298C6.73521 14.2288 6.76165 14.1626 6.80706 14.1105C7.12865 13.7626 7.45678 13.4206 7.78317 13.0771C7.80965 13.0493 7.8382 13.0238 7.87362 12.9895C8.4991 14.0376 9.1198 15.0754 9.73635 16.1158C9.77878 16.1873 9.82042 16.2134 9.90273 16.2133C10.8758 16.2102 11.8471 16.2114 12.8194 16.2111C12.8536 16.2111 12.8877 16.2079 12.9344 16.2054C12.9111 16.1632 12.8953 16.1318 12.877 16.1022C12.5939 15.6395 12.3093 15.1778 12.0274 14.7146Z"
        fill="#00F899"
      />
      <path
        d="M17.3106 7.89893V10.7871H14.5196V7.89797C14.4877 7.89588 14.4644 7.89331 14.4415 7.89331H11.9736V12.8547C11.9736 12.9124 11.9819 12.9788 12.0104 13.026C12.6374 14.0653 13.2667 15.1034 13.8984 16.1406C13.9157 16.1689 13.9463 16.2086 13.9714 16.2095C14.1535 16.2154 14.3358 16.2127 14.5274 16.2127V12.8611H17.3148V16.204H19.8725V7.89893H17.3106Z"
        fill="white"
      />
      <path
        d="M109.667 18.6551H106.577V13.9949H101.45V18.6491H98.3418V6.14673H101.452V11.1075H106.54V6.12964H109.667V18.6551Z"
        fill="black"
      />
      <path
        d="M123.055 5.53186H126.002V10.1297C127.189 9.53195 128.369 9.32272 129.597 9.6498C130.827 9.97687 131.744 10.7216 132.352 11.836C133.356 13.6721 133.069 16.0334 131.669 17.5245C130.246 19.0376 128.193 19.3332 126.213 18.3784C125.957 18.5023 125.781 18.6611 125.598 18.6671C124.766 18.6944 123.932 18.679 123.056 18.679L123.055 5.53186ZM126.018 14.1871C126.018 14.4578 126.054 14.7345 126.01 14.9974C125.911 15.5723 126.21 15.895 126.656 16.1512C127.702 16.749 129.027 16.4467 129.633 15.468C130.296 14.3945 129.988 12.8855 128.959 12.2639C128.216 11.8147 127.46 11.8898 126.691 12.2408C125.967 12.5704 125.975 13.1759 126.016 13.8147C126.024 13.9368 126.018 14.0624 126.018 14.1879V14.1871Z"
        fill="black"
      />
      <path
        d="M121.013 9.71643V18.65H118.083L117.997 18.1897C117.912 18.2341 117.84 18.2649 117.776 18.305C115.049 20.0018 111.959 18.5023 111.766 15.3161C111.655 13.4714 111.747 11.6157 111.747 9.72327H114.73C114.73 10.8334 114.725 11.9539 114.73 13.0744C114.73 13.6772 114.724 14.2852 114.788 14.8831C114.873 15.6516 115.325 16.1017 116.047 16.2306C116.709 16.3485 117.686 15.9497 117.958 15.4159C118.037 15.2622 118.026 15.0547 118.027 14.872C118.032 13.164 118.027 11.456 118.027 9.71728L121.013 9.71643Z"
        fill="black"
      />
      <path
        d="M30.972 18.6508H27.8596V6.14757H30.9541V11.5644L31.0942 11.625C31.2557 11.4543 31.4224 11.2835 31.578 11.1126C32.9273 9.57548 34.2622 8.03147 35.6355 6.51905C35.8736 6.28256 36.1887 6.13923 36.5234 6.11511C37.537 6.06473 38.5557 6.09633 39.7127 6.09633L34.9117 11.6114L40.1136 18.6782C38.824 18.6782 37.6455 18.6952 36.4696 18.6602C36.2987 18.6551 36.0961 18.4296 35.9662 18.2614C34.9109 16.895 33.8691 15.5158 32.7675 14.0675C32.1813 14.7439 31.6181 15.3715 31.0874 16.0248C30.9857 16.1504 30.9797 16.3749 30.9763 16.5552C30.9643 17.2401 30.972 17.9249 30.972 18.6508Z"
        fill="black"
      />
      <path
        d="M71.7503 18.6449C71.7503 17.0547 71.7503 15.5346 71.7503 14.0136C71.7503 13.2673 71.5923 12.5798 70.8309 12.2477C70.0694 11.9154 69.3848 12.1511 68.8251 12.6934C68.6195 12.9096 68.4982 13.1923 68.4833 13.4902C68.4534 15.1939 68.4679 16.8984 68.4679 18.6406H65.4956V5.54126H68.4483V10.222C68.6892 10.0802 68.8534 9.98114 69.0191 9.8855C71.4248 8.49948 74.3176 9.8855 74.7235 12.6285C74.7658 12.9802 74.783 13.3343 74.7748 13.6883C74.7799 15.3297 74.7748 16.9711 74.7748 18.6415L71.7503 18.6449Z"
        fill="black"
      />
      <path
        d="M89.988 18.6466H87.0286V9.71639H89.9342C89.9624 9.85132 89.9949 9.99992 90.0368 10.1955C90.8332 9.59584 91.8232 9.31147 92.8167 9.397C94.6515 9.53449 95.9334 10.7361 96.235 12.6378C96.2741 12.9268 96.291 13.2183 96.2855 13.5098C96.2855 15.2135 96.2855 16.9163 96.2855 18.65H93.2679V15.7558C93.2679 15.1306 93.279 14.5047 93.2637 13.877C93.2415 12.9923 92.8637 12.4005 92.2168 12.1929C91.5195 11.9693 90.5974 12.2502 90.141 12.8659C90.0308 13.0136 89.9958 13.2459 89.9941 13.4398C89.9829 14.9616 89.988 16.4825 89.988 18.0043V18.6466Z"
        fill="black"
      />
      <path
        d="M85.4101 15.8258C85.1264 17.8557 82.8267 19.1563 80.2065 18.8037C77.4881 18.4381 75.8481 16.1862 76.2429 13.3604C76.6061 10.7608 78.8981 9.18347 81.7644 9.55923C84.3717 9.90083 85.8801 12.1127 85.4784 15.0709H79.1861C79.5279 16.3894 81.2089 16.9163 82.2626 16.105C82.4671 15.9493 82.7129 15.8567 82.9694 15.8386C83.7829 15.8053 84.5948 15.8258 85.4101 15.8258ZM82.6908 13.3031C82.4738 12.2988 81.884 11.8103 80.9492 11.8198C79.9946 11.8292 79.3203 12.3817 79.1597 13.3031H82.6908Z"
        fill="black"
      />
      <path
        d="M53.1997 12.2622H50.2368C50.2368 13.287 50.1795 14.2819 50.2573 15.2656C50.306 15.8797 50.8128 16.1914 51.4178 16.188C51.9938 16.188 52.569 16.0966 53.198 16.0411C53.3065 16.8584 53.4142 17.6748 53.5269 18.5228C52.2904 18.9618 51.0624 19.1445 49.8181 18.8516C48.2619 18.4852 47.2585 17.0906 47.2082 15.3016C47.18 14.3255 47.203 13.3485 47.203 12.3006H45.4819V9.7045H47.1911V6.65918H50.2087V9.66949H53.1997V12.2622Z"
        fill="black"
      />
      <path
        d="M63.836 13.3954C62.9703 13.3954 62.1396 13.4056 61.3098 13.3834C61.1608 13.3592 61.0331 13.2634 60.9681 13.1272C60.6655 12.1878 59.3563 11.7224 58.2649 12.2912C57.3122 12.7865 56.9464 14.1084 57.4515 15.1879C57.8934 16.142 59.0116 16.5757 59.9819 16.1691C60.3057 16.0317 60.6758 15.7703 60.81 15.4706C61.0125 15.0154 61.274 14.9317 61.7132 14.953C62.4148 14.9872 63.1199 14.9616 63.8215 14.9616C63.8112 17.0966 61.844 18.8131 59.4409 18.8447C56.525 18.8822 54.4151 17.0035 54.3603 14.3186C54.304 11.6139 56.2524 9.60537 59.0298 9.50119C61.644 9.40725 63.7019 11.0315 63.836 13.3954Z"
        fill="black"
      />
      <path
        d="M41.2773 9.70789H44.2437V10.8446C44.2437 13.24 44.2283 15.6363 44.2548 18.0317C44.2608 18.5654 44.0754 18.7226 43.5711 18.7021C42.8234 18.6722 42.073 18.6944 41.2773 18.6944V9.70789Z"
        fill="black"
      />
      <path
        d="M44.4591 6.59248C44.4641 7.55833 43.6899 8.30046 42.6892 8.29536C41.7073 8.29106 40.9543 7.57713 40.9406 6.63688C40.9261 5.65394 41.667 4.91609 42.6763 4.90671C43.6856 4.89731 44.453 5.61722 44.4591 6.59248Z"
        fill="black"
      />
    </g>
    <defs>
      <clipPath id="clip0_585_2">
        <rect width="133" height="24" fill="white" />
      </clipPath>
    </defs>
  </svg>
);

export const FoodHubLogo = () => (
  <svg
    width="129"
    height="47"
    viewBox="0 0 129 47"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clipPath="url(#clip0_583_1722)">
      <path d="M0 0H129V47H0V0Z" fill="#FEFDFD" />
      <path
        d="M58.05 3.85242H64.5L67.854 4.87974L70.176 6.42072L71.982 8.7322L73.014 11.8142V17.7213L71.982 21.0601L70.176 23.3715L67.596 24.9125L64.758 25.683H56.76L55.728 25.4262V4.10925L58.05 3.85242Z"
        fill="#C9403B"
      />
      <path
        d="M112.746 3.85242H118.938L121.518 4.62291L123.066 5.65023L124.098 6.93438L124.356 7.70488V11.0437L123.324 13.0983L122.55 14.1256L123.84 14.6393L125.388 16.4371L125.904 17.9781V20.2896L125.13 22.6011L123.582 24.3989L120.486 25.683H112.23L110.682 25.4262V4.10925L112.746 3.85242Z"
        fill="#C9413C"
      />
      <path
        d="M22.704 3.85242H27.09L30.186 4.87974L32.25 6.67755L33.282 8.21854L34.056 10.0164L34.572 12.3278V17.2076L33.798 20.2896L32.508 22.6011L30.702 24.3989L28.638 25.4262L25.8 25.9398V21.0601L27.864 18.7486L28.38 17.2076V14.1256L27.348 9.24586L27.09 15.6666H26.574L26.058 11.5573L25.542 15.4098H24.768L24.51 12.071L23.994 15.4098H23.22L22.962 10.2732L22.188 13.8688V17.9781L23.736 20.0327L24.51 20.8032V25.683H22.446L20.124 24.6557L18.06 22.8579L16.512 20.2896L15.738 17.2076V13.3551L16.254 10.2732L18.06 6.67755L19.866 5.13657L21.93 4.10925L22.704 3.85242Z"
        fill="#CA423D"
      />
      <path
        d="M42.312 3.85242H46.698L49.278 4.62291L51.342 6.16389L52.89 8.21854L53.664 9.75952L54.18 12.5847V17.2076L53.664 19.5191L52.632 22.0874L51.084 23.8852L49.02 25.1694L47.214 25.683H45.666V20.8032L47.214 19.5191L47.988 17.9781L48.246 16.6939V12.5847L46.956 10.2732L45.924 9.50269H43.86L42.57 10.53L41.538 12.5847V17.2076L42.828 19.7759L44.118 20.8032V25.683H42.054L38.958 24.142L37.152 22.0874L36.12 20.0327L35.604 17.7213V11.8142L36.636 8.47537L38.184 6.42072L39.99 4.87974L42.312 3.85242Z"
        fill="#C9413C"
      />
      <path
        d="M74.562 4.10925H79.98V12.071H85.14V4.10925H90.558V25.4262L89.01 25.683H86.172L85.14 25.4262V16.694H79.98V25.4262L78.432 25.683H75.594L74.562 25.4262V4.10925Z"
        fill="#CA433F"
      />
      <path
        d="M92.364 4.10925H97.782L98.04 18.7486L98.814 20.5464L99.33 20.8032H101.652L102.684 20.2896L103.2 19.0054L103.458 4.10925H108.876V18.7486L107.844 22.3442L105.78 24.6557L102.942 25.683H97.782L94.686 24.142L93.138 21.8306L92.364 19.0054V4.10925Z"
        fill="#CA433E"
      />
      <path
        d="M3.354 4.10925H15.996V8.7322H8.514V12.3278H14.448V16.9508H8.514V25.4262L7.998 25.683H3.87L3.354 25.4262V4.10925Z"
        fill="#C9403B"
      />
      <path
        d="M60.8879 8.47546H63.7259L65.7899 9.50279L66.8219 10.7869L67.5959 12.5848V16.4372L66.8219 19.0055L65.7899 20.2897L63.2099 21.317H60.8879V8.47546Z"
        fill="#FDF8F8"
      />
      <path
        d="M109.908 33.9016H113.262L115.326 35.1858L116.1 36.4699V39.8087L115.068 41.3497L113.778 42.377L113.004 42.6339H110.166L108.36 41.6065L107.328 40.3224L107.07 39.2951V36.7267L108.102 35.1858L109.392 34.1584L109.908 33.9016Z"
        fill="#CA443F"
      />
      <path
        d="M6.45006 33.9016H9.54606L11.0941 34.6721L12.3841 36.2131L12.6421 36.7267V39.5519L11.6101 41.3497L10.3201 42.377L9.28806 42.6339H6.70806L4.90206 41.6065L3.87006 40.3224L3.61206 39.8087V36.4699L4.90206 34.6721L6.45006 33.9016Z"
        fill="#CA443F"
      />
      <path
        d="M22.446 33.9016H27.348L29.412 34.9289L30.444 36.2131L30.702 37.2404V39.5519L29.67 41.3497L27.09 42.6339H22.446V33.9016Z"
        fill="#CB4742"
      />
      <path
        d="M39.4741 33.9016H44.8921L46.6981 35.4426V38.0109L45.4081 39.2951L45.9241 40.5792L46.6981 42.1202V42.6339H44.1181L43.0861 40.3224V39.8087H41.7961V42.6339H39.4741V33.9016Z"
        fill="#CB4742"
      />
      <path
        d="M13.9319 33.9016H19.3499L20.8979 35.1858L21.1559 35.6994V37.7541L20.3819 39.0382L19.8659 39.2951L20.3819 40.5792L21.1559 42.1202V42.6339H18.5759L17.2859 40.0655V39.5519H15.9959V42.377H13.9319V33.9016Z"
        fill="#CA433E"
      />
      <path
        d="M91.5901 33.9016H93.9121L97.0081 38.0109L97.2661 33.9016H99.5881V42.6339H97.2661L94.1701 38.2677L93.9121 38.0109L93.6541 42.377H91.5901V33.9016Z"
        fill="#CA443F"
      />
      <path
        d="M64.7581 33.9016H67.5961L68.6281 36.2131L70.9501 42.1202V42.6339H68.1121V41.3497L64.5001 41.6065L63.9841 42.6339H61.6621L61.9201 41.0929L64.5001 34.1584L64.7581 33.9016Z"
        fill="#CB4843"
      />
      <path
        d="M83.8501 33.9016H90.3001V35.9563H86.1721V37.2404H90.0421V39.0382H86.1721V40.5792H90.3001V42.6339H83.8501V33.9016Z"
        fill="#CB4642"
      />
      <path
        d="M31.7339 33.9016H38.1839V35.9563H34.0559V37.2404H37.9259V39.0382H34.0559V40.5792H38.1839V42.6339H31.7339V33.9016Z"
        fill="#CB4843"
      />
      <path
        d="M54.696 33.9016H61.146V35.6994H57.018V37.2404H61.146V39.0382H57.018V40.5792H61.146V42.6339H54.696V33.9016Z"
        fill="#CB4843"
      />
      <path
        d="M116.1 33.9016H118.422L119.97 36.2131L120.228 36.7267L121.776 34.4153L122.034 33.9016H124.614L123.066 36.7267L121.776 38.7814L121.518 42.6339H119.196L118.938 38.7814L116.1 34.4153V33.9016Z"
        fill="#CB4642"
      />
      <path
        d="M70.176 33.9016H77.142V35.6994H74.82V42.377H72.756V35.9563H70.176V33.9016Z"
        fill="#C9423D"
      />
      <path
        d="M103.716 33.9016H105.78V40.836L105.006 42.1202L103.974 42.6339H101.394L100.362 42.1202L100.878 40.5792L101.652 40.3224H103.2L103.458 40.0655L103.716 33.9016Z"
        fill="#CA433E"
      />
      <path
        d="M115.842 16.4371H118.164L120.228 17.4645L120.486 17.9781V19.7759L119.712 21.0601L118.422 21.5737H115.842V16.4371Z"
        fill="#FCF7F7"
      />
      <path
        d="M110.682 35.6995H112.488L113.778 36.9836L114.036 37.2404V39.0383L112.746 40.5792H110.424L109.392 39.2951V36.9836L110.682 35.6995Z"
        fill="#FDF9F8"
      />
      <path
        d="M7.22403 35.6995H8.77203L10.062 36.47L10.32 36.9836V39.5519L9.28803 40.5792H6.96603L5.67603 39.0383V37.4973L6.45003 36.2131L7.22403 35.6995Z"
        fill="#FDF9F8"
      />
      <path
        d="M24.7681 35.9563H27.3481L28.3801 36.9836V39.0383L27.3481 40.3224L26.8321 40.5792H24.7681V35.9563Z"
        fill="#FEFCFC"
      />
      <path
        d="M115.842 7.96179H118.164L119.454 9.24595V10.7869L118.938 11.8143L117.906 12.3279H115.842V7.96179Z"
        fill="#FCF7F6"
      />
      <path
        d="M15.9961 35.6995H18.3181L18.8341 36.2131L18.5761 37.4973L18.3181 37.7541H15.9961V35.6995Z"
        fill="#F8E6E5"
      />
      <path
        d="M41.5381 35.9563H44.1181L44.3761 36.2131V37.4973L43.8601 37.7541H41.5381V35.9563Z"
        fill="#F9EDED"
      />
      <path
        d="M124.356 40.3224H125.904L126.42 41.0929L126.162 42.1202L125.646 42.6339H124.356L123.84 41.8634L124.098 40.5792L124.356 40.3224Z"
        fill="#CD4D49"
      />
      <path
        d="M48.246 40.3224H49.794L50.052 40.5792V42.1202L49.536 42.6339H48.246L47.73 41.8634L47.988 40.5792L48.246 40.3224Z"
        fill="#CC4B47"
      />
      <path
        d="M77.4 40.3224H78.69L79.206 40.836V42.1202L78.69 42.6339H77.4L76.884 42.1202V40.836L77.4 40.3224Z"
        fill="#CB4642"
      />
      <path
        d="M66.0479 36.2131L66.5639 36.7268L67.3379 39.2951H65.2739L65.5319 37.4973L66.0479 36.2131Z"
        fill="#FAEFEF"
      />
    </g>
    <defs>
      <clipPath id="clip0_583_1722">
        <rect width="129" height="47" fill="white" />
      </clipPath>
    </defs>
  </svg>
);

export const RetryIcon = () => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 640 640">
    <path d="M552 256L408 256C398.3 256 389.5 250.2 385.8 241.2C382.1 232.2 384.1 221.9 391 215L437.7 168.3C362.4 109.7 253.4 115 184.2 184.2C109.2 259.2 109.2 380.7 184.2 455.7C259.2 530.7 380.7 530.7 455.7 455.7C463.9 447.5 471.2 438.8 477.6 429.6C487.7 415.1 507.7 411.6 522.2 421.7C536.7 431.8 540.2 451.8 530.1 466.3C521.6 478.5 511.9 490.1 501 501C401 601 238.9 601 139 501C39.1 401 39 239 139 139C233.3 44.7 382.7 39.4 483.3 122.8L535 71C541.9 64.1 552.2 62.1 561.2 65.8C570.2 69.5 576 78.3 576 88L576 232C576 245.3 565.3 256 552 256z" />
  </svg>
);
export const CustomerStatsIcon = () => (
  <svg
    width="28"
    height="28"
    viewBox="0 0 28 28"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M5.60005 5.59922C5.60005 4.82484 4.97442 4.19922 4.20005 4.19922C3.42567 4.19922 2.80005 4.82484 2.80005 5.59922V20.2992C2.80005 22.233 4.3663 23.7992 6.30005 23.7992H23.8C24.5744 23.7992 25.2 23.1736 25.2 22.3992C25.2 21.6248 24.5744 20.9992 23.8 20.9992H6.30005C5.91505 20.9992 5.60005 20.6842 5.60005 20.2992V5.59922ZM23.3888 9.38797C23.9357 8.84109 23.9357 7.95297 23.3888 7.40609C22.8419 6.85922 21.9538 6.85922 21.4069 7.40609L16.8 12.0173L14.2888 9.51047C13.7419 8.96359 12.8538 8.96359 12.3069 9.51047L8.10692 13.7105C7.56005 14.2573 7.56005 15.1455 8.10692 15.6923C8.6538 16.2392 9.54192 16.2392 10.0888 15.6923L13.3 12.4811L15.8113 14.9923C16.3582 15.5392 17.2463 15.5392 17.7932 14.9923L23.3932 9.39234L23.3888 9.38797Z"
      fill="white"
    />
  </svg>
);

export const StarIcon = () => (
  <svg
    width="21"
    height="20"
    viewBox="0 0 21 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M11.1216 0.49125C10.9679 0.19125 10.6566 0 10.3191 0C9.98163 0 9.67038 0.19125 9.51663 0.49125L6.75663 5.89875L0.760379 6.85125C0.426629 6.90375 0.149129 7.14 0.0441289 7.4625C-0.0608711 7.785 0.025379 8.1375 0.261629 8.3775L4.55163 12.6713L3.60663 18.6675C3.55413 19.0013 3.69288 19.3388 3.96663 19.5375C4.24038 19.7362 4.60038 19.7663 4.90413 19.6125L10.3191 16.86L15.7304 19.6125C16.0304 19.7663 16.3941 19.7362 16.6679 19.5375C16.9416 19.3388 17.0804 19.005 17.0279 18.6675L16.0791 12.6713L20.3691 8.3775C20.6091 8.1375 20.6916 7.785 20.5866 7.4625C20.4816 7.14 20.2079 6.90375 19.8704 6.85125L13.8779 5.89875L11.1216 0.49125Z"
      fill="#FF9900"
    />
  </svg>
);

export const StarCircleIcon = () => (
  <svg
    width="32"
    height="32"
    viewBox="0 0 32 32"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <circle cx="16" cy="16" r="16" fill="#4C4C4C" />
    <path
      d="M16.6049 8.26687C16.4896 8.04187 16.2561 7.89844 16.003 7.89844C15.7499 7.89844 15.5165 8.04187 15.4011 8.26687L13.3311 12.3225L8.83396 13.0369C8.58364 13.0762 8.37552 13.2534 8.29677 13.4953C8.21802 13.7372 8.28271 14.0016 8.45989 14.1816L11.6774 17.4019L10.9686 21.8991C10.9293 22.1494 11.0333 22.4025 11.2386 22.5516C11.444 22.7006 11.714 22.7231 11.9418 22.6078L16.003 20.5434L20.0615 22.6078C20.2865 22.7231 20.5593 22.7006 20.7646 22.5516C20.9699 22.4025 21.074 22.1522 21.0346 21.8991L20.323 17.4019L23.5405 14.1816C23.7205 14.0016 23.7824 13.7372 23.7036 13.4953C23.6249 13.2534 23.4196 13.0762 23.1665 13.0369L18.6721 12.3225L16.6049 8.26687Z"
      fill="white"
    />
  </svg>
);

export const PosIcon = () => (
  <svg
    width="22"
    height="22"
    viewBox="0 0 22 22"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <circle cx="11" cy="11" r="11" fill="#0068EE" />
    <path
      d="M8.13086 6.84033H11.3999C13.1201 6.84033 14.3325 8.04639 14.3325 9.7793C14.3325 11.5186 13.1074 12.731 11.3872 12.731H9.27344V16H8.13086V6.84033ZM9.27344 7.85596V11.7153H11.1016C12.4092 11.7153 13.1582 10.998 13.1582 9.7793C13.1582 8.56689 12.4155 7.85596 11.1016 7.85596H9.27344Z"
      fill="white"
    />
  </svg>
);

export const PosSuccessIcon = () => (
  <svg
    width="32"
    height="24"
    viewBox="0 0 32 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clipPath="url(#clip0_2428_24)">
      <path
        d="M16 22C22.0751 22 27 17.0751 27 11C27 4.92487 22.0751 0 16 0C9.92487 0 5 4.92487 5 11C5 17.0751 9.92487 22 16 22Z"
        fill="#0068EE"
      />
      <path
        d="M13.1309 6.84033H16.3999C18.1201 6.84033 19.3325 8.04639 19.3325 9.7793C19.3325 11.5186 18.1074 12.731 16.3872 12.731H14.2734V16H13.1309V6.84033ZM14.2734 7.85596V11.7153H16.1016C17.4092 11.7153 18.1582 10.998 18.1582 9.7793C18.1582 8.56689 17.4155 7.85596 16.1016 7.85596H14.2734Z"
        fill="white"
      />
    </g>
    <path
      d="M26 24C29.3137 24 32 21.3137 32 18C32 14.6863 29.3137 12 26 12C22.6863 12 20 14.6863 20 18C20 21.3137 22.6863 24 26 24Z"
      fill="white"
    />
    <path
      d="M26 24C27.5913 24 29.1174 23.3679 30.2426 22.2426C31.3679 21.1174 32 19.5913 32 18C32 16.4087 31.3679 14.8826 30.2426 13.7574C29.1174 12.6321 27.5913 12 26 12C24.4087 12 22.8826 12.6321 21.7574 13.7574C20.6321 14.8826 20 16.4087 20 18C20 19.5913 20.6321 21.1174 21.7574 22.2426C22.8826 23.3679 24.4087 24 26 24ZM28.6484 16.8984L25.6484 19.8984C25.4281 20.1188 25.0719 20.1188 24.8539 19.8984L23.3539 18.3984C23.1336 18.1781 23.1336 17.8219 23.3539 17.6039C23.5742 17.3859 23.9305 17.3836 24.1484 17.6039L25.25 18.7055L27.8516 16.1016C28.0719 15.8813 28.4281 15.8813 28.6461 16.1016C28.8641 16.3219 28.8664 16.6781 28.6461 16.8961L28.6484 16.8984Z"
      fill="#00B51D"
    />
    <defs>
      <clipPath id="clip0_2428_24">
        <rect width="22" height="22" fill="white" transform="translate(5)" />
      </clipPath>
    </defs>
  </svg>
);

export const PosFailedIcon = () => (
  <svg
    width="32"
    height="24"
    viewBox="0 0 32 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clipPath="url(#clip0_2428_18)">
      <path
        d="M16 22C22.0751 22 27 17.0751 27 11C27 4.92487 22.0751 0 16 0C9.92487 0 5 4.92487 5 11C5 17.0751 9.92487 22 16 22Z"
        fill="#0068EE"
      />
      <path
        d="M13.1309 6.84033H16.3999C18.1201 6.84033 19.3325 8.04639 19.3325 9.7793C19.3325 11.5186 18.1074 12.731 16.3872 12.731H14.2734V16H13.1309V6.84033ZM14.2734 7.85596V11.7153H16.1016C17.4092 11.7153 18.1582 10.998 18.1582 9.7793C18.1582 8.56689 17.4155 7.85596 16.1016 7.85596H14.2734Z"
        fill="white"
      />
    </g>
    <path
      d="M26 24C29.3137 24 32 21.3137 32 18C32 14.6863 29.3137 12 26 12C22.6863 12 20 14.6863 20 18C20 21.3137 22.6863 24 26 24Z"
      fill="white"
    />
    <path
      d="M26 24C29.3141 24 32 21.3141 32 18C32 14.6859 29.3141 12 26 12C22.6859 12 20 14.6859 20 18C20 21.3141 22.6859 24 26 24ZM23.9141 15.9141C24.1344 15.6938 24.4906 15.6938 24.7086 15.9141L25.9977 17.2031L27.2867 15.9141C27.507 15.6938 27.8633 15.6938 28.0812 15.9141C28.2992 16.1344 28.3016 16.4906 28.0812 16.7086L26.7922 17.9977L28.0812 19.2867C28.3016 19.507 28.3016 19.8633 28.0812 20.0812C27.8609 20.2992 27.5047 20.3016 27.2867 20.0812L25.9977 18.7922L24.7086 20.0812C24.4883 20.3016 24.132 20.3016 23.9141 20.0812C23.6961 19.8609 23.6938 19.5047 23.9141 19.2867L25.2031 17.9977L23.9141 16.7086C23.6938 16.4883 23.6938 16.132 23.9141 15.9141Z"
      fill="#E61E29"
    />
    <defs>
      <clipPath id="clip0_2428_18">
        <rect width="22" height="22" fill="white" transform="translate(5)" />
      </clipPath>
    </defs>
  </svg>
);

export const AiCallSuccessIcon = () => (
  <svg
    width="32"
    height="24"
    viewBox="0 0 32 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M16 22C22.0751 22 27 17.0751 27 11C27 4.92487 22.0751 0 16 0C9.92487 0 5 4.92487 5 11C5 17.0751 9.92487 22 16 22Z"
      fill="#172A55"
    />
    <path
      d="M16.7355 6C19.0902 6 21 7.90985 21 10.2645C21 10.509 20.8033 10.7057 20.5588 10.7057C20.3144 10.7057 20.1177 10.509 20.1177 10.2645C20.1177 8.39697 18.6031 6.88232 16.7355 6.88232C16.491 6.88232 16.2943 6.68563 16.2943 6.44116C16.2943 6.19669 16.491 6 16.7355 6ZM16.8825 9.52924C17.2078 9.52924 17.4708 9.79216 17.4708 10.1175C17.4708 10.4429 17.2078 10.7057 16.8825 10.7057C16.5571 10.7057 16.2943 10.4429 16.2943 10.1175C16.2943 9.79216 16.5571 9.52924 16.8825 9.52924ZM16.2943 8.2058C16.2943 7.96132 16.491 7.76463 16.7355 7.76463C18.1159 7.76463 19.2354 8.88407 19.2354 10.2645C19.2354 10.509 19.0387 10.7057 18.7942 10.7057C18.5498 10.7057 18.3531 10.509 18.3531 10.2645C18.3531 9.37116 17.6288 8.64695 16.7355 8.64695C16.491 8.64695 16.2943 8.45027 16.2943 8.2058ZM13.061 6.61395C13.4231 6.51469 13.8018 6.70034 13.9451 7.04592L14.6896 8.83444C14.8165 9.13777 14.7282 9.48885 14.4727 9.69839L13.6621 10.3619C14.2595 11.6781 15.298 12.7516 16.5902 13.3931L17.2998 12.5255C17.5075 12.2699 17.8586 12.1835 18.1637 12.3086L19.9522 13.0549C20.2978 13.1982 20.4835 13.5769 20.3842 13.939L20.3566 14.0401C20.0332 15.2294 18.8843 16.2441 17.4818 15.9481C14.265 15.2662 11.7338 12.735 11.0519 9.51824C10.7559 8.11573 11.7706 6.96687 12.9581 6.64152L13.0591 6.61395H13.061Z"
      fill="white"
    />
    <path
      d="M26 24C29.3137 24 32 21.3137 32 18C32 14.6863 29.3137 12 26 12C22.6863 12 20 14.6863 20 18C20 21.3137 22.6863 24 26 24Z"
      fill="white"
    />
    <path
      d="M26 24C27.5913 24 29.1174 23.3679 30.2426 22.2426C31.3679 21.1174 32 19.5913 32 18C32 16.4087 31.3679 14.8826 30.2426 13.7574C29.1174 12.6321 27.5913 12 26 12C24.4087 12 22.8826 12.6321 21.7574 13.7574C20.6321 14.8826 20 16.4087 20 18C20 19.5913 20.6321 21.1174 21.7574 22.2426C22.8826 23.3679 24.4087 24 26 24ZM28.6484 16.8984L25.6484 19.8984C25.4281 20.1188 25.0719 20.1188 24.8539 19.8984L23.3539 18.3984C23.1336 18.1781 23.1336 17.8219 23.3539 17.6039C23.5742 17.3859 23.9305 17.3836 24.1484 17.6039L25.25 18.7055L27.8516 16.1016C28.0719 15.8813 28.4281 15.8813 28.6461 16.1016C28.8641 16.3219 28.8664 16.6781 28.6461 16.8961L28.6484 16.8984Z"
      fill="#00B51D"
    />
  </svg>
);

export const AiCallFailedIcon = () => (
  <svg
    width="32"
    height="24"
    viewBox="0 0 32 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M16 22C22.0751 22 27 17.0751 27 11C27 4.92487 22.0751 0 16 0C9.92487 0 5 4.92487 5 11C5 17.0751 9.92487 22 16 22Z"
      fill="#172A55"
    />
    <path
      d="M16.7355 6C19.0902 6 21 7.90985 21 10.2645C21 10.509 20.8033 10.7057 20.5588 10.7057C20.3144 10.7057 20.1177 10.509 20.1177 10.2645C20.1177 8.39697 18.6031 6.88232 16.7355 6.88232C16.491 6.88232 16.2943 6.68563 16.2943 6.44116C16.2943 6.19669 16.491 6 16.7355 6ZM16.8825 9.52924C17.2078 9.52924 17.4708 9.79216 17.4708 10.1175C17.4708 10.4429 17.2078 10.7057 16.8825 10.7057C16.5571 10.7057 16.2943 10.4429 16.2943 10.1175C16.2943 9.79216 16.5571 9.52924 16.8825 9.52924ZM16.2943 8.2058C16.2943 7.96132 16.491 7.76463 16.7355 7.76463C18.1159 7.76463 19.2354 8.88407 19.2354 10.2645C19.2354 10.509 19.0387 10.7057 18.7942 10.7057C18.5498 10.7057 18.3531 10.509 18.3531 10.2645C18.3531 9.37116 17.6288 8.64695 16.7355 8.64695C16.491 8.64695 16.2943 8.45027 16.2943 8.2058ZM13.061 6.61395C13.4231 6.51469 13.8018 6.70034 13.9451 7.04592L14.6896 8.83444C14.8165 9.13777 14.7282 9.48885 14.4727 9.69839L13.6621 10.3619C14.2595 11.6781 15.298 12.7516 16.5902 13.3931L17.2998 12.5255C17.5075 12.2699 17.8586 12.1835 18.1637 12.3086L19.9522 13.0549C20.2978 13.1982 20.4835 13.5769 20.3842 13.939L20.3566 14.0401C20.0332 15.2294 18.8843 16.2441 17.4818 15.9481C14.265 15.2662 11.7338 12.735 11.0519 9.51824C10.7559 8.11573 11.7706 6.96687 12.9581 6.64152L13.0591 6.61395H13.061Z"
      fill="white"
    />
    <path
      d="M26 24C29.3137 24 32 21.3137 32 18C32 14.6863 29.3137 12 26 12C22.6863 12 20 14.6863 20 18C20 21.3137 22.6863 24 26 24Z"
      fill="white"
    />
    <path
      d="M26 24C29.3141 24 32 21.3141 32 18C32 14.6859 29.3141 12 26 12C22.6859 12 20 14.6859 20 18C20 21.3141 22.6859 24 26 24ZM23.9141 15.9141C24.1344 15.6938 24.4906 15.6938 24.7086 15.9141L25.9977 17.2031L27.2867 15.9141C27.507 15.6938 27.8633 15.6938 28.0812 15.9141C28.2992 16.1344 28.3016 16.4906 28.0812 16.7086L26.7922 17.9977L28.0812 19.2867C28.3016 19.507 28.3016 19.8633 28.0812 20.0812C27.8609 20.2992 27.5047 20.3016 27.2867 20.0812L25.9977 18.7922L24.7086 20.0812C24.4883 20.3016 24.132 20.3016 23.9141 20.0812C23.6961 19.8609 23.6938 19.5047 23.9141 19.2867L25.2031 17.9977L23.9141 16.7086C23.6938 16.4883 23.6938 16.132 23.9141 15.9141Z"
      fill="#E61E29"
    />
  </svg>
);

export const ProviderConnectionConnectedIcon = () => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <ellipse cx="12" cy="11.9999" rx="12" ry="11.9999" fill="white" />
      <g clipPath="url(#clip0_25029_20173)">
        <path
          d="M0 11.9999C0 5.37182 5.37188 0 12 0C18.6281 0 24 5.37182 24 11.9999C24 18.6279 18.6281 23.9998 12 23.9998C5.37188 23.9998 0 18.6279 0 11.9999ZM17.4281 9.92803C17.9391 9.41709 17.9391 8.58273 17.4281 8.07179C16.9172 7.56086 16.0828 7.56086 15.5719 8.07179L10.5 13.1436L8.42813 11.0718C7.91719 10.5608 7.08281 10.5608 6.57188 11.0718C6.06094 11.5827 6.06094 12.4171 6.57188 12.928L9.57188 15.928C10.0828 16.4389 10.9172 16.4389 11.4281 15.928L17.4281 9.92803Z"
          fill="#00B51D"
        />
      </g>
      <defs>
        <clipPath id="clip0_25029_20173">
          <rect width="24" height="23.9998" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};

export const ProviderConnectionPendingIcon = () => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <ellipse cx="12" cy="11.9999" rx="12" ry="11.9999" fill="#FF9900" />
      <g clipPath="url(#clip0_25029_20157)">
        <path
          d="M13.4058 5.90624C13.4058 6.68289 12.7759 7.31247 11.9995 7.31247C11.2231 7.31247 10.5933 6.68289 10.5933 5.90624C10.5933 5.12958 11.2231 4.5 11.9995 4.5C12.7759 4.5 13.4058 5.12958 13.4058 5.90624ZM13.4058 18.0936C13.4058 18.87 12.7759 19.4999 11.9995 19.4999C11.2231 19.4999 10.5933 18.87 10.5933 18.0936C10.5933 17.3173 11.2231 16.6874 11.9995 16.6874C12.7759 16.6874 13.4058 17.3173 13.4058 18.0936ZM4.49951 11.9999C4.49951 11.2236 5.1291 10.5937 5.90576 10.5937C6.68242 10.5937 7.31201 11.2236 7.31201 11.9999C7.31201 12.7763 6.68242 13.4062 5.90576 13.4062C5.1291 13.4062 4.49951 12.7763 4.49951 11.9999ZM19.4995 11.9999C19.4995 12.7763 18.8696 13.4062 18.0933 13.4062C17.3169 13.4062 16.687 12.7763 16.687 11.9999C16.687 11.2236 17.3169 10.5937 18.0933 10.5937C18.8696 10.5937 19.4995 11.2236 19.4995 11.9999ZM6.69619 17.3026C6.14688 16.7548 6.14688 15.8641 6.69619 15.3134C7.24551 14.7655 8.13525 14.7655 8.68604 15.3134C9.23389 15.8641 9.23389 16.7548 8.68604 17.3026C8.13525 17.8534 7.24551 17.8534 6.69619 17.3026ZM8.68604 8.68648C8.13525 9.23433 7.24551 9.23433 6.69619 8.68648C6.14717 8.13571 6.14717 7.24597 6.69619 6.69666C7.24551 6.14735 8.13525 6.14735 8.68604 6.69666C9.23389 7.24597 9.23389 8.13571 8.68604 8.68648ZM15.313 15.3134C15.8638 14.7655 16.7544 14.7655 17.3022 15.3134C17.853 15.8641 17.853 16.7548 17.3022 17.3026C16.7544 17.8534 15.8638 17.8534 15.313 17.3026C14.7651 16.7548 14.7651 15.8641 15.313 15.3134Z"
          fill="white"
        />
      </g>
      <defs>
        <clipPath id="clip0_25029_20157">
          <rect
            width="15"
            height="14.9999"
            fill="white"
            transform="translate(4.49951 4.5)"
          />
        </clipPath>
      </defs>
    </svg>
  );
};

export const ProviderConnectionDisabledIcon = () => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <ellipse cx="12" cy="11.9999" rx="12" ry="11.9999" fill="#E61E29" />
      <g clipPath="url(#clip0_25029_20200)">
        <path
          d="M17.5474 15.966C18.0162 16.4055 18.0162 17.1174 17.5474 17.5568C17.3149 17.7765 17.0074 17.8855 16.6999 17.8855C16.3924 17.8855 16.0857 17.7757 15.8517 17.5559L11.8999 13.8531L7.94853 17.5551C7.71415 17.7765 7.40703 17.8855 7.0999 17.8855C6.79278 17.8855 6.48603 17.7765 6.25146 17.5551C5.78271 17.1156 5.78271 16.4037 6.25146 15.9643L10.204 12.2588L6.25146 8.55516C5.78271 8.11571 5.78271 7.4038 6.25146 6.96435C6.72021 6.5249 7.47959 6.5249 7.94834 6.96435L11.8999 10.6715L15.8524 6.96611C16.3212 6.52666 17.0805 6.52666 17.5493 6.96611C18.018 7.40556 18.018 8.11747 17.5493 8.55691L13.5968 12.2623L17.5474 15.966Z"
          fill="white"
        />
      </g>
      <defs>
        <clipPath id="clip0_25029_20200">
          <rect
            width="12"
            height="17.9998"
            fill="white"
            transform="translate(5.8999 3.26074)"
          />
        </clipPath>
      </defs>
    </svg>
  );
};

export const PhoneIcon = () => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 640 640">
      <path
        fill={lightTheme.lightGray}
        d="M224.2 89C216.3 70.1 195.7 60.1 176.1 65.4L170.6 66.9C106 84.5 50.8 147.1 66.9 223.3C104 398.3 241.7 536 416.7 573.1C493 589.3 555.5 534 573.1 469.4L574.6 463.9C580 444.2 569.9 423.6 551.1 415.8L453.8 375.3C437.3 368.4 418.2 373.2 406.8 387.1L368.2 434.3C297.9 399.4 241.3 341 208.8 269.3L253 233.3C266.9 222 271.6 202.9 264.8 186.3L224.2 89z"
      />
    </svg>
  );
};

export const DuplicateIcon = () => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 640 640">
      <path
        fill="#4c4c4c"
        d="M352 512L128 512L128 288L176 288L176 224L128 224C92.7 224 64 252.7 64 288L64 512C64 547.3 92.7 576 128 576L352 576C387.3 576 416 547.3 416 512L416 464L352 464L352 512zM288 416L512 416C547.3 416 576 387.3 576 352L576 128C576 92.7 547.3 64 512 64L288 64C252.7 64 224 92.7 224 128L224 352C224 387.3 252.7 416 288 416z"
      />
    </svg>
  );
};

export const UndoIcon = ({ color }: { color?: string }) => (
  <svg
    width="18"
    height="18"
    viewBox="0 0 640 640"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fill={color || '#4C4C4C'}
      d="M88 256L232 256C241.7 256 250.5 250.2 254.2 241.2C257.9 232.2 255.9 221.9 249 215L202.3 168.3C277.6 109.7 386.6 115 455.8 184.2C530.8 259.2 530.8 380.7 455.8 455.7C380.8 530.7 259.3 530.7 184.3 455.7C174.1 445.5 165.3 434.4 157.9 422.7C148.4 407.8 128.6 403.4 113.7 412.9C98.8 422.4 94.4 442.2 103.9 457.1C113.7 472.7 125.4 487.5 139 501C239 601 401 601 501 501C601 401 601 239 501 139C406.8 44.7 257.3 39.3 156.7 122.8L105 71C98.1 64.2 87.8 62.1 78.8 65.8C69.8 69.5 64 78.3 64 88L64 232C64 245.3 74.7 256 88 256z"
    />
  </svg>
);

export const ExpandEditorIcon = ({ color }: { color?: string }) => (
  <svg
    width="12"
    height="12"
    viewBox="0 0 640 640"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fill={color || '#4C4C4C'}
      d="M408 64L552 64C565.3 64 576 74.7 576 88L576 232C576 241.7 570.2 250.5 561.2 254.2C552.2 257.9 541.9 255.9 535 249L496 210L409 297C399.6 306.4 384.4 306.4 375.1 297L343.1 265C333.7 255.6 333.7 240.4 343.1 231.1L430.1 144.1L391.1 105.1C384.2 98.2 382.2 87.9 385.9 78.9C389.6 69.9 398.3 64 408 64zM232 576L88 576C74.7 576 64 565.3 64 552L64 408C64 398.3 69.8 389.5 78.8 385.8C87.8 382.1 98.1 384.2 105 391L144 430L231 343C240.4 333.6 255.6 333.6 264.9 343L296.9 375C306.3 384.4 306.3 399.6 296.9 408.9L209.9 495.9L248.9 534.9C255.8 541.8 257.8 552.1 254.1 561.1C250.4 570.1 241.7 576 232 576z"
    />
  </svg>
);

/* -------------------------------------------------------------------------- */
/* Internal chat                                                              */
/* -------------------------------------------------------------------------- */

/**
 * Every glyph below is Font Awesome 7 Free Solid on its native `0 0 640 640`
 * grid - see docs/icons.md. One grid across the whole feature is what makes the
 * sizes comparable: a 640-grid glyph covers about 80% of its box, so two icons
 * declared at the same px are the same size on screen. Sizes here were picked
 * to match what the hand-drawn set they replaced rendered at.
 */

/**
 * Font Awesome `comment-dots`. Sidebar nav icon, sized and recoloured by
 * `NavLinkCircle` in AdminSidebar, which rewrites `path { fill }` - so keep it
 * a plain single-path shape with no gradients (a gradient here would need
 * per-instance ids to avoid the shared-id blanking issue).
 */
export const ChatIcon = () => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 640 640"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M320 544C461.4 544 576 436.5 576 304C576 171.5 461.4 64 320 64C178.6 64 64 171.5 64 304C64 358.3 83.2 408.3 115.6 448.5L66.8 540.8C62 549.8 63.5 560.8 70.4 568.3C77.3 575.8 88.2 578.1 97.5 574.1L215.9 523.4C247.7 536.6 282.9 544 320 544zM192 272A32 32 0 1 1 192 336A32 32 0 1 1 192 272zM320 272A32 32 0 1 1 320 336A32 32 0 1 1 320 272zM416 304A32 32 0 1 1 480 304A32 32 0 1 1 416 304z"
      fill="white"
    />
  </svg>
);

/**
 * Font Awesome `ticket` (solid). The support tickets page, in the sidebar -
 * white like every other nav glyph, which sits on the red rail.
 */
export const SupportTicketsIcon = () => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 640 640"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M64 192C64 156.7 92.7 128 128 128L512 128C547.3 128 576 156.7 576 192L576 256C576 264.8 568.7 271.7 560.4 274.7C541.3 281.5 527.7 299.7 527.7 321.1C527.7 342.5 541.3 360.7 560.4 367.5C568.7 370.5 576 377.4 576 386.2L576 448C576 483.3 547.3 512 512 512L128 512C92.7 512 64 483.3 64 448L64 386.2C64 377.4 71.3 370.5 79.6 367.5C98.7 360.7 112.3 342.5 112.3 321.1C112.3 299.7 98.7 281.5 79.6 274.7C71.3 271.7 64 264.8 64 256L64 192zM416 224C416 210.7 405.3 200 392 200C378.7 200 368 210.7 368 224L368 416C368 429.3 378.7 440 392 440C405.3 440 416 429.3 416 416L416 224z"
      fill="white"
    />
  </svg>
);

/**
 * Font Awesome `triangle-exclamation` (solid). The System Problems card's
 * header on the Dashboard - red by nature.
 */
export const SystemProblemsIcon = ({ color }: { color?: string }) => (
  <svg width="22" height="22" viewBox="0 0 640 640" fill="none">
    <path
      d="M320 64C334.7 64 348.2 72.1 355.2 85L571.2 485C577.9 497.4 577.6 512.4 570.4 524.5C563.2 536.6 550.1 544 536 544L104 544C89.9 544 76.9 536.6 69.6 524.5C62.3 512.4 62.1 497.4 68.8 485L284.8 85C291.8 72.1 305.3 64 320 64zM320 232C306.7 232 296 242.7 296 256L296 368C296 381.3 306.7 392 320 392C333.3 392 344 381.3 344 368L344 256C344 242.7 333.3 232 320 232zM346.7 448C346.7 433.3 334.7 421.3 320 421.3C305.3 421.3 293.3 433.3 293.3 448C293.3 462.7 305.3 474.7 320 474.7C334.7 474.7 346.7 462.7 346.7 448z"
      fill={color || '#E61E29'}
    />
  </svg>
);

/**
 * Font Awesome `utensils` (solid). Marks a menu issue ticket, so it stands
 * apart from the tickets about money.
 */
export const MenuIssueIcon = ({ color }: { color?: string }) => (
  <svg width="12" height="12" viewBox="0 0 512 512" fill="none">
    <path
      d="M63.9 14.4C63.1 6.2 56.2 0 48 0s-15.1 6.2-16 14.3L17.9 149.7c-1.3 6-1.9 12.1-1.9 18.2 0 45.9 35.1 83.6 80 87.7L96 480c0 17.7 14.3 32 32 32s32-14.3 32-32l0-224.4c44.9-4.1 80-41.8 80-87.7 0-6.1-.6-12.2-1.9-18.2L223.9 14.3C223.1 6.2 216.2 0 208 0s-15.1 6.2-15.9 14.4L178.5 149.9c-.6 5.7-5.4 10.1-11.1 10.1-5.8 0-10.6-4.4-11.2-10.2L143.9 14.6C143.2 6.3 136.3 0 128 0s-15.2 6.3-15.9 14.6L99.8 149.8c-.5 5.8-5.4 10.2-11.2 10.2-5.8 0-10.6-4.4-11.1-10.1L63.9 14.4zM448 0C432 0 320 32 320 176l0 112c0 35.3 28.7 64 64 64l32 0 0 128c0 17.7 14.3 32 32 32s32-14.3 32-32l0-448c0-17.7-14.3-32-32-32z"
      fill={color || '#4C4C4C'}
    />
  </svg>
);

/**
 * The same `triangle-exclamation`, as the System Problems page in the
 * sidebar - white and nav-sized like every other glyph on the red rail.
 */
export const SystemProblemsPageIcon = () => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 640 640"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M320 64C334.7 64 348.2 72.1 355.2 85L571.2 485C577.9 497.4 577.6 512.4 570.4 524.5C563.2 536.6 550.1 544 536 544L104 544C89.9 544 76.9 536.6 69.6 524.5C62.3 512.4 62.1 497.4 68.8 485L284.8 85C291.8 72.1 305.3 64 320 64zM320 232C306.7 232 296 242.7 296 256L296 368C296 381.3 306.7 392 320 392C333.3 392 344 381.3 344 368L344 256C344 242.7 333.3 232 320 232zM346.7 448C346.7 433.3 334.7 421.3 320 421.3C305.3 421.3 293.3 433.3 293.3 448C293.3 462.7 305.3 474.7 320 474.7C334.7 474.7 346.7 462.7 346.7 448z"
      fill="white"
    />
  </svg>
);

/** Font Awesome `paper-plane`. Send, in the composer. */
export const ChatSendIcon = ({ color }: { color?: string }) => (
  <svg width="20" height="20" viewBox="0 0 640 640" fill="none">
    <path
      d="M568.4 37.7C578.2 34.2 589 36.7 596.4 44C603.8 51.3 606.2 62.2 602.7 72L424.7 568.9C419.7 582.8 406.6 592 391.9 592C377.7 592 364.9 583.4 359.6 570.3L295.4 412.3C290.9 401.3 292.9 388.7 300.6 379.7L395.1 267.3C400.2 261.2 399.8 252.3 394.2 246.7C388.6 241.1 379.6 240.7 373.6 245.8L261.2 340.1C252.1 347.7 239.6 349.7 228.6 345.3L70.1 280.8C57 275.5 48.4 262.7 48.4 248.5C48.4 233.8 57.6 220.7 71.5 215.7L568.4 37.7z"
      fill={color || '#A9A9A9'}
    />
  </svg>
);

/** Font Awesome `paperclip`. Attach a file. */
export const ChatAttachIcon = ({ color }: { color?: string }) => (
  <svg width="22" height="22" viewBox="0 0 640 640" fill="none">
    <path
      d="M288.6 76.8C344.8 20.6 436 20.6 492.2 76.8C548.4 133 548.4 224.2 492.2 280.4L328.2 444.4C293.8 478.8 238.1 478.8 203.7 444.4C169.3 410 169.3 354.3 203.7 319.9L356.5 167.3C369 154.8 389.3 154.8 401.8 167.3C414.3 179.8 414.3 200.1 401.8 212.6L249 365.3C239.6 374.7 239.6 389.9 249 399.2C258.4 408.5 273.6 408.6 282.9 399.2L446.9 235.2C478.1 204 478.1 153.3 446.9 122.1C415.7 90.9 365 90.9 333.8 122.1L169.8 286.1C116.7 339.2 116.7 425.3 169.8 478.4C222.9 531.5 309 531.5 362.1 478.4L492.3 348.3C504.8 335.8 525.1 335.8 537.6 348.3C550.1 360.8 550.1 381.1 537.6 393.6L407.4 523.6C329.3 601.7 202.7 601.7 124.6 523.6C46.5 445.5 46.5 318.9 124.6 240.8L288.6 76.8z"
      fill={color || '#A9A9A9'}
    />
  </svg>
);

/** Font Awesome `box-archive`. Archive a conversation. */
export const ChatArchiveIcon = ({ color }: { color?: string }) => (
  <svg width="16" height="16" viewBox="0 0 640 640" fill="none">
    <path
      d="M64 128C64 110.3 78.3 96 96 96L544 96C561.7 96 576 110.3 576 128L576 160C576 177.7 561.7 192 544 192L96 192C78.3 192 64 177.7 64 160L64 128zM96 240L544 240L544 480C544 515.3 515.3 544 480 544L160 544C124.7 544 96 515.3 96 480L96 240zM248 304C234.7 304 224 314.7 224 328C224 341.3 234.7 352 248 352L392 352C405.3 352 416 341.3 416 328C416 314.7 405.3 304 392 304L248 304z"
      fill={color || '#4C4C4C'}
    />
  </svg>
);

/** Font Awesome `arrow-rotate-left`. Take one back out of the archive. */
export const ChatRestoreIcon = ({ color }: { color?: string }) => (
  <svg width="16" height="16" viewBox="0 0 640 640" fill="none">
    <path
      d="M320 128C263.2 128 212.1 152.7 176.9 192L224 192C241.7 192 256 206.3 256 224C256 241.7 241.7 256 224 256L96 256C78.3 256 64 241.7 64 224L64 96C64 78.3 78.3 64 96 64C113.7 64 128 78.3 128 96L128 150.7C174.9 97.6 243.5 64 320 64C461.4 64 576 178.6 576 320C576 461.4 461.4 576 320 576C233 576 156.1 532.6 109.9 466.3C99.8 451.8 103.3 431.9 117.8 421.7C132.3 411.5 152.2 415.1 162.4 429.6C197.2 479.4 254.8 511.9 320 511.9C426 511.9 512 425.9 512 319.9C512 213.9 426 128 320 128z"
      fill={color || '#4C4C4C'}
    />
  </svg>
);

/** Font Awesome `bell` (solid). The header's notifications button. */
export const NotificationBellIcon = ({ color }: { color?: string }) => (
  <svg width="20" height="20" viewBox="0 0 640 640" fill="none">
    <path
      d="M320 64C302.3 64 288 78.3 288 96L288 99.2C215 114 160 178.6 160 256L160 277.7C160 325.8 143.6 372.5 113.6 410.1L103.8 422.3C98.7 428.6 96 436.4 96 444.5C96 464.1 111.9 480 131.5 480L508.5 480C528.1 480 544 464.1 544 444.5C544 436.4 541.3 428.6 536.2 422.3L526.4 410.1C496.4 372.5 480 325.8 480 277.7L480 256C480 178.6 425 114 352 99.2L352 96C352 78.3 337.7 64 320 64zM258 528C265.1 555.6 290.2 576 320 576C349.8 576 374.9 555.6 382 528L258 528z"
      fill={color || '#E61E29'}
    />
  </svg>
);

/** Font Awesome `bell-slash`. The conversation is muted for this member. */
export const ChatMuteIcon = ({ color }: { color?: string }) => (
  <svg width="12" height="12" viewBox="0 0 640 640" fill="none">
    <path
      d="M73 39.1C63.6 29.7 48.4 29.7 39.1 39.1C29.8 48.5 29.7 63.7 39 73.1L567 601.1C576.4 610.5 591.6 610.5 600.9 601.1C610.2 591.7 610.3 576.5 600.9 567.2L513.4 479.7C530.6 477.3 543.9 462.4 543.9 444.5C543.9 436.4 541.2 428.6 536.1 422.3L526.3 410.1C496.4 372.5 480 325.8 480 277.7L480 256C480 178.6 425 114 352 99.2L352 96C352 78.3 337.7 64 320 64C302.3 64 288 78.3 288 96L288 99.2C249.4 107 215.8 128.8 192.8 158.9L73 39.1zM160 277.6C160 325.7 143.6 372.4 113.6 410L103.8 422.2C98.8 428.5 96 436.3 96 444.4C96 464 111.9 479.9 131.5 479.9L366.8 479.9L159.9 273L159.9 277.5zM320 576C349.8 576 374.9 555.6 382 528L258 528C265.1 555.6 290.2 576 320 576z"
      fill={color || '#A9A9A9'}
    />
  </svg>
);

/** Font Awesome `plus`. Start a new conversation. */
export const ChatPlusIcon = ({ color }: { color?: string }) => (
  <svg width="16" height="16" viewBox="0 0 640 640" fill="none">
    <path
      d="M352 128C352 110.3 337.7 96 320 96C302.3 96 288 110.3 288 128L288 288L128 288C110.3 288 96 302.3 96 320C96 337.7 110.3 352 128 352L288 352L288 512C288 529.7 302.3 544 320 544C337.7 544 352 529.7 352 512L352 352L512 352C529.7 352 544 337.7 544 320C544 302.3 529.7 288 512 288L352 288L352 128z"
      fill={color || '#E61E29'}
    />
  </svg>
);

/** Font Awesome `circle-info`. Open the conversation's details. */
export const ChatInfoIcon = ({ color }: { color?: string }) => (
  <svg width="16" height="16" viewBox="0 0 640 640" fill="none">
    <path
      d="M320 576A256 256 0 1 0 320 64A256 256 0 1 0 320 576zM288 224A32 32 0 1 1 352 224A32 32 0 1 1 288 224zM280 288L328 288C341.3 288 352 298.7 352 312L352 400L360 400C373.3 400 384 410.7 384 424C384 437.3 373.3 448 360 448L280 448C266.7 448 256 437.3 256 424C256 410.7 266.7 400 280 400L304 400L304 336L280 336C266.7 336 256 325.3 256 312C256 298.7 266.7 288 280 288z"
      fill={color || '#4C4C4C'}
    />
  </svg>
);

/**
 * Font Awesome `magnifying-glass`, at the composer's weight rather than the
 * form set's - `SearchIcon` already exists and is deliberately heavier.
 */
export const ChatSearchIcon = ({ color }: { color?: string }) => (
  <svg width="20" height="20" viewBox="0 0 640 640" fill="none">
    <path
      d="M480 272C480 317.9 465.1 360.3 440 394.7L566.6 521.4C579.1 533.9 579.1 554.2 566.6 566.7C554.1 579.2 533.8 579.2 521.3 566.7L394.7 440C360.3 465.1 317.9 480 272 480C157.1 480 64 386.9 64 272C64 157.1 157.1 64 272 64C386.9 64 480 157.1 480 272zM272 416A144 144 0 1 0 272 128A144 144 0 1 0 272 416z"
      fill={color || '#A9A9A9'}
    />
  </svg>
);

/**
 * Font Awesome `microphone`. Record a voice message.
 *
 * Larger than it looks like it should be: the microphone is a narrow glyph, so
 * at the same declared size as the paperclip beside it in the composer it drew
 * noticeably less ink and read as a smaller control. Sized to match what those
 * two actually paint, not to match their numbers. The record button pins its
 * own size, so nothing there is affected.
 */
export const ChatMicIcon = ({ color }: { color?: string }) => (
  <svg width="22" height="22" viewBox="0 0 640 640" fill="none">
    <path
      d="M320 64C267 64 224 107 224 160L224 288C224 341 267 384 320 384C373 384 416 341 416 288L416 160C416 107 373 64 320 64zM176 248C176 234.7 165.3 224 152 224C138.7 224 128 234.7 128 248L128 288C128 385.9 201.3 466.7 296 478.5L296 528L248 528C234.7 528 224 538.7 224 552C224 565.3 234.7 576 248 576L392 576C405.3 576 416 565.3 416 552C416 538.7 405.3 528 392 528L344 528L344 478.5C438.7 466.7 512 385.9 512 288L512 248C512 234.7 501.3 224 488 224C474.7 224 464 234.7 464 248L464 288C464 367.5 399.5 432 320 432C240.5 432 176 367.5 176 288L176 248z"
      fill={color || '#A9A9A9'}
    />
  </svg>
);

/** Font Awesome `square`. Stop, inside the red record button. */
export const ChatStopRecordingIcon = ({ color }: { color?: string }) => (
  <svg width="12" height="12" viewBox="0 0 640 640" fill="none">
    <path
      d="M160 96L480 96C515.3 96 544 124.7 544 160L544 480C544 515.3 515.3 544 480 544L160 544C124.7 544 96 515.3 96 480L96 160C96 124.7 124.7 96 160 96z"
      fill={color || '#FFFFFF'}
    />
  </svg>
);

/** Font Awesome `reply`. Quote a message. */
export const ChatReplyIcon = ({ color }: { color?: string }) => (
  <svg width="16" height="16" viewBox="0 0 640 640" fill="none">
    <path
      d="M268.2 82.4C280.2 87.4 288 99 288 112L288 192L400 192C497.2 192 576 270.8 576 368C576 481.3 494.5 531.9 475.8 542.1C473.3 543.5 470.5 544 467.7 544C456.8 544 448 535.1 448 524.3C448 516.8 452.3 509.9 457.8 504.8C467.2 496 480 478.4 480 448.1C480 395.1 437 352.1 384 352.1L288 352.1L288 432.1C288 445 280.2 456.7 268.2 461.7C256.2 466.7 242.5 463.9 233.3 454.8L73.3 294.8C60.8 282.3 60.8 262 73.3 249.5L233.3 89.5C242.5 80.3 256.2 77.6 268.2 82.6z"
      fill={color || '#4C4C4C'}
    />
  </svg>
);

/** Font Awesome `play`. Both media players. */
export const ChatPlayIcon = ({ color }: { color?: string }) => (
  <svg width="16" height="16" viewBox="0 0 640 640" fill="none">
    <path
      d="M187.2 100.9C174.8 94.1 159.8 94.4 147.6 101.6C135.4 108.8 128 121.9 128 136L128 504C128 518.1 135.5 531.2 147.6 538.4C159.7 545.6 174.8 545.9 187.2 539.1L523.2 355.1C536 348.1 544 334.6 544 320C544 305.4 536 291.9 523.2 284.9L187.2 100.9z"
      fill={color || '#FFFFFF'}
    />
  </svg>
);

/** Font Awesome `pause`. Both media players. */
export const ChatPauseIcon = ({ color }: { color?: string }) => (
  <svg width="16" height="16" viewBox="0 0 640 640" fill="none">
    <path
      d="M176 96C149.5 96 128 117.5 128 144L128 496C128 522.5 149.5 544 176 544L240 544C266.5 544 288 522.5 288 496L288 144C288 117.5 266.5 96 240 96L176 96zM400 96C373.5 96 352 117.5 352 144L352 496C352 522.5 373.5 544 400 544L464 544C490.5 544 512 522.5 512 496L512 144C512 117.5 490.5 96 464 96L400 96z"
      fill={color || '#FFFFFF'}
    />
  </svg>
);

/** Font Awesome `file-lines`. PDF / document chip. */
export const ChatFileIcon = ({ color }: { color?: string }) => (
  <svg width="24" height="24" viewBox="0 0 640 640" fill="none">
    <path
      d="M128 128C128 92.7 156.7 64 192 64L341.5 64C358.5 64 374.8 70.7 386.8 82.7L493.3 189.3C505.3 201.3 512 217.6 512 234.6L512 512C512 547.3 483.3 576 448 576L192 576C156.7 576 128 547.3 128 512L128 128zM336 122.5L336 216C336 229.3 346.7 240 360 240L453.5 240L336 122.5zM248 320C234.7 320 224 330.7 224 344C224 357.3 234.7 368 248 368L392 368C405.3 368 416 357.3 416 344C416 330.7 405.3 320 392 320L248 320zM248 416C234.7 416 224 426.7 224 440C224 453.3 234.7 464 248 464L392 464C405.3 464 416 453.3 416 440C416 426.7 405.3 416 392 416L248 416z"
      fill={color || '#E61E29'}
    />
  </svg>
);

/** Font Awesome `xmark`. Dismiss a reply strip, a staged file, a recording. */
export const ChatCloseIcon = ({ color }: { color?: string }) => (
  <svg width="10" height="10" viewBox="0 0 640 640" fill="none">
    <path
      d="M183.1 137.4C170.6 124.9 150.3 124.9 137.8 137.4C125.3 149.9 125.3 170.2 137.8 182.7L275.2 320L137.9 457.4C125.4 469.9 125.4 490.2 137.9 502.7C150.4 515.2 170.7 515.2 183.2 502.7L320.5 365.3L457.9 502.6C470.4 515.1 490.7 515.1 503.2 502.6C515.7 490.1 515.7 469.8 503.2 457.3L365.8 320L503.1 182.6C515.6 170.1 515.6 149.8 503.1 137.3C490.6 124.8 470.3 124.8 457.8 137.3L320.5 274.7L183.1 137.4z"
      fill={color || '#4C4C4C'}
    />
  </svg>
);

/**
 * Font Awesome `pen`. Edit a message.
 *
 * Deliberately separate from the app's existing edit glyph: that one is
 * exported three times from this file at three natural sizes, so which one you
 * get depends on export order. `MessageActionButton` pins the size anyway.
 */
export const ChatEditIcon = ({ color }: { color?: string }) => (
  <svg width="22" height="22" viewBox="0 0 640 640" fill="none">
    <path
      d="M416.9 85.2L372 130.1L509.9 268L554.8 223.1C568.4 209.6 576 191.2 576 172C576 152.8 568.4 134.4 554.8 120.9L519.1 85.2C505.6 71.6 487.2 64 468 64C448.8 64 430.4 71.6 416.9 85.2zM338.1 164L122.9 379.1C112.2 389.8 104.4 403.2 100.3 417.8L64.9 545.6C62.6 553.9 64.9 562.9 71.1 569C77.3 575.1 86.2 577.5 94.5 575.2L222.3 539.7C236.9 535.6 250.2 527.9 261 517.1L476 301.9L338.1 164z"
      fill={color || '#4C4C4C'}
    />
  </svg>
);

/** Font Awesome `trash`. Delete a message - see the note on `ChatEditIcon`. */
export const ChatTrashIcon = ({ color }: { color?: string }) => (
  <svg width="22" height="22" viewBox="0 0 640 640" fill="none">
    <path
      d="M232.7 69.9L224 96L128 96C110.3 96 96 110.3 96 128C96 145.7 110.3 160 128 160L512 160C529.7 160 544 145.7 544 128C544 110.3 529.7 96 512 96L416 96L407.3 69.9C402.9 56.8 390.7 48 376.9 48L263.1 48C249.3 48 237.1 56.8 232.7 69.9zM512 208L128 208L149.1 531.1C150.7 556.4 171.7 576 197 576L443 576C468.3 576 489.3 556.4 490.9 531.1L512 208z"
      fill={color || '#E61E29'}
    />
  </svg>
);

/** Font Awesome `volume-high`. Video player, unmuted. */
export const ChatVolumeOnIcon = ({ color }: { color?: string }) => (
  <svg width="18" height="18" viewBox="0 0 640 640" fill="none">
    <path
      d="M533.6 96.5C523.3 88.1 508.2 89.7 499.8 100C491.4 110.3 493 125.4 503.3 133.8C557.5 177.8 592 244.8 592 320C592 395.2 557.5 462.2 503.3 506.3C493 514.7 491.5 529.8 499.8 540.1C508.1 550.4 523.3 551.9 533.6 543.6C598.5 490.7 640 410.2 640 320C640 229.8 598.5 149.2 533.6 96.5zM473.1 171C462.8 162.6 447.7 164.2 439.3 174.5C430.9 184.8 432.5 199.9 442.8 208.3C475.3 234.7 496 274.9 496 320C496 365.1 475.3 405.3 442.8 431.8C432.5 440.2 431 455.3 439.3 465.6C447.6 475.9 462.8 477.4 473.1 469.1C516.3 433.9 544 380.2 544 320.1C544 260 516.3 206.3 473.1 171.1zM412.6 245.5C402.3 237.1 387.2 238.7 378.8 249C370.4 259.3 372 274.4 382.3 282.8C393.1 291.6 400 305 400 320C400 335 393.1 348.4 382.3 357.3C372 365.7 370.5 380.8 378.8 391.1C387.1 401.4 402.3 402.9 412.6 394.6C434.1 376.9 448 350.1 448 320C448 289.9 434.1 263.1 412.6 245.5zM80 416L128 416L262.1 535.2C268.5 540.9 276.7 544 285.2 544C304.4 544 320 528.4 320 509.2L320 130.8C320 111.6 304.4 96 285.2 96C276.7 96 268.5 99.1 262.1 104.8L128 224L80 224C53.5 224 32 245.5 32 272L32 368C32 394.5 53.5 416 80 416z"
      fill={color || '#E61E29'}
    />
  </svg>
);

/** Font Awesome `volume-xmark`. Video player, muted. */
export const ChatVolumeOffIcon = ({ color }: { color?: string }) => (
  <svg width="18" height="18" viewBox="0 0 640 640" fill="none">
    <path
      d="M80 416L128 416L262.1 535.2C268.5 540.9 276.7 544 285.2 544C304.4 544 320 528.4 320 509.2L320 130.8C320 111.6 304.4 96 285.2 96C276.7 96 268.5 99.1 262.1 104.8L128 224L80 224C53.5 224 32 245.5 32 272L32 368C32 394.5 53.5 416 80 416zM399 239C389.6 248.4 389.6 263.6 399 272.9L446 319.9L399 366.9C389.6 376.3 389.6 391.5 399 400.8C408.4 410.1 423.6 410.2 432.9 400.8L479.9 353.8L526.9 400.8C536.3 410.2 551.5 410.2 560.8 400.8C570.1 391.4 570.2 376.2 560.8 366.9L513.8 319.9L560.8 272.9C570.2 263.5 570.2 248.3 560.8 239C551.4 229.7 536.2 229.6 526.9 239L479.9 286L432.9 239C423.5 229.6 408.3 229.6 399 239z"
      fill={color || '#E61E29'}
    />
  </svg>
);

/**
 * Font Awesome `arrow-left`. Back out of a thread on mobile, and - rotated -
 * the lightbox's two arrows. Its own glyph rather than the shared `ArrowRed`,
 * which carries a hardcoded clipPath id that collides when the icon appears
 * more than once on a screen.
 */
export const ChatBackIcon = ({ color }: { color?: string }) => (
  <svg width="20" height="20" viewBox="0 0 640 640" fill="none">
    <path
      d="M73.4 297.4C60.9 309.9 60.9 330.2 73.4 342.7L233.4 502.7C245.9 515.2 266.2 515.2 278.7 502.7C291.2 490.2 291.2 469.9 278.7 457.4L173.3 352L544 352C561.7 352 576 337.7 576 320C576 302.3 561.7 288 544 288L173.3 288L278.7 182.6C291.2 170.1 291.2 149.8 278.7 137.3C266.2 124.8 245.9 124.8 233.4 137.3L73.4 297.3z"
      fill={color || '#E61E29'}
    />
  </svg>
);

/** Font Awesome `expand`. Video player, fullscreen. */
export const ChatFullscreenIcon = ({ color }: { color?: string }) => (
  <svg width="24" height="24" viewBox="0 0 640 640" fill="none">
    <path
      d="M128 96C110.3 96 96 110.3 96 128L96 224C96 241.7 110.3 256 128 256C145.7 256 160 241.7 160 224L160 160L224 160C241.7 160 256 145.7 256 128C256 110.3 241.7 96 224 96L128 96zM160 416C160 398.3 145.7 384 128 384C110.3 384 96 398.3 96 416L96 512C96 529.7 110.3 544 128 544L224 544C241.7 544 256 529.7 256 512C256 494.3 241.7 480 224 480L160 480L160 416zM416 96C398.3 96 384 110.3 384 128C384 145.7 398.3 160 416 160L480 160L480 224C480 241.7 494.3 256 512 256C529.7 256 544 241.7 544 224L544 128C544 110.3 529.7 96 512 96L416 96zM544 416C544 398.3 529.7 384 512 384C494.3 384 480 398.3 480 416L480 480L416 480C398.3 480 384 494.3 384 512C384 529.7 398.3 544 416 544L512 544C529.7 544 544 529.7 544 512L544 416z"
      fill={color || '#E61E29'}
    />
  </svg>
);

/** Font Awesome `crop-simple`. Image editor, crop tool. */
export const ChatCropIcon = ({ color }: { color?: string }) => (
  <svg width="16" height="16" viewBox="0 0 640 640" fill="none">
    <path
      d="M192 96C192 78.3 177.7 64 160 64C142.3 64 128 78.3 128 96L128 128L96 128C78.3 128 64 142.3 64 160C64 177.7 78.3 192 96 192L128 192L128 448C128 483.3 156.7 512 192 512L400 512L400 448L192 448L192 96zM448 544C448 561.7 462.3 576 480 576C497.7 576 512 561.7 512 544L512 512L544 512C561.7 512 576 497.7 576 480C576 462.3 561.7 448 544 448L512 448L512 192C512 156.7 483.3 128 448 128L240 128L240 192L448 192L448 544z"
      fill={color || '#4C4C4C'}
    />
  </svg>
);

/** Font Awesome `paintbrush`. Image editor, freehand drawing tool. */
export const ChatDrawIcon = ({ color }: { color?: string }) => (
  <svg width="16" height="16" viewBox="0 0 640 640" fill="none">
    <path
      d="M512.5 74.3L291.1 222C262 241.4 243.5 272.9 240.5 307.3C302.8 320.1 351.9 369.2 364.8 431.6C399.3 428.6 430.7 410.1 450.1 381L597.7 159.5C604.4 149.4 608 137.6 608 125.4C608 91.5 580.5 64 546.6 64C534.5 64 522.6 67.6 512.5 74.3zM320 464C320 402.1 269.9 352 208 352C146.1 352 96 402.1 96 464C96 467.9 96.2 471.8 96.6 475.6C98.4 493.1 86.4 512 68.8 512L64 512C46.3 512 32 526.3 32 544C32 561.7 46.3 576 64 576L208 576C269.9 576 320 525.9 320 464z"
      fill={color || '#4C4C4C'}
    />
  </svg>
);

/**
 * Font Awesome `eraser`. Image editor, rubs out what was drawn.
 *
 * Two px smaller than its neighbours: the eraser is a solid wedge and reads
 * heavier than the outline-ish brush and the letter beside it at the same
 * nominal size - see the note on sizing in docs/icons.md.
 */
export const ChatEraseIcon = ({ color }: { color?: string }) => (
  <svg width="14" height="14" viewBox="0 0 640 640" fill="none">
    <path
      d="M210.5 480L333.5 480L398.8 414.7L225.3 241.2L98.6 367.9L210.6 479.9zM256 544L210.5 544C193.5 544 177.2 537.3 165.2 525.3L49 409C38.1 398.1 32 383.4 32 368C32 352.6 38.1 337.9 49 327L295 81C305.9 70.1 320.6 64 336 64C351.4 64 366.1 70.1 377 81L559 263C569.9 273.9 576 288.6 576 304C576 319.4 569.9 334.1 559 345L424 480L544 480C561.7 480 576 494.3 576 512C576 529.7 561.7 544 544 544L256 544z"
      fill={color || '#4C4C4C'}
    />
  </svg>
);

/** Font Awesome `font`. Image editor, add-text tool. */
export const ChatTextIcon = ({ color }: { color?: string }) => (
  <svg width="16" height="16" viewBox="0 0 640 640" fill="none">
    <path
      d="M349.1 114.7C343.9 103.3 332.5 96 320 96C307.5 96 296.1 103.3 290.9 114.7L123.5 480L112 480C94.3 480 80 494.3 80 512C80 529.7 94.3 544 112 544L200 544C217.7 544 232 529.7 232 512C232 494.3 217.7 480 200 480L193.9 480L215.9 432L424.2 432L446.2 480L440.1 480C422.4 480 408.1 494.3 408.1 512C408.1 529.7 422.4 544 440.1 544L528.1 544C545.8 544 560.1 529.7 560.1 512C560.1 494.3 545.8 480 528.1 480L516.6 480L349.2 114.7zM394.8 368L245.2 368L320 204.8L394.8 368z"
      fill={color || '#4C4C4C'}
    />
  </svg>
);

/**
 * Font Awesome `arrow-rotate-right`. Image editor, redo - the mirror twin of
 * `ChatRestoreIcon` (`arrow-rotate-left`), which doubles as its undo.
 */
export const ChatRedoIcon = ({ color }: { color?: string }) => (
  <svg width="16" height="16" viewBox="0 0 640 640" fill="none">
    <path
      d="M500.7 138.7L512 149.4L512 96C512 78.3 526.3 64 544 64C561.7 64 576 78.3 576 96L576 224C576 241.7 561.7 256 544 256L416 256C398.3 256 384 241.7 384 224C384 206.3 398.3 192 416 192L463.9 192L456.3 184.8C456.1 184.6 455.9 184.4 455.7 184.2C380.7 109.2 259.2 109.2 184.2 184.2C109.2 259.2 109.2 380.7 184.2 455.7C259.2 530.7 380.7 530.7 455.7 455.7C463.9 447.5 471.2 438.8 477.6 429.6C487.7 415.1 507.7 411.6 522.2 421.7C536.7 431.8 540.2 451.8 530.1 466.3C521.6 478.5 511.9 490.1 501 501C401 601 238.9 601 139 501C39.1 401 39 239 139 139C238.9 39.1 400.7 39 500.7 138.7z"
      fill={color || '#4C4C4C'}
    />
  </svg>
);

/**
 * Delivered / seen ticks. One tick delivered, two seen.
 *
 * The one glyph in this feature that is deliberately NOT Font Awesome, and it
 * should stay that way. `check` and `check-double` are two separately drawn
 * icons: swapping one for the other does not add a tick, it replaces the whole
 * mark with a differently shaped and differently sized one, so a message
 * flipping to seen looks like it changed icon rather than gained a state.
 *
 * Here the second tick is literally a second path - the first one does not move
 * - which is the only way the two states read as one control.
 */
/**
 * Font Awesome `user-group`. A group conversation with no photo of its own.
 *
 * Its box is 576x512 rather than the 640x640 the other chat icons use - that is
 * what the free set ships for this one, and re-drawing it onto the square grid
 * is how an icon ends up a hair off-centre from its twin. The avatar sizes it in
 * CSS anyway, since the circle it sits in changes size per breakpoint.
 */
export const ChatGroupIcon = ({ color }: { color?: string }) => (
  <svg width="18" height="16" viewBox="0 0 576 512" fill="none">
    <path
      d="M64 128a112 112 0 1 1 224 0 112 112 0 1 1 -224 0zM0 464c0-97.2 78.8-176 176-176s176 78.8 176 176l0 6c0 23.2-18.8 42-42 42L42 512c-23.2 0-42-18.8-42-42l0-6zM432 64a96 96 0 1 1 0 192 96 96 0 1 1 0-192zm0 240c79.5 0 144 64.5 144 144l0 22.4c0 23-18.6 41.6-41.6 41.6l-144.8 0c6.6-12.5 10.4-26.8 10.4-42l0-6c0-51.5-17.4-98.9-46.5-136.7 22.6-14.7 49.6-23.3 78.5-23.3z"
      fill={color || '#FFFFFF'}
    />
  </svg>
);

/**
 * Font Awesome `location-dot` (solid). The location filter in the merchant
 * group member picker. Placeholder weight by default, like the search
 * field's magnifier it sits beside.
 */
export const ChatLocationIcon = ({ color }: { color?: string }) => (
  <svg width="15" height="20" viewBox="0 0 384 512" fill="none">
    <path
      d="M215.7 499.2C267 435 384 279.4 384 192C384 86 298 0 192 0S0 86 0 192c0 87.4 117 243 168.3 307.2c12.3 15.3 35.1 15.3 47.4 0zM192 128a64 64 0 1 1 0 128 64 64 0 1 1 0-128z"
      fill={color || '#A9A9A9'}
    />
  </svg>
);

export const ChatSeenIcon = ({
  color,
  double,
}: {
  color?: string;
  double?: boolean;
}) => (
  <svg width="16" height="16" viewBox="0 0 20 12" fill="none">
    <path
      d="M1 6.2L4.4 9.6L10.6 2"
      stroke={color || '#A9A9A9'}
      strokeWidth="1.6"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    {double && (
      <path
        d="M8.4 9.4L9 10L15.2 2.4"
        stroke={color || '#A9A9A9'}
        strokeWidth="1.6"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    )}
  </svg>
);

/**
 * Font Awesome `cloud-arrow-up`, shared by the Import Menu dropzone and the chat
 * drop overlay. Fills with `currentColor`, so the block around it sets the
 * colour.
 */
export const CloudUploadIcon = () => (
  <svg
    width="52"
    height="52"
    viewBox="0 0 640 640"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M176 544C96.5 544 32 479.5 32 400C32 336.6 73 282.8 129.9 263.5C128.6 255.8 128 248 128 240C128 160.5 192.5 96 272 96C327.4 96 375.5 127.3 399.6 173.1C413.8 164.8 430.4 160 448 160C501 160 544 203 544 256C544 271.7 540.2 286.6 533.5 299.7C577.5 320 608 364.4 608 416C608 486.7 550.7 544 480 544L176 544zM337 255C327.6 245.6 312.4 245.6 303.1 255L231.1 327C221.7 336.4 221.7 351.6 231.1 360.9C240.5 370.2 255.7 370.3 265 360.9L296 329.9L296 432C296 445.3 306.7 456 320 456C333.3 456 344 445.3 344 432L344 329.9L375 360.9C384.4 370.3 399.6 370.3 408.9 360.9C418.2 351.5 418.3 336.3 408.9 327L336.9 255z"
      fill="currentColor"
    />
  </svg>
);

/**
 * Font Awesome `bullhorn` (solid). Announcements, in the admin sidebar.
 *
 * White by default, unlike the neutral glyphs: every sidebar icon is drawn on
 * the red rail or inside its white disc, and the disc recolours it via CSS.
 */
export const AnnouncementsIcon = ({ color }: { color?: string }) => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 512 512"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fill={color || '#FFFFFF'}
      d="M480 32c0-12.9-7.8-24.6-19.8-29.6s-25.7-2.2-34.9 6.9L381.7 53c-48 48-113.1 75-181 75l-8.7 0-32 0-96 0c-35.3 0-64 28.7-64 64l0 96c0 35.3 28.7 64 64 64l0 128c0 17.7 14.3 32 32 32l64 0c17.7 0 32-14.3 32-32l0-128 8.7 0c67.9 0 133 27 181 75l43.6 43.6c9.2 9.2 22.9 11.9 34.9 6.9s19.8-16.6 19.8-29.6l0-147.6c18.6-8.8 32-32.5 32-60.4s-13.4-51.6-32-60.4L480 32zm-64 76.7L416 240l0 131.3C357.2 317.8 280.5 288 200.7 288l-8.7 0 0-96 8.7 0c79.8 0 156.5-29.8 215.3-83.3z"
    />
  </svg>
);

/**
 * A disc with the AI stars cut out of it, for the open vGrubs AI entry card.
 *
 * There the surface under the avatar is the card's own animated gradient, and
 * the stars are meant to be that gradient - moving exactly as the card does.
 * A gradient painted INTO the stars could only imitate the motion, and two
 * animations started at different moments never agree; a hole shows the real
 * thing. So the disc is drawn here rather than by the Circle's background,
 * white with the stars masked out, over a transparent Circle.
 *
 * The stars take 60% of the disc's width, centred - the same place
 * `ConversationAvatar` puts the flat AIStarsIcon - so the two discs swap
 * without the mark moving. The mask id is per instance, see AIStarsIcon for
 * why.
 */
export const AIStarsCutout = ({ color }: { color?: string }) => {
  const maskId = `aiStarsCut_${useId().replace(/:/g, '')}`;
  return (
    <svg
      width="36"
      height="36"
      viewBox="0 0 100 100"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <mask
        id={maskId}
        maskUnits="userSpaceOnUse"
        x="0"
        y="0"
        width="100"
        height="100"
      >
        <rect width="100" height="100" fill="#FFFFFF" />
        {/* 60 / 21 scales the mark to 60% of the disc; the translate
            centres its 51.43 high box. */}
        <g transform="translate(20 24.286) scale(2.85714)">
          {AI_STARS_PATHS.map((d, i) => (
            <path key={i} d={d} fill="#000000" />
          ))}
        </g>
      </mask>
      <circle
        cx="50"
        cy="50"
        r="50"
        fill={color || '#FFFFFF'}
        mask={`url(#${maskId})`}
      />
    </svg>
  );
};

/** Font Awesome `gear` (solid). Settings of the open menu, on the Menu page. */
export const GearIcon = ({ color }: { color?: string }) => (
  <svg
    width="20"
    height="20"
    viewBox="0 0 512 512"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M495.9 166.6c3.2 8.7 .5 18.4-6.4 24.6l-43.3 39.4c1.1 8.3 1.7 16.8 1.7 25.4s-.6 17.1-1.7 25.4l43.3 39.4c6.9 6.2 9.6 15.9 6.4 24.6c-4.4 11.9-9.7 23.3-15.8 34.3l-4.7 8.1c-6.6 11-14 21.4-22.1 31.2c-5.9 7.2-15.7 9.6-24.5 6.8l-55.7-17.7c-13.4 10.3-28.2 18.9-44 25.4l-12.5 57.1c-2 9.1-9 16.3-18.2 17.8c-13.8 2.3-28 3.5-42.5 3.5s-28.7-1.2-42.5-3.5c-9.2-1.5-16.2-8.7-18.2-17.8l-12.5-57.1c-15.8-6.5-30.6-15.1-44-25.4L83.1 425.9c-8.8 2.8-18.6 .3-24.5-6.8c-8.1-9.8-15.5-20.2-22.1-31.2l-4.7-8.1c-6.1-11-11.4-22.4-15.8-34.3c-3.2-8.7-.5-18.4 6.4-24.6l43.3-39.4C64.6 273.1 64 264.6 64 256s.6-17.1 1.7-25.4L22.4 191.2c-6.9-6.2-9.6-15.9-6.4-24.6c4.4-11.9 9.7-23.3 15.8-34.3l4.7-8.1c6.6-11 14-21.4 22.1-31.2c5.9-7.2 15.7-9.6 24.5-6.8l55.7 17.7c13.4-10.3 28.2-18.9 44-25.4l12.5-57.1c2-9.1 9-16.3 18.2-17.8C227.3 1.2 241.5 0 256 0s28.7 1.2 42.5 3.5c9.2 1.5 16.2 8.7 18.2 17.8l12.5 57.1c15.8 6.5 30.6 15.1 44 25.4l55.7-17.7c8.8-2.8 18.6-.3 24.5 6.8c8.1 9.8 15.5 20.2 22.1 31.2l4.7 8.1c6.1 11 11.4 22.4 15.8 34.3zM256 336a80 80 0 1 0 0-160 80 80 0 1 0 0 160z"
      fill={color || '#4C4C4C'}
    />
  </svg>
);

/**
 * Font Awesome `user-group` (solid). Drivers, in the deliveries sidebar.
 *
 * White by default like the other sidebar glyphs - the nav disc recolours it
 * via CSS either way.
 */
export const DriversIcon = ({ color }: { color?: string }) => (
  <svg width="16" height="16" viewBox="0 0 576 512" fill="none">
    <path
      fill={color || '#FFFFFF'}
      d="M64 128a112 112 0 1 1 224 0 112 112 0 1 1 -224 0zM0 464c0-97.2 78.8-176 176-176s176 78.8 176 176l0 6c0 23.2-18.8 42-42 42L42 512c-23.2 0-42-18.8-42-42l0-6zM432 64a96 96 0 1 1 0 192 96 96 0 1 1 0-192zm0 240c79.5 0 144 64.5 144 144l0 22.4c0 23-18.6 41.6-41.6 41.6l-144.8 0c6.6-12.5 10.4-26.8 10.4-42l0-6c0-51.5-17.4-98.9-46.5-136.7 22.6-14.7 49.6-23.3 78.5-23.3z"
    />
  </svg>
);

/**
 * Font Awesome `truck` (solid). Plain glyph - unlike TruckIcon/TruckLeftIcon
 * it carries no baked-in circle, so it sits cleanly inside an Icon disc.
 */
export const TruckSolidIcon = ({ color }: { color?: string }) => (
  <svg width="20" height="16" viewBox="0 0 640 512" fill="none">
    <path
      fill={color || '#FFFFFF'}
      d="M48 0C21.5 0 0 21.5 0 48V368c0 26.5 21.5 48 48 48H64c0 53 43 96 96 96s96-43 96-96H384c0 53 43 96 96 96s96-43 96-96h32c17.7 0 32-14.3 32-32s-14.3-32-32-32V288 256 237.3c0-17-6.7-33.3-18.7-45.3L512 114.7c-12-12-28.3-18.7-45.3-18.7H416V48c0-26.5-21.5-48-48-48H48zM416 160h50.7L544 237.3V256H416V160zM112 416a48 48 0 1 1 96 0 48 48 0 1 1 -96 0zm368-48a48 48 0 1 1 0 96 48 48 0 1 1 0-96z"
    />
  </svg>
);

/** Font Awesome `map-location-dot` (solid). Live map, in the deliveries sidebar. */
export const LiveMapIcon = ({ color }: { color?: string }) => (
  <svg width="16" height="16" viewBox="0 0 640 512" fill="none">
    <path
      fill={color || '#FFFFFF'}
      d="M576 48c0-11.1-5.7-21.4-15.2-27.2s-21.2-6.4-31.1-1.4L413.5 77.5 234.1 17.6c-8.1-2.7-16.8-2.1-24.4 1.7l-128 64C70.8 88.8 64 99.9 64 112l0 352c0 11.1 5.7 21.4 15.2 27.2s21.2 6.4 31.1 1.4l116.1-58.1 173.3 57.8c-4.3-6.4-8.5-13.1-12.6-19.9-11-18.3-21.9-39.3-30-61.8l-101.2-33.7 0-284.5 128 42.7 0 99.3c31-35.8 77-58.4 128-58.4 22.6 0 44.2 4.4 64 12.5L576 48zM512 224c-66.3 0-120 52.8-120 117.9 0 68.9 64.1 150.4 98.6 189.3 11.6 13 31.3 13 42.9 0 34.5-38.9 98.6-120.4 98.6-189.3 0-65.1-53.7-117.9-120-117.9zM472 344a40 40 0 1 1 80 0 40 40 0 1 1 -80 0z"
    />
  </svg>
);

/** Font Awesome `draw-polygon` (solid). Delivery zones, in the deliveries sidebar. */
export const ZonesIcon = ({ color }: { color?: string }) => (
  <svg width="16" height="16" viewBox="0 0 512 512" fill="none">
    <path
      fill={color || '#FFFFFF'}
      d="M64 0c23.7 0 44.4 12.9 55.4 32l273.1 0c11.1-19.1 31.7-32 55.4-32 35.3 0 64 28.7 64 64 0 34-26.5 61.8-60 63.9l-2.1 2.9-71.5 99.1c3.6 8 5.6 16.9 5.6 26.2s-2 18.2-5.6 26.2l2.2 3.1 69.3 96 2.1 2.9c33.5 2.1 60 29.9 60 63.9 0 35.3-28.7 64-64 64-23.7 0-44.4-12.9-55.4-32l-273.1 0c-11.1 19.1-31.7 32-55.4 32-35.3 0-64-28.7-64-64 0-23.7 12.9-44.4 32-55.4l0-273.1C12.9 108.4 0 87.7 0 64 0 28.7 28.7 0 64 0zM394.2 413.4l-65.5-90.6-2.2-3.1c-2.1 .2-4.3 .3-6.5 .3-35.3 0-64-28.7-64-64s28.7-64 64-64c2.2 0 4.4 .1 6.5 .3l67.7-93.7c-.6-.9-1.1-1.7-1.6-2.6L119.4 96c-5.6 9.7-13.7 17.8-23.4 23.4l0 273.1c9.7 5.6 17.8 13.7 23.4 23.4l273.1 0c.5-.9 1.1-1.8 1.6-2.6z"
    />
  </svg>
);

/** Font Awesome `bell` (solid). The notification centre trigger in the deliveries header. */
export const BellIcon = ({ color }: { color?: string }) => (
  <svg width="20" height="20" viewBox="0 0 448 512" fill="none">
    <path
      fill={color || '#4C4C4C'}
      d="M224 0c-17.7 0-32 14.3-32 32l0 3.2C119 50 64 114.6 64 192l0 21.7c0 48.1-16.4 94.8-46.4 132.4L7.8 358.3C2.7 364.6 0 372.4 0 380.5 0 400.1 15.9 416 35.5 416l376.9 0c19.6 0 35.5-15.9 35.5-35.5 0-8.1-2.7-15.9-7.8-22.2l-9.8-12.2C400.4 308.5 384 261.8 384 213.7l0-21.7c0-77.4-55-142-128-156.8l0-3.2c0-17.7-14.3-32-32-32zM162 464c7.1 27.6 32.2 48 62 48s54.9-20.4 62-48l-124 0z"
    />
  </svg>
);

/**
 * The vDrive mark on a white disc - `VDriveLogo` inverted, for surfaces that
 * are already navy (the deliveries sidebar and auth screens), the way
 * `LogoWhiteCircle` carries the red vGrubs mark on the red rail.
 */
export const VDriveLogoWhiteCircle = (props: React.SVGProps<SVGSVGElement>) => (
  <svg
    width="60"
    height="60"
    viewBox="0 0 125 125"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <circle cx="62.5" cy="62.5" r="62.5" fill="white" />
    <path
      d="M51.5408 44.582C46.1966 44.582 41.7061 49.0726 41.7061 54.4168C41.7061 59.761 46.0853 64.2515 51.5408 64.2515C56.9963 64.2515 61.3756 59.761 61.3756 54.4168C61.3756 49.0726 56.9963 44.582 51.5408 44.582ZM52.9511 59.2785H50.2048L47.3471 49.8891H49.611L51.5779 56.9033L53.5449 49.852H55.7716L52.9511 59.2785Z"
      fill="#172A55"
    />
    <path
      d="M74.105 64.7759C73.7338 64.5532 73.3627 64.479 73.0287 64.5532C72.6947 64.6274 72.4349 64.8501 72.2122 65.2212L71.3586 66.6686L73.8452 68.116L74.6987 66.6315C74.9214 66.2604 74.9585 65.9264 74.8472 65.5924C74.7359 65.2584 74.4761 64.9986 74.105 64.7759Z"
      fill="#172A55"
    />
    <path
      d="M98.3021 39.0916C97.7825 38.1638 97.1516 37.3474 96.4094 36.6051C94.0713 34.3041 90.8425 33.0423 87.4653 33.0423H85.7953C81.3047 33.4506 77.3337 36.2711 75.1811 40.3535L72.472 45.0667C70.1339 49.0748 68.0927 52.6005 66.4227 55.4582C66.1258 55.9406 65.866 56.386 65.6062 56.8313C65.4206 57.1282 65.2351 57.4251 65.0866 57.722C64.8639 58.056 64.6784 58.39 64.4928 58.724C64.1959 59.2065 63.9361 59.6518 63.6763 60.0601C63.6021 60.2085 63.5279 60.3199 63.4166 60.4683C63.2681 60.7281 63.1197 60.9508 62.9712 61.1735C62.563 61.8415 62.1918 62.3239 61.9692 62.6579C59.4455 65.9609 55.623 67.7423 51.652 67.7423C51.4664 67.7423 51.2437 67.7423 51.0582 67.7423C49.7592 67.6681 48.4232 67.4083 47.1614 66.963C41.7059 65.1074 38.1802 60.1343 38.1802 54.3819C38.1802 53.3056 38.3286 52.3036 38.5884 51.3387C38.6626 51.0047 38.774 50.7078 38.8853 50.3738C39.108 49.7058 39.3678 49.0748 39.6647 48.481C39.8131 48.1841 39.9245 47.9244 40.0729 47.6646C40.3698 47.1079 40.6667 46.5512 41.0007 46.0316C41.0378 45.9574 41.1121 45.8461 41.1492 45.7718C41.4832 45.2523 41.7801 44.7327 42.1141 44.2502C43.6357 41.8751 45.0089 39.7597 44.8975 37.6814C44.8975 37.3845 44.8233 37.0876 44.7491 36.8278C44.712 36.7536 44.712 36.6422 44.6748 36.568C44.6377 36.4567 44.6006 36.3824 44.5635 36.2711C44.081 35.1206 43.1532 34.3041 42.2625 33.7846C41.9656 33.599 41.6316 33.4506 41.3347 33.3392C41.1492 33.265 40.9265 33.2279 40.7409 33.1537C40.7409 33.1537 40.7409 33.1537 40.7038 33.1537H40.6667H40.5925C38.4771 32.7825 35.9906 33.1908 35.5452 33.265C35.5081 33.265 35.471 33.265 35.471 33.265C31.9824 33.8588 28.6794 35.8629 26.8609 38.7947C24.4115 42.5802 24.4115 47.3677 26.6754 51.2645L52.0231 95.1312C54.2498 98.9167 58.1466 101.143 62.4887 101.181C66.868 101.181 70.7277 98.9167 72.9544 95.1312L98.3021 51.2645C100.566 47.4048 100.566 42.9142 98.3021 39.0916ZM74.9585 74.8308C74.8843 75.3875 74.6245 75.9813 74.2162 76.6864L72.6946 79.3214L64.901 74.7937L66.4227 72.1587C66.8309 71.4907 67.202 70.9711 67.6102 70.6C68.0185 70.2289 68.4267 70.0433 68.9092 70.0062C69.3916 69.9691 69.837 70.0062 70.3566 70.1546C70.839 70.3031 71.4328 70.6 72.1379 71.0082C72.8431 71.4164 73.3998 71.7876 73.808 72.1587C74.2162 72.4927 74.5502 72.9009 74.7729 73.3463C74.9585 73.7916 75.0327 74.3112 74.9585 74.8308ZM79.2635 67.965L76.109 67.3712L75.2183 68.8928L77.8532 70.4144L76.9254 72.0102L69.1318 67.4825L70.8761 64.4393C71.9524 62.5837 73.3255 62.1755 75.0327 63.1775C76.0347 63.7713 76.5914 64.5878 76.6285 65.6269L80.2655 66.2578L79.2635 67.965ZM81.0449 64.8476L73.2513 60.3199L74.1791 58.724L81.9727 63.2517L81.0449 64.8476ZM83.6056 60.4312L74.7358 57.722L75.7007 56.052L82.9005 58.4271L83.1974 57.9076L77.5563 52.8232L78.5213 51.1531L85.2757 57.4993L83.6056 60.4312ZM86.9829 54.6417L79.1893 50.114L82.1211 45.0667L83.4943 45.8832L81.4902 49.3346L83.3087 50.3738L84.9046 47.5904L86.2777 48.3697L84.6819 51.1531L86.5375 52.2294L88.5416 48.7779L89.9147 49.5944L86.9829 54.6417Z"
      fill="#172A55"
    />
    <path
      d="M72.0639 73.2325C71.8412 73.0841 71.5072 72.8614 71.0618 72.6387C70.6165 72.3789 70.2825 72.1934 69.9856 72.082C69.6887 71.9707 69.4289 71.8965 69.132 71.8965C68.8351 71.8965 68.6124 71.9707 68.3897 72.1563C68.1671 72.3418 67.9444 72.6016 67.7588 73.0099L67.165 74.049L72.2123 76.9809L72.8061 75.9417C73.1401 75.385 73.2515 74.8655 73.103 74.4201C73.0288 74.0119 72.6577 73.6408 72.0639 73.2325Z"
      fill="#172A55"
    />
  </svg>
);

/** Font Awesome `plus` (solid). Zoom in, on the zone editor's map toolbar. */
export const ZoomInIcon = ({ color }: { color?: string }) => (
  <svg width="14" height="14" viewBox="0 0 448 512" fill="none">
    <path
      fill={color || '#4C4C4C'}
      d="M256 80c0-17.7-14.3-32-32-32s-32 14.3-32 32l0 144L48 224c-17.7 0-32 14.3-32 32s14.3 32 32 32l144 0 0 144c0 17.7 14.3 32 32 32s32-14.3 32-32l0-144 144 0c17.7 0 32-14.3 32-32s-14.3-32-32-32l-144 0 0-144z"
    />
  </svg>
);

/** Font Awesome `minus` (solid). Zoom out, beside `ZoomInIcon`. */
export const ZoomOutIcon = ({ color }: { color?: string }) => (
  <svg width="14" height="14" viewBox="0 0 448 512" fill="none">
    <path
      fill={color || '#4C4C4C'}
      d="M432 256c0 17.7-14.3 32-32 32L48 288c-17.7 0-32-14.3-32-32s14.3-32 32-32l352 0c17.7 0 32 14.3 32 32z"
    />
  </svg>
);

/** Font Awesome `circle` (solid). Draw a circular zone. */
export const DrawCircleIcon = ({ color }: { color?: string }) => (
  <svg width="14" height="14" viewBox="0 0 512 512" fill="none">
    <path
      fill={color || '#4C4C4C'}
      d="M256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512z"
    />
  </svg>
);

/** Font Awesome `arrow-pointer` (solid). Select and edit a drawn zone. */
export const SelectPointerIcon = ({ color }: { color?: string }) => (
  <svg width="14" height="14" viewBox="0 0 320 512" fill="none">
    <path
      fill={color || '#4C4C4C'}
      d="M0 55.2L0 426c0 12.2 9.9 22 22 22 6.3 0 12.4-2.7 16.6-7.5L121.2 346l58.1 116.3c7.9 15.8 27.1 22.2 42.9 14.3s22.2-27.1 14.3-42.9L179.8 320l118.1 0c12.2 0 22.1-9.9 22.1-22.1 0-6.3-2.7-12.3-7.4-16.5L38.6 37.9C34.3 34.1 28.9 32 23.2 32 10.4 32 0 42.4 0 55.2z"
    />
  </svg>
);

/** Font Awesome `chevron-left` (solid). The week before, in a pager. */
export const ChevronLeftIcon = ({ color }: { color?: string }) => (
  <svg width="14" height="14" viewBox="0 0 320 512" fill="none">
    <path
      fill={color || '#4C4C4C'}
      d="M9.4 233.4c-12.5 12.5-12.5 32.8 0 45.3l192 192c12.5 12.5 32.8 12.5 45.3 0s12.5-32.8 0-45.3L73.3 256 246.6 82.6c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0l-192 192z"
    />
  </svg>
);

/** Font Awesome `chevron-right` (solid). The week after, in a pager. */
export const ChevronRightIcon = ({ color }: { color?: string }) => (
  <svg width="14" height="14" viewBox="0 0 320 512" fill="none">
    <path
      fill={color || '#4C4C4C'}
      d="M310.6 233.4c12.5 12.5 12.5 32.8 0 45.3l-192 192c-12.5 12.5-32.8 12.5-45.3 0s-12.5-32.8 0-45.3L246.7 256 73.4 82.6c-12.5-12.5-12.5-32.8 0-45.3s32.8-12.5 45.3 0l192 192z"
    />
  </svg>
);

/** Font Awesome `eraser` (solid). Click a zone to remove it. */
export const EraserIcon = ({ color }: { color?: string }) => (
  <svg width="17" height="17" viewBox="0 0 576 512" fill="none">
    <path
      fill={color || '#4C4C4C'}
      d="M290.7 57.4L57.4 290.7c-25 25-25 65.5 0 90.5l80 80c12 12 28.3 18.7 45.3 18.7L288 480l9.4 0L512 480c17.7 0 32-14.3 32-32s-14.3-32-32-32l-124.1 0L518.6 285.3c25-25 25-65.5 0-90.5L381.3 57.4c-25-25-65.5-25-90.5 0zM297.4 416l-9.4 0-105.4 0-80-80L227.3 211.3 364.7 348.7 297.4 416z"
    />
  </svg>
);

/** Font Awesome `check` (solid). Confirm - the save half of a draft's pair. */
export const CheckIcon = ({ color }: { color?: string }) => (
  <svg width="16" height="16" viewBox="0 0 448 512" fill="none">
    <path
      fill={color || '#FFFFFF'}
      d="M438.6 105.4C451.1 117.9 451.1 138.1 438.6 150.6L182.6 406.6C170.1 419.1 149.9 419.1 137.4 406.6L9.4 278.6C-3.1 266.1-3.1 245.9 9.4 233.4C21.9 220.9 42.1 220.9 54.6 233.4L160 338.7L393.4 105.4C405.9 92.9 426.1 92.9 438.6 105.4z"
    />
  </svg>
);

/** Font Awesome `circle-question` (solid). The guides button in a page header. */
export const GuideIcon = ({ color }: { color?: string }) => (
  <svg width="20" height="20" viewBox="0 0 512 512" fill="none">
    <path
      d="M256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM169.8 165.3c7.9-22.3 29.1-37.3 52.8-37.3h58.3c34.9 0 63.1 28.3 63.1 63.1c0 22.6-12.1 43.5-31.7 54.8L280 264.4c-.2 13-10.9 23.6-24 23.6c-13.3 0-24-10.7-24-24V250.5c0-8.6 4.6-16.5 12.1-20.8l44.3-25.4c4.7-2.7 7.6-7.7 7.6-13.1c0-8.4-6.8-15.1-15.1-15.1H222.6c-3.4 0-6.4 2.1-7.5 5.3l-.4 1.2c-4.4 12.5-18.2 19-30.6 14.6s-19-18.2-14.6-30.6l.4-1.2zM224 352a32 32 0 1 1 64 0 32 32 0 1 1 -64 0z"
      fill={color || '#4C4C4C'}
    />
  </svg>
);

/** Font Awesome `key` (solid). "Integration Access" in the location options dropdown. */
export const DropdownAccessIcon = ({ color }: { color?: string }) => (
  <svg width="18" height="18" viewBox="0 0 512 512" fill="none">
    <path
      d="M336 352c97.2 0 176-78.8 176-176S433.2 0 336 0S160 78.8 160 176c0 18.7 2.9 36.8 8.3 53.7L7 391c-4.5 4.5-7 10.6-7 17v80c0 13.3 10.7 24 24 24h80c13.3 0 24-10.7 24-24V448h40c13.3 0 24-10.7 24-24V384h40c6.4 0 12.5-2.5 17-7l33.3-33.3c16.9 5.4 35 8.3 53.7 8.3zM376 96a40 40 0 1 1 0 80 40 40 0 1 1 0-80z"
      fill={color || '#A9A9A9'}
    />
  </svg>
);

/**
 * Font Awesome `file-invoice-dollar` (solid). Receivables, in the admin
 * sidebar. White by default for the same reason as AnnouncementsIcon.
 */
export const ReceivablesIcon = ({ color }: { color?: string }) => (
  <svg
    width="18"
    height="24"
    viewBox="0 0 384 512"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fill={color || '#FFFFFF'}
      d="M0 64C0 28.7 28.7 0 64 0L213.5 0c17 0 33.3 6.7 45.3 18.7L365.3 125.3c12 12 18.7 28.3 18.7 45.3L384 448c0 35.3-28.7 64-64 64L64 512c-35.3 0-64-28.7-64-64L0 64zm208-5.5l0 93.5c0 13.3 10.7 24 24 24L325.5 176 208 58.5zM64 88c0 13.3 10.7 24 24 24l48 0c13.3 0 24-10.7 24-24s-10.7-24-24-24L88 64C74.7 64 64 74.7 64 88zm0 96c0 13.3 10.7 24 24 24l48 0c13.3 0 24-10.7 24-24s-10.7-24-24-24l-48 0c-13.3 0-24 10.7-24 24zm112 76l0 4c-28.8 .3-52 23.7-52 52.5 0 25.7 18.5 47.6 43.9 51.8l41.7 7c6 1 10.4 6.2 10.4 12.3 0 6.9-5.6 12.5-12.5 12.5L152 400c-11 0-20 9-20 20s9 20 20 20l24 0 0 4c0 11 9 20 20 20s20-9 20-20l0-4.7c25-4.1 44-25.7 44-51.8 0-25.7-18.5-47.6-43.9-51.8l-41.7-7c-6-1-10.4-6.2-10.4-12.3 0-6.9 5.6-12.5 12.5-12.5l47.5 0c11 0 20-9 20-20s-9-20-20-20l-8 0 0-4c0-11-9-20-20-20s-20 9-20 20z"
    />
  </svg>
);

/** Font Awesome `building-columns` (solid). A bank account with no name, on the pay tiles. */
export const BankAccountIcon = ({ color }: { color?: string }) => (
  <svg width="18" height="18" viewBox="0 0 512 512" fill="none">
    <path
      fill={color || '#4C4C4C'}
      d="M243.4 2.6l-224 96c-14 6-21.8 21-18.7 35.8S16.8 160 32 160v8c0 13.3 10.7 24 24 24H456c13.3 0 24-10.7 24-24v-8c15.2 0 28.3-10.7 31.3-25.6s-4.8-29.9-18.7-35.8l-224-96c-8-3.4-17.2-3.4-25.2 0zM128 224H64V420.3c-.6 .3-1.2 .7-1.8 1.1l-48 32c-11.7 7.8-17 22.4-12.9 35.9S17.9 512 32 512H480c14.1 0 26.5-9.2 30.6-22.7s-1.1-28.1-12.9-35.9l-48-32c-.6-.4-1.2-.7-1.8-1.1V224H384V416H344V224H280V416H232V224H168V416H128V224zM256 64a32 32 0 1 1 0 64 32 32 0 1 1 0-64z"
    />
  </svg>
);

/** Font Awesome `credit-card` (solid). A card with no brand, on the pay tiles. */
export const PaymentCardIcon = ({ color }: { color?: string }) => (
  <svg width="20" height="18" viewBox="0 0 576 512" fill="none">
    <path
      fill={color || '#4C4C4C'}
      d="M64 32C28.7 32 0 60.7 0 96v32H576V96c0-35.3-28.7-64-64-64H64zM576 224H0V416c0 35.3 28.7 64 64 64H512c35.3 0 64-28.7 64-64V224zM112 352h64c8.8 0 16 7.2 16 16s-7.2 16-16 16H112c-8.8 0-16-7.2-16-16s7.2-16 16-16zm112 16c0-8.8 7.2-16 16-16H368c8.8 0 16 7.2 16 16s-7.2 16-16 16H240c-8.8 0-16-7.2-16-16z"
    />
  </svg>
);

/** Font Awesome `cc-visa` (brands). Visa logo on a saved vDrive card's tile. */
export const CardVisaIcon = ({ color }: { color?: string }) => (
  <svg width="28" height="25" viewBox="0 0 576 512" fill="none">
    <path
      fill={color || '#4C4C4C'}
      d="M470.1 231.3s7.6 37.2 9.3 45H446c3.3-8.9 16-43.5 16-43.5-.2.3 3.3-9.1 5.3-14.9l2.8 13.4zM576 80v352c0 26.5-21.5 48-48 48H48c-26.5 0-48-21.5-48-48V80c0-26.5 21.5-48 48-48h480c26.5 0 48 21.5 48 48zM152.5 331.2L215.7 176h-42.5l-39.3 106-4.3-21.5-14-71.4c-2.3-9.9-9.4-12.7-18.2-13.1H32.7l-.7 3.1c15.8 4 29.9 9.8 42.2 17.1l35.8 135h42.5zm94.4.2L272.1 176h-40.2l-25.1 155.4h40.1zm139.9-50.8c.2-17.7-10.6-31.2-33.7-42.3-14.1-7.1-22.7-11.9-22.7-19.2.2-6.6 7.3-13.4 23.1-13.4 13.1-.3 22.7 2.8 29.9 5.9l3.6 1.7 5.5-33.6c-7.9-3.1-20.5-6.6-36-6.6-39.7 0-67.6 21.2-67.8 51.4-.3 22.3 20 34.7 35.2 42.2 15.5 7.6 20.8 12.6 20.8 19.3-.2 10.4-12.6 15.2-24.1 15.2-16 0-24.6-2.5-37.7-8.3l-5.3-2.5-5.6 34.9c9.4 4.3 26.8 8.1 44.8 8.3 42.2.1 69.7-20.8 70-53zM528 331.4L495.6 176h-31.1c-9.6 0-16.9 2.8-21 12.9l-59.7 142.5H426s6.9-19.2 8.4-23.3H486c1.2 5.5 4.8 23.3 4.8 23.3H528z"
    />
  </svg>
);

/** Font Awesome `cc-mastercard` (brands). Mastercard logo on a saved vDrive card's tile. */
export const CardMastercardIcon = ({ color }: { color?: string }) => (
  <svg width="28" height="25" viewBox="0 0 576 512" fill="none">
    <path
      fill={color || '#4C4C4C'}
      d="M482.9 410.3c0 6.8-4.6 11.7-11.2 11.7-6.8 0-11.2-5.2-11.2-11.7 0-6.5 4.4-11.7 11.2-11.7 6.6 0 11.2 5.2 11.2 11.7zm-310.8-11.7c-7.1 0-11.2 5.2-11.2 11.7 0 6.5 4.1 11.7 11.2 11.7 6.5 0 10.9-4.9 10.9-11.7-.1-6.5-4.4-11.7-10.9-11.7zm117.5-.3c-5.4 0-8.7 3.5-9.5 8.7h19.1c-.9-5.7-4.4-8.7-9.6-8.7zm107.8.3c-6.8 0-10.9 5.2-10.9 11.7 0 6.5 4.1 11.7 10.9 11.7 6.8 0 11.2-4.9 11.2-11.7 0-6.5-4.4-11.7-11.2-11.7zm105.9 26.1c0 .3.3.5.3 1.1 0 .3-.3.5-.3 1.1-.3.3-.3.5-.5.8-.3.3-.5.5-1.1.5-.3.3-.5.3-1.1.3-.3 0-.5 0-1.1-.3-.3 0-.5-.3-.8-.5-.3-.3-.5-.5-.5-.8-.3-.5-.3-.8-.3-1.1 0-.5 0-.8.3-1.1 0-.5.3-.8.5-1.1.3-.3.5-.3.8-.5.5-.3.8-.3 1.1-.3.5 0 .8 0 1.1.3.5.3.8.3 1.1.5s.2.6.5 1.1zm-2.2 1.4c.5 0 .5-.3.8-.3.3-.3.3-.5.3-.8 0-.3 0-.5-.3-.8-.3 0-.5-.3-1.1-.3h-1.6v3.5h.8V426h.3l1.1 1.4h.8l-1.1-1.3zM576 81v352c0 26.5-21.5 48-48 48H48c-26.5 0-48-21.5-48-48V81c0-26.5 21.5-48 48-48h480c26.5 0 48 21.5 48 48zM64 220.6c0 76.5 62.1 138.5 138.5 138.5 27.2 0 53.9-8.2 76.5-23.1-72.9-59.3-72.4-171.2 0-230.5-22.6-15-49.3-23.1-76.5-23.1-76.4-.1-138.5 62-138.5 138.2zm224 108.8c70.5-55 70.2-162.2 0-217.5-70.2 55.3-70.5 162.6 0 217.5zm-142.3 76.3c0-8.7-5.7-14.4-14.7-14.7-4.6 0-9.5 1.4-12.8 6.5-2.4-4.1-6.5-6.5-12.2-6.5-3.8 0-7.6 1.4-10.6 5.4V392h-8.2v36.7h8.2c0-18.9-2.5-30.2 9-30.2 10.2 0 8.2 10.2 8.2 30.2h7.9c0-18.3-2.5-30.2 9-30.2 10.2 0 8.2 10 8.2 30.2h8.2v-23zm44.9-13.7h-7.9v4.4c-2.7-3.3-6.5-5.4-11.7-5.4-10.3 0-18.2 8.2-18.2 19.3 0 11.2 7.9 19.3 18.2 19.3 5.2 0 9-1.9 11.7-5.4v4.6h7.9V392zm40.5 25.6c0-15-22.9-8.2-22.9-15.2 0-5.7 11.9-4.8 18.5-1.1l3.3-6.5c-9.4-6.1-30.2-6-30.2 8.2 0 14.3 22.9 8.3 22.9 15 0 6.3-13.5 5.8-20.7.8l-3.5 6.3c11.2 7.6 32.6 6 32.6-7.5zm35.4 9.3l-2.2-6.8c-3.8 2.1-12.2 4.4-12.2-4.1v-16.6h13.1V392h-13.1v-11.2h-8.2V392h-7.6v7.3h7.6V416c0 17.6 17.3 14.4 22.6 10.9zm13.3-13.4h27.5c0-16.2-7.4-22.6-17.4-22.6-10.6 0-18.2 7.9-18.2 19.3 0 20.5 22.6 23.9 33.8 14.2l-3.8-6c-7.8 6.4-19.6 5.8-21.9-4.9zm59.1-21.5c-4.6-2-11.6-1.8-15.2 4.4V392h-8.2v36.7h8.2V408c0-11.6 9.5-10.1 12.8-8.4l2.4-7.6zm10.6 18.3c0-11.4 11.6-15.1 20.7-8.4l3.8-6.5c-11.6-9.1-32.7-4.1-32.7 15 0 19.8 22.4 23.8 32.7 15l-3.8-6.5c-9.2 6.5-20.7 2.6-20.7-8.6zm66.7-18.3H408v4.4c-8.3-11-29.9-4.8-29.9 13.9 0 19.2 22.4 24.7 29.9 13.9v4.6h8.2V392zm33.7 0c-2.4-1.2-11-2.9-15.2 4.4V392h-7.9v36.7h7.9V408c0-11 9-10.3 12.8-8.4l2.4-7.6zm40.3-14.9h-7.9v19.3c-8.2-10.9-29.9-5.1-29.9 13.9 0 19.4 22.5 24.6 29.9 13.9v4.6h7.9v-51.7zm7.6-75.1v4.6h.8V302h1.9v-.8h-4.6v.8h1.9zm6.6 123.8c0-.5 0-1.1-.3-1.6-.3-.3-.5-.8-.8-1.1-.3-.3-.8-.5-1.1-.8-.5 0-1.1-.3-1.6-.3-.3 0-.8.3-1.4.3-.5.3-.8.5-1.1.8-.5.3-.8.8-.8 1.1-.3.5-.3 1.1-.3 1.6 0 .3 0 .8.3 1.4 0 .3.3.8.8 1.1.3.3.5.5 1.1.8.5.3 1.1.3 1.4.3.5 0 1.1 0 1.6-.3.3-.3.8-.5 1.1-.8.3-.3.5-.8.8-1.1.3-.6.3-1.1.3-1.4zm3.2-124.7h-1.4l-1.6 3.5-1.6-3.5h-1.4v5.4h.8v-4.1l1.6 3.5h1.1l1.4-3.5v4.1h1.1v-5.4zm4.4-80.5c0-76.2-62.1-138.3-138.5-138.3-27.2 0-53.9 8.2-76.5 23.1 72.1 59.3 73.2 171.5 0 230.5 22.6 15 49.5 23.1 76.5 23.1 76.4.1 138.5-61.9 138.5-138.4z"
    />
  </svg>
);

/** Font Awesome `cc-amex` (brands). American Express logo on a saved vDrive card's tile. */
export const CardAmexIcon = ({ color }: { color?: string }) => (
  <svg width="28" height="25" viewBox="0 0 576 512" fill="none">
    <path
      fill={color || '#4C4C4C'}
      d="M0 432c0 26.5 21.5 48 48 48H528c26.5 0 48-21.5 48-48v-1.1H514.3l-31.9-35.1-31.9 35.1H246.8V267.1H181L262.7 82.4h78.6l28.1 63.2V82.4h97.2L483.5 130l17-47.6H576V80c0-26.5-21.5-48-48-48H48C21.5 32 0 53.5 0 80V432zm440.4-21.7L482.6 364l42 46.3H576l-68-72.1 68-72.1H525.4l-42 46.7-41.5-46.7H390.5L458 338.6l-67.4 71.6V377.1h-83V354.9h80.9V322.6H307.6V300.2h83V267.1h-122V410.3H440.4zm96.3-72L576 380.2V296.9l-39.3 41.4zm-36.3-92l36.9-100.6V246.3H576V103H515.8l-32.2 89.3L451.7 103H390.5V246.1L327.3 103H276.1L213.7 246.3h43l11.9-28.7h65.9l12 28.7h82.7V146L466 246.3h34.4zM282 185.4l19.5-46.9 19.4 46.9H282z"
    />
  </svg>
);

/** Font Awesome `cc-discover` (brands). Discover logo on a saved vDrive card's tile. */
export const CardDiscoverIcon = ({ color }: { color?: string }) => (
  <svg width="28" height="25" viewBox="0 0 576 512" fill="none">
    <path
      fill={color || '#4C4C4C'}
      d="M520.4 196.1c0-7.9-5.5-12.1-15.6-12.1h-4.9v24.9h4.7c10.3 0 15.8-4.4 15.8-12.8zM528 32H48C21.5 32 0 53.5 0 80v352c0 26.5 21.5 48 48 48h480c26.5 0 48-21.5 48-48V80c0-26.5-21.5-48-48-48zm-44.1 138.9c22.6 0 52.9-4.1 52.9 24.4 0 12.6-6.6 20.7-18.7 23.2l25.8 34.4h-19.6l-22.2-32.8h-2.2v32.8h-16zm-55.9.1h45.3v14H444v18.2h28.3V217H444v22.2h29.3V253H428zm-68.7 0l21.9 55.2 22.2-55.2h17.5l-35.5 84.2h-8.6l-35-84.2zm-55.9-3c24.7 0 44.6 20 44.6 44.6 0 24.7-20 44.6-44.6 44.6-24.7 0-44.6-20-44.6-44.6 0-24.7 20-44.6 44.6-44.6zm-49.3 6.1v19c-20.1-20.1-46.8-4.7-46.8 19 0 25 27.5 38.5 46.8 19.2v19c-29.7 14.3-63.3-5.7-63.3-38.2 0-31.2 33.1-53 63.3-38zm-97.2 66.3c11.4 0 22.4-15.3-3.3-24.4-15-5.5-20.2-11.4-20.2-22.7 0-23.2 30.6-31.4 49.7-14.3l-8.4 10.8c-10.4-11.6-24.9-6.2-24.9 2.5 0 4.4 2.7 6.9 12.3 10.3 18.2 6.6 23.6 12.5 23.6 25.6 0 29.5-38.8 37.4-56.6 11.3l10.3-9.9c3.7 7.1 9.9 10.8 17.5 10.8zM55.4 253H32v-82h23.4c26.1 0 44.1 17 44.1 41.1 0 18.5-13.2 40.9-44.1 40.9zm67.5 0h-16v-82h16zM544 433c0 8.2-6.8 15-15 15H128c189.6-35.6 382.7-139.2 416-160zM74.1 191.6c-5.2-4.9-11.6-6.6-21.9-6.6H48v54.2h4.2c10.3 0 17-2 21.9-6.4 5.7-5.2 8.9-12.8 8.9-20.7s-3.2-15.5-8.9-20.5z"
    />
  </svg>
);
/**
 * Font Awesome `gift` (solid). Restaurant referrals: both sidebars, and the
 * disc on the merchant's offer card - the same mark the mobile app uses.
 */
export const RestaurantReferralsIcon = ({
  color,
  size = 20,
}: {
  color?: string;
  size?: number;
}) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 512 512"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M321.5 68.8C329.1 55.9 342.9 48 357.8 48l2.2 0c22.1 0 40 17.9 40 40s-17.9 40-40 40l-73.3 0 34.8-59.2zm-131 0l34.8 59.2-73.3 0c-22.1 0-40-17.9-40-40s17.9-40 40-40l2.2 0c14.9 0 28.8 7.9 36.3 20.8zm89.6-24.3l-24.1 41-24.1-41C215.7 16.9 186.1 0 154.2 0L152 0c-48.6 0-88 39.4-88 88 0 14.4 3.5 28 9.6 40L32 128c-17.7 0-32 14.3-32 32l0 32c0 17.7 14.3 32 32 32l448 0c17.7 0 32-14.3 32-32l0-32c0-17.7-14.3-32-32-32l-41.6 0c6.1-12 9.6-25.6 9.6-40 0-48.6-39.4-88-88-88l-2.2 0c-31.9 0-61.5 16.9-77.7 44.4zM480 272l-200 0 0 208 136 0c35.3 0 64-28.7 64-64l0-144zm-248 0l-200 0 0 144c0 35.3 28.7 64 64 64l136 0 0-208z"
      fill={color || '#FFFFFF'}
    />
  </svg>
);

/** Font Awesome `qrcode` (solid). Show the invite link as a QR code. */
export const QrCodeIcon = ({ color }: { color?: string }) => (
  <svg
    width="14"
    height="16"
    viewBox="0 0 448 512"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M64 160l64 0 0-64-64 0 0 64zM0 80C0 53.5 21.5 32 48 32l96 0c26.5 0 48 21.5 48 48l0 96c0 26.5-21.5 48-48 48l-96 0c-26.5 0-48-21.5-48-48L0 80zM64 416l64 0 0-64-64 0 0 64zM0 336c0-26.5 21.5-48 48-48l96 0c26.5 0 48 21.5 48 48l0 96c0 26.5-21.5 48-48 48l-96 0c-26.5 0-48-21.5-48-48l0-96zM320 96l0 64 64 0 0-64-64 0zM304 32l96 0c26.5 0 48 21.5 48 48l0 96c0 26.5-21.5 48-48 48l-96 0c-26.5 0-48-21.5-48-48l0-96c0-26.5 21.5-48 48-48zM288 352a32 32 0 1 1 0-64 32 32 0 1 1 0 64zm0 64c17.7 0 32 14.3 32 32s-14.3 32-32 32-32-14.3-32-32 14.3-32 32-32zm96 32c0-17.7 14.3-32 32-32s32 14.3 32 32-14.3 32-32 32-32-14.3-32-32zm32-96a32 32 0 1 1 0-64 32 32 0 1 1 0 64zm-32 32a32 32 0 1 1 -64 0 32 32 0 1 1 64 0z"
      fill={color || '#4C4C4C'}
    />
  </svg>
);

/** Font Awesome `gamepad` (solid). Play & Earn on the tracking page. */
export const GamepadIcon = ({ color }: { color?: string }) => (
  <svg width="24" height="19" viewBox="0 0 640 512" fill="none">
    <path
      d="M448 64c106 0 192 86 192 192S554 448 448 448l-256 0C86 448 0 362 0 256S86 64 192 64l256 0zM192 176c-13.3 0-24 10.7-24 24l0 32-32 0c-13.3 0-24 10.7-24 24s10.7 24 24 24l32 0 0 32c0 13.3 10.7 24 24 24s24-10.7 24-24l0-32 32 0c13.3 0 24-10.7 24-24s-10.7-24-24-24l-32 0 0-32c0-13.3-10.7-24-24-24zm240 96a32 32 0 1 0 0 64 32 32 0 1 0 0-64zm64-96a32 32 0 1 0 0 64 32 32 0 1 0 0-64z"
      fill={color || '#FFFFFF'}
    />
  </svg>
);

/** Font Awesome `file-invoice-dollar` (solid). The Invoices entry in the vDrive console sidebar. */
export const InvoicesIcon = ({ color }: { color?: string }) => (
  <svg width="18" height="24" viewBox="0 0 384 512" fill="none">
    <path
      fill={color || '#FFFFFF'}
      d="M0 64C0 28.7 28.7 0 64 0L213.5 0c17 0 33.3 6.7 45.3 18.7L365.3 125.3c12 12 18.7 28.3 18.7 45.3L384 448c0 35.3-28.7 64-64 64L64 512c-35.3 0-64-28.7-64-64L0 64zm208-5.5l0 93.5c0 13.3 10.7 24 24 24L325.5 176 208 58.5zM64 88c0 13.3 10.7 24 24 24l48 0c13.3 0 24-10.7 24-24s-10.7-24-24-24L88 64C74.7 64 64 74.7 64 88zm0 96c0 13.3 10.7 24 24 24l48 0c13.3 0 24-10.7 24-24s-10.7-24-24-24l-48 0c-13.3 0-24 10.7-24 24zm112 76l0 4c-28.8 .3-52 23.7-52 52.5 0 25.7 18.5 47.6 43.9 51.8l41.7 7c6 1 10.4 6.2 10.4 12.3 0 6.9-5.6 12.5-12.5 12.5L152 400c-11 0-20 9-20 20s9 20 20 20l24 0 0 4c0 11 9 20 20 20s20-9 20-20l0-4.7c25-4.1 44-25.7 44-51.8 0-25.7-18.5-47.6-43.9-51.8l-41.7-7c-6-1-10.4-6.2-10.4-12.3 0-6.9 5.6-12.5 12.5-12.5l47.5 0c11 0 20-9 20-20s-9-20-20-20l-8 0 0-4c0-11-9-20-20-20s-20 9-20 20z"
    />
  </svg>
);

/** Font Awesome `lock` (solid). A vDrive console locked for an overdue invoice. */
export const LockedAccountIcon = ({ color }: { color?: string }) => (
  <svg width="28" height="32" viewBox="0 0 448 512" fill="none">
    <path
      fill={color || '#4C4C4C'}
      d="M144 144v48H304V144c0-44.2-35.8-80-80-80s-80 35.8-80 80zM80 192V144C80 64.5 144.5 0 224 0s144 64.5 144 144v48h16c35.3 0 64 28.7 64 64V448c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V256c0-35.3 28.7-64 64-64H80z"
    />
  </svg>
);

/** Font Awesome `calendar-day` (solid). The vTablet fee charged per day. */
export const CalendarDaySolidIcon = ({ color }: { color?: string }) => (
  <svg width="18" height="20" viewBox="0 0 448 512" fill="none">
    <path
      fill={color || '#4C4C4C'}
      d="M128 0c17.7 0 32 14.3 32 32V64H288V32c0-17.7 14.3-32 32-32s32 14.3 32 32V64h48c26.5 0 48 21.5 48 48v48H0V112C0 85.5 21.5 64 48 64H96V32c0-17.7 14.3-32 32-32zM0 192H448V464c0 26.5-21.5 48-48 48H48c-26.5 0-48-21.5-48-48V192zm80 64c-8.8 0-16 7.2-16 16v96c0 8.8 7.2 16 16 16h96c8.8 0 16-7.2 16-16V272c0-8.8-7.2-16-16-16H80z"
    />
  </svg>
);

/** Font Awesome `eye-slash` (solid). A viewer who dismissed an announcement for good. */
export const DismissedForGoodIcon = ({
  color,
  size = 14,
}: {
  color?: string;
  size?: number;
}) => (
  <svg width={size} height={size} viewBox="0 0 640 512" fill="none">
    <path
      d="M38.8 5.1C28.4-3.1 13.3-1.2 5.1 9.2S-1.2 34.7 9.2 42.9l592 464c10.4 8.2 25.5 6.3 33.7-4.1s6.3-25.5-4.1-33.7L525.6 386.7c39.6-40.6 66.4-86.1 79.9-118.4c3.3-7.9 3.3-16.7 0-24.6c-14.9-35.7-46.2-87.7-93-131.1C465.5 68.8 400.8 32 320 32c-68.2 0-125 26.3-169.3 60.8L38.8 5.1zM223.1 149.5C248.6 126.2 282.7 112 320 112c79.5 0 144 64.5 144 144c0 24.9-6.3 48.3-17.4 68.7L408 294.5c8.4-19.3 10.6-41.4 4.8-63.3c-11.1-41.5-47.8-69.4-88.6-71.1c-5.8-.2-9.2 6.1-7.4 11.7c2.1 6.4 3.3 13.2 3.3 20.3c0 10.2-2.4 19.8-6.6 28.3l-90.3-70.8zM373 389.9c-16.4 6.5-34.3 10.1-53 10.1c-79.5 0-144-64.5-144-144c0-6.9 .5-13.6 1.4-20.2L83.1 161.5C60.3 191.2 44 220.8 34.5 243.7c-3.3 7.9-3.3 16.7 0 24.6c14.9 35.7 46.2 87.7 93 131.1C174.5 443.2 239.2 480 320 480c47.8 0 89.9-12.9 126.2-32.5L373 389.9z"
      fill={color || '#A9A9A9'}
    />
  </svg>
);
